<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C2" :fill="fill">
      <path
        class="st3"
        d="M301.4,117.1c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8c0.1,0.1,0.2,0.1,0.2,0.2v-2.9V118v-4
		c-1,0.3-2,0.6-3,0.9C302.1,115.4,301.5,116.1,301.4,117.1z"
      />
      <path
        class="st3"
        d="M109.7,304.6c-0.1,0-0.1,0-0.2,0.1c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.2
		c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7c-0.1-0.1-0.3-0.2-0.4-0.2c-0.5-0.1-0.9-0.2-1.5-0.2c0,0,0-0.1,0.1-0.1
		c-0.4-0.1-0.8-0.2-1.2-0.3c0,0.1,0.1,0.3,0.1,0.4c-0.7,0.4-1.2,0.6-1.7,0.9c-0.9,0.7-1.7,1.4-2.6,2.1c-0.6,0.5-0.4,1.2,0.3,1.3
		c0.9,0.1,1.4,0.6,2,1c0.5,0.4,1,0.6,1.5,0.7c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6
		c0.3,1.4,1.8,2.3,3.4,2.2c0.3,0,0.7,0,1-0.1c1.8-0.4,3-1.8,3-3.4c0-0.1,0-0.2,0-0.4C113.6,305.2,111.8,304.2,109.7,304.6z"
      />
      <path
        class="st3"
        d="M110.5,301.1c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3
		c-0.8-0.6-1.9-0.8-3.1-0.5c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.4-0.4,0.8-0.5,1.2
		C105.8,300.1,108.2,300.6,110.5,301.1z"
      />
      <path
        class="st3"
        d="M86.9,321.3c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9
		l-0.1-0.1c-0.5-0.5-1.4-0.6-2-0.2c-0.4,0.2-0.6,0.5-0.8,0.7c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2
		c-1.3,1.2-1.3,1.2-0.5,2.5c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3
		c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6c0.7-0.3,0.5-0.8,0.4-1.2C87,322.3,86.9,321.8,86.9,321.3z"
      />
      <path
        class="st3"
        d="M167.3,275.1c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5
		c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9c-0.5-0.1-1.1,0-1.6,0.1
		C168,271.7,166.9,273.1,167.3,275.1z"
      />
      <path
        class="st3"
        d="M179.7,278.4c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C179.9,278.9,179.9,278.6,179.7,278.4z"
      />
      <path
        class="st3"
        d="M102.1,308.4c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.4,0.2-0.8,0.5-1.1,0.7c-0.4-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.2-1.3,0
		c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.5-0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1c0.8-0.8,1.5-1.5,2.2-2.2
		c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1
		c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3-0.1-0.4C102.5,308.9,102.3,308.6,102.1,308.4z"
      />
      <path
        class="st3"
        d="M172.2,266.4c0.5,0.1,1,0.1,1.5,0c1.3-0.3,2.3-1.2,2.6-2.3c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8
		c-0.5-0.1-1.1-0.1-1.7,0c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9C170.1,265.5,171.1,266.2,172.2,266.4z"
      />
      <path
        class="st3"
        d="M148,337.3c-1.1,0.2-1.9,0.7-2.3,1.4c0.1,0.2,0.2,0.5,0.3,0.7h5.3c0-0.1,0-0.2,0-0.3
		C151.1,337.9,149.6,337,148,337.3z"
      />
      <path
        class="st3"
        d="M250.6,237.2c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0c-0.8,0.1-1.5,0.4-2.4,1.1c0.4-1.1-0.4-1.3-0.8-1.7
		c-0.6-0.6-1.4-0.5-2.2-0.2c-0.7,0.2-1.3,0.6-1.9,0.8v0.1c0.8,0.7,1.6,1.4,2.4,2.1c1.1,0.1,1.8-0.6,2.7-1.2c0.1,0.5,0.3,1,0.7,1.3
		c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7
		s0.5-0.8,0.4-1.6c-0.6-0.1-1.2-0.1-1.8-0.2C250.7,237.2,250.7,237.2,250.6,237.2z"
      />
      <path
        class="st3"
        d="M232.8,294.9c0.6-1.2-0.1-2.4-1.5-2.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6
		c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2c-0.2,0.1-0.2,0.5-0.2,0.7l0,0c0.1,0.3,0.4,0.6,0.6,0.9c-0.2,0.4-0.4,0.8-0.5,1.2
		c-0.3,1.3,0.5,2.3,2,2.6C230.9,296.8,232.3,296.1,232.8,294.9z"
      />
      <path
        class="st3"
        d="M184.6,254.7c0.4,0.5,0.8,0.9,1.1,1.4c0.2,0.1,0.3,0.2,0.5,0.2c1.1,0.4,2.6,0,3.4-0.8c0.8-0.8,1-2,0.4-2.9
		c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9c-0.1,0.4-0.3,0.8-0.4,1.2C184.5,254.1,184.5,254.4,184.6,254.7z"
      />
      <path
        class="st3"
        d="M194.3,257.8c-0.1-0.4-0.7-0.8-1.2-1c-0.9-0.3-1.8-0.4-2.7-0.6c-0.8-0.1-1.5,0.1-2,0.7
		c-0.6,0.6-0.5,1.3-0.2,1.9c0.3,0.5,1,0.7,1.9,0.5c0.4-0.1,0.8-0.2,1.3-0.3c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0,0.8-0.1,1.1-0.1
		s0.7,0.2,1.1,0.4c0.4-0.5,0.8-1,1.2-1.6C195,258.7,194.5,258.4,194.3,257.8z"
      />
      <path
        class="st3"
        d="M223.7,294c0.2-0.7,0.3-1.2,0-1.7c-0.2-0.4-0.5-0.8-1.1-1.1c-0.4,0.4-0.6,0.8-0.6,1.1
		c-0.1,0.7,0.5,1.3,0.9,1.9c-0.4,0.4-0.8,0.7-1.1,1.1c0.3,0.9,0.9,1.5,1.5,2c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1
		c0.8,0.1,1.3-0.3,1.6-0.9c0-0.1,0.1-0.1,0.1-0.2c-0.6-1.1-1.3-2.1-1.9-3.2C224.5,294.1,224.1,294,223.7,294z"
      />
      <path
        class="st3"
        d="M91.7,308.1c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6c0.2-0.4,0.2-0.7,0.2-1.1
		c-0.2-1.2-1.6-2-3.1-1.7s-2.5,1.4-2.4,2.7C91.4,307.5,91.5,307.8,91.7,308.1z"
      />
      <path
        class="st3"
        d="M188.1,263.8c-0.4-1.1-1.5-1.6-2.8-1.5c-1,0.1-2,0.9-2.3,1.7c-0.4,1,0.1,2,1.1,2.5c1.1,0.5,2.2,0.3,3.2-0.5
		c0.5-0.4,1-0.8,1.7-1.3C188,264.8,188.2,264.2,188.1,263.8z"
      />
      <path
        class="st3"
        d="M91.1,300.5c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1c0.2-0.2,0.3-0.4,0.4-0.6
		c-1.7-0.4-3.3-0.7-5-1.1v0.1c-0.1,0.6,0,1.2,0.5,1.7C90.3,300.2,90.7,300.4,91.1,300.5z"
      />
      <path
        class="st3"
        d="M90.6,296.7c1.4,0.3,2.8,0.6,4.2,0.9c-0.1-0.2-0.2-0.5-0.3-0.7l0,0c-0.6-0.8-1.9-1-3.1-0.6
		C91.1,296.5,90.9,296.6,90.6,296.7z"
      />
      <path
        class="st3"
        d="M1.2,311c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1c0.1-0.4,0.2-0.7,0.1-1.1c0-0.1-0.1-0.3-0.1-0.4
		c-0.3-0.6-0.8-1-1.4-1.1v1.1v1.5v0.8v0.7c0.1-0.1,0.3-0.1,0.4-0.2C0.7,311.5,1,311.3,1.2,311z"
      />
      <path
        class="st3"
        d="M90.7,314.2c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.6-1.5-1.3-1.9-2.8-1.6
		c-0.3,0.1-0.6,0.2-1,0.4c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9
		c0.8,0.3,1.6,0.1,2.9-0.8c1.3,1,1.8,1.1,2.6,0.6C90.9,315.5,91.1,314.8,90.7,314.2z"
      />
      <path
        class="st3"
        d="M273.6,247.1c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.1-0.3-0.2-0.6-0.4-0.9c0,0,0,0-0.1,0
		c-1.6,0.7-3.1,1.5-4.5,2.3c0.3,0.6,1,1.1,1.8,1.2c0.3,0,0.7,0,1,0c0.2,0,0.5-0.1,0.7-0.2C272.9,248.2,273.4,247.7,273.6,247.1z"
      />
      <path
        class="st3"
        d="M270.5,244.5c-0.8,0.2-1.5,0.8-1.8,1.4c0.8-0.5,1.6-1,2.4-1.5c-0.2,0-0.3,0-0.5,0
		C270.6,244.5,270.5,244.5,270.5,244.5z"
      />
      <path
        class="st3"
        d="M4.5,310.9c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.7-0.7,1.2
		c-0.1,0.2-0.1,0.5,0,0.7c0,0.1,0,0.1,0.1,0.2c0.2,0.8,1,1.3,2,1.4c0.3,0,0.6,0,0.9,0c0.5-0.1,0.9-0.3,1.2-0.5
		c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0.7-1,0.6-1.5c0-0.1,0-0.2,0-0.3C7.2,311.3,5.9,310.6,4.5,310.9z"
      />
      <path
        class="st3"
        d="M88.4,294.6c-0.4-1.1-2.4-1.5-3.5-0.7c-0.4,0.3-0.7,0.9-0.8,1.5c2,0.4,4,0.9,6.1,1.3c0-0.1,0.1-0.2,0.1-0.3
		c-0.6-0.2-1.1-0.3-1.6-0.4C88.6,295.4,88.5,295,88.4,294.6z"
      />
      <path
        class="st3"
        d="M249.4,264.9c0.1-0.2,0.2-0.4,0.4-0.6c0.1-0.3,0.3-0.5,0.4-0.8c-0.2,0-0.4-0.1-0.6-0.1l0.1-0.1
		c0.2,0,0.4,0,0.7,0c0-0.1,0.1-0.1,0.1-0.2V263c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C248.8,265.6,249.1,265.4,249.4,264.9z"
      />
      <path
        class="st3"
        d="M207.3,269c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.9,0.1-1.4,0.6-2,1.2c0.2,0.5,0.3,0.9,0.5,1.3s0.4,0.8,0.7,1.2c0.2,0.3,0.6,0.5,0.9,0.5C206.1,270.6,207.6,269.4,207.3,269z"
      />
      <path
        class="st3"
        d="M108,311.7c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3c0.3,1.1,1.5,1.6,2.8,1.3
		c1.2-0.3,1.9-1.3,1.7-2.3C108.2,312.2,108.1,311.9,108,311.7z"
      />
      <path
        class="st3"
        d="M251.2,281.8c0.1-0.1,0.2-0.1,0.3-0.2c0.6-0.5,0.8-1.2,0.6-1.8c-0.1-0.4-0.4-0.7-0.9-0.9
		c-1.2-0.3-2.6,0.3-3.2,1.2c0.1,0.9,0.2,1.8,0.3,2.7c0.5-0.1,1-0.2,1.4-0.3C250.2,282.3,250.8,282.1,251.2,281.8z"
      />
      <path
        class="st3"
        d="M10.3,306c-0.4-0.2-1-0.3-1.5-0.2c-1.3,0.2-2.1,1.3-1.9,2.4c0.2,1,1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8
		s0.5-0.9,0.4-1.4C11.3,306.8,10.9,306.3,10.3,306z"
      />
      <path
        class="st3"
        d="M278.3,268.5c0.2,0,0.5,0,0.7,0c0-0.4-0.1-0.6-0.2-0.9c-0.1,0-0.3,0-0.4,0c-2-0.1-2.2-0.2-1.9-1.6
		c-0.1,0-0.3,0-0.4,0c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C277.5,268.5,277.9,268.5,278.3,268.5z"
      />
      <path
        class="st3"
        d="M3.4,306.5c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C1.2,306.2,2.3,306.7,3.4,306.5z"
      />
      <path
        class="st3"
        d="M200.3,264.3c0,0.1-0.1,0.2,0,0.3c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.4,0.6,0.8,1.3,0.5c0.6-0.2,0.6-0.6,0.5-1.1
		c0-0.4-0.2-0.9,0-1.2c1.3-1.5,0.5-2.6-0.5-3.7C200.6,261.5,199.4,262.6,200.3,264.3z"
      />
      <path
        class="st3"
        d="M15,301.8L15,301.8v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9c0.2,0.2,0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C15.2,303,15.3,302.3,15,301.8z"
      />
      <path
        class="st3"
        d="M164.9,303.8c-0.9,0.2-1.5,0.9-1.7,1.6c0.3,0.6,0.6,1.1,0.9,1.7c0.5,0.2,1,0.3,1.6,0.1c1.2-0.3,2-1.4,1.7-2.3
		C167.2,304.1,166,303.5,164.9,303.8z"
      />
      <path
        class="st3"
        d="M295,250.9c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4c0.4,0.7,1.2,1.2,2.1,1h0.1
		c0.5-0.1,1-0.4,1.3-0.7c0.4-0.4,0.6-0.9,0.5-1.5C297.2,251.3,296.2,250.7,295,250.9z"
      />
      <path
        class="st3"
        d="M256.8,249.9c-0.1-0.1-0.2-0.2-0.3-0.4c-0.3-0.3-0.6-0.5-1-0.7c-0.1,0-0.2-0.1-0.3-0.1l0,0
		c0.7,0.6,1.3,1.1,2,1.7c0.1,0,0.1-0.1,0.2-0.1C257.1,250.2,257,250.1,256.8,249.9C256.9,249.9,256.9,249.9,256.8,249.9z"
      />
      <path
        class="st3"
        d="M256.5,252.1c-0.1,0.1-0.2,0.2-0.3,0.3l0,0C256.4,252.3,256.5,252.2,256.5,252.1
		C256.6,252.1,256.5,252.1,256.5,252.1z"
      />
      <path
        class="st3"
        d="M253.7,250c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0,0.2,0,0.4,0
		c0.4-0.3,0.7-0.7,1.1-1.1c-0.7-0.6-1.4-1.2-2-1.7C253.9,249.8,253.8,249.9,253.7,250z"
      />
      <path
        class="st3"
        d="M195,250.8c0.2,0,0.4,0.1,0.5,0.2l0,0c0.3,0.2,0.5,0.3,0.7,0.3s0.4-0.2,0.7-0.8c-0.1-0.1-0.2-0.1-0.3-0.2l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-1.3,0.3-1.8-0.5-2.2c-0.9-0.5-1.8-0.2-2.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		C192.4,250.3,192.7,250.7,195,250.8z"
      />
      <path
        class="st3"
        d="M282.8,248.7c-0.2-0.2-0.5-0.4-0.9-0.5c-0.2-0.1-0.5-0.1-0.9-0.1c0.8,0.5,1.6,0.9,2.2,1
		C283.1,248.9,283,248.8,282.8,248.7z"
      />
      <path
        class="st3"
        d="M282.9,250.9c-1,0.1-1.5,0.3-1.8,1.1C281.7,251.6,282.3,251.3,282.9,250.9z"
      />
      <path
        class="st3"
        d="M248.9,243.5c-0.2-0.7-0.4-1.4-0.7-2c0-0.1-0.1-0.2-0.1-0.2c-0.2-0.4-0.6-0.8-1.2-0.7c-0.1,0-0.1,0-0.2,0
		c-0.2,0.2-0.4,0.4-0.5,0.6C247.1,241.9,248,242.7,248.9,243.5z"
      />
      <path
        class="st3"
        d="M247.6,244.6l0.1-0.1c-0.7-0.6-1.5-1.3-2.2-1.9c-0.1,0.3-0.2,0.6-0.3,0.8c-0.2,0.6,0.3,1,0.9,1.4
		C246.6,245.1,247.1,244.9,247.6,244.6z"
      />
      <path
        class="st3"
        d="M260.3,256.9h0.1c0.5-0.1,0.9-0.5,1.2-0.9c0.3-0.4,0.4-0.8,0.3-1.1l0,0c-0.1-0.8-0.9-1.2-1.9-1.2
		c-0.7,0.7-1.5,1.3-2.2,2c0,0.1,0.1,0.3,0.2,0.4C258.5,256.8,259.4,257.2,260.3,256.9z"
      />
      <path
        class="st3"
        d="M244.6,254.5c0.3,0.3,0.6,0.5,1,0.7c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2h0.1
		c0.6-0.2,1.1-0.3,1.7-0.4c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1c-0.5-1-0.6-1.1-1.5-1.3
		c0,0,0,0-0.1,0s-0.2,0-0.4-0.1c-0.3,0-0.5-0.2-0.7-0.3c-0.7-0.6-1.3-0.3-2,0.1c0.1,0.5,0.3,1,0.6,1.4
		C244.5,254.3,244.5,254.4,244.6,254.5z"
      />
      <path
        class="st3"
        d="M41.2,332.3c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C43.3,332.5,42.3,332.1,41.2,332.3z"
      />
      <path
        class="st3"
        d="M36.6,338.3c-0.8,0.1-1.4,0.6-1.6,1.1h3.7C38.6,338.7,37.6,338.1,36.6,338.3z"
      />
      <path
        class="st3"
        d="M140,276c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C141,276.6,140.6,276.2,140,276z"
      />
      <path
        class="st3"
        d="M21.1,304.9c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1c0.2,0,0.4,0,0.6-0.1
		c1.1-0.2,1.7-1,1.5-1.9C21.1,305,21.1,305,21.1,304.9z"
      />
      <path
        class="st3"
        d="M8.4,298.1c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C9.1,298.6,8.8,298.3,8.4,298.1z"
      />
      <path
        class="st3"
        d="M176.2,289.8c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C176.3,290.3,176.3,290.1,176.2,289.8L176.2,289.8z"
      />
      <path
        class="st3"
        d="M276.4,255.6c0.1,0.8,1,1.3,1.9,1.2c0.2-0.7,0.3-1.4,0.5-2.2c0-0.2,0.1-0.5,0.2-0.7c-0.4-0.1-0.8-0.2-1.1-0.1
		C276.9,254.1,276.3,254.9,276.4,255.6z"
      />
      <path
        class="st3"
        d="M222.3,276c-0.2,0.4-0.4,0.9-0.6,1.3c0.8,1.3,0.8,1.3,2.4,1.5c0.8,0.1,1.3-0.3,1.1-1c-0.1-0.4-0.5-0.8-0.4-1.1
		c0.4-0.8-0.1-1.1-0.5-1.5c-1.1,0.3-0.6,0.8-0.6,1.3c-0.4-0.2-0.8-0.4-1.2-0.6C222.4,275.9,222.3,275.9,222.3,276z"
      />
      <path
        class="st3"
        d="M220.6,301.1c-0.7,0.2-1.3,0.6-2,0.9c-0.1,0.4,0,0.7,0.1,1c0.2,0.4,0.5,0.8,1,1.1c0.9-0.4,1.6-0.8,2.3-1.1
		c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7C221.3,301,220.9,301,220.6,301.1z"
      />
      <path
        class="st3"
        d="M0.4,316.9c-0.1,0-0.3,0.1-0.4,0.2v2.6c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.5-1.1,1.3-1.8
		C2.3,317.1,1.3,316.6,0.4,316.9z"
      />
      <path
        class="st3"
        d="M272.9,264.7c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C272.2,264.3,272.5,264.6,272.9,264.7z"
      />
      <path
        class="st3"
        d="M286.4,288.1c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5
		c0.1,0.8,0.9,1.3,1.8,1.1C285.8,289.7,286.6,288.9,286.4,288.1z"
      />
      <path
        class="st3"
        d="M213,315.3c-0.5-0.1-1.1-0.1-1.6-0.1c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0
		c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C211.6,316.3,212.3,315.9,213,315.3z"
      />
      <path
        class="st3"
        d="M278.3,289.4c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C280,289.6,279.3,289.2,278.3,289.4z"
      />
      <path
        class="st3"
        d="M111.7,314.7c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C113.5,314.9,112.5,314.4,111.7,314.7z"
      />
      <path
        class="st3"
        d="M211.7,317.1c-0.8,0.2-1.3,0.9-1.2,1.6s1,1.2,1.9,1s1.4-1,1.3-1.7C213.4,317.2,212.6,316.8,211.7,317.1z"
      />
      <path
        class="st3"
        d="M238,255c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.3c0.3,0.1,0.6,0.1,0.9-0.1
		c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7c-0.5-0.5-1.3-0.6-1.9-0.1S237.6,254.5,238,255z"
      />
      <path
        class="st3"
        d="M11.8,295.3c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C10.1,295.1,10.9,295.5,11.8,295.3z"
      />
      <path
        class="st3"
        d="M0,336.6v2.4c0.1,0,0.3,0,0.4,0c0.8-0.2,1.4-0.9,1.2-1.5C1.5,337,0.7,336.5,0,336.6z"
      />
      <path
        class="st3"
        d="M1.5,325.5c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.1-0.6-0.2-0.9-0.2v0.7v1.6c0.1,0,0.2,0,0.3,0
		C1,326.8,1.6,326.1,1.5,325.5z"
      />
      <path
        class="st3"
        d="M259.6,257.5c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C260.4,257.5,260,257.4,259.6,257.5z"
      />
      <path
        class="st3"
        d="M17.8,336.9L17.8,336.9c-0.2,0.1-0.4,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3
		c0.6-0.2,1-0.4,1.2-0.7C18.4,338.3,18.4,337.7,17.8,336.9C17.9,336.9,17.8,336.9,17.8,336.9z"
      />
      <path
        class="st3"
        d="M278.4,285.7c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C277.6,287.2,278.2,286.7,278.4,285.7z"
      />
      <path
        class="st3"
        d="M286.7,292.4c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7c0.7-0.2,1.1-0.8,1-1.3
		C288.1,292.6,287.4,292.3,286.7,292.4z"
      />
      <path
        class="st3"
        d="M212.3,305.3c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0s0.5-0.2,0.7-0.4
		c0.3-0.2,0.4-0.6,0.3-0.9C213.6,305.5,213,305.2,212.3,305.3z"
      />
      <path
        class="st3"
        d="M16.4,311c0.2-0.5,0-0.9-0.5-1.1c-0.9-0.3-1.5,0.1-2,0.6c0,0.7,0.3,1.3,1.2,1.4
		C15.6,311.9,16.1,311.6,16.4,311z"
      />
      <path
        class="st3"
        d="M216.3,312.3c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		C217.1,312,216.7,312.1,216.3,312.3z"
      />
      <path
        class="st3"
        d="M183.3,274c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2C184.6,274.1,184,273.8,183.3,274z"
      />
      <path
        class="st3"
        d="M261.1,268.8C261.1,268.8,261,268.8,261.1,268.8c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.8,0.1,1.3
		c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7c-0.2-0.3-0.3-0.4-0.4-0.6C262.7,268.7,261.8,268.5,261.1,268.8z"
      />
      <path
        class="st3"
        d="M283.4,266.2L283.4,266.2c0-0.1,0-0.2,0-0.3c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2
		c-0.2-0.1-0.5-0.1-0.7,0c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.1-0.1,0.2-0.1,0.3C281.8,266.1,282.6,266.1,283.4,266.2z"
      />
      <path
        class="st3"
        d="M158,309.3c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C159.4,309.5,158.6,309.2,158,309.3z"
      />
      <path
        class="st3"
        d="M197,265.8c-0.4,0.5-0.7,1.1-1.1,1.6c-0.2,0-0.4,0.1-0.5,0.1c0.4,0.2,0.7,0.5,1.1,0.7c0.4-0.4,0.8-0.8,1.1-1.3
		C197.9,266.4,197.9,266,197,265.8z"
      />
      <path
        class="st3"
        d="M217,271.1c0.8,0.9,0.9,0.9,2.2,0.5c-0.1-0.1-0.1-0.2-0.2-0.4c-0.4-0.8-0.9-1.5-0.9-2.3c0-0.2-0.4-0.4-0.7-0.7
		c0.2,1.3,0.2,1.3-0.6,2.6C216.9,271,217,271.1,217,271.1z"
      />
      <path
        class="st3"
        d="M86,319.5c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.6,0.1-1.1,0.7-1,1.2
		C84.6,319.3,85.2,319.7,86,319.5z"
      />
      <path
        class="st3"
        d="M304.3,287c0.1,0.5,0.8,0.8,1.4,0.7c0.4-0.1,0.7-0.3,0.8-0.5v-0.7c-0.7,0-1.5-0.1-2.2-0.1
		C304.3,286.7,304.2,286.8,304.3,287z"
      />
      <path
        class="st3"
        d="M305.4,285.7c-0.3,0.1-0.5,0.2-0.7,0.4c0.6,0,1.3,0,1.9,0.1v-0.1C306.3,285.8,305.9,285.6,305.4,285.7z"
      />
      <path
        class="st3"
        d="M212.8,269.8c0-0.1-0.6-0.1-0.9-0.1c-0.2,0.7-0.3,1.5,0.6,1.9c0.3-0.2,0.7-0.5,0.8-0.4c0.8,0.5,1-0.1,1.1-0.5
		c0.1-0.3-0.1-0.6-0.1-0.8C213.7,269.8,213.1,270.6,212.8,269.8z"
      />
      <path
        class="st3"
        d="M189.7,248.8c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C190.8,248,190.2,248.5,189.7,248.8z"
      />
      <path
        class="st3"
        d="M233.7,285.4c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C234.5,285.2,233.9,285.2,233.7,285.4z"
      />
      <path
        class="st3"
        d="M231,273c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0c1.1-0.8,0.5-1.3,0-1.8C232.1,272.2,231.3,272.2,231,273z"
      />
      <path
        class="st3"
        d="M88,309.4c0.4,0.7,1,0.8,1.7,0.5c0.3-0.1,0.5-0.2,0.6-0.4c0.4-0.3,0.6-0.8,0.5-1.5c-0.5,0.2-0.9,0.3-1.3,0.5
		c-0.3,0.1-0.5,0.2-0.8,0.4C88.5,309,88.2,309.2,88,309.4L88,309.4z"
      />
      <path
        class="st3"
        d="M167.9,301.1c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C167.1,302,167.5,301.6,167.9,301.1z"
      />
      <path
        class="st3"
        d="M248.7,321.1c0.2,0.8,0.6,1.5,0.8,2.3c0.1-0.7,0.1-1.4,0.2-2.1c-0.4-0.2-0.7-0.5-1.1-0.8
		C248.7,320.8,248.7,320.9,248.7,321.1z"
      />
      <path
        class="st3"
        d="M249.9,319.6v-0.1c0,0-0.1,0-0.1,0.1C249.8,319.6,249.9,319.6,249.9,319.6z"
      />
      <path
        class="st3"
        d="M229.3,273.8c0.1-0.3,0-0.6,0-0.9s0.1-0.7,0.2-1.1c-0.5,0-0.9,0-1.3-0.1c0.1-0.2,0.2-0.4,0.5-0.8
		c-0.5,0.2-0.8,0.3-1.1,0.4l0,0l0,0C227.8,272.3,228.4,273.1,229.3,273.8z"
      />
      <path
        class="st3"
        d="M201.4,259.6c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7c-0.2,0.4-0.1,0.8,0.3,0.9
		c0.4,0.1,0.9,0,1.3-0.2C201.2,260.4,201.2,260,201.4,259.6z"
      />
      <path
        class="st3"
        d="M203.5,243.3c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C202.1,243,202.1,243,203.5,243.3z"
      />
      <path
        class="st3"
        d="M74.7,326.9c1-0.6,1.8-1.1,2.7-1.6C75.7,324.7,75.2,325,74.7,326.9z"
      />
      <path
        class="st3"
        d="M27.9,336.7c1.5-0.5,1.7-0.8,1.2-1.9C27.9,335.5,27.9,335.5,27.9,336.7z"
      />
      <path
        class="st3"
        d="M210.3,268.2c-0.1,0.1-0.3,0.4-0.2,0.5c0.1,0.8,0.7,1.1,1.8,0.9c-0.2-0.5-0.5-1-0.8-1.5
		C211,268.1,210.5,268.1,210.3,268.2z"
      />
      <path
        class="st3"
        d="M215.8,294.9c0,0.5,0.5,0.8,1.1,0.7c0.6-0.1,0.9-0.4,0.9-0.8c0-0.6-0.5-0.9-1.1-0.8
		C216.1,294.1,215.8,294.4,215.8,294.9z"
      />
      <path
        class="st3"
        d="M217.8,278.3c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C218.3,279.3,218.2,278.7,217.8,278.3z"
      />
      <path
        class="st3"
        d="M251.6,283.2c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C251.8,283.1,251.7,283.1,251.6,283.2z"
      />
      <path
        class="st3"
        d="M232.2,298.2c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C233.2,298.8,232.7,298.6,232.2,298.2z"
      />
      <path
        class="st3"
        d="M227.4,273c-0.2-0.1-0.4-0.2-0.6-0.2c-0.5-0.2-0.9-0.3-1.4-0.5c-0.1,0-0.5,0.3-0.5,0.4
		c0.1,0.2,0.3,0.4,0.5,0.5l0,0c0.5,0.2,1.1,0.4,1.8,0.6C227.6,273.6,227.8,273.2,227.4,273z"
      />
      <path
        class="st3"
        d="M194.1,254.9L194.1,254.9c-0.2-0.2-0.5-0.3-0.7-0.3h-0.1c-0.3,0.1-0.6,0.5-0.6,0.7c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5C194.5,255.5,194.3,255.2,194.1,254.9z"
      />
      <path
        class="st3"
        d="M137.6,283.5c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C139,283.2,138.3,283.2,137.6,283.5z"
      />
      <path
        class="st3"
        d="M233.5,279.8c1,0.3,1.1,1.7,2.7,1.1c-0.3-0.5-0.6-1-0.9-1.5C234.7,279.5,234.2,279.6,233.5,279.8z"
      />
      <path
        class="st3"
        d="M116,310c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6s0.9-0.5,0.8-0.9C117,310.1,116.4,309.8,116,310z"
      />
      <path
        class="st3"
        d="M30.2,303.1c-0.1-0.1-0.3-0.3-0.5-0.3c-0.1,0-0.3-0.1-0.4-0.1c-0.5,0-1,0.5-0.7,0.9c0.1,0.2,0.3,0.3,0.4,0.4
		s0.3,0.2,0.4,0.2C30.2,303.8,30.5,303.5,30.2,303.1z"
      />
      <path
        class="st3"
        d="M152.8,304.1c-0.3,0.2-0.7,0.6-0.6,0.8c0.1,0.2,0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C153.9,304.2,153.3,303.9,152.8,304.1z"
      />
      <path
        class="st3"
        d="M288.8,277c0.1,0,0.1,0,0.1,0c0.1,0,0.2,0,0.4,0c-0.2-0.3-0.3-0.6-0.4-0.8C288.8,276.5,288.8,276.8,288.8,277z
		"
      />
      <path
        class="st3"
        d="M287.2,275.8l0.1,0.1c0-0.1,0-0.1,0-0.2C287.3,275.8,287.3,275.8,287.2,275.8z"
      />
      <path
        class="st3"
        d="M74.5,317c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C74.4,317.1,74.4,317.1,74.5,317z"
      />
      <path
        class="st3"
        d="M220.2,272.1c0.6,0.4-0.4,1.3,0.6,1.6h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2
		C221.7,272.8,221.5,272.4,220.2,272.1z"
      />
      <path
        class="st3"
        d="M235.4,282.1c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C236.5,283.1,236.1,282.6,235.4,282.1z"
      />
      <path
        class="st3"
        d="M232.2,277.6c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.6,0.2,0.9,0.5,1.2c0.1,0.1,0.5,0.1,0.7,0c0,0,0,0,0.1,0
		s0.2-0.4,0.2-0.5C233.1,278.5,232.7,278.2,232.2,277.6z"
      />
      <path
        class="st3"
        d="M240.4,263.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.6,0.4,1.4,1.5,1.4l0,0c0,0,0,0,0.1,0l0,0
		C241.1,264.2,240,263.8,240.4,263.3z"
      />
      <path
        class="st3"
        d="M204.9,253.5c0.1,0,0.3,0,0.4-0.1c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		C204.3,253.2,204.4,253.5,204.9,253.5z"
      />
      <path
        class="st3"
        d="M251.6,275c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C250.9,274.8,251.5,275.1,251.6,275z"
      />
      <path
        class="st3"
        d="M249.1,234.8c-0.3,0.4-0.6,0.8-0.8,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.6-0.3,1.3-0.5,2-0.9
		C250,235.1,249.7,235,249.1,234.8z"
      />
      <path
        class="st3"
        d="M78.6,331.5c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C79.3,331.7,78.9,331.6,78.6,331.5z"
      />
      <path
        class="st3"
        d="M305,230.2c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C305.8,230.3,305.5,230,305,230.2z"
      />
      <path
        class="st3"
        d="M206,250.9c1.1,0.7,1.1,0.7,1.8-0.1C207.1,250.7,206.7,250,206,250.9z"
      />
      <path
        class="st3"
        d="M79.2,325.7c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C78.7,326.1,79.2,325.9,79.2,325.7z"
      />
      <path
        class="st3"
        d="M206.6,245c0.7-0.4,0.4-1,0.4-1.5C205.9,244,205.8,244.1,206.6,245z"
      />
      <path
        class="st3"
        d="M250.8,243.9c0.5-0.7,1.5-1.2,1.2-2.5C251.2,242.3,250.8,243,250.8,243.9z"
      />
      <path
        class="st3"
        d="M227.1,279.9c-0.3,0.3-0.5,0.5-0.7,0.8c0.3,0.1,0.6,0.4,0.8,0.3c0.3-0.1,0.5-0.4,0.6-0.7
		C227.8,280.2,227.4,280,227.1,279.9z"
      />
      <path
        class="st3"
        d="M233.3,245.2c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C233.8,245.4,233.6,245.3,233.3,245.2z"
      />
      <path
        class="st3"
        d="M241.7,258c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C242.5,257.3,242.1,257.6,241.7,258z"
      />
      <path
        class="st3"
        d="M46.1,327.4c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C46.7,327.5,46.4,327.4,46.1,327.4z"
      />
      <path
        class="st3"
        d="M12,327.3c0.7-0.7,0.8-1.2,0.2-1.9C11.4,326,11.5,326.5,12,327.3z"
      />
      <path
        class="st3"
        d="M225.8,289.4L225.8,289.4L225.8,289.4C225.7,289.4,225.7,289.4,225.8,289.4c-0.1,0.4,0,0.7,0.1,1
		c0.1,0.2,0.3,0.4,0.7,0.5c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.1-0.5,0-0.7C226.6,289.6,226.3,289.5,225.8,289.4z"
      />
      <path
        class="st3"
        d="M188.9,268.5c1.3-0.8,0.1-1.1,0.1-1.7C187.7,267.6,188.9,267.9,188.9,268.5z"
      />
      <path
        class="st3"
        d="M277.4,272.8c0.5,0.4,0.3,1.1,1.3,1.3C278.6,272.8,278.6,272.8,277.4,272.8z"
      />
      <path
        class="st3"
        d="M258.2,277.8c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C258.8,277.4,258.6,277.5,258.2,277.8z"
      />
      <path
        class="st3"
        d="M228.7,241.9c-0.5,0.4-0.8,0.6-1.2,0.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C229.2,243.1,228.9,242.6,228.7,241.9z"
      />
      <path
        class="st3"
        d="M90.4,317.2c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C91.6,316.4,91,316.8,90.4,317.2z"
      />
      <path
        class="st3"
        d="M248.7,245.3c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C249.2,246.1,248.8,245.7,248.7,245.3z"
      />
      <path
        class="st3"
        d="M256.1,286c0.1,0.8,0.1,0.8,0.9,1.3C256.9,286.8,256.9,286.3,256.1,286z"
      />
      <path
        class="st3"
        d="M205.7,321.1c0,0.7,0.2,1.1,1,1.7C206.8,321.8,206.6,321.4,205.7,321.1z"
      />
      <path
        class="st3"
        d="M230.9,244.3c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C231.5,244.1,231.2,244.2,230.9,244.3
		L230.9,244.3z"
      />
      <path
        class="st3"
        d="M212.2,287c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C212.8,287.4,212.5,287.3,212.2,287z"
      />
      <path
        class="st3"
        d="M81.9,328.6c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C82.2,328.1,82.1,328.4,81.9,328.6z"
      />
      <path
        class="st3"
        d="M288.1,270.3c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0.1,0.1,0.2,0.1C288.1,270.6,288.1,270.5,288.1,270.3z"
      />
      <path
        class="st3"
        d="M251.7,261c0.1-0.2,0.2-0.3,0.3-0.5c-0.2-0.3-0.4-0.5-1-0.5C251.1,260.4,251.2,260.7,251.7,261z"
      />
      <path
        class="st3"
        d="M233.4,274.1c0.4,0.3,0.8,0.5,1.2,0.8c0.1-0.1,0.2-0.2,0.3-0.4C234.7,274,234.3,273.8,233.4,274.1z"
      />
      <path
        class="st3"
        d="M47.2,337.8c0.2-0.5,0.4-1,0.7-1.6C46.8,337,46.8,337,47.2,337.8z"
      />
      <path
        class="st3"
        d="M273.2,251.3c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C272.8,251.8,273,251.5,273.2,251.3z"
      />
      <path
        class="st3"
        d="M215.4,272c0.1,1,0.1,1.2,0.7,1.3c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6
		C216,272.7,215.7,272.4,215.4,272z"
      />
      <path
        class="st3"
        d="M241.3,246.6c0.1,0.1,0.2,0.2,0.3,0.2s0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.6c0.1-0.1-0.2-0.3-0.3-0.5
		c-0.3,0.3-0.5,0.6-0.8,0.8C241.4,246.5,241.3,246.5,241.3,246.6z"
      />
      <path
        class="st3"
        d="M241.3,236.2c0-0.2-0.4-0.3-0.7-0.5c-0.1,0.2-0.2,0.3-0.3,0.4c0.2,0.2,0.4,0.4,0.6,0.5
		C241.1,236.5,241.3,236.3,241.3,236.2z"
      />
      <path
        class="st3"
        d="M31.9,302.5c-0.4-0.2-0.7-0.3-1-0.4c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.1,0.2,0.4,0.3,0.7,0.3C31.4,303.1,31.6,302.8,31.9,302.5z"
      />
      <path
        class="st3"
        d="M74.6,328.9c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C75.2,329,74.9,328.8,74.6,328.9z"
      />
      <path
        class="st3"
        d="M16.8,301c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2
		C16.5,301.3,16.6,301.2,16.8,301z"
      />
      <path
        class="st3"
        d="M29.3,322.4c0.8-0.2,0.9-0.5,0.6-1.2C29.4,321.5,29,321.8,29.3,322.4z"
      />
      <path
        class="st3"
        d="M208.6,255.1c0-0.3,0.1-0.6,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c-0.2,0-0.4,0.1-0.6,0.1
		C208.2,254.3,208.2,254.3,208.6,255.1z"
      />
      <path
        class="st3"
        d="M210,276c0.1-0.4,0.2-0.8,0.4-1.1c-0.2,0-0.4,0-0.6-0.1c-0.1,0.4-0.1,0.8-0.2,1.2C209.8,276,209.9,276,210,276
		z"
      />
      <path
        class="st3"
        d="M233,295.9c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.4,0.7,1,1.1c0-0.2,0-0.3-0.1-0.4C233.9,296.4,233.6,296,233,295.9z"
      />
      <path
        class="st3"
        d="M89.7,320.7c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C90.2,321.1,89.9,321,89.7,320.7z"
      />
      <path
        class="st3"
        d="M182.3,281.1c0.6-0.2,1.1-0.5,0.7-1.3C182.7,280.4,182.5,280.8,182.3,281.1z"
      />
      <path
        class="st3"
        d="M203.2,239.7c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C202.9,238.8,203,239.2,203.2,239.7z"
      />
      <path
        class="st3"
        d="M202.2,241.2c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C201.6,241.9,202.1,241.9,202.2,241.2z"
      />
      <path
        class="st3"
        d="M193.1,252c0.7,0.2,1.1,0.3,1.8,0.5C194.4,251.8,194,251.6,193.1,252z"
      />
      <path
        class="st3"
        d="M184.2,259c0.4,0.2,0.8,0.4,1.5,0.8C185.3,259,184.9,258.9,184.2,259z"
      />
      <path
        class="st3"
        d="M213.5,289.7c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C213.6,289,213.6,289.4,213.5,289.7z"
      />
      <path
        class="st3"
        d="M253.2,254c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0,0.2,0,0.4,0C253.2,254.3,253.2,254.2,253.2,254
		C253.3,254.1,253.2,254,253.2,254z"
      />
      <path
        class="st3"
        d="M14,312.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0,0,0.1-0.1,0.2-0.2l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C14.2,312.4,14.1,312.3,14,312.2z"
      />
      <path
        class="st3"
        d="M180.2,288.2c0.3-0.5,0.4-0.8,0.6-1.1C180.3,287.3,179.8,287.6,180.2,288.2z"
      />
      <path
        class="st3"
        d="M195.5,252.6c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C195.4,252.7,195.4,252.6,195.5,252.6z"
      />
      <path
        class="st3"
        d="M292.2,237.8L292.2,237.8c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C292.8,237.7,292.4,237.5,292.2,237.8z"
      />
      <path
        class="st3"
        d="M216.3,275.7c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.2,0.7-0.7
		C216.7,275.7,216.5,275.7,216.3,275.7z"
      />
      <path
        class="st3"
        d="M44.9,320.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C45.3,320.4,45,320.3,44.9,320.3z"
      />
      <path
        class="st3"
        d="M31,337.8c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9c-0.1-0.1-0.1-0.1-0.2-0.2
		C31.6,337.2,31.3,337.5,31,337.8z"
      />
      <path
        class="st3"
        d="M254.1,255.9c-0.2,0.5,0,0.7,0.4,0.9h0.1c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1,0-0.1,0-0.2
		C254.8,256.1,254.5,256,254.1,255.9z"
      />
      <path
        class="st3"
        d="M289.3,255.3c0.2,0.3,0.4,0.5,0.5,0.8c-0.1-0.4-0.3-0.8,0.3-0.9l0,0c-0.2,0-0.4,0-0.8-0.1
		C289.3,255.2,289.3,255.3,289.3,255.3z"
      />
      <path
        class="st3"
        d="M78,319.6c0.3,0.1,0.5,0.3,0.7,0.2c0.2-0.1,0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3
		C78.3,319.1,78.2,319.3,78,319.6z"
      />
      <path
        class="st3"
        d="M67.5,323.4c-0.3-0.3-0.5-0.5-0.7-0.7C66.5,323.5,66.5,323.5,67.5,323.4z"
      />
      <path
        class="st3"
        d="M272.4,265.2C272.4,265.2,272.4,265.1,272.4,265.2c-0.2,0-0.3,0-0.3,0.1l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0
		c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1l0,0C272.7,265.6,272.6,265.4,272.4,265.2z"
      />
      <path
        class="st3"
        d="M92.5,292.2c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C92.4,292.5,92.6,292.4,92.5,292.2z"
      />
      <path
        class="st3"
        d="M221.5,311.5c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C221.8,311.2,221.7,311.4,221.5,311.5z"
      />
      <path
        class="st3"
        d="M36.9,306.1c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.3,0.3c0.2,0.1,0.3,0.2,0.5,0.2
		C36.6,306.4,36.7,306.2,36.9,306.1z"
      />
      <path
        class="st3"
        d="M82.6,334.5c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C83.1,334.6,82.8,334.6,82.6,334.5z"
      />
      <path
        class="st3"
        d="M203.8,250.1c0.1,0.2,0.1,0.4,0.2,0.6c1.1-0.9,1.1-0.9,0.5-1.4c-0.1,0.2-0.3,0.3-0.4,0.5l0,0l0,0
		c-0.2,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8C203.6,250.3,203.7,250.2,203.8,250.1L203.8,250.1L203.8,250.1z"
      />
      <path
        class="st3"
        d="M205.5,242.9l0.2,0.1c0.1-0.1,0.3-0.3,0.4-0.4c-0.2-0.1-0.3-0.1-0.4-0.2C205.6,242.6,205.5,242.7,205.5,242.9z
		"
      />
      <path
        class="st3"
        d="M252.5,256.9c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C253,256.5,252.8,256.7,252.5,256.9z"
      />
      <path
        class="st3"
        d="M93.1,317.8c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C93.2,317.5,93,317.7,93.1,317.8z"
      />
      <path
        class="st3"
        d="M245.7,240.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0-0.2,0.1-0.3,0.2-0.7
		C246.4,240.1,246.1,240.3,245.7,240.5z"
      />
      <path
        class="st3"
        d="M10.4,296.3c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C10.1,296.1,10.2,296.2,10.4,296.3z"
      />
      <path
        class="st3"
        d="M200.4,278.3c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C200.5,277.8,200.5,278,200.4,278.3z"
      />
      <path
        class="st3"
        d="M299.5,272.4c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C299.9,272.5,299.6,272.5,299.5,272.4z"
      />
      <path
        class="st3"
        d="M209.6,270.2c0,0.1,0.1,0.3,0.2,0.4c0.1-0.2,0.2-0.4,0.2-0.6c-0.1,0-0.2,0-0.3,0
		C209.7,270.1,209.6,270.2,209.6,270.2z"
      />
      <path
        class="st3"
        d="M238,245.5c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0
		c0.2,0,0.4-0.2,0.5-0.5C238,245.7,238,245.6,238,245.5z"
      />
      <path
        class="st3"
        d="M234.6,247.2c0.3-0.1,0.6-0.2,0.9-0.3c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.2-0.6,0.3-0.9,0.5
		C234.6,247,234.6,247.1,234.6,247.2z"
      />
      <path
        class="st3"
        d="M305,237c0,0.3,0,0.6,0,0.9C305.4,237.6,305.5,237.3,305,237z"
      />
      <path
        class="st3"
        d="M304.9,238C305,238,305,238,304.9,238c0.1-0.1,0.1-0.1,0.1-0.1l0,0C304.9,237.9,304.9,238,304.9,238z"
      />
      <path
        class="st3"
        d="M25.4,329.8c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C25.5,329.7,25.5,329.7,25.4,329.8z"
      />
      <path
        class="st3"
        d="M245,249.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.3-0.2,0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		C245.3,249.4,245.1,249.5,245,249.5z"
      />
      <path
        class="st3"
        d="M199.4,251.4c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C199.7,251.5,199.5,251.4,199.4,251.4z"
      />
      <path
        class="st3"
        d="M83.6,317c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1C83.7,317.4,83.6,317.2,83.6,317z
		"
      />
      <path
        class="st3"
        d="M205.9,257.5c0.1,0.1,0.3,0.2,0.4,0.1c0.1,0,0.2-0.2,0.3-0.4c-0.2-0.1-0.4-0.1-0.5-0.1
		C206,257.2,205.8,257.4,205.9,257.5z"
      />
      <path
        class="st3"
        d="M265.8,245.8c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C265.9,245.9,265.8,245.9,265.8,245.8z"
      />
      <path
        class="st3"
        d="M265.3,246.4c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0S265.3,246.4,265.3,246.4z"
      />
      <path
        class="st3"
        d="M230,270.6c-0.1,0.1-0.3,0.2-0.3,0.3c0,0.1,0.2,0.2,0.4,0.3c0.1-0.2,0.2-0.3,0.1-0.4
		C230.3,270.6,230.1,270.5,230,270.6z"
      />
      <path
        class="st3"
        d="M201,330.8c0.2,0.2,0.4,0.4,0.6,0.6C201.6,331.1,201.9,330.8,201,330.8z"
      />
      <path
        class="st3"
        d="M201.6,331.4C201.6,331.4,201.6,331.5,201.6,331.4c0,0.1,0.1,0.1,0.1,0.1C201.7,331.5,201.6,331.5,201.6,331.4
		L201.6,331.4z"
      />
      <path
        class="st3"
        d="M92.6,301.5c0,0.1,0.2,0.1,0.4,0.1l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.4C92.7,301.3,92.5,301.4,92.6,301.5z"
      />
      <path
        class="st3"
        d="M229.1,314.4c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C229.2,314.2,229.1,314.3,229.1,314.4z"
      />
      <path
        class="st3"
        d="M303.4,235.4l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.2-0.1,0.3
		S303.2,235.4,303.4,235.4C303.3,235.3,303.3,235.4,303.4,235.4z"
      />
      <path
        class="st3"
        d="M213.5,279c0.1-0.1,0.2-0.2,0.2-0.3c-0.2,0-0.4,0-0.6-0.1C213.2,278.7,213.3,278.8,213.5,279
		C213.4,278.9,213.4,279,213.5,279z"
      />
      <path
        class="st3"
        d="M306,232.3c0,0,0.1,0,0.1-0.1v-0.5c-0.1,0-0.1,0-0.2,0s-0.2,0.2-0.3,0.3C305.8,232.2,305.9,232.3,306,232.3z"
      />
      <path
        class="st3"
        d="M204.2,256.7c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.4,0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1
		C204.3,256.3,204.2,256.5,204.2,256.7z"
      />
      <path
        class="st3"
        d="M202.1,269.1c0.2,0,0.3,0.1,0.5,0c0.1,0,0.2-0.2,0.5-0.4c-0.4,0-0.5,0-0.6,0.1
		C202.3,268.9,202.2,269,202.1,269.1z"
      />
      <path
        class="st3"
        d="M304.4,233c0,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5
		C304.4,232.7,304.4,232.9,304.4,233z"
      />
      <path
        class="st3"
        d="M204.9,280.7c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0
		C205,280.2,204.9,280.5,204.9,280.7z"
      />
      <path
        class="st3"
        d="M127,296.9c0.2,0.2,0.4,0.5,0.6,0.8C127.9,296.9,127.4,297,127,296.9z"
      />
      <path
        class="st3"
        d="M127,296.9C127,296.9,127,296.8,127,296.9c-0.1-0.1-0.1-0.1-0.1-0.1l0,0C127,296.9,127,296.9,127,296.9z"
      />
      <path
        class="st3"
        d="M183.9,283.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C184.1,283.5,184,283.4,183.9,283.3z"
      />
      <path
        class="st3"
        d="M30.2,310.7c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0-0.3,0C30.3,310.6,30.3,310.7,30.2,310.7z"
      />
      <path
        class="st3"
        d="M212.8,278c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C213,278,212.9,278,212.8,278z"
      />
      <path
        class="st3"
        d="M213.1,278.6C213.1,278.6,213,278.6,213.1,278.6c-0.1-0.1-0.1-0.1-0.1-0.1v0.1
		C213,278.6,213,278.6,213.1,278.6z"
      />
      <path
        class="st3"
        d="M244.2,260.5l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1h-0.1c-0.1,0-0.3,0-0.4,0
		C244.3,260.5,244.3,260.5,244.2,260.5z"
      />
      <path
        class="st3"
        d="M198.1,274.4l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C198.2,274.1,198.1,274.2,198.1,274.4z"
      />
      <path
        class="st3"
        d="M248.5,251.5c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4
		C248.8,251.6,248.5,251.5,248.5,251.5z"
      />
      <path
        class="st3"
        d="M90.9,312.1c-0.1,0-0.2-0.1-0.4-0.1l-0.1,0.2c0.1,0.1,0.2,0.1,0.4,0.2C90.8,312.4,90.9,312.3,90.9,312.1z"
      />
      <path
        class="st3"
        d="M203.7,241.2c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C203.9,241.3,203.8,241.3,203.7,241.2z"
      />
      <path
        class="st3"
        d="M238.7,290.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C238.8,290.4,238.7,290.5,238.7,290.6z"
      />
      <path
        class="st3"
        d="M58.7,312.1c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C58.9,312.1,58.8,312.1,58.7,312.1z"
      />
      <path
        class="st3"
        d="M58.7,312.5C58.6,312.5,58.6,312.5,58.7,312.5c-0.1,0.1-0.1,0.1-0.1,0.2h0.1C58.7,312.6,58.7,312.5,58.7,312.5
		z"
      />
      <path
        class="st3"
        d="M238.2,246.6C238.3,246.6,238.2,246.5,238.2,246.6c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1,0,0.2,0,0.3
		C237.9,246.8,238.1,246.7,238.2,246.6z"
      />
      <path
        class="st3"
        d="M297.4,236.1c0,0.1,0.1,0.3,0.1,0.5c0.1-0.2,0.1-0.3,0.1-0.4C297.6,236.1,297.5,236.1,297.4,236.1z"
      />
      <path
        class="st3"
        d="M129.9,335c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C130,335.1,130,335,129.9,335z"
      />
      <path
        class="st3"
        d="M108.7,277.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
		C108.9,277.1,108.8,277.2,108.7,277.3z"
      />
      <path
        class="st3"
        d="M67.2,310.8c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C67.2,310.6,67.2,310.7,67.2,310.8z"
      />
      <path
        class="st3"
        d="M205.7,256.9c0.1,0,0.2-0.1,0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C205.5,256.8,205.6,256.9,205.7,256.9z"
      />
      <path
        class="st3"
        d="M230.7,271.4c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.4,0.1
		C230.5,271.6,230.6,271.5,230.7,271.4z"
      />
      <path
        class="st3"
        d="M248.2,250.9c-0.6,0.2-0.8,0.3-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C247.6,251.4,247.8,251.3,248.2,250.9z"
      />
      <path
        class="st3"
        d="M292.5,256.1c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C292.6,256.2,292.5,256.2,292.5,256.1z"
      />
      <path
        class="st3"
        d="M304.8,238.5c0-0.2,0.1-0.4,0.1-0.5c-0.1,0.1-0.3,0.3-0.4,0.4C304.6,238.5,304.7,238.5,304.8,238.5z"
      />
      <path
        class="st3"
        d="M162.2,310.7C162.2,310.7,162.3,310.7,162.2,310.7c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C162.3,310.6,162.3,310.6,162.2,310.7z"
      />
      <path
        class="st3"
        d="M251.7,254.4c0.1-0.1,0.2-0.1,0.2-0.2l0,0c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.3,0.1-0.3,0.2
		c0,0,0,0.1,0.1,0.1C251.7,254.3,251.7,254.4,251.7,254.4z"
      />
      <path
        class="st3"
        d="M62.5,321c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C62.7,320.7,62.6,320.9,62.5,321z"
      />
      <path
        class="st3"
        d="M209.4,266.8c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
		C209.6,266.7,209.5,266.7,209.4,266.8z"
      />
      <path
        class="st3"
        d="M195.7,272.9c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C195.7,272.7,195.6,272.8,195.7,272.9z"
      />
      <path
        class="st3"
        d="M119.2,284.4c0.1,0,0.1-0.1,0.2-0.2v-0.1c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2-0.1l-0.1,0.1l0.1,0.1
		C119.1,284.3,119.1,284.3,119.2,284.4z"
      />
      <path
        class="st3"
        d="M297.9,255.5c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C298.1,255.5,298,255.5,297.9,255.5z"
      />
      <path
        class="st3"
        d="M291.9,256.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C292.1,257.1,292,257,291.9,256.9z"
      />
      <path
        class="st3"
        d="M293.7,282.7c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C293.8,282.4,293.8,282.6,293.7,282.7z"
      />
      <path
        class="st3"
        d="M248.9,266.1L248.9,266.1C248.8,266.2,248.9,266.2,248.9,266.1C248.9,266.2,248.9,266.1,248.9,266.1z"
      />
      <path
        class="st3"
        d="M249.2,240.3c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1C249.3,240.4,249.3,240.3,249.2,240.3z"
      />
      <path
        class="st3"
        d="M40,311.2c-0.1,0-0.2-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0S40,311.3,40,311.2z"
      />
      <path
        class="st3"
        d="M201.8,331.9c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C201.7,331.7,201.8,331.8,201.8,331.9z"
      />
      <path
        class="st3"
        d="M231.3,243.3C231.3,243.3,231.3,243.4,231.3,243.3c0,0.1,0.1,0.1,0.1,0.1v-0.1
		C231.4,243.3,231.3,243.3,231.3,243.3z"
      />
      <path
        class="st3"
        d="M227.9,243.9c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C227.8,243.8,227.9,243.9,227.9,243.9z"
      />
      <path
        class="st3"
        d="M228.3,243.6h0.1C228.4,243.5,228.4,243.5,228.3,243.6C228.3,243.5,228.3,243.5,228.3,243.6
		C228.3,243.5,228.3,243.6,228.3,243.6z"
      />
      <path
        class="st3"
        d="M242.3,240.3c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c0.1,0,0.2,0,0.3,0C242.2,240.5,242.3,240.4,242.3,240.3z"
      />
      <path
        class="st3"
        d="M259,241.3l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C259.2,241.3,259.1,241.3,259,241.3z"
      />
      <path
        class="st3"
        d="M253.5,236.3l0.1,0.1c0.1,0,0.1,0,0.2,0c-0.1,0-0.1-0.1-0.2-0.1H253.5z"
      />
      <path
        class="st3"
        d="M198,247.4c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C197.9,247.5,198,247.5,198,247.4
		C198,247.5,198,247.4,198,247.4z"
      />
      <path
        class="st3"
        d="M192.7,248.3c0,0,0.1,0.1,0.1,0.2l0,0l0,0C192.7,248.4,192.7,248.3,192.7,248.3z"
      />
      <path
        class="st3"
        d="M114.2,297c0.1,0,0.1,0.1,0.2,0.1s0.2-0.1,0.3-0.2l-0.1-0.1C114.4,296.8,114.3,296.9,114.2,297z"
      />
      <path
        class="st3"
        d="M10.7,316.2l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2L11,316C10.9,316.1,10.8,316.1,10.7,316.2z"
      />
      <path
        class="st3"
        d="M207,243.1v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C207.1,243.2,207,243.1,207,243.1z"
      />
      <path
        class="st3"
        d="M200.9,240.8l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C201.1,240.8,201,240.8,200.9,240.8z"
      />
      <path
        class="st3"
        d="M144.2,292.6l0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C144.4,292.5,144.3,292.6,144.2,292.6z"
      />
      <path
        class="st3"
        d="M121.9,297.8c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C121.9,297.8,121.8,297.8,121.9,297.8z"
      />
      <path
        class="st3"
        d="M204.3,310.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C204.4,310,204.3,310.1,204.3,310.1z"
      />
      <path
        class="st3"
        d="M181.3,285.9c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C181.3,285.8,181.3,285.8,181.3,285.9z"
      />
      <path
        class="st3"
        d="M226.1,277.6c0-0.1-0.1-0.3-0.1-0.4h-0.1c0,0.2,0,0.3,0.1,0.5C226,277.6,226,277.6,226.1,277.6z"
      />
      <path
        class="st3"
        d="M88.2,307.3c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2C88.4,307.4,88.2,307.3,88.2,307.3
		z"
      />
      <path
        class="st3"
        d="M236.1,275.7c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C236.1,275.5,236.1,275.6,236.1,275.7z"
      />
      <path
        class="st3"
        d="M254.4,259.7L254.4,259.7c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1C254.5,259.6,254.4,259.7,254.4,259.7z"
      />
      <path
        class="st3"
        d="M230.1,278.8C230.1,278.8,230,278.8,230.1,278.8c-0.1,0.1,0,0.1,0,0.2l0,0l0,0
		C230.1,278.9,230.1,278.8,230.1,278.8L230.1,278.8z"
      />
      <path
        class="st3"
        d="M240.2,262.1c0.1,0,0.2,0,0.3,0l0,0c0,0,0-0.1,0.1-0.1c-0.1,0-0.2,0-0.3,0C240.3,262,240.3,262,240.2,262.1
		C240.3,262,240.3,262.1,240.2,262.1z"
      />
      <path
        class="st3"
        d="M201.8,270.6c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C201.9,270.6,201.8,270.6,201.8,270.6z"
      />
      <path
        class="st3"
        d="M195.3,272.2c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C195.3,272,195.3,272.1,195.3,272.2z"
      />
      <path
        class="st3"
        d="M25.2,308.7c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C25.2,308.8,25.2,308.8,25.2,308.7z"
      />
      <path
        class="st3"
        d="M161.9,310.1c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C161.9,309.9,161.9,310,161.9,310.1z"
      />
      <path
        class="st3"
        d="M267.4,246.8C267.4,246.7,267.5,246.7,267.4,246.8C267.5,246.7,267.5,246.7,267.4,246.8
		C267.4,246.7,267.4,246.7,267.4,246.8z"
      />
      <path
        class="st3"
        d="M216.4,283.7c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0C216.4,283.8,216.4,283.7,216.4,283.7z"
      />
      <path
        class="st3"
        d="M243.1,252.7c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C243,252.6,243.1,252.7,243.1,252.7z"
      />
      <path
        class="st3"
        d="M238.2,289.9c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C238.3,289.7,238.2,289.8,238.2,289.9z"
      />
      <path
        class="st3"
        d="M222.6,282.8v-0.1h-0.1C222.5,282.7,222.5,282.7,222.6,282.8C222.5,282.8,222.5,282.8,222.6,282.8z"
      />
      <path
        class="st3"
        d="M223.1,283.4c-0.1,0-0.2,0-0.3,0c0.1,0,0.1,0,0.2,0C223,283.5,223,283.4,223.1,283.4z"
      />
      <path
        class="st3"
        d="M50.9,321.9L51,322c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0S50.9,321.9,50.9,321.9z"
      />
      <path
        class="st3"
        d="M198.5,264.1c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C198.6,264,198.5,264,198.5,264.1z"
      />
      <path
        class="st3"
        d="M251.5,252.6L251.5,252.6c0.1-0.1,0-0.1,0-0.1V252.6z"
      />
      <path
        class="st3"
        d="M52.8,296.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C52.7,296.5,52.8,296.5,52.8,296.5z"
      />
      <path
        class="st3"
        d="M274.1,248.3c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C274.2,248.2,274.1,248.2,274.1,248.3z"
      />
      <path
        class="st3"
        d="M274.5,248.6C274.5,248.5,274.4,248.5,274.5,248.6C274.4,248.5,274.4,248.6,274.5,248.6L274.5,248.6
		L274.5,248.6L274.5,248.6L274.5,248.6z"
      />
      <path
        class="st3"
        d="M243.2,255.2L243.2,255.2c0.2,0.1,0.4,0.1,0.6,0.1c0-0.1,0-0.1,0-0.2C243.5,255,243.4,255.1,243.2,255.2z"
      />
      <path
        class="st3"
        d="M279.7,272.9l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C279.9,272.9,279.8,272.9,279.7,272.9z"
      />
      <path
        class="st3"
        d="M268.4,250c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1L268.4,250z"
      />
      <path
        class="st3"
        d="M268.3,249.9c-0.4-0.2-0.9-0.5-1.3-0.7c-0.2-0.1-0.4-0.1-0.7-0.2c-1.1,0.7-2.1,1.4-3.1,2.1
		c0,0.3,0.1,0.6,0.2,0.8c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1c1.5-0.1,2.3-0.7,2.7-1.8c0-0.2,0.1-0.3,0.1-0.5
		C268,250.5,268.2,250.2,268.3,249.9C268.3,250,268.3,250,268.3,249.9C268.3,250,268.3,249.9,268.3,249.9L268.3,249.9z"
      />
      <path
        class="st3"
        d="M274.5,248.9c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C274.5,248.7,274.5,248.8,274.5,248.9z"
      />
      <path
        class="st3"
        d="M260.6,277.9h-0.1C260.5,277.9,260.5,277.9,260.6,277.9c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0.1,0v-0.1
		C260.9,278.1,260.8,278,260.6,277.9z"
      />
      <path
        class="st3"
        d="M261.2,278.5c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C261.1,278.3,261.2,278.4,261.2,278.5z"
      />
      <polygon class="st3" points="60.1,322.3 60.2,322.3 60.2,322.2 	" />
      <path
        class="st3"
        d="M204.5,265.7c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1
		C204.6,265.8,204.6,265.7,204.5,265.7z"
      />
      <path
        class="st3"
        d="M97.2,314c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C97.3,314.1,97.2,314.1,97.2,314
		C97.2,314.1,97.2,314,97.2,314z"
      />
      <path
        class="st3"
        d="M269.2,252l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C269.2,251.9,269.2,252,269.2,252z"
      />
      <path
        class="st3"
        d="M2,311.1L2,311.1C2.1,311.2,2.1,311.2,2,311.1L2,311.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1
		C2.1,311,2,311,2,311.1z"
      />
      <path
        class="st3"
        d="M89.6,292.3c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C89.7,292.4,89.6,292.4,89.6,292.3z"
      />
      <path
        class="st3"
        d="M25.3,303.4l-0.1-0.1c0,0.1,0,0.1,0,0.2C25.2,303.4,25.3,303.4,25.3,303.4z"
      />
      <path
        class="st3"
        d="M12.9,304.8L12.9,304.8L12.9,304.8c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C13,304.7,13,304.7,12.9,304.8z"
      />
      <path
        class="st3"
        d="M196.7,264.8v0.1V264.8c0.1,0,0.1-0.1,0.1-0.1C196.7,264.7,196.7,264.8,196.7,264.8z"
      />
      <path
        class="st3"
        d="M45.1,295.9c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2H45C45,296,45.1,296,45.1,295.9z"
      />
      <polygon class="st3" points="246.1,260.6 245.9,260.5 245.9,260.6 	" />
      <polygon class="st3" points="193.5,261.6 193.6,261.6 193.5,261.5 	" />
      <path
        class="st3"
        d="M272.4,243.7c0.1-0.1,0.1-0.1,0.2-0.2l0,0C272.4,243.5,272.3,243.6,272.4,243.7
		C272.3,243.7,272.3,243.7,272.4,243.7z"
      />
      <path
        class="st3"
        d="M246.2,248.5C246.3,248.4,246.3,248.4,246.2,248.5C246.2,248.4,246.2,248.4,246.2,248.5L246.2,248.5z"
      />
      <path
        class="st3"
        d="M246.3,248.3c0,0,0,0.1-0.1,0.1C246.3,248.4,246.3,248.4,246.3,248.3L246.3,248.3z"
      />
      <path
        class="st3"
        d="M207.6,256.4l0.1,0.1l0.1-0.1l-0.1-0.1C207.7,256.3,207.6,256.3,207.6,256.4z"
      />
      <polygon class="st3" points="304.5,234.5 304.5,234.4 304.3,234.4 	" />
      <path
        class="st3"
        d="M240.9,264.7c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C240.8,264.9,240.8,264.8,240.9,264.7z"
      />
      <polygon class="st3" points="9,297.5 9.1,297.5 9,297.4 	" />
      <path
        class="st3"
        d="M199.9,274l0.1,0.1l0.1-0.1l-0.1-0.1C200,273.9,199.9,273.9,199.9,274z"
      />
      <path
        class="st3"
        d="M45.9,307.9c0,0.1,0,0.1,0,0.2L46,308C46,307.9,46,307.9,45.9,307.9z"
      />
      <polygon class="st3" points="200.4,274.5 200.5,274.6 200.5,274.5 	" />
      <path
        class="st3"
        d="M194.3,256.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C194.3,256.6,194.3,256.7,194.3,256.7z"
      />
      <path
        class="st3"
        d="M208.3,253.4C208.3,253.5,208.4,253.5,208.3,253.4C208.4,253.5,208.4,253.5,208.3,253.4c0.1,0.1,0.1,0,0.1,0
		C208.4,253.5,208.3,253.5,208.3,253.4z"
      />
      <polygon class="st3" points="296.4,234 296.3,233.9 296.3,234 	" />
      <polygon class="st3" points="42.2,310 42.3,310.1 42.3,310 	" />
      <path
        class="st3"
        d="M290,256.3L290,256.3c0-0.1-0.1-0.1-0.1-0.1s0-0.1-0.1-0.1c0,0.1,0,0.1,0,0.2
		C289.9,256.3,289.9,256.3,290,256.3z"
      />
      <path
        class="st3"
        d="M240.6,267.5l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C240.5,267.4,240.5,267.5,240.6,267.5z"
      />
      <path
        class="st3"
        d="M234,246.2c0,0-0.1-0.1-0.2-0.1l0,0l0,0C233.9,246.2,234,246.2,234,246.2z"
      />
      <path
        class="st3"
        d="M141.7,263.1l-0.1-0.1l-0.1,0.1l0.1,0.1C141.6,263.2,141.7,263.1,141.7,263.1z"
      />
      <path
        class="st3"
        d="M252.6,237.3L252.6,237.3c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L252.6,237.3z"
      />
      <path
        class="st3"
        d="M240.1,239.9l-0.1-0.1l-0.1,0.1l0.1,0.1L240.1,239.9z"
      />
      <path
        class="st3"
        d="M201.2,246.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C201.3,246.6,201.3,246.7,201.2,246.7z"
      />
      <path
        class="st3"
        d="M253.5,235C253.6,235,253.6,235,253.5,235c0.1-0.1,0.1-0.1,0.1-0.1S253.6,234.9,253.5,235L253.5,235z"
      />
      <path
        class="st3"
        d="M253.4,235.1l0.1-0.1C253.5,235,253.5,235,253.4,235.1C253.4,235,253.5,235.1,253.4,235.1z"
      />
      <polygon class="st3" points="203.6,244.7 203.6,244.6 203.5,244.7 	" />
      <path
        class="st3"
        d="M220.7,273.8l0.1,0.1C220.8,273.9,220.8,273.8,220.7,273.8L220.7,273.8z"
      />
      <path
        class="st3"
        d="M220.8,274C220.8,274,220.8,273.9,220.8,274L220.8,274c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C221.1,273.9,221,274,220.8,274z"
      />
      <path
        class="st3"
        d="M114.7,297.8l0.1,0.1l0.1-0.1l-0.1-0.1C114.7,297.7,114.7,297.7,114.7,297.8z"
      />
      <polygon class="st3" points="85.3,306 85.2,306 85.2,306.1 	" />
      <polygon class="st3" points="179.8,286.8 179.9,286.8 179.9,286.7 	" />
      <polygon class="st3" points="181.7,286.7 181.9,286.7 181.9,286.6 	" />
      <path
        class="st3"
        d="M235.9,275c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C235.8,275.1,235.8,275,235.9,275z"
      />
      <path
        class="st3"
        d="M292,265.7l0.1,0.1l0.1-0.1C292.1,265.7,292.1,265.7,292,265.7L292,265.7z"
      />
      <polygon class="st3" points="69.9,314.8 70,314.7 69.9,314.7 	" />
      <path
        class="st3"
        d="M292.6,266.3l-0.1,0.1l0.1,0.1l0.1-0.1C292.7,266.4,292.7,266.3,292.6,266.3z"
      />
      <polygon class="st3" points="237.7,279 237.8,279 237.8,278.9 	" />
      <polygon
        class="st3"
        points="172.1,302.2 172.2,302.3 172.2,302.2 172.3,302.2 172.2,302.2 	"
      />
      <path
        class="st3"
        d="M278,283.4c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1C278.1,283.5,278.1,283.5,278,283.4z"
      />
      <path
        class="st3"
        d="M44.1,334.7c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C44.1,334.6,44.1,334.7,44.1,334.7z"
      />
      <path
        class="st3"
        d="M224.9,298.6L224.9,298.6c0.1-0.1,0.1-0.1,0.1-0.1l0,0L224.9,298.6z"
      />
      <path
        class="st3"
        d="M296.9,289.1c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0.1-0.1,0.1C296.9,288.9,296.9,289,296.9,289.1z"
      />
      <path
        class="st3"
        d="M203.7,316.1l0.1,0.1l0.1-0.1C203.9,316,203.8,316,203.7,316.1C203.8,316,203.7,316,203.7,316.1z"
      />
      <path
        class="st3"
        d="M229.4,313.7l-0.1-0.1l-0.1,0.1l0.1,0.1C229.3,313.8,229.3,313.8,229.4,313.7z"
      />
      <polygon class="st3" points="193.8,333.6 193.9,333.6 193.9,333.5 	" />
      <path
        class="st3"
        d="M228.1,268c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C228.2,267.8,228.2,267.9,228.1,268z"
      />
      <path
        class="st3"
        d="M57.7,144.1c0.6,0.6,1.4,0.7,2.3,0.4c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2.6,0.2,4.3-0.2,5.4-1.3
		c0-1.6,0-3.3,0-4.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5-0.4-1.2-0.6-1.9-0.7c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2
		c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5c-0.7,0-1.2-0.1-1.7-0.1c-1.9,0.2-3.3,1.2-3.8,2.7
		c-0.2,0.6-0.1,1.1,0.4,1.5C56.5,142.9,57.1,143.5,57.7,144.1z"
      />
      <path
        class="st3"
        d="M69.3,136.3c0.1-0.7,0-1.4-0.4-2.1c0,1.1,0,2.1,0,3.2l0,0C69.1,137,69.2,136.6,69.3,136.3z"
      />
      <path
        class="st3"
        d="M123.7,135.2c1.1-0.6,0.6-1.6,0.9-2.5c1.6,0.2,2.8,0.8,4,1.3c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9
		c0.5,1.3,0.8,2.5,1.2,3.6c0,0.1,0.1,0.3,0.1,0.4c-0.7,0.1-1.3,0.3-1.7,0.6c0.8,0.7,1.6,1.4,2.4,2.1c0.5-0.5,0.7-1.3,0.5-2.4
		c1,0.1,2,0.2,3.2,0.2c-0.8-0.8-1-1-0.9-1.7c0-0.2,0.1-0.4,0.2-0.7c0.6,0.2,1.1,0.3,1.7,0.5c-1.7-1.3-3.3-2.6-5-3.8
		c-0.8-0.3-1.5-0.7-2.4-1c0.3-0.1,0.5-0.2,0.7-0.2c-0.3-0.2-0.6-0.4-0.9-0.7c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.2-1.9-0.3
		c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.8,0.6-1,1c0.9,0.8,1.8,1.5,2.7,2.3
		C123.1,135.5,123.4,135.4,123.7,135.2z"
      />
      <path
        class="st3"
        d="M136.2,134.3c0.1-0.8-1.1-1.3-2-0.9c0.7,0.5,1.4,1.1,2.1,1.6C136.2,134.7,136.1,134.5,136.2,134.3z"
      />
      <path
        class="st3"
        d="M4.6,180.4c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4c0-0.1,0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-1.3-0.9-2.3-2.2-3c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,1.9
		C4.1,179,4.1,179.7,4.6,180.4C4.6,180.3,4.6,180.4,4.6,180.4z"
      />
      <path
        class="st3"
        d="M83.9,119c-0.9,0.9-1.3,2-1.1,3c0.4,2,2.4,3.1,4.8,2.6s3.9-2.3,3.6-4.3c-0.3-1.6-2.1-2.8-4.1-2.7
		c0,0.2,0.1,0.3,0.1,0.5C86.2,118.4,85,118.7,83.9,119z"
      />
      <path
        class="st3"
        d="M193.3,109.8c0.8,0.9,1.6,1.9,3.1,2c0.2,0,0.4,0.2,0.5,0.3c0,0.8-0.3,1.3-1.1,1.8c-1.2,0.8-1.3,2-0.3,2.8
		c0.8,0.7,1.9,0.6,2.8-0.2c0.9-0.8,0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0.4-0.9,0.9-1.6,1.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.4-0.2,0.7-0.6,1-1l0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.7,0.3-1.6-0.3-2.1s-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C192.9,109.1,193,109.5,193.3,109.8z"
      />
      <path
        class="st3"
        d="M180.8,110c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.6,0.4,1.1,0.3,1.7c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1,0,1.5c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1
		c1,0.6,1.7,1.4,1.4,2.6c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.4-0.2-0.7-0.4-1.1c0.1-0.1,0.2-0.2,0.3-0.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.8,1.3,1.6,2.6,2.5,3.9c0.4,0.6,0.6,1,0.1,1.7s0,1.3,0.4,1.8s0.9,1,1.9,0.7c0.1-0.4,0.2-0.9,0.3-1.3
		c0.2,0,0.4,0,0.8,0.1c0-0.4,0.2-0.8,0-1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4
		c-0.9-0.3-1.1-1.1-1.6-1.7c-0.2-0.2-0.5-0.5-0.8-0.5c-1.3-0.2-2.1-0.8-2.4-1.7c-0.2-0.7-0.6-1.3-0.9-2c-0.1-0.3-0.4-0.6-0.3-0.8
		c0.3-1.3-0.6-2.1-1.4-2.9c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C180.7,109,180.5,109.5,180.8,110z
M191.3,123.6c-0.5-0.4-0.6-0.9-0.8-1.4C191,122.6,191.1,122.7,191.3,123.6z"
      />
      <path
        class="st3"
        d="M92.8,129.9c2-0.4,3.1-1.8,3.2-4.2c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2c-0.3,0-0.7,0.1-1,0.1
		c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.1,0.3,0.3,0.5,0.4,0.7c0.4,0.2,0.8,0.5,1.2,0.8c0.2,0.1,0.4,0.3,0.6,0.4
		C91.4,129.9,92.1,130,92.8,129.9z"
      />
      <path
        class="st3"
        d="M68.9,145.1c0-0.1,0-0.1-0.1-0.2c0,0.5,0,1,0,1.4C69,145.9,69,145.5,68.9,145.1z"
      />
      <path
        class="st3"
        d="M68.1,143.6c-0.8-0.8-2.2-1.2-3.6-0.9c-2.1,0.5-3.4,2.1-3,3.8c0.3,1.7,2.2,2.7,4.3,2.3
		c0.9-0.2,1.7-0.7,2.3-1.3C68.1,146.3,68.1,144.9,68.1,143.6z"
      />
      <path
        class="st3"
        d="M226.2,133c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5c0,0.1,0.1,0.1,0.1,0.1c0,0.1,0.1,0.2,0.1,0.2
		c0.2,0.5,0.6,0.8,1.1,1.1c0.3,0.2,0.7,0.3,1.1,0.4c0.1,0,0.2,0,0.3,0c1.2,0.2,2.4,0,3.3-1c0.1-0.1,0.1-0.2,0.2-0.3
		c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.3-0.9,0.4-1.3c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.2-0.1
		c-0.4-0.3-0.9-0.6-1.3-0.9c0,0,0,0-0.1,0c-1.2-0.6-2.6-0.5-3.8,0.2C226.3,133,226.3,133,226.2,133z"
      />
      <path
        class="st3"
        d="M96.7,123.7c0.8,0.9,1.9,1.1,3.1,1c1.2-0.3,2.9-1.8,3.4-2.9c-0.9-0.8-1.7-1.6-2.6-2.3c-0.3,0-0.5-0.1-0.8-0.1
		c-1.3-0.1-2.4,0.4-3.2,1.4C95.9,121.6,95.9,122.8,96.7,123.7z"
      />
      <path
        class="st3"
        d="M296.4,112.2c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4c0.1-0.9-1.6-2.6-2-2.8
		c-1.1-0.3-2.2-0.1-3.1,0.5C297.1,111,296.7,111.5,296.4,112.2z"
      />
      <path
        class="st3"
        d="M97.9,135.1c1-0.2,1.9-0.8,2.4-1.6c0.3-0.5,0.5-1.1,0.4-1.7c0-0.2-0.1-0.3-0.2-0.5c-0.5-1.2-2.1-1.8-3.6-1.5
		c-1.8,0.4-3,1.9-2.6,3.4C94.5,134.5,96.3,135.4,97.9,135.1z"
      />
      <path
        class="st3"
        d="M101.4,128.2c0.3,1.5,1.9,2.4,3.7,2c1.8-0.4,3-1.8,2.6-3.3l0,0c-0.3-1.5-2-2.3-3.8-1.9
		C102.3,125.3,101.1,126.7,101.4,128.2z"
      />
      <path
        class="st3"
        d="M220.4,116.2c1.7-0.4,2.8-1.9,2.5-3.3s-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.2,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C216.8,115.7,218.6,116.6,220.4,116.2z"
      />
      <path
        class="st3"
        d="M93.1,138.1c0.3-0.5,0.4-1,0.2-1.6c-0.2-0.8-0.7-1.3-1.5-1.6c0,1.5,0.1,2.9,0.1,4.3
		C92.5,138.9,92.9,138.5,93.1,138.1z"
      />
      <path
        class="st3"
        d="M90,134.6c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6c-0.9,0.6-1.4,1.6-1.1,2.6c0.2,0.8,0.8,1.4,1.6,1.7
		c0.5,0.2,1.2,0.3,1.8,0.2c0-1.7-0.1-3.4-0.1-5.1C90.3,134.7,90.2,134.6,90,134.6z"
      />
      <path
        class="st3"
        d="M40.8,162.7c0.4,0,0.7,0,1.1-0.1c0.8-0.3,1.3-1,1.4-1.6l0,0c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.3-0.2-0.5
		c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.1,0-0.2,0-0.2,0C40.9,160.3,40.9,161.5,40.8,162.7z"
      />
      <path
        class="st3"
        d="M40.2,159.1L40.2,159.1c-1.3-1.2-2.2-1.5-3.4-0.9c-0.9,0.4-1.5,1.4-1.2,2.3c0.3,1,1.2,1.4,3.2,1.2
		c0.5,0.5,0.9,0.7,1.3,0.9C40.1,161.4,40.2,160.2,40.2,159.1z"
      />
      <path
        class="st3"
        d="M105.3,135.5c0,0.5,0.3,0.9,0.9,1c1.1,0.2,1.6-0.5,1.9-1.2c0.6,0,1.1,0.1,1.6,0.1c-0.3-1.4-0.6-2.8-1-4.3
		c-0.6,0.3-1.1,0.7-1.5,1.3c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6C106.4,134.3,105.2,134.4,105.3,135.5z"
      />
      <path
        class="st3"
        d="M110.2,130.9c0.3,1.4,0.6,2.7,0.9,4.1c0.9-0.4,1.4-1.2,1.4-2.1c0-0.6-0.3-1.2-0.7-1.5
		C111.4,131.1,110.8,130.9,110.2,130.9z"
      />
      <path
        class="st3"
        d="M293.2,110.7c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-1,0-3.2-0.2-3.3c-0.4-0.1-0.8-0.3-1.1-0.3
		c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5C291.6,109,292.1,110.1,293.2,110.7z"
      />
      <path
        class="st3"
        d="M225.5,111c0.8,0.3,1.7,0.3,2.5-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.9-0.8,1.2-1.9,0.7-2.8c-0.2-0.3-0.4-0.6-0.6-1
		c0-0.1-0.1-0.1-0.1-0.2s-0.1-0.1-0.1-0.2c-0.6,0-1.3,0-2,0.1c-1,0.1-1.8,0.6-2.2,1.2c-0.2,0.2-0.3,0.5-0.4,0.8
		C223.7,109.4,224.3,110.5,225.5,111z"
      />
      <path
        class="st3"
        d="M25.4,135.7c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9s-1.8-2-3.2-1.7
		C26.3,133.2,25.2,134.5,25.4,135.7z"
      />
      <path
        class="st3"
        d="M98.1,143.4c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.1h-0.1
		c-0.2,0.1-0.4,0.2-0.6,0.4s-0.4,0.3-0.5,0.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3
		c0.1,0.6,0.4,1.1,0.6,1.8c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0c0.1,0,0.3,0,0.4,0
		C96.7,145,97.7,144.4,98.1,143.4z"
      />
      <path
        class="st3"
        d="M105.2,138.6c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1s-0.6,0.2-0.8,0.3
		c-0.3,0.2-0.6,0.4-0.8,0.6c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5c0.3-0.1,0.6-0.2,0.8-0.3
		C104.6,139.5,105,139.1,105.2,138.6z"
      />
      <path
        class="st3"
        d="M35,143.7c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-0.9,0.2-1.6,0.9-1.9,1.6c0,0.5-0.1,1-0.1,1.5C32,143.7,33.6,144.3,35,143.7z"
      />
      <path
        class="st3"
        d="M59.2,133.9c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C56.4,133.4,57.7,134.2,59.2,133.9z"
      />
      <path
        class="st3"
        d="M250.9,74.9L250.9,74.9c-1.5,0-3.1,0.1-4.7,0.1c0,0.1,0.1,0.3,0.2,0.4c1.4-0.1,2.9-0.2,4.3-0.4
		C250.7,75,250.8,75,250.9,74.9z"
      />
      <path
        class="st3"
        d="M246.1,73.9c1.8-0.1,3.7-0.3,5.5-0.4c0-0.3,0-0.6-0.2-0.8c-0.7-1.1-1.1-1.3-2.9-0.9c-0.3,0.2-1.1,0.4-1.7,0.9
		C246.3,73,246.1,73.4,246.1,73.9z"
      />
      <path
        class="st3"
        d="M298.3,119.3c-1,0.2-1.7,0.8-2.1,1.5c-0.2,0.3-0.2,0.7-0.2,1c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6
		c1.4-0.3,2.4-1.5,2.2-2.6C301.2,119.7,299.8,119,298.3,119.3z"
      />
      <path
        class="st3"
        d="M210.9,104.4c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c-0.1-0.3-0.2-0.6-0.5-0.9
		c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.2,0.5-0.3,1-0.4,1.4c-0.3,0.1-0.7,0.2-0.9,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8c0.2,0.1,0.3,0.2,0.5,0.3
		c0.1,0,0.3,0,0.4-0.1C210.5,105.7,210.9,105.1,210.9,104.4z"
      />
      <path
        class="st3"
        d="M102.2,146.9c-0.4-0.2-0.8-0.4-1.3-0.6c0-0.4,0.3-0.9-0.4-1.1c-0.9-0.2-1.4,0.1-2.3,1.3
		c0.2,0.3,0.5,0.6,0.7,0.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2
		s1.3,0.8,2.2,0.7c0.9-0.2,1.5-0.7,1.8-1.5C103.2,148,102.9,147.4,102.2,146.9z"
      />
      <path
        class="st3"
        d="M19.5,164.1c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.2,0.4-0.3,0.6-0.5c-0.2-0.3-0.3-0.7-0.5-1.1
		c-0.2-0.4-0.4-0.7-0.6-1.1c-0.3-0.4-0.7-0.5-0.4-1.1c0.2-0.4-0.2-0.8-0.8-0.8c-0.6,0-1.1,0.4-1,0.8c0.2,0.6-0.2,0.9-0.6,1.3
		c-0.9,0.9-1,1.8-0.5,2.7C17.2,164.7,18.3,164.9,19.5,164.1z"
      />
      <path
        class="st3"
        d="M69.1,178.2c-0.1-0.3-0.3-0.6-0.5-0.7c0,0.8,0,1.6,0,2.3c0.3-0.3,0.5-0.7,0.5-1.3
		C69.1,178.4,69.1,178.3,69.1,178.2z"
      />
      <path
        class="st3"
        d="M67.9,175.4c0-0.7,0-1.2-0.9-1.4c-0.5-0.1-1-0.2-1.6-0.3c0,0.1,0,0.1,0,0.2c0.1,0.2,0.2,0.5,0.2,0.8
		c0.1,0.6,0.1,1.3,0.6,1.8c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2l-0.1,0.1c-0.9,1-1.3,1.6-0.9,2.3
		c0.2,0.4,0.7,0.8,1.5,1.2c0.1,0,0.2-0.1,0.3-0.2c0-1.1,0-2.2,0-3.2c-0.1-0.1-0.2-0.1-0.4-0.2c0.2-0.1,0.3-0.3,0.4-0.4
		C67.9,176.2,67.9,175.8,67.9,175.4z"
      />
      <path
        class="st3"
        d="M71,170.3C71,170.4,71,170.4,71,170.3c0.2,0.1,0.3,0.1,0.4,0.1c0.8,0.4,1.6,0.5,2.4,0c1,1.3,1,1.3,2.6,1
		c0.1-0.5,0.2-1,0.3-1.6c0,0,0,0-0.1,0c-0.7-0.1-1.3-0.3-2-0.4c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.2-0.1-0.2-0.1
		c-0.2-0.1-0.4-0.1-0.6-0.2h-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.8,0.7-1.6,1.5-2.6,2.4c0.4,0.1,0.8,0.2,1.2,0.2
		C70.3,170.2,70.7,170.3,71,170.3z"
      />
      <path
        class="st3"
        d="M231.5,104.4c0.2,1.1,1.6,1.8,3,1.5s2.2-1.4,2-2.5s-1.5-1.7-2.9-1.5C232.3,102.2,231.3,103.3,231.5,104.4z"
      />
      <path
        class="st3"
        d="M251.5,99.4c0.3-1.2-1.2-2.2-2.6-1.9c-1,0.2-1.7,0.9-1.9,1.8c-0.1,0.8,0.3,1.6,1.2,1.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.5,0.1,1,0.3,1.4,0.6c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.3-0.3-0.5
		C251.2,100.3,251.4,99.9,251.5,99.4z"
      />
      <path
        class="st3"
        d="M110.1,143c-0.1-0.5-0.5-0.9-1.1-1.1c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1
		c-0.7-1.1-0.7-1.1-2.3-1.2c0.5,1.1,1,1.9,0.4,3c-0.4,0.9,0.5,1.8,1.6,1.9c0.8,0.1,1.5-0.1,2-0.5c0.1-0.1,0.3-0.3,0.4-0.4
		c0.1-0.1,0.1-0.2,0.2-0.2C110.1,143.8,110.2,143.4,110.1,143z"
      />
      <path
        class="st3"
        d="M238.3,111.5c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.7-0.8,2-1.6c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-1.5-1.8-2.8-1.5c-0.9,0.2-1.5,0.8-1.8,1.5c-0.2,0.4-0.2,0.7-0.1,1.1C237,110.7,237.6,111.3,238.3,111.5z"
      />
      <path
        class="st3"
        d="M264.8,90c-0.7,0.6-0.7,1.3-0.4,1.9c1.6-0.1,3.3-0.2,4.9-0.3c-0.2-1.1-0.5-1.6-0.9-2.1
		c-0.1-0.1-0.2-0.2-0.3-0.3c-0.7,0-1.5,0.1-2.2,0.1C265.5,89.5,265.1,89.7,264.8,90z"
      />
      <path
        class="st3"
        d="M126,110c0.7,0.2,1.5,0.4,2.2,0.4c0.1,0,0.2,0,0.4,0s0.3,0,0.5-0.1s0.5-0.2,0.7-0.2c0.3-0.1,0.5-0.4,0.8-0.6
		c0.6-0.5,0.9-0.9,0.9-1.4c-2.1,0.3-4.2,0.6-6.3,0.9c0,0,0,0-0.1,0C125.2,109.5,125.5,109.9,126,110z"
      />
      <path
        class="st3"
        d="M65.1,128.2c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C62.6,127.9,63.8,128.5,65.1,128.2z"
      />
      <path
        class="st3"
        d="M82.2,117.5c1.2-0.3,2.1-1.4,1.9-2.4c-0.2-0.7-0.8-1.1-1.5-1.3c-0.9,0.4-1.9,0.7-2.8,1.1
		c-0.3,0.4-0.4,0.9-0.3,1.4C79.8,117.1,81,117.7,82.2,117.5z"
      />
      <path
        class="st3"
        d="M282.8,128.3c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1c0.2-0.7,0.7-1.4-0.1-2.1c-0.8-0.6-1.6-0.1-2.5,0.1
		c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1C281.3,127,282,127.7,282.8,128.3z"
      />
      <path
        class="st3"
        d="M69.1,132.2c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3c-0.6,0.1-1,0.4-1.3,0.7
		c0,0.8,0,1.6,0,2.5C69,132,69,132.1,69.1,132.2z"
      />
      <path
        class="st3"
        d="M95.8,153.5c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5c-0.3,0.1-0.6,0.2-0.8,0.3c0,1.1,0.1,2.1,0.1,3.2
		c0.4,0.2,0.9,0.3,1.4,0.1c0.1,0,0.2-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5C95.5,154.2,95.7,153.9,95.8,153.5z"
      />
      <path
        class="st3"
        d="M252.7,95.7c-0.1,0.1-0.1,0.1-0.1,0.2c0.2,0,0.4,0,0.5,0C253,95.8,252.9,95.7,252.7,95.7z"
      />
      <path
        class="st3"
        d="M252.4,98.6c0.5,0.3,1.2,0.5,2.2,0.7c-0.2,1,0.1,1.7,1.2,2.2c0.6-1.2,0.6-1.2-0.5-2.5c0.9-0.9,0.9-1,0.6-1.4
		c-0.4-0.4-0.8-0.9-1.3-1.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.7,0-1.4,0.1-2.1,0.2C251.6,97.4,251.6,98.1,252.4,98.6z"
      />
      <path
        class="st3"
        d="M286.2,121.7c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C285.9,121.4,286.1,121.5,286.2,121.7z"
      />
      <path
        class="st3"
        d="M28.2,146.6c-0.2-0.9-1.4-1.6-2.5-1.4c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2
		c0.2,1,1.4,1.5,2.6,1.3C27.6,148.6,28.4,147.6,28.2,146.6z"
      />
      <path class="st3" d="M80.3,123.1L80.3,123.1L80.3,123.1L80.3,123.1z" />
      <path
        class="st3"
        d="M77.9,124.9c1,0.4,2,0.7,3,1c0-0.2,0-0.5-0.1-0.7c-0.7-0.4-1.4-0.9-2.1-1.3C78.4,124.2,78.1,124.6,77.9,124.9z
		"
      />
      <path
        class="st3"
        d="M81.2,128.1c0-0.1,0-0.2,0-0.3c-1.1-0.4-2.2-0.8-3.3-1.2C78.3,127.7,79.3,128.3,81.2,128.1z"
      />
      <path
        class="st3"
        d="M30.8,155.1c0.4,0.2,1,0.3,1.4,0.2c1.3-0.3,2.1-1.3,1.8-2.4c-0.3-1-1.3-1.5-2.6-1.2c-0.2,0-0.3,0.1-0.5,0.2
		C30.9,152.9,30.9,154,30.8,155.1z"
      />
      <path
        class="st3"
        d="M29.7,153.9c0.1,0.3,0.2,0.5,0.4,0.7c0-0.8,0.1-1.5,0.1-2.3C29.8,152.8,29.6,153.4,29.7,153.9z"
      />
      <path
        class="st3"
        d="M43.8,158.9c0.4-0.7,0.6-1.1,0.9-1.7c0.7,0,1.4-0.2,1.9-0.7c0.2-0.2,0.3-0.3,0.4-0.6c0-0.1,0.1-0.1,0.1-0.2
		c0.3-1.1-0.7-1.6-1.5-2.1c-0.9,0.4-1.6,0.7-2.4,1.1C43.3,156.1,43.1,157.5,43.8,158.9z"
      />
      <path
        class="st3"
        d="M84.8,129.9c-1.2,0.2-2,1.3-1.8,2.3c0.2,0.9,1.5,1.5,2.5,1.2c1.1-0.3,1.9-1.3,1.7-2.2
		C87,130.2,85.9,129.7,84.8,129.9z"
      />
      <path
        class="st3"
        d="M265,111.8c0,0,0-0.1-0.1-0.1c-0.1-0.3-0.2-0.5-0.3-0.8c-0.7,0.4-1.4,0.8-2,1.2c0.2-0.5,0.5-0.8,0.8-1.1
		c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6c0.6,1.2,0.3,2-0.5,2.7
		c-0.3,0.3-0.2,0.7-0.4,1.4c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7C263,113,263.1,111.7,265,111.8
		C264.9,111.8,264.9,111.8,265,111.8z"
      />
      <path
        class="st3"
        d="M2.2,133C2,132.1,1,131.6,0,131.7v3.6c0.2,0,0.3,0,0.5-0.1C1.7,135,2.5,134,2.2,133z"
      />
      <path
        class="st3"
        d="M269.7,121c0.3,0.3,0.6,0.6,0.9,0.9c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2
		c-0.4,0.1-0.8,0.3-1.1,0.5c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5C270.5,119.6,270,120.2,269.7,121L269.7,121z"
      />
      <path
        class="st3"
        d="M88.7,149.9C88.8,149.9,88.8,149.9,88.7,149.9c0.5,0.2,1.1,0.1,1.7-0.2c-0.7-1.2-0.1-2.8-1.6-3.9
		c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.6,0.6,0.9,0.9
		C88.4,149.7,88.5,149.8,88.7,149.9z"
      />
      <path
        class="st3"
        d="M70.9,141.9c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		c-0.4-0.4-1.1-0.7-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2c-0.5,0.3-0.9,0.4-1.4,0.4c0,0.5,0,0.9,0,1.4c0.4,0.3,0.8,0.6,1.2,0.8
		C70.4,141.9,70.6,141.9,70.9,141.9z"
      />
      <path
        class="st3"
        d="M68.1,139.5L68.1,139.5c-0.3,0-0.5,0.1-0.9,0.3c0.3,0.2,0.6,0.4,0.9,0.7C68.1,140.1,68.1,139.8,68.1,139.5z"
      />
      <path
        class="st3"
        d="M62.2,170.3c-0.1-0.9-0.7-1.3-1.7-1.5c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6c-0.8,0.2-1.1,0.8-1,1.4
		l0,0c0.7,0.1,1.3,0.2,2,0.3c-0.2-0.3-0.3-0.6,0.2-1.1C60.6,170.5,61.3,171.1,62.2,170.3z"
      />
      <path
        class="st3"
        d="M143.3,128.4c0,0.1,0.1,0.1,0.2,0.2c0.7,0.2,1.5,0.3,2.3,0.5c0.1-0.3,0.2-0.5,0.2-0.6s0.1-0.2,0.1-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,1-0.7
		c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3c-0.2,0.1-0.2,0.3-0.3,0.4
		c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5C143.1,128,143.2,128.3,143.3,128.4z"
      />
      <path
        class="st3"
        d="M237.8,118.5c-0.3,0-0.5,0-0.8,0c-1.1,0.2-1.7,1-1.5,1.9c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2
		c1-0.2,1.7-1.1,1.6-1.9C239.1,119,238.5,118.6,237.8,118.5z"
      />
      <path
        class="st3"
        d="M189.6,98.8c1.2-0.1,2.3-0.3,3.5-0.4c0.1-0.2,0.1-0.3,0.1-0.5c-0.3-1.1-1.2-1.6-2.5-1.3
		c-1.1,0.3-1.6,0.8-1.5,1.5C189.2,98.4,189.4,98.6,189.6,98.8z"
      />
      <path
        class="st3"
        d="M251.6,105.6c-0.2-0.8-1.2-1.3-2.2-1.1c-1,0.2-1.7,1.1-1.5,1.9s1.2,1.2,2.1,1
		C251.2,107.1,251.8,106.4,251.6,105.6z"
      />
      <path
        class="st3"
        d="M136.6,100.2c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.7-0.4-1.6-0.8-2.4-1.2c-0.1,0-0.1,0-0.2,0c-0.2,0.3-0.4,0.5-0.6,0.7c-0.6-0.1-1.2-0.2-1.9-0.4c-0.1,0-0.3,0-0.4,0
		C135.3,99.3,135.7,99.9,136.6,100.2z"
      />
      <path
        class="st3"
        d="M274.3,121.9c0.1,0.3,0.2,0.6,0,0.8c-1,1.3-0.4,2.1,0.8,2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.6-1.2-0.7
		C274.2,121.5,274.2,121.5,274.3,121.9z"
      />
      <path
        class="st3"
        d="M118.4,144.6c0,0.1,0,0.2,0.1,0.3c0.2,0.6,0.9,1,1.6,1c0.1,0,0.3,0,0.4,0c1-0.2,1.7-1.1,1.5-1.9
		c-0.2-0.8-1.1-1.2-2-1.1C119,143.1,118.3,143.8,118.4,144.6z"
      />
      <path
        class="st3"
        d="M58.7,126.6c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C56.7,126.2,57.7,126.8,58.7,126.6z"
      />
      <path
        class="st3"
        d="M303.8,86.5c-0.1-0.3-0.2-0.6-0.5-0.8c-0.4-0.3-0.9-0.4-1.5-0.4c-0.7,0.1-1.3,0.6-1.5,1.2
		C301.5,86.6,302.7,86.6,303.8,86.5C303.8,86.6,303.8,86.6,303.8,86.5z"
      />
      <path
        class="st3"
        d="M26.3,163.5c-0.1-0.4-0.5-0.7-0.7-1.1c-0.6,0.1-1,0.1-1.4,0.3c-1,0.3-1.5,1.1-1.2,1.9c0.1,0.2,0.2,0.4,0.4,0.5
		c0.6,0.1,1.2,0.2,1.8,0.3C26,165.1,26.6,164.3,26.3,163.5z"
      />
      <path
        class="st3"
        d="M280,133.4c0.9,0.5,0,1.4,0.5,1.9c1.5,0.6,1.5,0.6,2.9-0.2c0.1-0.5,0.2-1.1,0.3-1.5c-0.8-0.9-2.2-0.3-3-0.9
		C280.5,132.5,279.8,133.2,280,133.4z"
      />
      <path
        class="st3"
        d="M113.1,150.7c-0.2-0.9-0.4-1.9-0.6-2.8c-0.7,0.3-1.3,1-1.1,1.7C111.5,150.3,112.2,150.7,113.1,150.7z"
      />
      <path
        class="st3"
        d="M114.8,148.8c-0.1-0.3-0.2-0.5-0.4-0.7c-0.1-0.1-0.2-0.1-0.3-0.2c0.2,0.7,0.3,1.3,0.5,2
		C114.8,149.6,114.9,149.2,114.8,148.8z"
      />
      <path
        class="st3"
        d="M235,101.3c0.9-0.3,1.6-1.3,1.4-2c-0.2-0.7-0.9-1.1-1.7-0.9c-1.1,0.3-2,1.4-1.8,2.2
		C233.1,101,234.4,101.5,235,101.3z"
      />
      <path
        class="st3"
        d="M45.4,136.2c0-1.9-0.8-2.7-2.9-2.7c0,0.7-0.1,1.4-0.1,2.2c0.1,0.1,0.1,0.2,0.2,0.3
		C43.4,136.5,44.3,136.6,45.4,136.2z"
      />
      <path
        class="st3"
        d="M193.8,113.9c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7c0.1,0.8,0.8,1.1,1.6,0.8
		c0.6-0.3,1.1-0.7,1.6-0.9C193.8,115.8,193.8,115,193.8,113.9z"
      />
      <path
        class="st3"
        d="M24.1,160.3h0.1c0.9-0.3,1.5-1,1.3-1.8c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.9,0.2-1.6,1.1-1.4,1.8
		C22.2,160.1,23.2,160.5,24.1,160.3z"
      />
      <path
        class="st3"
        d="M51.2,142.6c0.3-1.9-0.6-2.7-3-2.8C47.5,141.8,48.4,142.8,51.2,142.6z"
      />
      <path
        class="st3"
        d="M75.3,130c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8C73.6,129.8,74.4,130.2,75.3,130z"
      />
      <path
        class="st3"
        d="M94.5,117.7c0.7-0.2,1.2-0.7,1.3-1.2c-0.8,0.1-1.6,0.3-2.6,0.4c0.3-0.5,0.3-0.6,0.4-0.7s0.3-0.1,0.4-0.2
		c0.6-0.1,1.1-0.2,1.7-0.3c-0.3-0.5-0.9-0.9-1.7-0.7c-1,0.2-1.6,0.9-1.5,1.7C92.7,117.5,93.6,117.9,94.5,117.7z"
      />
      <path
        class="st3"
        d="M71.5,176.3c0.4,0,0.7,0,0.9-0.1c0.6-0.1,0.8-0.4,1.1-1.1c-1-0.2-2-0.3-3.1-0.5c-0.1,0.1-0.3,0.2-0.4,0.3
		c-0.3,0.2-0.6,0.4-0.6,0.7c0.1,0.3,0.2,0.5,0.4,0.8c0,0,0-0.1,0.1-0.1l0,0l0,0C70.5,176.3,71,176.3,71.5,176.3z"
      />
      <path
        class="st3"
        d="M105.6,118.9c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1c0.1-0.2,0.1-0.4,0-0.6
		c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.4-0.3-0.6-0.4c-0.3-0.1-0.7-0.2-1.1-0.2c-1,0.2-1.6,0.9-1.4,1.7
		C105.5,118.7,105.5,118.8,105.6,118.9z"
      />
      <path
        class="st3"
        d="M102.5,114.5c0.5-0.1,0.9-0.2,1.4-0.3c-0.7-0.6-1.1-0.9-1.7-0.7c0,0.2-0.1,0.3,0,0.5S102.4,114.4,102.5,114.5z
		"
      />
      <path
        class="st3"
        d="M245.4,124.6c0.7,0.9,1.2,0.8,2.1-0.3c-0.7-1.1-2-1.5-3.3-1.9c-0.3-0.1-0.9,0-1.2,0.2c-0.4,0.3-0.2,0.6,0,0.9
		c0.1,0.1,0.1,0.3,0.2,0.5C244.2,123.9,244.9,123.9,245.4,124.6z"
      />
      <path
        class="st3"
        d="M30.3,165c0,0.4,0.3,1.3,0.7,1.3c0.6-0.5,0.8-1,0.5-1.7c-0.2-0.4-0.6-0.7-1.1-0.8
		C30.4,164.2,30.3,164.6,30.3,165z"
      />
      <path
        class="st3"
        d="M28,165c0.5,0.3,1,0.7,1.4,1c0.1-0.8,0.1-1.5,0.1-2.3C28.8,163.9,28.2,164.2,28,165z"
      />
      <path
        class="st3"
        d="M134,98.5c-0.8,0.1-1.7,0.2-2.5,0.3c-0.1,0.8,0.1,1.6,0.7,2.4C133.6,100.4,134.2,99.4,134,98.5z"
      />
      <path
        class="st3"
        d="M271.4,93.8c0.6,0.3,1.3,0.2,1.8-0.3c0.2-0.1,0.3-0.3,0.5-0.5c-1,0.1-1.9,0.1-2.9,0.2c0,0,0,0,0,0.1
		C270.9,93.5,271.1,93.7,271.4,93.8z"
      />
      <path
        class="st3"
        d="M40.5,150c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.4,0.7-0.4,1.4,0.1,2.1C38.3,150.1,39,150.3,40.5,150z"
      />
      <path
        class="st3"
        d="M152.6,139.5c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1s0.5,0.6,0.8,0.8s0.7,0.1,1.1,0.2
		c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.2-0.7,0.4-1s0.4-0.6,0.6-1c0.1-0.2,0.2-0.3,0.3-0.5C153.2,138.6,153.1,138.6,152.6,139.5z"
      />
      <path
        class="st3"
        d="M72.6,149.8c-0.2-0.7-1-1.1-1.8-0.8c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3
		c0.3,0.4,0.9,0.6,1.5,0.4C72.3,151.1,72.8,150.5,72.6,149.8z"
      />
      <path
        class="st3"
        d="M295.8,101c0.8-0.1,1.4-0.8,1.3-1.5s-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4C294.2,100.7,295,101.2,295.8,101
		z"
      />
      <path
        class="st3"
        d="M255.8,115c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2c-0.1,0-0.3,0-0.4,0
		c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4C254.9,114.3,255.4,114.5,255.8,115z"
      />
      <path
        class="st3"
        d="M132.5,143.9c0.5,0.4,1,0.9,1.6,1.3c0-0.1,0.1-0.3,0-0.4C134,144.2,133.3,143.8,132.5,143.9z"
      />
      <path
        class="st3"
        d="M59.2,158.8c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.4,1.5,0.5,2.3-0.1C61.9,158.9,61.4,158.6,59.2,158.8z"
      />
      <path
        class="st3"
        d="M40.9,147.8c0-0.6,0.1-1.3,0.1-1.9c-0.3-0.1-0.6-0.1-1-0.2C39.9,146.8,40.2,147.4,40.9,147.8z"
      />
      <path
        class="st3"
        d="M41.8,146.1c0,0.6-0.1,1.3-0.1,1.9c0.3,0,0.6,0.1,1,0.1C42.7,147,42.5,146.4,41.8,146.1z"
      />
      <path
        class="st3"
        d="M36.7,165c-0.7,0.1-1.1,0.5-1.2,1.1c-0.1,0.6,0.3,0.9,0.8,1.1c0.3,0,0.6,0.1,0.8,0.1c0.1-0.1,0.2-0.1,0.2-0.2
		c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3C37.6,165,37.2,164.9,36.7,165z"
      />
      <path
        class="st3"
        d="M258.2,92.3c0-0.6-0.3-1.1-1.2-1.5c-0.1,1-1.7,0.8-2.1,1.8c0.8-0.1,1.6-0.1,2.4-0.2
		C257.6,92.4,257.9,92.3,258.2,92.3z"
      />
      <path
        class="st3"
        d="M139.1,136.2c0.5,0.1,1.2-0.2,1.8-0.3c-0.6-0.5-1.2-0.9-1.8-1.4c-0.4,0.2-0.8,0.3-1.2,0.5
		C138.3,135.5,138.6,136.1,139.1,136.2z"
      />
      <path
        class="st3"
        d="M141.1,135.1c0-0.5,0.1-1,0.1-1.6c-0.5,0.2-1,0.4-1.4,0.6C140.3,134.5,140.7,134.8,141.1,135.1z"
      />
      <path
        class="st3"
        d="M124.8,150.9c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8s-1.2-0.4-2.1,0.2c-0.2,0.2-0.4,0.3-0.7,0.6
		C124.1,150.4,124.5,150.7,124.8,150.9z"
      />
      <path
        class="st3"
        d="M10.1,187.8c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C9,187.1,9.3,187.6,10.1,187.8z"
      />
      <path
        class="st3"
        d="M19.2,170.6c0.7-0.2,1.2-0.9,1.1-1.5s-0.9-1-1.6-0.8s-1.3,0.8-1.2,1.4c0,0.3,0.3,0.6,0.6,0.7
		c0.2,0.1,0.4,0.2,0.7,0.2C18.9,170.6,19,170.6,19.2,170.6z"
      />
      <path
        class="st3"
        d="M67.9,164c-0.4-0.8-1.1-0.9-2.5-0.8c-0.6,0.7-0.2,1.3,0.5,1.7c0.6,0.4,1.3,0.5,2,0.3H68
		C67.9,164.7,67.9,164.4,67.9,164z"
      />
      <path
        class="st3"
        d="M266.8,80.6c-1.2-0.7-2.3-0.8-3.3-0.3C264.6,80.4,265.7,80.5,266.8,80.6z"
      />
      <path
        class="st3"
        d="M110.6,139.5c-0.2-0.7-0.3-1.4-0.5-2c-0.2,0-0.3,0-0.5,0.1c-0.7,0.2-1.1,0.7-1,1.3c0.1,0.7,0.8,1,1.6,0.8
		C110.4,139.7,110.5,139.6,110.6,139.5z"
      />
      <path
        class="st3"
        d="M85.7,152c0.8-0.1,1.3-0.7,1.2-1.4c-0.1-0.6-0.8-1-1.6-0.8c-0.8,0.1-1.3,0.8-1.2,1.4
		C84.1,151.7,84.9,152.1,85.7,152z"
      />
      <path
        class="st3"
        d="M244.2,112.3c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1c-0.8,0-1.2,0.2-1.5,0.7
		c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3C243.5,112,243.8,112.2,244.2,112.3z"
      />
      <path
        class="st3"
        d="M132.1,121.4c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C131.6,122.4,132,122,132.1,121.4z"
      />
      <path
        class="st3"
        d="M203.1,107.2c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.6-0.9-1-1.6-0.8C203.5,106,203,106.7,203.1,107.2z"
      />
      <path
        class="st3"
        d="M207.2,111.1c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.8-1.1,0.9-1.5,0.3-1.9l0,0
		c-0.4-0.3-0.8-0.4-1.3-0.2h-0.1c-0.5,0.2-0.8,0.5-0.8,1C206.3,110.6,206.5,110.9,207.2,111.1z"
      />
      <path
        class="st3"
        d="M110.2,111.7c0.2-0.1,0.4-0.2,0.5-0.4c-0.3,0-0.5,0.1-0.8,0.1C110.1,111.5,110.1,111.6,110.2,111.7z"
      />
      <path
        class="st3"
        d="M110.5,109.8c-0.3-0.2-0.7-0.2-1-0.2c-0.2,0.1-0.4,0.2-0.6,0.3c0.3,0,0.7,0,1,0
		C110.1,109.8,110.3,109.8,110.5,109.8z"
      />
      <path
        class="st3"
        d="M262.8,79.8c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C261.3,79.7,262.1,79.9,262.8,79.8z"
      />
      <path
        class="st3"
        d="M16.1,175.4c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C14.7,175.1,15.4,175.5,16.1,175.4z"
      />
      <path
        class="st3"
        d="M110.5,123.1c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.3-0.4-0.6-0.8-0.7
		c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1c-0.4,0.2-0.7,0.5-0.8,0.8C110.4,122.7,110.4,122.9,110.5,123.1z"
      />
      <path
        class="st3"
        d="M26.5,110.8c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.6-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C25.2,110.5,25.9,110.9,26.5,110.8z"
      />
      <path
        class="st3"
        d="M139.6,124.2c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C140.6,125.5,140.4,124.7,139.6,124.2z"
      />
      <path
        class="st3"
        d="M145.7,133.9c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1
		c0,0.4,0.1,0.8,0.7,0.9c0.6,0,1.2-0.1,1.7-0.1C146.2,134.8,146.3,134.2,145.7,133.9z"
      />
      <path
        class="st3"
        d="M146.1,135.3C146.1,135.4,146.1,135.4,146.1,135.3C146.1,135.4,146.2,135.4,146.1,135.3
		C146.2,135.4,146.2,135.4,146.1,135.3L146.1,135.3z"
      />
      <path
        class="st3"
        d="M100.6,97.9c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C99.2,97.6,99.9,98,100.6,97.9z"
      />
      <path
        class="st3"
        d="M245,133.3c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.5,0.1-0.9,0.6-0.8,1.1
		c0,0.2,0.1,0.4,0.3,0.6C244.1,133.1,244.6,133.4,245,133.3z"
      />
      <path
        class="st3"
        d="M78.9,120.8c-0.1-0.5-0.7-0.8-1.3-0.7c-0.5,0.1-0.8,0.4-1,0.7c0.6,0.4,1.2,0.7,1.7,1.1
		C78.8,121.6,79,121.2,78.9,120.8z"
      />
      <path
        class="st3"
        d="M208.6,108c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C207.7,107.9,208.3,108.1,208.6,108z"
      />
      <path
        class="st3"
        d="M146.2,135.4c0.2,0.2,0.4,0.5,0.7,0.6c0.5,0.1,0.9,0.2,1.1,0.6c0.2,0.4,0.7,0.5,1.2,0.2
		c0.4-0.2,0.4-0.9-0.1-1.2s-1.1-0.6-1.7-0.9C146.9,134.9,146.6,135.2,146.2,135.4z"
      />
      <path
        class="st3"
        d="M85.1,175.5c-0.2-0.1-0.5-0.1-0.7-0.1C84.6,175.4,84.9,175.5,85.1,175.5L85.1,175.5z"
      />
      <path
        class="st3"
        d="M84.5,177.6c0.1-0.2,0.3-0.3,0.4-0.5c-0.6-0.1-1.2-0.2-1.8-0.3C83.1,177.4,83.7,177.5,84.5,177.6z"
      />
      <path
        class="st3"
        d="M24.1,127.1c-0.2,1.2-0.3,2.4-0.4,3.5C25.6,129.2,25.7,128.2,24.1,127.1z"
      />
      <path
        class="st3"
        d="M239.9,134.3c0.3,0.1,0.7-0.2,1.1-0.3c-0.9-1.8-1-1.8-2.6-1C238.7,133.5,239.1,134.1,239.9,134.3z"
      />
      <path
        class="st3"
        d="M2.8,184.7c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C2.8,184.6,2.8,184.7,2.8,184.7z"
      />
      <path
        class="st3"
        d="M48.6,153.8c-0.3-1.3-0.4-1.4-2.2-1.8C46.3,153.7,47,154.2,48.6,153.8z"
      />
      <path
        class="st3"
        d="M246.7,70.8c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C245.6,70.5,246.1,70.9,246.7,70.8z"
      />
      <path
        class="st3"
        d="M136.1,101.3c-0.8,0.1-1.3,0.4-1.4,1c0.6-0.1,1.3-0.2,1.9-0.3C136.4,101.7,136.3,101.5,136.1,101.3z"
      />
      <path
        class="st3"
        d="M128.9,101.4c0.1,0.5,0.7,0.9,1.2,0.8s0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C129.2,100.2,128.8,100.9,128.9,101.4z"
      />
      <path
        class="st3"
        d="M82.4,171.6c-1.6,1.4-1.6,1.4-0.7,2.4C83.6,172.6,83.6,172.6,82.4,171.6z"
      />
      <path
        class="st3"
        d="M180.3,105.2c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C181,106,181,105.6,180.3,105.2z"
      />
      <path
        class="st3"
        d="M211.4,107.4c-0.8,0.2-1.3,0.6-1.5,1.5c1.2-0.2,2.3-0.2,3.3-0.7C212.8,107.5,212.2,107.2,211.4,107.4z"
      />
      <path
        class="st3"
        d="M91.2,164.5c0-0.5,0-1.1,0-1.6c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.1-0.2,0.3-0.2,0.5s0.2,0.4,0.4,0.6
		C91,164.5,91.1,164.5,91.2,164.5z"
      />
      <path
        class="st3"
        d="M289.2,111.9c-0.6,0.1-1.1,0.6-1,1.1c0.1,0.4,0.7,0.7,1.2,0.6s0.9-0.6,0.9-1.1
		C290.3,112.2,289.8,111.8,289.2,111.9z"
      />
      <path
        class="st3"
        d="M259.2,84.1c0.7-0.3,1-0.8,0.9-1.5c-1.1,0-2,0.2-2.6,1.1C257.9,84.2,258.5,84.3,259.2,84.1z"
      />
      <path
        class="st3"
        d="M94.4,157c0.7-0.6,0.5-0.9-0.9-1.5c-1.1,1.1-1.1,1.3,0,2c0.2-0.1,0.3-0.2,0.4-0.2
		C94.1,157.2,94.3,157.1,94.4,157z"
      />
      <path
        class="st3"
        d="M262.7,87.7c-0.1,0-0.2,0.1-0.3,0.2c0.4,0,0.9-0.1,1.3-0.1C263.4,87.6,263,87.6,262.7,87.7z"
      />
      <path
        class="st3"
        d="M39.4,128.7c-0.1-0.9-0.7-1.4-1.9-1.6C37.1,128.8,37.7,129.3,39.4,128.7z"
      />
      <path
        class="st3"
        d="M187.6,110.2c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C186.5,110,187.1,110.3,187.6,110.2z"
      />
      <path
        class="st3"
        d="M179.2,113.4c0.2-0.3,0.2-0.7,0.1-1l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C178.4,114,178.8,113.9,179.2,113.4z"
      />
      <path
        class="st3"
        d="M201.3,103.1c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C201.7,102,201.2,102.6,201.3,103.1z"
      />
      <path
        class="st3"
        d="M186.8,122c0.2-0.8,0.2-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C186.4,122.5,186.7,122.2,186.8,122z"
      />
      <path
        class="st3"
        d="M87.3,144.3c-0.1-0.4-0.7-0.7-1.2-0.6c-0.5,0.1-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6
		C86.9,145.4,87.4,144.7,87.3,144.3z"
      />
      <path
        class="st3"
        d="M261.6,117.3c0,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C262.1,117.9,261.9,117.6,261.6,117.3z"
      />
      <path
        class="st3"
        d="M50.5,158.2c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C50.8,157.9,50.6,158.1,50.5,158.2z"
      />
      <path
        class="st3"
        d="M278.8,121c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C278.5,120.9,278.6,121,278.8,121z"
      />
      <path
        class="st3"
        d="M169.9,101.3c-0.3-0.6-0.8-0.9-2-0.7c0.1,0.4,0.3,0.7,0.4,0.9C168.9,101.5,169.4,101.4,169.9,101.3z"
      />
      <path
        class="st3"
        d="M176.2,130.1c0.1,0.5,0.3,0.7,0.4,0.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1
		C178,129.5,177.4,129.6,176.2,130.1z"
      />
      <path
        class="st3"
        d="M107.2,103.7c-1.3,0.9-1.3,0.9-0.8,2C108,104.6,108,104.6,107.2,103.7z"
      />
      <path
        class="st3"
        d="M148.7,133.6c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2s0.7-0.7,0.6-1.4
		C149.7,133.4,149.2,133.4,148.7,133.6z"
      />
      <path
        class="st3"
        d="M114.9,110.9c-0.1-0.2-0.2-0.3-0.3-0.4c-0.6,0.1-1.1,0.2-1.7,0.3C113.3,111.2,113.9,111.3,114.9,110.9z"
      />
      <path
        class="st3"
        d="M286.5,133.9c0.1-0.6-0.2-0.9-1.1-1c-0.2,0.6-0.4,1.2-0.7,2.2C285.8,134.8,286.4,134.5,286.5,133.9z"
      />
      <path
        class="st3"
        d="M246.2,82.2c0.3-0.5,0.7-0.8,0.7-1.2c0-0.4-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C245.4,81.8,245.8,81.9,246.2,82.2z"
      />
      <path
        class="st3"
        d="M264.6,118.4c0.6-0.6,0.9,0.3,1.4,0.1c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.1,0-0.2,0
		c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3C264.2,118.2,264.4,118.3,264.6,118.4z"
      />
      <path
        class="st3"
        d="M247.1,106.8c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C246.4,107,247,106.9,247.1,106.8z"
      />
      <path
        class="st3"
        d="M130.2,129c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.4,0.4-0.5,0.7c0.3,0.2,0.6,0.5,0.9,0.7
		C129.7,129.7,130.1,129.3,130.2,129z"
      />
      <path
        class="st3"
        d="M1.3,173c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1v1.3c0.2,0.1,0.5,0.3,0.7,0.5
		C1,173.7,1.3,173.3,1.3,173z"
      />
      <path
        class="st3"
        d="M128.7,88.9c0.5-1.1,0.5-1.1-0.8-1.8C127.5,88.5,127.5,88.5,128.7,88.9z"
      />
      <path
        class="st3"
        d="M2.5,122.3c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1
		C1.4,122.3,1.9,122.5,2.5,122.3z"
      />
      <path
        class="st3"
        d="M186.7,115c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C186.2,114.2,186,114.7,186.7,115z"
      />
      <path
        class="st3"
        d="M251.4,115.7c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C252.1,116.5,251.8,116.1,251.4,115.7z"
      />
      <path
        class="st3"
        d="M275.8,125.7c-0.1,0.2,0.1,0.6,0.3,0.7c0.9,0.3,1.1-0.3,1.4-0.9C276.4,125.1,276,125.1,275.8,125.7z"
      />
      <path
        class="st3"
        d="M138.1,96c-0.2,0-0.4,0.2-0.6,0.4c0.4,0,0.7-0.1,1.1-0.1C138.5,96.1,138.3,96,138.1,96z"
      />
      <path
        class="st3"
        d="M275.1,141C275.2,141,275.2,140.9,275.1,141C275.2,140.9,275.2,140.9,275.1,141
		C275.2,140.9,275.2,140.9,275.1,141C275.2,140.9,275.2,140.9,275.1,141z"
      />
      <path
        class="st3"
        d="M275.1,139.7c-0.2,0.3-0.5,0.6-0.6,0.9c0,0.1,0.2,0.2,0.4,0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1
		c0.5-0.1,1.1,0,1.4-0.7C276.3,139.8,275.8,139.7,275.1,139.7z"
      />
      <path
        class="st3"
        d="M56.2,155.3c-0.5-0.6-1-1-1.9-1C54.2,155.8,54.6,155.9,56.2,155.3z"
      />
      <path
        class="st3"
        d="M119.3,106.8c0-0.3,0-0.6,0-0.9c-0.5,0.1-1,0.1-1.5,0.2C118.1,106.5,118.6,106.6,119.3,106.8z"
      />
      <path
        class="st3"
        d="M179.6,109.7c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C178.4,109.6,179,109.5,179.6,109.7z"
      />
      <path
        class="st3"
        d="M177.6,118.2c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9c0.4,0.2,0.6,0.4,1,0.7
		C177.2,118.6,177.4,118.4,177.6,118.2z"
      />
      <path
        class="st3"
        d="M128.1,117.6L128.1,117.6c-0.3-0.2-0.5-0.4-0.8-0.4c-0.4,0-0.8,0.2-1.3,0.3c0.3,0.2,0.5,0.5,0.7,0.6
		c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2C128.1,118,128.2,117.7,128.1,117.6z"
      />
      <path
        class="st3"
        d="M259.6,98.3c0,0.2,0.5,0.6,0.8,0.6s0.6-0.4,1.1-0.8c-0.5-0.2-0.9-0.6-1.2-0.5C260,97.7,259.5,98.1,259.6,98.3z
		"
      />
      <path
        class="st3"
        d="M129.7,104.4c-0.2,0-0.3,0-0.5,0.1c0.1,0,0.1,0.1,0.2,0.1C129.6,104.5,129.7,104.4,129.7,104.4z"
      />
      <path
        class="st3"
        d="M128.4,102.9c0,0,0,0.1-0.1,0.2c0.3,0,0.7-0.1,1-0.1l0,0C129.2,102.8,128.6,102.8,128.4,102.9z"
      />
      <path
        class="st3"
        d="M281.5,129.1c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C282.2,128.5,281.7,128.5,281.5,129.1z"
      />
      <path
        class="st3"
        d="M255.2,116.8c-0.3-0.8-1.4-0.5-1.9-1l0,0l0,0C252.9,116.8,253.3,117.1,255.2,116.8z"
      />
      <path
        class="st3"
        d="M13.2,165.7c1-1,0.8-1.3-0.7-1.4C12.5,164.9,12.6,165.4,13.2,165.7z"
      />
      <path
        class="st3"
        d="M121.8,100c-0.3,0-0.7,0.1-1,0.1c0.2,0.2,0.5,0.3,0.9,0.4C121.7,100.3,121.7,100.1,121.8,100z"
      />
      <path
        class="st3"
        d="M266.7,119.5l0.1,0.1c0.1,0.1,0.6,0.2,0.8,0.1c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C265.9,118.8,266.3,119.2,266.7,119.5z"
      />
      <path
        class="st3"
        d="M231.9,79c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C231.5,79.4,231.9,79.2,231.9,79z"
      />
      <path
        class="st3"
        d="M0.9,152.8c-0.7,1.2-0.6,1.5,0.7,1.6C1.8,153.7,1.9,153,0.9,152.8z"
      />
      <path
        class="st3"
        d="M24.5,155c0.2-0.4,0.5-0.6,0.5-0.8c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8C23.7,154.7,24.1,154.8,24.5,155z"
      />
      <path
        class="st3"
        d="M74.6,173.7c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9C73.9,173.3,73.8,173.6,74.6,173.7z"
      />
      <path
        class="st3"
        d="M247.3,95.9c0.3-0.1,0.4-0.4,0.7-0.9c-0.5-0.1-0.9-0.3-1.2-0.2c-0.2,0.1-0.5,0.5-0.4,0.7
		C246.4,96,246.9,96.1,247.3,95.9z"
      />
      <path
        class="st3"
        d="M101.9,151.5c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.6,0.7,0.7,1.4,0.2
		C102.2,151.9,102.1,151.6,101.9,151.5z"
      />
      <path
        class="st3"
        d="M124.8,120.5c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C123.9,121.1,124.5,121.2,124.8,120.5z"
      />
      <path
        class="st3"
        d="M5.1,201.1c-0.4-0.2-0.7-0.5-0.9-0.4c-0.2,0.1-0.6,0.5-0.5,0.7c0,0.2,0.4,0.3,0.7,0.5
		C4.6,201.6,4.8,201.4,5.1,201.1z"
      />
      <path
        class="st3"
        d="M218.3,108.1c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.8-0.8c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.4
		c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2C218.2,108,218.3,108,218.3,108.1z"
      />
      <path
        class="st3"
        d="M154.7,99.5c0.2-0.3,0.3-0.7-0.1-1c-0.7,0.7-0.9,0.8-0.6,1.1C154.3,99.6,154.5,99.5,154.7,99.5z"
      />
      <path
        class="st3"
        d="M165.6,117.3c0.2,0.1,0.4,0.2,0.6,0.3c-0.1-0.5,0.2-0.9-0.1-1.3l0,0c-0.1-0.1-0.1-0.1-0.2-0.2c0,0,0,0-0.1,0.1
		s-0.2,0.2-0.3,0.3c-0.4,0.4-0.5,0.6-0.2,0.8C165.4,117.2,165.5,117.3,165.6,117.3z"
      />
      <path
        class="st3"
        d="M135,139.1c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1
		C134.2,139.3,134.6,139.2,135,139.1z"
      />
      <path
        class="st3"
        d="M117.6,108.2c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C116.6,108,116.9,108.4,117.6,108.2z"
      />
      <path
        class="st3"
        d="M258.4,116.9c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5
		C258,116.1,258.2,116.5,258.4,116.9z"
      />
      <path
        class="st3"
        d="M201.8,116.5c0.2,0.5,0.3,0.8,0.5,0.9s0.5,0.1,1.2,0.1l0,0C202.9,117,202.8,116.3,201.8,116.5z"
      />
      <path
        class="st3"
        d="M245.5,108.1c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2c-0.2,0.4-0.2,0.6,0.1,0.8c0.2,0.1,0.4,0.3,0.8,0.5
		c0-0.3,0-0.5,0-0.7C246.1,108.6,245.9,108.3,245.5,108.1z"
      />
      <path
        class="st3"
        d="M175.7,112.3c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C176,112.7,175.8,112.6,175.7,112.3z"
      />
      <path
        class="st3"
        d="M201.8,83.6c0.2-0.2,0.3-0.4,0.6-0.6c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.2,0.3,0.3,0.6,0.5,0.9
		C201.3,83.6,201.6,83.6,201.8,83.6z"
      />
      <path
        class="st3"
        d="M94.3,137.9c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C93.9,137,93.9,137,94.3,137.9z"
      />
      <path
        class="st3"
        d="M123.3,110.9c0.1,0.1,0.2,0.2,0.2,0.2c0.3-0.1,0.7-0.1,1-0.2c-0.1-0.3-0.4-0.5-0.7-0.8
		C123.6,110.5,123.3,110.8,123.3,110.9z"
      />
      <path
        class="st3"
        d="M132.6,96.9c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4
		C131.9,96.4,131.9,96.8,132.6,96.9z"
      />
      <path
        class="st3"
        d="M123.6,141.8c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C123.8,141.2,123.5,141.7,123.6,141.8z"
      />
      <path
        class="st3"
        d="M249.1,112.6c-0.3-0.4-0.6-0.8-1.2-1.4c-0.1,0.6-0.3,0.9-0.2,1.1C248,112.6,248.3,113.1,249.1,112.6z"
      />
      <path
        class="st3"
        d="M32.9,169c0.2-0.3,0.1-0.5-0.1-0.8c-0.1,0-0.2,0-0.3-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c-0.2,0.3,0,0.4,0.4,0.9
		C32.8,169.2,32.9,169.1,32.9,169z"
      />
      <path
        class="st3"
        d="M66.9,158.8c0-0.6-0.3-0.8-0.8-1c-0.2,0-0.3-0.1-0.5-0.1c0,0.3,0,0.5,0,0.6C65.8,158.8,66.2,158.8,66.9,158.8z
		"
      />
      <path
        class="st3"
        d="M136.7,147.2c-0.3-0.4-0.5-0.8-0.9-1.4c-0.1,0.3-0.2,0.5-0.3,0.7c0.3,0.3,0.7,0.6,1,0.9
		C136.6,147.3,136.6,147.2,136.7,147.2z"
      />
      <path
        class="st3"
        d="M183.4,122.4c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C183.6,122,183.3,122.3,183.4,122.4z"
      />
      <path
        class="st3"
        d="M273.6,133.1c0.4-1.2,0.4-1.2-0.9-1.7C273,132,273.3,132.4,273.6,133.1z"
      />
      <path
        class="st3"
        d="M285.9,119.4c-0.2-0.3-0.4-0.6-0.8-1.1C284.6,119.2,285,119.4,285.9,119.4z"
      />
      <path
        class="st3"
        d="M273.1,134.6c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,1.2-0.1,1.5-0.8c-0.4-0.1-0.7-0.2-0.9-0.2
		C273.6,134.1,273.4,134.4,273.1,134.6z"
      />
      <path
        class="st3"
        d="M184.7,120.3c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C184.3,120.8,184.5,120.5,184.7,120.3z"
      />
      <path
        class="st3"
        d="M24.5,177c0.6,0,0.9,0,1.2,0c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3
		s-0.2-0.2-0.4-0.3c-0.2,0.2-0.4,0.4-0.7,0.7C24.8,176.6,24.6,176.8,24.5,177z"
      />
      <path
        class="st3"
        d="M134.6,124.3c-0.1,0.1-0.1,0.3-0.1,0.4c0.4,0.4,0.8,0.2,1.2-0.1c0,0,0-0.1,0.1-0.3
		C134.9,124,134.8,124,134.6,124.3z"
      />
      <path
        class="st3"
        d="M188.6,80.1c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C187.8,80.1,188.2,80.2,188.6,80.1z"
      />
      <path
        class="st3"
        d="M130.5,110.1c0.1,0,0.2,0,0.4-0.1c-0.1,0-0.2-0.1-0.3-0.1C130.5,110,130.5,110.1,130.5,110.1z"
      />
      <path
        class="st3"
        d="M131.3,110.8c-0.2,0-0.4,0.1-0.7,0.1c0.1,0,0.1,0.1,0.2,0.1C131,111,131.3,110.9,131.3,110.8z"
      />
      <path
        class="st3"
        d="M157.1,99.1c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C156.6,99,156.9,99,157.1,99.1z"
      />
      <path
        class="st3"
        d="M170.3,105.5c-0.1,0-0.2-0.1-0.4-0.1s-0.3,0-0.5,0.1c-0.2,0.2-0.3,0.4-0.4,0.6l0.4,0.2
		C169.7,106,169.9,105.8,170.3,105.5z"
      />
      <path
        class="st3"
        d="M87.1,145.9c-0.8-0.2-1.2,0-1.4,0.6C86.4,146.8,86.8,146.6,87.1,145.9z"
      />
      <path
        class="st3"
        d="M135.1,127.1c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.3,0.7-0.5
		C135.5,127.3,135.2,127.1,135.1,127.1z"
      />
      <path
        class="st3"
        d="M134.6,115.9c-0.2-0.1-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3,0
		s0.3,0,0.4-0.1C134.6,116.2,134.7,115.9,134.6,115.9L134.6,115.9z"
      />
      <path
        class="st3"
        d="M12.9,156.6c-0.1-0.6-0.2-1-0.3-1.4C12,155.8,12.1,156.3,12.9,156.6z"
      />
      <path
        class="st3"
        d="M7.7,169.5c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C6.6,168.6,6.7,169,7.7,169.5z"
      />
      <path
        class="st3"
        d="M272.4,133.6c-0.4-0.4-0.8-0.6-1.6,0.1C271.5,133.9,271.9,134.4,272.4,133.6z"
      />
      <path
        class="st3"
        d="M192.7,122.7c0,0.1,0.4,0.3,0.5,0.3c0.2-0.1,0.4-0.4,0.6-0.6c-0.3-0.1-0.6-0.3-0.7-0.2
		C192.8,122.2,192.7,122.5,192.7,122.7z"
      />
      <path
        class="st3"
        d="M84.4,169.9C84.5,169.9,84.5,169.9,84.4,169.9c0.2-0.1,0.4-0.4,0.6-0.6c-0.4-0.1-0.7-0.2-0.8-0.1
		c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.2-0.2,0.3C84.1,169.8,84.3,170,84.4,169.9z"
      />
      <path
        class="st3"
        d="M87,167c0.3-0.3,0.5-0.6,0.7-0.9C86.8,166.4,86.8,166.4,87,167z"
      />
      <path
        class="st3"
        d="M164.1,110.4c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C163.9,109.8,164,110.1,164.1,110.4z"
      />
      <path
        class="st3"
        d="M171,118.5c-0.7,0.5-1,1-0.6,1.6C170.7,119.6,171.2,119.1,171,118.5z"
      />
      <path
        class="st3"
        d="M267.6,76C267.6,75.9,267.5,75.9,267.6,76c-0.2-0.1-0.4,0-0.6,0c0.1,0.1,0.1,0.2,0.2,0.2
		C267.3,76.1,267.4,76,267.6,76z"
      />
      <path
        class="st3"
        d="M159.1,108.9c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C158.7,108.7,159,108.8,159.1,108.9z"
      />
      <path
        class="st3"
        d="M243.9,125.1c-0.2-0.3-0.4-0.7-0.6-1c-0.1,0-0.2,0-0.4,0C242.4,124.9,243.1,125,243.9,125.1z"
      />
      <path
        class="st3"
        d="M252.7,111.1c0.3-0.3,0.4-0.5,0.6-0.7c-0.2-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C252.2,110.7,252.5,110.9,252.7,111.1z"
      />
      <path
        class="st3"
        d="M87.3,173.8c0-0.5-0.2-0.8-0.5-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1
		C86.5,173.4,86.8,173.6,87.3,173.8z"
      />
      <path
        class="st3"
        d="M272.4,138.4c-0.5,0.5-0.4,0.9,0,1.3C273,139.2,272.9,138.8,272.4,138.4L272.4,138.4z"
      />
      <path
        class="st3"
        d="M131.3,125.8c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C130.7,125.5,131,125.6,131.3,125.8z"
      />
      <path
        class="st3"
        d="M264.9,104.4c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C264.6,104.4,264.8,104.4,264.9,104.4z"
      />
      <path
        class="st3"
        d="M174.3,115.4c0.2-0.5,0.5-0.9,0.7-1.4c-0.4,0.1-0.7,0.1-0.8,0.2c-0.1,0-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C174.3,115.4,174.3,115.4,174.3,115.4z"
      />
      <path
        class="st3"
        d="M237.2,131c-0.1-1.2-0.7-2.1-2.5-2c-0.2,0.3-0.5,0.6-0.7,0.9c-0.5,1,0.2,1.9,1.5,1.8c0.4,0,0.7-0.2,1.1-0.3
		v0.1c0,0,0,0,0.1,0c0.4,0.7,0.5,0.7,1.4-0.1C237.7,131.2,237.4,131.1,237.2,131L237.2,131L237.2,131z"
      />
      <path
        class="st3"
        d="M33.2,171.4c0-0.2-0.3-0.3-0.7-0.5c-0.2,0.3-0.3,0.6-0.3,0.8c0,0.1,0.4,0.3,0.5,0.3
		C32.9,171.7,33.2,171.5,33.2,171.4z"
      />
      <path
        class="st3"
        d="M95.3,99.6c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C95,100,95.1,99.8,95.3,99.6z"
      />
      <path
        class="st3"
        d="M49.8,148.9c-0.3,0.3-0.6,0.5-0.8,0.8c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1C50,149,49.9,149,49.8,148.9z
		"
      />
      <path
        class="st3"
        d="M27.3,172.8l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C26.9,173.3,27.1,173,27.3,172.8z"
      />
      <path
        class="st3"
        d="M246.8,115.6c0,0.8,0.8,0.6,1.2,0.8C247.9,115.9,247.6,115.5,246.8,115.6z"
      />
      <path
        class="st3"
        d="M104.5,131.6c0.3,0.4,0.4,0.7,0.7,1.2C105.5,132,105.4,131.6,104.5,131.6z"
      />
      <path
        class="st3"
        d="M241.2,130.5c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C241.5,129.5,241.3,129.8,241.2,130.5z"
      />
      <path
        class="st3"
        d="M128.3,114.1C128.2,114.1,128.2,114.1,128.3,114.1c-0.1,0-0.1,0.1-0.1,0.1S128.2,114.2,128.3,114.1
		C128.2,114.2,128.3,114.1,128.3,114.1z"
      />
      <path
        class="st3"
        d="M128.3,114.1c0.6-0.1,1.1-0.2,1.7-0.4C129.2,113.3,129.1,113.3,128.3,114.1z"
      />
      <path
        class="st3"
        d="M76.2,167c-0.2,0.1-0.3,0.1-0.4,0.2c-0.2,0.1-0.3,0.2-0.3,0.4c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.2,0.4
		c0-0.1,0.1-0.2,0.1-0.3v-0.1c-0.1-0.1-0.1-0.3-0.2-0.4c0.2-0.1,0.3-0.1,0.5-0.2C76.2,167.2,76.2,167.1,76.2,167z"
      />
      <path
        class="st3"
        d="M131.1,123.9c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C130.8,124.3,131.1,124.1,131.1,123.9z"
      />
      <path
        class="st3"
        d="M111.6,147.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C111,147.6,111.3,147.5,111.6,147.3z"
      />
      <path
        class="st3"
        d="M28.8,176.2c0.5-0.1,0.7-0.3,0.6-0.8c0-0.1-0.4-0.2-0.4-0.1C28.5,175.6,28.4,175.9,28.8,176.2z"
      />
      <path
        class="st3"
        d="M262.3,115.3c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C262.8,115.9,262.6,115.7,262.3,115.3z"
      />
      <path
        class="st3"
        d="M168.9,114.5c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1
		c0.2-0.1,0.4-0.3,0.7-0.6C169.1,114.6,169,114.5,168.9,114.5z"
      />
      <path
        class="st3"
        d="M175.6,128.4C175.6,128.4,175.6,128.3,175.6,128.4h-0.1C175.5,128.4,175.5,128.4,175.6,128.4
		C175.5,128.4,175.6,128.4,175.6,128.4z"
      />
      <path
        class="st3"
        d="M176.4,129c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.6-0.7-0.3-1.1-0.3C175.7,128.8,175.8,129.1,176.4,129z"
      />
      <path
        class="st3"
        d="M177.9,127.3c-0.1,0.2-0.3,0.5-0.4,0.7c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6
		C178.2,127.4,178.1,127.3,177.9,127.3z"
      />
      <path
        class="st3"
        d="M55.7,151.9c0,0.1,0,0.2,0,0.3c0.2,0,0.3,0,0.5,0c0.1,0,0.2,0,0.4,0s0.5-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2
		c-0.4,0-0.8,0-1.3,0.1C55.8,151.8,55.8,151.9,55.7,151.9z"
      />
      <path
        class="st3"
        d="M283.3,123.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C282.5,124.2,282.9,124.1,283.3,123.9z"
      />
      <path
        class="st3"
        d="M64.7,176.7c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.3-0.6-0.6-0.9-1c-0.1,0.1-0.2,0.1-0.3,0.2
		C64.1,176.1,64.4,176.4,64.7,176.7z"
      />
      <path
        class="st3"
        d="M233.6,127.7c-0.1,0.6,0.3,0.8,1,1.1C234.5,128.1,234.2,127.8,233.6,127.7z"
      />
      <path
        class="st3"
        d="M126.4,88.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C126.2,88.8,126.3,88.8,126.4,88.7z"
      />
      <path
        class="st3"
        d="M79.5,179.5c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C78.9,179.7,79.3,180,79.5,179.5z"
      />
      <path
        class="st3"
        d="M253.2,102.9c-0.1-0.4-0.1-0.8-1.1-0.9c0.3,0.5,0.5,0.8,0.7,1.1C253,103,253.1,103,253.2,102.9z"
      />
      <path
        class="st3"
        d="M75.6,177.5c0.3,0.2,0.7,0.4,1,0c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5,0.1-0.8,0.1
		C75.4,177.4,75.5,177.4,75.6,177.5z"
      />
      <path
        class="st3"
        d="M76.7,177.2c0,0,0,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C76.7,177.3,76.7,177.2,76.7,177.2z"
      />
      <path
        class="st3"
        d="M267.6,113.3c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0
		C267.5,113.9,267.6,113.6,267.6,113.3z"
      />
      <path
        class="st3"
        d="M251.1,118.8c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C250.7,118.2,250.9,118.5,251.1,118.8z"
      />
      <path
        class="st3"
        d="M281.9,131.8c0,0.1-0.1,0.2-0.1,0.3c0.3,0,0.6,0.1,0.9,0.1c0-0.1,0.1-0.2,0.1-0.3
		C282.5,132,282.2,131.9,281.9,131.8z"
      />
      <path
        class="st3"
        d="M130.1,113.8L130.1,113.8C130,113.7,130,113.8,130.1,113.8C130,113.8,130,113.8,130.1,113.8
		C130,113.8,130.1,113.8,130.1,113.8z"
      />
      <path
        class="st3"
        d="M130.1,115.1c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C130.2,114.7,130.1,114.9,130.1,115.1z"
      />
      <path
        class="st3"
        d="M141.5,128.8c0,0.5,0.4,0.5,1,0.3c-0.3-0.2-0.4-0.4-0.6-0.6C141.9,128.5,141.5,128.7,141.5,128.8z"
      />
      <path
        class="st3"
        d="M167.5,111.8c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C167.2,112.1,167.4,111.9,167.5,111.8z"
      />
      <path
        class="st3"
        d="M115.4,106.5c-0.2,0-0.4,0.1-0.6,0.1c0.2,0.1,0.4,0.2,0.7,0.4C115.5,106.8,115.5,106.6,115.4,106.5z"
      />
      <path
        class="st3"
        d="M178.2,88.2c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C177.6,88.6,178,88.6,178.2,88.2z"
      />
      <path
        class="st3"
        d="M217.5,117.8c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1
		C217.3,117.7,217.4,117.7,217.5,117.8z"
      />
      <path
        class="st3"
        d="M178,121.9L178,121.9c0.1-0.1,0.1-0.2,0.2-0.2C178.1,121.7,178,121.8,178,121.9
		C177.9,121.9,177.9,121.9,178,121.9z"
      />
      <path
        class="st3"
        d="M177.5,122.9c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C177.5,122.1,177.4,122.5,177.5,122.9z"
      />
      <path
        class="st3"
        d="M135.4,132C135.5,132,135.5,132,135.4,132c0.1,0,0.2,0,0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1,0.1
		C135.1,131.8,135.3,132,135.4,132z"
      />
      <path
        class="st3"
        d="M227.4,130.6c-0.2,0.1-0.3,0.3-0.5,0.5c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C227.8,130.8,227.5,130.6,227.4,130.6z"
      />
      <path
        class="st3"
        d="M159,143.4c0.1-0.2,0.2-0.4,0.2-0.5s-0.2-0.2-0.5-0.5c-0.1,0.4-0.3,0.6-0.2,0.7
		C158.6,143.2,158.9,143.3,159,143.4z"
      />
      <path
        class="st3"
        d="M102.1,156c-0.1-0.3-0.2-0.6-0.3-0.9C101.3,155.8,101.3,155.8,102.1,156z"
      />
      <path
        class="st3"
        d="M173.7,114.3c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2
		C173.4,114.3,173.6,114.3,173.7,114.3z"
      />
      <path
        class="st3"
        d="M246.8,98c-0.2-0.3-0.5-0.5-0.8-1C245.9,97.7,246.1,98,246.8,98z"
      />
      <path
        class="st3"
        d="M247,109.1c0,0,0.1,0.2,0.2,0.3c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		C247.5,108.8,247.2,108.9,247,109.1z"
      />
      <path
        class="st3"
        d="M136.7,132.7L136.7,132.7c-0.3,0-0.6,0.1-0.9,0.2c0,0.1,0.1,0.2,0.1,0.3c0.3-0.1,0.6-0.2,0.8-0.3
		C136.8,133,136.7,132.8,136.7,132.7z"
      />
      <path
        class="st3"
        d="M179.8,125.5c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.2-0.2-0.3-0.3-0.4-0.4
		c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.4C179.5,125.3,179.7,125.5,179.8,125.5z"
      />
      <path
        class="st3"
        d="M279.5,115.9c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1
		c0,0,0,0.1,0.1,0.1C279.2,115.5,279.4,115.7,279.5,115.9z"
      />
      <path
        class="st3"
        d="M288.7,125.7c0.4,0.2,0.6,0.3,1,0.4C289.4,125.6,289.4,125.6,288.7,125.7z"
      />
      <path
        class="st3"
        d="M141.7,126.3c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C141.4,126.2,141.6,126.4,141.7,126.3z"
      />
      <path
        class="st3"
        d="M80.8,167.6c0.1,0,0.2-0.1,0.3-0.1h0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0,0-0.1-0.1
		c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.1,0.1,0.2C80.7,167.2,80.8,167.4,80.8,167.6z"
      />
      <path
        class="st3"
        d="M232.4,137.7c-0.7-0.3-1.1-0.4-1.5-0.6C231,137.6,231.3,137.9,232.4,137.7z"
      />
      <path
        class="st3"
        d="M230.9,137.1C230.9,137.1,230.9,137,230.9,137.1C230.9,137,230.9,137,230.9,137.1
		C230.8,137.1,230.8,137.1,230.9,137.1L230.9,137.1z"
      />
      <path
        class="st3"
        d="M144.8,103.2c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8
		C144.5,103.2,144.7,103.2,144.8,103.2z"
      />
      <path
        class="st3"
        d="M123.9,98.1C123.9,98.1,124,98,123.9,98.1c0-0.2-0.1-0.3-0.3-0.4c-0.1,0-0.4,0.2-0.3,0.2
		c0,0.1,0.1,0.1,0.1,0.2C123.6,98.1,123.8,98.1,123.9,98.1z"
      />
      <path
        class="st3"
        d="M126.8,94.4l0.3-0.1c0.2-0.4-0.1-0.6-0.7-0.7C126.5,93.9,126.6,94.2,126.8,94.4z"
      />
      <path
        class="st3"
        d="M237,132.2c-0.5,0.3-0.8,0.5-1.3,0.8C236.6,132.9,236.6,132.9,237,132.2z"
      />
      <path
        class="st3"
        d="M33.3,160.3c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C33.3,160.9,33.3,160.6,33.3,160.3
		z"
      />
      <path
        class="st3"
        d="M82.8,166.3c0.1-0.3,0.3-0.5,0.4-0.8c-0.1,0-0.2-0.1-0.2-0.1c-0.2,0.2-0.4,0.5-0.6,0.7
		C82.5,166.2,82.6,166.3,82.8,166.3z"
      />
      <path
        class="st3"
        d="M27.6,162.8c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4,0c0,0.2,0,0.4,0,0.6C27.4,162.8,27.5,162.8,27.6,162.8z
		"
      />
      <path
        class="st3"
        d="M189.2,113.3c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.2-0.1-0.4-0.2-0.5-0.2
		C189.3,113.1,189.2,113.2,189.2,113.3z"
      />
      <path
        class="st3"
        d="M127.4,90c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C126.8,89.8,127.1,89.9,127.4,90z"
      />
      <path
        class="st3"
        d="M232.8,145c0.3-0.1,0.5-0.2,0.8-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4
		C232.6,144.8,232.8,145,232.8,145z"
      />
      <path
        class="st3"
        d="M231.5,131.5c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0.3,0.5,0.4c0.1-0.1,0.1-0.1,0.2-0.2l0,0
		c-0.2-0.2-0.4-0.4-0.5-0.6C231.7,131.3,231.6,131.4,231.5,131.5z"
      />
      <path
        class="st3"
        d="M232.3,133.6c0.3-0.1,0.7-0.1,1-0.2v-0.1c-0.3,0.1-0.7,0.1-1,0.2C232.3,133.5,232.3,133.5,232.3,133.6z"
      />
      <path
        class="st3"
        d="M163.8,103.7c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C163.6,104,163.6,103.8,163.8,103.7z"
      />
      <path
        class="st3"
        d="M289.8,107.9c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.2,0,0.3,0
		C289.6,108.3,289.7,108.1,289.8,107.9z"
      />
      <path
        class="st3"
        d="M196.2,68.4h-0.4C195.9,68.4,196,68.5,196.2,68.4C196.1,68.5,196.2,68.5,196.2,68.4z"
      />
      <path
        class="st3"
        d="M171.2,111.7c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C171,112.1,171.1,111.9,171.2,111.7z"
      />
      <path
        class="st3"
        d="M147.4,125.1c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C147.6,124.9,147.5,125,147.4,125.1z"
      />
      <path
        class="st3"
        d="M127.7,97.4c0.1,0,0.3,0,0.4,0c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.1-0.4-0.1-0.5-0.2
		C127.8,97.2,127.7,97.3,127.7,97.4z"
      />
      <path
        class="st3"
        d="M304.5,82.9c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.4
		C304.4,82.9,304.4,82.9,304.5,82.9z"
      />
      <path
        class="st3"
        d="M243.8,106c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1v0.1c-0.1,0.1-0.1,0.2-0.1,0.3
		C243.6,105.9,243.8,106,243.8,106z"
      />
      <path
        class="st3"
        d="M271.7,128.3c0.2,0.2,0.3,0.5,0.5,0.7c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6
		C271.8,128.2,271.8,128.3,271.7,128.3z"
      />
      <path
        class="st3"
        d="M134,96.8h0.1c-0.1-0.3-0.1-0.7-0.7-0.7C133.5,96.4,133.5,96.8,134,96.8z"
      />
      <path
        class="st3"
        d="M263.2,102.3c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C263.4,102.8,263.3,102.6,263.2,102.3C263.3,102.3,263.3,102.3,263.2,102.3C263.3,102.3,263.3,102.3,263.2,102.3z"
      />
      <path
        class="st3"
        d="M129.7,115.9c-0.3-0.2-0.5-0.3-0.7-0.5C129,115.7,129,116.1,129.7,115.9z"
      />
      <path
        class="st3"
        d="M128.7,115.2L128.7,115.2l0.1,0.2C128.9,115.4,128.9,115.3,128.7,115.2C128.8,115.3,128.8,115.2,128.7,115.2z"
      />
      <path
        class="st3"
        d="M83.2,142.3l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3C83,142.1,83.1,142.2,83.2,142.3z"
      />
      <path
        class="st3"
        d="M82.1,169.7c-0.1,0.1-0.1,0.1-0.2,0.2L82,170c0.2,0.2,0.3,0.3,0.5,0.5c0.1-0.1,0.2-0.2,0.3-0.2
		c-0.2-0.1-0.3-0.3-0.5-0.4C82.2,169.7,82.1,169.7,82.1,169.7z"
      />
      <path
        class="st3"
        d="M77.5,109.3c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3
		C77.1,109.6,77.2,109.4,77.5,109.3z"
      />
      <path
        class="st3"
        d="M212.2,81.3c0.1-0.2,0.2-0.3,0.2-0.4s-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C211.9,81.1,212,81.1,212.2,81.3z"
      />
      <path
        class="st3"
        d="M273.8,119c0.2-0.1,0.3-0.3,0.5-0.4l0,0c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2s-0.2,0.2-0.2,0.3
		C273.7,118.9,273.7,118.9,273.8,119z"
      />
      <path
        class="st3"
        d="M146.2,130.3c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.1-0.2,0.2-0.2,0.3s0.2,0.2,0.4,0.4
		C146.1,130.5,146.2,130.4,146.2,130.3z"
      />
      <path
        class="st3"
        d="M131.8,115.6c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C132.1,115.8,131.9,115.6,131.8,115.6z"
      />
      <path
        class="st3"
        d="M76.2,174c-0.1,0-0.2-0.1-0.2-0.1l-0.1,0.1C76,174,76.1,174,76.2,174L76.2,174z"
      />
      <path
        class="st3"
        d="M224.9,114.3c0.1,0.1,0.3,0.1,0.4,0.1h0.1c-0.2-0.1-0.5-0.2-0.7-0.4C224.8,114.1,224.9,114.2,224.9,114.3z"
      />
      <path
        class="st3"
        d="M171.3,91.8c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C171.2,91.9,171.2,91.9,171.3,91.8z"
      />
      <path
        class="st3"
        d="M223.9,113.8c0.2,0,0.5,0.1,0.7,0.1c-0.2-0.1-0.4-0.3-0.6-0.4C224,113.6,223.9,113.7,223.9,113.8z"
      />
      <path
        class="st3"
        d="M224.6,113.9c0,0,0.1,0,0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0-0.1C224.7,113.9,224.6,113.9,224.6,113.9z"
      />
      <path
        class="st3"
        d="M158.6,96.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C158.4,96.3,158.5,96.2,158.6,96.1z"
      />
      <path
        class="st3"
        d="M78.3,174c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.2l0.1-0.1C78.5,174.1,78.4,174.1,78.3,174z"
      />
      <path
        class="st3"
        d="M231,76.7c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C231.1,76.6,231.1,76.6,231,76.7z"
      />
      <path
        class="st3"
        d="M235.1,110.1c0.2-0.1,0.4-0.2,0.6-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2
		C235.1,110,235.1,110,235.1,110.1z"
      />
      <path
        class="st3"
        d="M270,130.4c0,0.4,0.1,0.7,0.1,0.9C270.6,131.1,270.3,130.8,270,130.4z"
      />
      <path
        class="st3"
        d="M267.9,118.1c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0c-0.1,0,0,0.2-0.1,0.2
		C267.8,118.1,267.9,118.1,267.9,118.1z"
      />
      <path
        class="st3"
        d="M25.3,172.8c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1C25.5,172.9,25.4,172.8,25.3,172.8z
		"
      />
      <path
        class="st3"
        d="M124.5,137C124.5,137,124.5,137.1,124.5,137c0,0.1,0.1,0.2,0.2,0.2v-0.1C124.6,137.1,124.6,137.1,124.5,137z"
      />
      <path
        class="st3"
        d="M0.4,203.1c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2,0.1v0.1c0.1,0.1,0.2,0.1,0.3,0.2C0.3,203.2,0.4,203.1,0.4,203.1
		z"
      />
      <path
        class="st3"
        d="M0.3,202.2c-0.1-0.2-0.1-0.3-0.2-0.5H0v0.2c0,0.1,0.1,0.2,0.1,0.3C0.2,202.2,0.3,202.2,0.3,202.2z"
      />
      <path
        class="st3"
        d="M83.7,173.5C83.8,173.5,83.8,173.5,83.7,173.5c0.1,0.2,0.2,0.2,0.2,0.3c0.1-0.1,0.1-0.1,0.2-0.2
		c0-0.1-0.1-0.2-0.1-0.2C84,173.3,83.9,173.4,83.7,173.5C83.8,173.4,83.8,173.4,83.7,173.5z"
      />
      <path
        class="st3"
        d="M178.5,120.8c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		c0.2-0.2,0.3-0.4,0.5-0.6C178.7,120.9,178.6,120.9,178.5,120.8z"
      />
      <path
        class="st3"
        d="M185.8,124.4L185.8,124.4l0.1,0.1C185.9,124.6,185.8,124.5,185.8,124.4C185.8,124.5,185.8,124.5,185.8,124.4z"
      />
      <path
        class="st3"
        d="M185.5,124.1c0.1,0.1,0.1,0.2,0.2,0.3C185.7,124.3,185.7,124.2,185.5,124.1
		C185.6,124.1,185.6,124.1,185.5,124.1z"
      />
      <path
        class="st3"
        d="M173.4,108.5c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C173.1,108.6,173.2,108.6,173.4,108.5z"
      />
      <path
        class="st3"
        d="M276.7,141.3c0.1,0,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2
		C276.5,141.2,276.6,141.3,276.7,141.3z"
      />
      <path
        class="st3"
        d="M186.3,125c0.1-0.1,0.1-0.2,0.2-0.3c-0.2,0-0.4-0.1-0.6-0.1C186,124.7,186.2,124.9,186.3,125z"
      />
      <path
        class="st3"
        d="M74.6,143.3c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C74.5,143.2,74.6,143.2,74.6,143.3z"
      />
      <path
        class="st3"
        d="M75.1,143c0.1,0,0.2,0,0.2-0.1v-0.1c0,0,0,0-0.1,0.1C75.2,142.9,75.2,142.9,75.1,143z"
      />
      <path
        class="st3"
        d="M189.7,117.8c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C189.6,118.1,189.6,117.9,189.7,117.8
		z"
      />
      <path
        class="st3"
        d="M31.7,158.7c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1
		C31.5,158.8,31.6,158.8,31.7,158.7z"
      />
      <path
        class="st3"
        d="M159.9,113.6l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1
		C160,113.3,159.9,113.4,159.9,113.6C159.8,113.5,159.8,113.6,159.9,113.6z"
      />
      <path
        class="st3"
        d="M199.6,114.3c0,0.1,0.2,0.2,0.3,0.3c0.1-0.2,0.2-0.3,0.2-0.5c-0.1,0-0.3-0.1-0.4-0.1
		C199.7,114.1,199.6,114.3,199.6,114.3z"
      />
      <path
        class="st3"
        d="M249.7,113.5c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		C249.6,113.4,249.7,113.5,249.7,113.5z"
      />
      <path
        class="st3"
        d="M120.8,131c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1C120.7,131.3,120.8,131.2,120.8,131
		z"
      />
      <path
        class="st3"
        d="M233.5,121.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5
		C233.3,121,233.4,121,233.5,121.1z"
      />
      <path
        class="st3"
        d="M238.3,135.4c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C238.2,135.5,238.2,135.5,238.3,135.4z"
      />
      <path
        class="st3"
        d="M220,89.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C220,90.3,220,90.1,220,89.9z"
      />
      <path
        class="st3"
        d="M81.2,162.6c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1c-0.1,0.1-0.2,0.2-0.3,0.3C80.9,162.6,81,162.6,81.2,162.6z"
      />
      <path
        class="st3"
        d="M275.1,111c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C275,111.3,275.1,111.1,275.1,111z"
      />
      <path
        class="st3"
        d="M234.4,134.7c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.2-0.1-0.3,0C234.4,134.5,234.4,134.6,234.4,134.7z
		"
      />
      <path
        class="st3"
        d="M185.5,110c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C185.7,110.4,185.6,110.2,185.5,110z"
      />
      <path
        class="st3"
        d="M141.6,137.3c-0.1,0.1-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2-0.2,0.3-0.2
		C141.8,137.4,141.7,137.3,141.6,137.3z"
      />
      <path
        class="st3"
        d="M166.4,103.5h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C166.4,103.7,166.4,103.6,166.4,103.5z"
      />
      <path
        class="st3"
        d="M241.2,132.2c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C241,132.1,241.1,132.2,241.2,132.2z"
      />
      <path
        class="st3"
        d="M270.8,109.5c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2
		C270.9,109.4,270.8,109.5,270.8,109.5z"
      />
      <path
        class="st3"
        d="M23.2,178.5c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C23.3,178.5,23.2,178.5,23.2,178.5z"
      />
      <path
        class="st3"
        d="M188.1,100.7c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0-0.1,0s-0.2,0-0.3,0
		C188.2,100.5,188.1,100.6,188.1,100.7z"
      />
      <path
        class="st3"
        d="M288.4,105.9c0.1-0.1,0.2-0.1,0.2-0.2s-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C288.2,105.8,288.3,105.9,288.4,105.9z"
      />
      <path
        class="st3"
        d="M150.4,136.7L150.4,136.7L150.4,136.7C150.4,136.7,150.4,136.8,150.4,136.7c-0.1,0.2-0.2,0.3-0.3,0.4l0,0
		c0.1,0,0.2,0,0.4,0c0-0.1,0.1-0.2,0.1-0.3C150.6,136.8,150.5,136.8,150.4,136.7z"
      />
      <path
        class="st3"
        d="M168.6,118.4c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C168.5,118.1,168.5,118.2,168.6,118.4z"
      />
      <path
        class="st3"
        d="M140.7,123.7L140.7,123.7C140.8,123.7,140.8,123.7,140.7,123.7C140.8,123.7,140.8,123.6,140.7,123.7
		C140.8,123.6,140.7,123.6,140.7,123.7z"
      />
      <path
        class="st3"
        d="M141.8,122.5c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C142,122.6,141.9,122.5,141.8,122.5z"
      />
      <path
        class="st3"
        d="M241.2,99.3c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C241,99.2,241.1,99.3,241.2,99.3z"
      />
      <path
        class="st3"
        d="M165.6,119.8c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C165.5,119.7,165.6,119.8,165.6,119.8z"
      />
      <path
        class="st3"
        d="M84.1,137.9c0-0.1,0.1-0.1,0.1-0.2C84.2,137.7,84.1,137.8,84.1,137.9c-0.1,0-0.2,0.1-0.2,0.1
		C84,137.9,84,137.9,84.1,137.9z"
      />
      <path
        class="st3"
        d="M105.9,133.3c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C106.3,133.3,106.1,133.3,105.9,133.3z"
      />
      <path
        class="st3"
        d="M183.8,109.4c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1C183.7,109.6,183.7,109.5,183.8,109.4z"
      />
      <path
        class="st3"
        d="M76,141l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C75.9,141.2,75.9,141.1,76,141z"
      />
      <path
        class="st3"
        d="M75.5,142.5c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2c0.1-0.1,0.1-0.1,0.1-0.2V142.5z"
      />
      <path
        class="st3"
        d="M75.1,166.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.3C75,165.9,75,166,75,166
		C75,166.2,75.1,166.2,75.1,166.3z"
      />
      <path
        class="st3"
        d="M196.7,104.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C196.6,104.8,196.6,104.8,196.7,104.8z"
      />
      <path
        class="st3"
        d="M171.3,123.2h0.1C171.4,123.2,171.4,123.1,171.3,123.2C171.4,123.1,171.3,123.1,171.3,123.2L171.3,123.2z"
      />
      <path
        class="st3"
        d="M112,120.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C111.7,120.8,111.8,120.8,112,120.7
		C111.9,120.8,112,120.7,112,120.7z"
      />
      <path
        class="st3"
        d="M132.6,115.3c0,0,0.1,0,0.2,0C132.8,115.3,132.8,115.2,132.6,115.3C132.6,115.2,132.6,115.2,132.6,115.3
		C132.5,115.2,132.5,115.3,132.6,115.3z"
      />
      <path
        class="st3"
        d="M171.3,125.3c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C171.3,125.2,171.3,125.3,171.3,125.3z"
      />
      <path
        class="st3"
        d="M148.6,130.6c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C148.6,130.7,148.6,130.7,148.6,130.6L148.6,130.6z"
      />
      <path
        class="st3"
        d="M139.9,113.4c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C140.1,113.4,140,113.4,139.9,113.4z"
      />
      <path
        class="st3"
        d="M261.7,107.2L261.7,107.2c0-0.1-0.1-0.1-0.1-0.1l-0.1,0.1l0,0C261.5,107.3,261.6,107.3,261.7,107.2
		C261.7,107.3,261.7,107.3,261.7,107.2z"
      />
      <path
        class="st3"
        d="M163.2,107.7c0.1,0,0.2,0,0.3,0s0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C163.3,107.6,163.3,107.7,163.2,107.7z"
      />
      <path
        class="st3"
        d="M275,141.4c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C274.9,141.1,275,141.2,275,141.4z"
      />
      <path
        class="st3"
        d="M290.9,102.3C290.9,102.4,290.9,102.4,290.9,102.3c-0.1,0.2-0.1,0.3-0.1,0.3
		C290.8,102.6,290.9,102.5,290.9,102.3C290.9,102.4,290.9,102.4,290.9,102.3z"
      />
      <path
        class="st3"
        d="M291,102c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C291.1,102,291.1,102,291,102z"
      />
      <path
        class="st3"
        d="M30.6,159.6L30.6,159.6c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1
		C30.7,159.7,30.7,159.6,30.6,159.6z"
      />
      <path
        class="st3"
        d="M119,141c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C118.9,141.2,118.9,141.1,119,141z"
      />
      <path
        class="st3"
        d="M273.2,140.4l0.1,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1S273.2,140.3,273.2,140.4z"
      />
      <path
        class="st3"
        d="M31.7,160.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C31.7,160.9,31.7,160.8,31.7,160.8z"
      />
      <path
        class="st3"
        d="M188.1,127.4l0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1C188,127.2,188.1,127.3,188.1,127.4z"
      />
      <path
        class="st3"
        d="M122.7,115.2c-0.1,0-0.2,0-0.3-0.1c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0.1,0.1,0.2,0.1
		C122.7,115.4,122.7,115.3,122.7,115.2z"
      />
      <path
        class="st3"
        d="M253.9,112.9c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C254,112.9,254,112.8,253.9,112.9
		C254,112.8,253.9,112.9,253.9,112.9z"
      />
      <path
        class="st3"
        d="M245.4,115c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0S245.4,114.9,245.4,115z"
      />
      <path
        class="st3"
        d="M76.9,178c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C77.1,178,77,178,76.9,178z"
      />
      <path
        class="st3"
        d="M109.7,145.8L109.7,145.8C109.6,145.8,109.6,145.9,109.7,145.8c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C109.9,145.8,109.8,145.8,109.7,145.8L109.7,145.8z"
      />
      <path
        class="st3"
        d="M10,167.8H9.9v0.1c0.1,0,0.1,0,0.2,0C10,167.9,10,167.9,10,167.8z"
      />
      <path
        class="st3"
        d="M33.6,131.4v0.1C33.7,131.5,33.7,131.5,33.6,131.4C33.7,131.5,33.7,131.4,33.6,131.4z"
      />
      <path
        class="st3"
        d="M220.1,90.6l-0.1-0.1c0,0,0,0,0-0.1v0.1C220,90.6,220.1,90.6,220.1,90.6z"
      />
      <path
        class="st3"
        d="M220.4,90.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4C220.4,91,220.4,90.9,220.4,90.9z"
      />
      <path
        class="st3"
        d="M71.5,155.2c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0.1
		C71.6,155.2,71.6,155.2,71.5,155.2z"
      />
      <path
        class="st3"
        d="M71.4,155.3L71.4,155.3c0.1,0,0.1,0,0.1-0.1C71.5,155.3,71.5,155.3,71.4,155.3L71.4,155.3z"
      />
      <path
        class="st3"
        d="M71.1,155.7c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C71,155.6,71,155.6,71.1,155.7z"
      />
      <path
        class="st3"
        d="M248.3,82.9c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C248.5,82.9,248.4,82.9,248.3,82.9z"
      />
      <path
        class="st3"
        d="M160.1,97.8c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C160,98,160.1,97.9,160.1,97.8z"
      />
      <path
        class="st3"
        d="M26.8,125.9l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C27,125.9,26.9,125.9,26.8,125.9z"
      />
      <path
        class="st3"
        d="M277.3,114.2c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C277.2,114.2,277.3,114.2,277.3,114.2z"
      />
      <path
        class="st3"
        d="M277.6,132.6c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.2
		C277.7,132.4,277.6,132.5,277.6,132.6z"
      />
      <path
        class="st3"
        d="M144.5,100.2c0,0.1,0,0.1,0,0.2c0,0,0.1,0,0.1-0.1C144.5,100.3,144.5,100.3,144.5,100.2z"
      />
      <path
        class="st3"
        d="M249,138.4v-0.1c-0.2,0-0.4,0.1-0.6,0.1v0.1C248.6,138.5,248.8,138.4,249,138.4z"
      />
      <path
        class="st3"
        d="M27.7,125.4c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C27.6,125.2,27.7,125.3,27.7,125.4z"
      />
      <path
        class="st3"
        d="M27.5,124.9C27.5,125,27.5,125,27.5,124.9c0.1,0.1,0.1,0.1,0.1,0.1C27.6,125.1,27.6,125,27.5,124.9
		C27.5,125,27.5,125,27.5,124.9z"
      />
      <path
        class="st3"
        d="M144.3,99.1l-0.1-0.1l-0.1,0.1l0.1,0.1C144.3,99.1,144.3,99.1,144.3,99.1z"
      />
      <path
        class="st3"
        d="M11.3,188.5c0,0,0.1,0,0.1-0.1v-0.1c-0.1,0-0.1,0.1-0.2,0.1C11.2,188.4,11.3,188.5,11.3,188.5z"
      />
      <path
        class="st3"
        d="M96.5,107.8L96.5,107.8C96.4,107.7,96.4,107.8,96.5,107.8C96.4,107.8,96.4,107.8,96.5,107.8z"
      />
      <path
        class="st3"
        d="M96.3,107.7L96.3,107.7L96.3,107.7C96.2,107.6,96.2,107.6,96.3,107.7C96.3,107.6,96.3,107.7,96.3,107.7z"
      />
      <path
        class="st3"
        d="M172.9,90.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C172.8,90.2,172.9,90.1,172.9,90.1z"
      />
      <path
        class="st3"
        d="M269.9,130.1C269.9,130.1,269.9,130,269.9,130.1c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		C269.7,130.1,269.8,130.1,269.9,130.1z"
      />
      <path
        class="st3"
        d="M119.9,101.1c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C119.9,100.8,119.8,100.9,119.9,101.1
		C119.7,101,119.8,101.1,119.9,101.1z"
      />
      <path
        class="st3"
        d="M228.5,128.6c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1
		C228.4,128.8,228.5,128.7,228.5,128.6z"
      />
      <path
        class="st3"
        d="M244.3,135.3c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3
		C244.2,135.2,244.3,135.3,244.3,135.3z"
      />
      <path
        class="st3"
        d="M157.6,144.7C157.6,144.6,157.5,144.7,157.6,144.7c-0.1,0.1,0,0.2,0,0.2l0.1-0.1
		C157.6,144.7,157.6,144.7,157.6,144.7z"
      />
      <path
        class="st3"
        d="M243.1,126.2c0,0.1,0,0.1,0.1,0.2l0.1-0.1C243.3,126.2,243.2,126.2,243.1,126.2
		C243.2,126.2,243.2,126.2,243.1,126.2z"
      />
      <path
        class="st3"
        d="M268.2,120.7c0,0.1,0.1,0.1,0.2,0.2v-0.1C268.4,120.7,268.4,120.7,268.2,120.7
		C268.3,120.7,268.2,120.7,268.2,120.7z"
      />
      <path
        class="st3"
        d="M239.8,127.6l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.1,0.1C239.8,127.7,239.8,127.6,239.8,127.6z"
      />
      <path
        class="st3"
        d="M286,125c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3C285.9,124.9,286,124.9,286,125z"
      />
      <path
        class="st3"
        d="M107.1,97.4L107.1,97.4c-0.1-0.1-0.2-0.1-0.2,0C106.9,97.4,106.9,97.5,107.1,97.4
		C107,97.4,107,97.4,107.1,97.4z"
      />
      <path
        class="st3"
        d="M79.9,169l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1l0.1,0.1C79.7,169.1,79.8,169,79.9,169z"
      />
      <path
        class="st3"
        d="M93.5,159.5c0,0.1,0.1,0.1,0.2,0.2l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C93.5,159.4,93.5,159.5,93.5,159.5z"
      />
      <path
        class="st3"
        d="M26.3,174.9C26.4,174.8,26.4,174.8,26.3,174.9c0.1-0.1,0-0.1,0-0.1l-0.1-0.1l-0.1,0.1
		C26.2,174.8,26.2,174.8,26.3,174.9L26.3,174.9z"
      />
      <path
        class="st3"
        d="M154.8,75.1c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C154.7,75.3,154.8,75.2,154.8,75.1z"
      />
      <path
        class="st3"
        d="M65.2,89.5c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C65.2,89.7,65.3,89.6,65.2,89.5z"
      />
      <path
        class="st3"
        d="M14.3,177.6c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C14.2,177.7,14.3,177.7,14.3,177.6z"
      />
      <path
        class="st3"
        d="M18.3,176.9c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0.1C18.3,176.8,18.3,176.9,18.3,176.9z"
      />
      <path
        class="st3"
        d="M2.1,207.7c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0l0,0l0,0C2.1,207.9,2.1,207.8,2.1,207.7z"
      />
      <path
        class="st3"
        d="M277.5,141.5l-0.1-0.1l-0.1,0.1l0.1,0.1C277.5,141.6,277.5,141.6,277.5,141.5z"
      />
      <path
        class="st3"
        d="M0.5,200.2c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C0.6,200.2,0.6,200.2,0.5,200.2z"
      />
      <path
        class="st3"
        d="M0.3,200.5v0.1C0.4,200.6,0.4,200.5,0.3,200.5C0.4,200.5,0.4,200.4,0.3,200.5C0.4,200.4,0.4,200.4,0.3,200.5z"
      />
      <path
        class="st3"
        d="M283.6,135.1c0,0-0.1,0-0.1-0.1l0,0l0,0C283.5,135.1,283.5,135.1,283.6,135.1z"
      />
      <path
        class="st3"
        d="M76.9,180.1L76.9,180.1C76.8,180.1,76.8,180.1,76.9,180.1C76.8,180.2,76.9,180.2,76.9,180.1L76.9,180.1z"
      />
      <path
        class="st3"
        d="M76.9,179.9c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C77.1,180,77,179.9,76.9,179.9z"
      />
      <path
        class="st3"
        d="M254.7,140.5l-0.1,0.1C254.6,140.6,254.6,140.6,254.7,140.5C254.7,140.6,254.7,140.6,254.7,140.5z"
      />
      <path
        class="st3"
        d="M70.4,179.3L70.4,179.3c0,0,0-0.1-0.1-0.1C70.3,179.2,70.3,179.2,70.4,179.3C70.3,179.3,70.3,179.3,70.4,179.3
		z"
      />
      <path
        class="st3"
        d="M77.7,177c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C77.8,176.9,77.8,176.9,77.7,177z"
      />
      <path
        class="st3"
        d="M280.9,131.9c0-0.1,0.1-0.2,0.1-0.3C280.9,131.7,280.9,131.8,280.9,131.9c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.1,0,0.1,0.1,0.2,0.1C280.8,132.1,280.8,132,280.9,131.9z"
      />
      <path
        class="st3"
        d="M249.4,138.9C249.4,138.9,249.5,138.9,249.4,138.9c0.1,0.1,0.1,0.1,0.2,0.1l0,0c0,0,0,0,0.1,0l0,0
		C249.5,138.9,249.5,138.9,249.4,138.9z"
      />
      <polygon class="st3" points="273.5,130.8 273.6,130.8 273.5,130.7 	" />
      <path
        class="st3"
        d="M270,131.6c0-0.1,0.1-0.2,0.1-0.2l0,0l0,0C270,131.5,270,131.5,270,131.6z"
      />
      <path
        class="st3"
        d="M79.4,172.1c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C79.5,172.1,79.4,172.1,79.4,172.1z"
      />
      <path
        class="st3"
        d="M79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.3,172.1,79.3,172.1,79.3,172C79.4,172.1,79.3,172.1,79.3,172
		C79.3,172.1,79.3,172.1,79.3,172z"
      />
      <path
        class="st3"
        d="M79.1,172c0.1,0,0.1,0,0.2,0.1V172C79.2,172,79.2,172,79.1,172z"
      />
      <path
        class="st3"
        d="M8.3,187.1h0.1l0.1-0.1l-0.1-0.1C8.3,187,8.3,187,8.3,187.1z"
      />
      <path
        class="st3"
        d="M273.4,129.1v0.1C273.4,129.2,273.4,129.2,273.4,129.1c0.1,0,0.1-0.1,0.1-0.1
		C273.4,129,273.4,129.1,273.4,129.1z"
      />
      <polygon class="st3" points="270.6,129.3 270.6,129.2 270.5,129.3 	" />
      <path
        class="st3"
        d="M83.2,166.7L83.2,166.7C83.2,166.7,83.3,166.7,83.2,166.7c0.1,0,0.2,0,0.2,0.1
		C83.4,166.7,83.4,166.7,83.2,166.7C83.3,166.6,83.3,166.7,83.2,166.7z"
      />
      <path
        class="st3"
        d="M83.5,166.8L83.5,166.8c0.1,0.1,0.1,0.1,0.1,0.1C83.6,166.8,83.5,166.8,83.5,166.8L83.5,166.8z"
      />
      <polygon class="st3" points="32.6,175.6 32.5,175.5 32.4,175.5 	" />
      <path
        class="st3"
        d="M233,131.3c0,0.1,0,0.2-0.1,0.2C233,131.4,233,131.4,233,131.3c0.1-0.1,0.1-0.1,0.1-0.2
		C233.1,131.1,233,131.2,233,131.3z"
      />
      <polygon class="st3" points="28.8,172.6 28.9,172.5 28.9,172.5 	" />
      <polygon class="st3" points="87.9,159.5 87.9,159.4 87.8,159.4 	" />
      <path
        class="st3"
        d="M86.5,158.1c-0.1,0-0.2,0-0.2-0.1h-0.1c0,0,0,0,0.1,0.1C86.3,158.1,86.4,158.1,86.5,158.1z"
      />
      <path
        class="st3"
        d="M274.5,117.1c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C274.4,117.2,274.5,117.2,274.5,117.1z"
      />
      <path
        class="st3"
        d="M242.7,124.1c0.1,0,0.1,0,0.2,0C242.8,124.1,242.8,124,242.7,124.1C242.7,124,242.7,124,242.7,124.1z"
      />
      <path
        class="st3"
        d="M85.9,157.8l-0.1,0.1c0.1,0,0.2,0,0.3,0.1C86.1,158,86,157.9,85.9,157.8z"
      />
      <path
        class="st3"
        d="M101.9,154.1c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2-0.1,0.2c0-0.1,0.1-0.1,0.1-0.2
		C101.9,154.3,101.9,154.2,101.9,154.1z"
      />
      <path
        class="st3"
        d="M235.3,123.7c0.1,0,0.2,0,0.2,0.1c0-0.1,0-0.1,0-0.2C235.5,123.6,235.4,123.7,235.3,123.7z"
      />
      <polygon class="st3" points="155.8,140.9 156,141 155.9,140.9 	" />
      <polygon class="st3" points="242.6,121.9 242.7,121.8 242.6,121.8 	" />
      <path
        class="st3"
        d="M235.6,123.3c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0.1l0,0C235.6,123.4,235.6,123.4,235.6,123.3z"
      />
      <path
        class="st3"
        d="M75.7,157.7l-0.1-0.1l-0.1,0.1l0.1,0.1C75.7,157.7,75.7,157.7,75.7,157.7z"
      />
      <polygon class="st3" points="246.2,115.5 246.2,115.4 246.1,115.4 	" />
      <path
        class="st3"
        d="M290.3,103.6c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C290.2,103.7,290.3,103.7,290.3,103.6z"
      />
      <path
        class="st3"
        d="M186.8,124.3c-0.1,0.1-0.2,0.2-0.3,0.4l0,0c0,0,0,0,0.1,0C186.7,124.6,186.8,124.5,186.8,124.3L186.8,124.3
		c0.1-0.1,0.1-0.1,0.1-0.2C186.9,124.2,186.9,124.2,186.8,124.3z"
      />
      <path
        class="st3"
        d="M178.4,126c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1C178.4,126.1,178.4,126,178.4,126z"
      />
      <polygon class="st3" points="103.4,141.3 103.3,141.3 103.4,141.4 	" />
      <path
        class="st3"
        d="M182.7,122.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C182.6,123,182.6,122.9,182.7,122.9z"
      />
      <path
        class="st3"
        d="M138.3,132.4L138.3,132.4c0-0.1-0.1-0.1-0.1-0.1C138.1,132.3,138.2,132.3,138.3,132.4z"
      />
      <path
        class="st3"
        d="M208.5,113.6c0,0-0.1,0-0.1-0.1c0,0.1,0,0.1,0,0.2C208.4,113.6,208.5,113.6,208.5,113.6z"
      />
      <path
        class="st3"
        d="M74.3,142.5l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1S74.4,142.5,74.3,142.5z"
      />
      <path
        class="st3"
        d="M74.5,142.4L74.5,142.4c0.1,0,0.1-0.1,0.1-0.1C74.6,142.3,74.5,142.3,74.5,142.4z"
      />
      <path
        class="st3"
        d="M207.9,113.1l0.1-0.1c0,0-0.1,0-0.1-0.1l-0.1,0.1C207.8,113.1,207.9,113.1,207.9,113.1z"
      />
      <polygon class="st3" points="242.8,103.3 242.7,103.3 242.8,103.4 	" />
      <path
        class="st3"
        d="M94.3,135.1c0,0-0.1,0.1,0,0.1l0.1,0.1C94.4,135.2,94.4,135.2,94.3,135.1C94.4,135,94.4,135.1,94.3,135.1z"
      />
      <polygon class="st3" points="27.3,149.6 27.3,149.7 27.4,149.7 	" />
      <polygon class="st3" points="242.4,102.8 242.3,102.7 242.3,102.8 	" />
      <polygon class="st3" points="127.1,124.3 127.2,124.3 127.2,124.2 	" />
      <path
        class="st3"
        d="M128.7,116.9l0.1-0.1l-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2C128.6,116.8,128.6,116.9,128.7,116.9z"
      />
      <polygon
        class="st3"
        points="227,93.9 227,93.8 227,93.8 226.9,93.8 227,93.8 	"
      />
      <polygon class="st3" points="132.3,114.3 132.1,114.4 132.3,114.4 	" />
      <path
        class="st3"
        d="M195.1,100.3C195.1,100.3,195,100.3,195.1,100.3c-0.1,0.1-0.1,0.2-0.1,0.3C195,100.5,195,100.4,195.1,100.3
		L195.1,100.3z"
      />
      <path
        class="st3"
        d="M195.2,100c0,0.1-0.1,0.2-0.1,0.2C195.2,100.1,195.3,100.1,195.2,100C195.3,100.1,195.2,100,195.2,100z"
      />
      <polygon class="st3" points="139.8,112.2 139.9,112.2 139.8,112.1 	" />
      <polygon class="st3" points="226.5,93 226.4,93.1 226.6,93.1 	" />
      <path
        class="st3"
        d="M115.2,116.7L115.2,116.7v0.2V116.7C115.3,116.8,115.3,116.8,115.2,116.7z"
      />
      <polygon class="st3" points="2.6,141.3 2.6,141.2 2.5,141.3 	" />
      <path
        class="st3"
        d="M269.6,80.3c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C269.5,80.3,269.6,80.3,269.6,80.3z"
      />
      <path
        class="st3"
        d="M70.4,120.8L70.4,120.8L70.4,120.8v0.2C70.4,121,70.4,120.9,70.4,120.8z"
      />
      <path
        class="st3"
        d="M106.5,110.2C106.5,110.3,106.5,110.3,106.5,110.2c0.1,0,0.2,0,0.2-0.1l-0.1-0.1
		C106.5,110.1,106.5,110.2,106.5,110.2z"
      />
      <path
        class="st3"
        d="M159.2,97.6l-0.1-0.1l-0.1,0.1l0.1,0.1C159.2,97.7,159.2,97.6,159.2,97.6z"
      />
      <polygon class="st3" points="139.2,101 139.3,101 139.2,100.9 	" />
      <path
        class="st3"
        d="M157.1,96.5l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C157,96.5,157,96.5,157.1,96.5z"
      />
      <path
        class="st3"
        d="M96,107.5L96,107.5c0.1,0.1,0.1,0.1,0.2,0.1C96.1,107.5,96.1,107.5,96,107.5z"
      />
      <path
        class="st3"
        d="M156,92.4L156,92.4c-0.1,0.1-0.1,0.2-0.1,0.2L156,92.4L156,92.4z"
      />
      <path
        class="st3"
        d="M218.2,247.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C218.4,247,218.3,247,218.2,247.1z"
      />
      <path
        class="st3"
        d="M239.9,231.1c0,0-0.1,0-0.1-0.1l0,0l0,0C239.8,231.1,239.9,231.1,239.9,231.1z"
      />
      <path
        class="st3"
        d="M607.6,49.8c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8l0,0v-6.9c-0.9,0.3-1.9,0.5-2.8,0.9
		C608.3,48.1,607.7,48.8,607.6,49.8z"
      />
      <path
        class="st3"
        d="M258.1,234.6c0.1,0.2,0.1,0.5,0.3,0.6c0.7,0.3,1.9-0.1,2.6-0.7c-0.5-0.4-1-0.8-1.6-1.2
		C259,233.7,258.5,234.1,258.1,234.6c0-0.7,0-1.2,0.1-1.9c0.1-0.1,0.2-0.1,0.3-0.1c-0.5-0.4-0.9-0.7-1.4-1.1c-0.4,0.3-0.7,0.7-1,1.2
		c0,0.1-0.2,0.1-0.3,0.1c0-0.6-0.5-0.3-1-0.2c0.3-0.8,0.4-1.5,1.1-2c-21.9-16.8-43.7-33.6-65.6-50.4c-6.1-4.7-12.3-9.4-18.4-14.1
		c-0.4-0.3-1.2-0.6-1.5-0.4c-2.4,1.3-4.7,2.8-7.3,4.3c25.5,21.8,50.9,43.5,76.2,65.1c0-0.3,0-0.5,0.1-0.7s0.6-0.1,0.9-0.2
		c0.6-0.1,1.1-0.2,2-0.4c0.1,0,0.4,0.2,0.8,0.5c0.4-0.2,0.9-0.5,1.4-0.7c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3
		c0.4,0.3,0.7,0.7,1,1c-1.6,0.4-2.9,1.2-3.9,3c1-0.5,1.8-0.8,2.4-1.3c1.2-0.9,1.9-1.2,3.3-1.4c1.3-0.1,1.9-0.5,2.9-2.1
		c0.9,0.3,1.3,1.3,2.5,1.1c0.2,0,0.4,0.4,0.5,0.7s0,0.6,0,0.9c0,0.1-0.1,0.2-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3
		c0.1,0.1,0.3,0.2,0.3,0.3c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.5,0,0.7,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5
		c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1c0.1,0,0.3-0.1,0.5-0.1c0.1,0.3,0.3,0.6,0.4,0.8
		c0.2,0,0.3,0,0.4,0c0.3-0.3,0.6-0.5,1-0.8c0.3-0.2,0.6-0.5,0.9-0.7l0,0c0.6-0.5,1-0.9,0.6-1.5l-0.1-0.1
		C257.5,235.1,257.9,234.8,258.1,234.6z M242.1,230.4c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7c-0.9,0.2-1.7,0.4-2.9,0.6
		c0.9-0.9,1.5-1.5,2.1-2.1c0.6-1.1,1.9-1.3,3-1.9c0.2,0.7,0.3,1.4,0.5,2.3C242.7,230.9,242.4,230.6,242.1,230.4z M243.5,232l0.1-0.1
		c0,0.1,0.1,0.1,0.1,0.2C243.7,232,243.6,232,243.5,232z M254.6,235.6L254.6,235.6C254.6,235.6,254.6,235.5,254.6,235.6
		C254.6,235.5,254.6,235.6,254.6,235.6z M254.6,233.4C254.6,233.4,254.6,233.3,254.6,233.4c0-0.1,0-0.1,0.1-0.1l0.1,0.1
		C254.7,233.4,254.7,233.4,254.6,233.4z M255.7,233.1C255.7,233,255.7,233,255.7,233.1C255.7,233,255.7,233,255.7,233.1
		C255.7,233,255.7,233,255.7,233.1z"
      />
      <path
        class="st3"
        d="M437.5,189.7c2.3,0.9,4.6,1.7,7,2.6v-0.1c0-0.1,0-0.1,0.1-0.2c-2.3-0.8-4.6-1.7-6.9-2.5
		C437.7,189.5,437.6,189.6,437.5,189.7z"
      />
      <path
        class="st3"
        d="M401.3,204.2c0.2-0.1,0.3-0.3,0.5-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.3,0.2-0.4,0.3
		C401.2,204,401.2,204.1,401.3,204.2z"
      />
      <path
        class="st3"
        d="M451.9,90.8c5.8,0.7,11.6,1.2,17.5,1.9c1,0.1,1.6-0.1,2.2-0.8c1.8-1.9,3.7-3.8,5.6-5.7c1-1,1.9-2,2.9-3
		c-0.3-0.1-0.5-0.2-0.6-0.2c-11-0.9-22-1.8-33.1-2.6c0.1,0.2,0.2,0.4,0.4,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9
		c-0.1,0.1-0.1,0.3,0,0.4c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.4,0,0.9-0.1,1.3c-0.1,0.3-0.3,0.6-0.4,0.8c-0.5-0.1-1-0.3-1.5-0.5h-0.1
		c-0.9-0.3-1.7-0.8-2.5-1.2c-1,1.4-2,2.8-3.1,4.3C443.5,89.7,447.7,90.3,451.9,90.8z"
      />
      <path
        class="st3"
        d="M443.3,74.8c0,0.2,0,0.5,0,0.6c0.5,0.9,0.8,1.9,1.4,2.8c0.7-0.5,1.2-1.2,1.8-2.1c1.1-2,2.6-3.7,4-5.7
		c-0.1,0-0.2,0-0.2-0.1v0.1c0,0,0,0,0,0.1c-1.1,0.5-2.1,0.9-3.2,1.4c-0.1,0-0.4-0.2-0.7-0.2c-0.4,0-0.9,0-1.2,0.1
		c-0.6,0.2-1.4,1.4-1.8,2.4C443.4,74.4,443.3,74.6,443.3,74.8z"
      />
      <path
        class="st3"
        d="M305.4,252.5c0.3-0.1,0.5-0.1,0.8-0.2v0.1c0.2,0.1,0.5,0.1,0.7,0.1c0.1,0,0.3,0,0.4-0.1
		c0.4-0.1,0.7-0.3,0.9-0.5c-0.9,0-1.8-0.1-2.8-0.1C305.4,252,305.4,252.2,305.4,252.5z"
      />
      <path
        class="st3"
        d="M359.5,235.8c0.1,0,0.1,0.1,0.2,0.1c10.3-7.8,20.6-15.7,30.8-23.5c3.2-2.5,6.4-4.9,9.7-7.4
		c0.1-0.2,0.1-0.5,0.3-0.7c-13.9,10.3-27.7,20.6-41.6,30.9C359.1,235.4,359.3,235.6,359.5,235.8z"
      />
      <path
        class="st3"
        d="M610.2,56.6c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.1,0.1-0.1,0.2-0.1,0.4c1.6,0.5,3.2,1,4.8,1.5
		c0.4-0.1,0.8-0.3,1.1-0.5c-0.2,0.2-0.4,0.5-0.6,0.7c0.4,0.1,0.8,0.3,1.2,0.4v-3.6c-0.5,0-1-0.1-1.4-0.4
		C610.6,56.6,610.4,56.5,610.2,56.6z M611.7,59.2c0.1-0.1,0.3,0,0.4,0c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.1-0.4,0.2
		C611.6,59.4,611.6,59.3,611.7,59.2z"
      />
      <path
        class="st3"
        d="M598.2,143.3c-1.3,0.6-2.9,0.8-2.7,3.2c-0.5-0.6-0.6-0.8-0.9-1.2c-5.2,10-10.3,19.9-15.4,29.8
		c0.2-0.1,0.5-0.1,0.8-0.2c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.5,0.8,0.9,1.1s0.9,0.4,1.6,0.4c0.3,0,0.6,0,0.9-0.1
		c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3c-0.1-0.5,0.1-0.8,0.8-1
		c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4c1,0.3,1.5-0.6,2.4-0.8c0.6,1.2,1.6,0.3,2.6,0.3c0.4-0.8,0.3-1.3-0.5-1.7
		c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3c1.2,0.3,1.8,0.1,2.3-1
		c0.1-0.3,0.2-0.7,0.3-1.1c0.2-0.4,0.4-0.7,0.7-1c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8c0,0.5-0.1,0.9-0.1,1.4v-0.1
		c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2c0.3-0.4,0.6-0.9,1-1.6
		c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3c-0.3,0.1-0.6,0.1-0.9,0.2
		c0.1,0.2,0.1,0.4,0.2,0.6h-0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5c1.4,0.6,0.9,1.6,0.7,2.5c-1.1,0.4-2,0.3-2.9,0.1
		c-1.8-0.3-3.3,0.2-4.6,1.5l-0.1,0.1c-0.4,0.5-0.7,0.9-0.9,1.4c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1
		c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.7,0.7,3.4,0.1,4-1.3
		c0.1-0.3,0.2-0.7,0.2-1.1c0-0.5,0.1-0.9,0.5-1.3c0.3-0.3,0.6-0.7,0.8-1c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1
		c1.7,1.9,2.4,2.2,5.4,2.2c-0.3,0.3-0.5,0.6-0.7,1c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3
		c-0.3,1.8,0.6,3.6,2.7,4.4c1.4,0.6,3,0.6,4.4,0.1v-8.4c-0.8-0.1-1.6-0.2-2.4-0.4c-0.1,0-0.2,0-0.3,0c0.3-0.5,0.5-0.9,0.7-1.3
		c0.5-1,0.6-1.9,0.3-2.6c-0.2-0.5-0.6-1-1.2-1.4c0,0,0,0-0.1,0c-0.4-0.3-1-0.6-1.6-1c-1.3-0.1-2.2,0.9-3.3,0.4
		c-0.8,1.2-0.8,1.2-2.1,1c0-0.2,0-0.4,0.1-0.6c0.6-0.8,0-1.4-0.5-1.9c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0
		c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3c0.3-0.3,0.6-0.6,1-0.8c0.3-0.2,0.6-0.3,0.9-0.2c0.3,0,0.6,0.2,0.8,0.5
		c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2c-0.1,0.2-0.4,0.5-0.4,0.8c0,0.2,0.5,0.3,0.8,0.6c0.6-1.2,1.3-2.2,3.1-1.9
		c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3
		s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6c-0.4-0.6-0.4-1.1-0.3-1.5c0.1-0.4,0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3
		c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.7,1-0.9h0.1v-24.6l0,0C607.4,138.9,602.8,141.1,598.2,143.3z M600.6,170.2
		c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.1-0.4-0.2-0.5C600.5,170.3,600.5,170.3,600.6,170.2z"
      />
      <path
        class="st3"
        d="M249.8,139.3l0.1,0.1c0.3,0,0.7-0.1,1-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.8-0.3,1.2-0.8,1.6-1.4
		c-0.5,0.1-0.9,0.1-1.4,0.2l0,0c-0.8,0.4-1.4,0.8-2.1,1.2C249.7,139.1,249.8,139.2,249.8,139.3z"
      />
      <path
        class="st3"
        d="M421.3,62.8c0,0.2,0,0.4,0,0.6c0,1.6-0.1,3.3-0.1,4.9c0.4,0,0.9,0,1.3,0.1c-0.2-1.5-0.3-3.1-0.4-4.7
		c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.3,0.5-0.8,0.6-1.2c-0.7,0-1.4,0-2-0.1
		c-0.3,0-0.8,0.1-1,0.3C422,61.8,421.6,62.3,421.3,62.8L421.3,62.8z"
      />
      <path
        class="st3"
        d="M306.9,249.5c-0.1,0-0.2,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.2v-3.5v-0.5v-0.4v-0.7c0.1-0.1,0.3-0.1,0.4-0.2
		c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1c0.1-0.4,0.2-0.7,0.1-1.1
		c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.3-0.5-0.6-0.7l-0.1-0.1l-0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.3v-0.1c-0.1,0-0.2,0-0.3,0
		c-0.1,0.3-0.1,0.6-0.2,0.9c0.1,0,0.3,0,0.5-0.1v0.4v1.5v0.8c-0.9-0.1-1.8-0.3-2.6-0.4c-0.1,0-0.2,0-0.3,0c0.3-0.5,0.5-0.9,0.7-1.3
		c0.4-0.7,0.5-1.4,0.5-2c-3.1-0.2-6.3-0.2-9.4-0.1c0.1,0.5-0.1,1-0.2,1.4c-1.1,0.4-2,0.3-2.9,0.1c-1.8-0.3-3.3,0.2-4.6,1.5l-0.1,0.1
		c-0.4,0.5-0.7,0.9-0.9,1.4c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0,0.1,0.1,0.3,0.1,0.4c0.9,0.3,1.8,0.4,2.9,0.4
		c1.8-0.1,2,0.1,1.8,1.6c0.5-0.3,0.9-0.6,1.2-1.1c0.1-0.3,0.2-0.7,0.2-1.1c0-0.5,0.1-0.9,0.5-1.3c0.3-0.3,0.6-0.7,0.8-1
		c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1c1.7,1.9,2.4,2.2,5.4,2.2c-0.3,0.3-0.5,0.6-0.7,1c0,0.1-0.1,0.1-0.1,0.2
		c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3c-0.3,1.8,0.6,3.6,2.7,4.4c0.7,0.3,1.5,0.4,2.2,0.4c0-0.3,0-0.6,0.1-1
		c0.1-1,0.3-1.7,1.5-1.5c1.1,0.2,2.2,0.2,3.2,0C308.2,249.8,307.6,249.5,306.9,249.5z"
      />
      <path
        class="st3"
        d="M542.5,202c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8
		c-0.3,0-0.6-0.1-1.1-0.1c0.5-0.6,0.9-1.2,1.4-1.9c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.7,0.2,1.3,0.8,2.1,1
		c0.3-0.6,0.7-1.1,1-1.7c-0.1-0.1-0.3-0.3-0.6-0.3c-1-0.1-1.6-0.4-2-1.2c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7
		c0.9-1-0.2-0.8-0.3-1.2c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.3,0.1-0.7,0.3-0.9
		c1.1-0.8,1.1-0.7,3.4,0c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4c-0.9,0-1.8,0.3-2.6-0.1c-0.3-0.2-1.2,0.3-1.9,0.6
		s-1.3,0.5-1.8,0l0,0l0,0c0.5-0.4,0.7-0.6,0.7-0.8c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0
		c1.1,0,1.1,1,1.9,1.4c0.2-0.3,0.3-0.7,0.6-1.4c0.2,0.4,0.4,0.6,0.5,0.8c0.6-0.2,1.1-0.8,1.2-1.3V188c0-0.1,0-0.3,0-0.4
		c-0.2-0.5-0.6-0.9-1-1.4l-0.1-0.1c0.2,0,0.4,0,0.7,0c-0.1-0.7,0-1.3,0.3-1.9c0.2-0.5,0.6-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3-0.7-0.7-0.8-0.5c-0.3,0.9-1.5,0.6-2,1.2c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8
		c-0.4-0.1-0.8-0.2-1.3,0c0,0.3,0,0.6,0,0.8c-0.1,1-0.8,1.8-2.1,2.4c0.3-0.8,0.7-1.6,1-2.4c-0.8-0.7,1.2-1.7-0.2-2.4
		c-0.7,0.2-0.3,0.8-0.5,1.2c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3
		c-0.6-0.1-1.3-0.2-2.2-0.2c-0.2,0.2-0.7,0.5-1.1,0.8c-0.3-0.2-0.6-0.5-1-0.7c-3.6,5.7-7.1,11.5-10.6,17.2c0.1,0.1,0.2,0.1,0.3,0.2
		c0.2,0.1,0.3,0.3,0.4,0.5c0.7,0.7,1.1,0.7,2,0.1c0.5-0.4,0.9-0.6,1.7-0.8c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5
		c-1,0.1-1.6,0.2-2.3,0.3c0.3,0.8,0.7,1.6,1.5,1.6s1.3-0.2,0.8,0.7c-0.2,0.4,1.2,0.1,0.5,0.8c0.7,0.1,0.8,0.6,1,1.1
		c0.1,0.3,0.3,0.6,0.7,0.6c1.1,0,0.8-1.1,1.5-1.2c0.4,0.5,0.9,0.9,1.3,1.4c0.1,0.2,0.3,0.3,0.4,0.5c0.6-0.3,1.1-0.5,1.6-0.7
		c0,0,0,0,0-0.1c0.1-0.2,0.1-0.4,0.3-0.5c0.3-0.2,0.7-0.4,1.4-0.6c-0.4-0.4-0.8-0.7-1-1.1c-0.3-0.4-0.5-0.9-0.6-1.3
		c0-0.1,0.3-0.2,0.5-0.4c0.1,0.1,0.2,0.2,0.2,0.3c1.3-0.2,2.1-0.8,2.6-1.9c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8
		c0.2,0.5-0.1,0.9-0.7,1.1c-0.4,0.9-0.4,0.9,0.3,2.1c1.3-0.4,2,0,2.3,1.1c0.2,0.6,0.6,0.8,1.5,1l0.1-0.1c-0.1-0.3-0.1-0.7-0.2-1.1
		c0.2-0.1,0.7-0.5,0.9-0.5c0.4,0.1,0.7,0.1,0.9,0c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.3,0.3-0.5,0.5-0.8C543.3,202,543.2,201.7,542.5,202
		z M527.2,200.7c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.2,0.4-0.3,0.5-0.5c0.1,0.1,0.2,0.1,0.2,0.2C527.6,200.4,527.4,200.5,527.2,200.7z"
      />
      <path
        class="st3"
        d="M572.3,55.8c0,0-0.1-0.1-0.1-0.2c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6l-0.1-0.1
		c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3c-0.6-0.4-0.5-1.4-1.7-0.9
		c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1c-0.5-0.4-1-0.8-1.5-1.3
		c-0.5,0.3-1,0.5-1.4,0.8l0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1c0.5,0.5,1,1,1.5,1.5c-0.3,0.7-0.7,1.4-1,2.2
		C563.2,55.6,567.8,55.7,572.3,55.8z M566,54.5L566,54.5L566,54.5L566,54.5z"
      />
      <path
        class="st3"
        d="M449,47.9c0.1-0.2-0.1-0.6-0.2-1.1c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2
		c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2s-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4
		c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6c0.5,0.1,0.6,0.3,0.6,0.6s-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1
		c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8c0.4,0.2,0.7,0.3,1.1,0.5c0.2,0.1,0.4,0.2,0.6,0.3c2.3,0,4.7,0.1,7,0.1
		C449,48.1,449,48,449,47.9z"
      />
      <path
        class="st3"
        d="M289.2,182.4c-2.3,0.6-4,2.2-4,3.5c0.1,1.1,1.5,2.6,2.7,2.8C285,185.8,285.2,185,289.2,182.4z"
      />
      <path
        class="st3"
        d="M171.6,188.7c0,0.1,0,0.2,0,0.3c0.4,0.3,0.7,0.5,1.1,0.8c5.1,4.7,10.3,9.4,15.4,14.1c1.1,1,1,1.5-0.4,2
		c-4.2,1.5-8.4,3-12.6,4.6c-0.5,0.2-0.9,0.4-1.4,0.6c0.1,0.2,0.2,0.4,0.2,0.6c5.7-2,11.3-4,17.3-6.1c-6.3-5.7-12.3-11.1-18.4-16.5
		C172.5,188.7,172,188.8,171.6,188.7z"
      />
      <path
        class="st3"
        d="M247.2,138.4c-5.7,0.9-11.3,1.9-16.8,3.1c0.3,0.4,0.6,0.8,0.9,1.2c0.5-0.1,1-0.2,1.6-0.3
		c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.3,0.7-0.2c0.1,0.1,0.2,0.2,0.2,0.3c4.8-1,9.7-1.8,14.5-2.5c-0.3-0.1-0.5-0.3-0.7-0.4
		C247.4,139,247.3,138.7,247.2,138.4z"
      />
      <path
        class="st3"
        d="M161.8,169c2.6-1.6,5-3.1,7.6-4.6c-0.2-0.2-0.4-0.5-0.5-0.5c-2.4,1.2-4.8,2.5-7.2,3.8
		c-0.1-0.1-0.2-0.3-0.3-0.4c2.1-1.4,4.2-2.8,6.4-4.2c-0.6-0.4-1-0.8-1.5-1.2c-5.4-4.2-10.9-8.4-16.3-12.5c-4-3.1-8-6.1-12-9.2
		c-0.3,0.4-0.5,0.9-0.7,1.3c-0.1,0.2-0.1,0.5-0.2,0.7c0,0.2,0,0.5,0,0.6c0.7,1.4,1.1,2.8,2.4,3.9c0.5,0.4,0.7,1,1,1.5
		c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4c0.2,0.4,0.2,0.8,0.1,1.2C147.8,157,154.8,163,161.8,169z
		"
      />
      <path
        class="st3"
        d="M288.8,251.2c0.2,0.1,0.4,0.2,0.5,0.2c0.4,0.2,0.8,0.2,1.2,0.3c0-0.2,0-0.3,0.1-0.5c-0.7,0-1.3-0.1-2-0.1
		C288.7,251.1,288.8,251.1,288.8,251.2z"
      />
      <path
        class="st3"
        d="M565.3,182.4c0.8,0.3,1.6,0.3,2.4,0.1c1-0.2,1.9-0.7,2.5-1.5c0.4-0.6,0.8-1.2,1.2-1.8c-0.2,0-0.3-0.1-0.4-0.2
		c-0.2-0.2,0-0.6-0.1-1c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.3,0.5-0.6,0.6-0.9
		c0.2-0.6,0.3-1.3,0.1-2c-0.1-0.4-0.2-0.7,0.4-1c0.3,0.2,0.7,0.4,1,0.6c0.4,0.2,0.8,0.4,1.3,0.7c-0.3,0.3-0.6,0.5-0.8,0.7
		c-0.1,0.2-0.1,0.5-0.1,1.1c0.1-0.1,0.2-0.1,0.3-0.2c5-9.6,10-19.2,15-28.9c0.2-0.3,0.3-0.7,0.5-1.2c-0.6,0.2-1,0.4-1.3,0.5
		c-6.5,3.1-12.9,6.2-19.4,9.2c-1.2,0.5-1.9,1.3-2.6,2.4c-1.5,2.6-2.9,5.1-4.4,7.7c0.1,0.1,0.2,0.2,0.2,0.3c-0.3,0.3-0.6,0.6-1,0.9
		c-0.2,0.3-0.4,0.6-0.6,1c0,0.1,0.1,0.3,0.2,0.3c1,0.4,2.7-0.5,3.2-1.4v-0.1c0-0.1,0.1-0.2,0.1-0.3c0-0.2-0.4-0.3-0.6-0.5
		c0.1-0.3,0.2-0.7,0.3-1.1c1.3,0.2,2.5-0.1,3.3-1c0.1-0.1,0.3-0.3,0.4-0.5h0.1c1.6,0.5,3,1.1,4.9-0.3c-0.2,0.8-0.3,1.3-0.4,1.8
		c-2.3-0.7-3.8-0.5-4.7,0.5l0,0c-0.1,0.1-0.2,0.2-0.3,0.4c-0.8,1.2-0.2,2.4,1.6,3.5c-0.4,0.3-0.8,0.6-1.1,0.8
		c-0.1,0-0.3-0.1-0.3-0.1c-0.3-0.4-0.5-0.7-0.9-0.9c-0.1-0.1-0.3-0.2-0.5-0.3c-0.7-0.4-1.5-0.5-2.3-0.3c-1.1,0.2-1.8,0.7-2.4,1.4
		c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2,0,0.6,0.2,0.8l0,0c0.1,0.1,0.1,0.1,0.2,0.2
		c0.1,0.1,0.2,0.2,0.3,0.3c0.8,0.8,1.6,1.5,3.2,1.4c-0.3,0.9-0.6,1.7-0.8,2.4c-1.1,0.4-2.1,0.9-3.2,1.4c-0.2-0.2-0.6-0.5-0.9-0.9
		c0.1-0.1,0.1-0.3,0.3-0.4c0.4-0.3,0.6-0.7,0.6-1.1c0-0.2,0-0.3-0.1-0.5c-0.3-0.5-1-0.8-1.6-0.7c-0.8,0.1-1.2,0.6-1.3,1.2
		c-0.3,1.1-0.3,1.2-0.7,1.6c0,0,0,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2,0.4-0.4,0.8-0.7,1.2
		c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.2-0.3,0.5-0.6,0.8c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3,0.1-0.6,0.2-0.9,0.3c-0.4,0.7-0.8,1.4-1.2,2c0.3,0,0.5,0,0.8,0c-0.4,0.3-0.7,0.6-1.1,0.9
		c0.2,0.3,0.4,0.6,0.7,0.7c0.2,0.1,0.6,0,0.8-0.1c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.7v-0.1
		l0,0c1.4,0.5,2.5-0.2,3.6-0.9c0.2,0.8,0.4,1.4,0.6,2.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0.1,0.2,0.1c0.4,0.1,0.7,0.3,1.1,0.4
		C565,182.3,565.1,182.3,565.3,182.4z"
      />
      <path
        class="st3"
        d="M597.2,59.1c2.9,0.9,5.7,1.8,8.6,2.7c-0.3-0.4-0.6-0.7-1.3-0.8c-0.4,0-0.8-0.4-1-0.7c-0.2-0.2-0.4-0.5-0.5-0.8
		c-1.6-0.5-3.2-1-4.7-1.5c-0.3-0.1-0.8,0.1-1.4,0.4c0,0.2,0,0.3,0.1,0.5C597,59,597.1,59,597.2,59.1z"
      />
      <path
        class="st3"
        d="M454.3,57.9C454.3,57.9,454.2,57.9,454.3,57.9C454.2,57.9,454.3,57.9,454.3,57.9L454.3,57.9
		c0.3,1.4,0.6,1.7,2.9,1.9c-0.8,0.4-1.3,0.8-1.5,1.3c0.2,0,0.4,0,0.5,0c0.4,0,0.9-0.1,1.1-0.3c0.7-0.9,1.4-1.9,2.2-3.1
		c-0.8,0-1.2-0.1-1.7-0.1c-1.2,0-2.4,0-3.5,0C454.3,57.7,454.3,57.8,454.3,57.9z M457.8,59.5c0.1,0,0.1,0.1,0.2,0.1
		c-0.1,0.1-0.1,0.2-0.2,0.2C457.8,59.8,457.8,59.7,457.8,59.5z"
      />
      <path
        class="st3"
        d="M581.8,65.2c-0.1,0.7,0.2,1.5,0.9,2.2c0,0,0.1,0.1,0.1,0.2c0.3-0.2,0.5-0.4,0.8-0.6c0-0.1-0.1-0.1-0.2-0.2
		c-0.3-0.4-0.4-1-0.4-1.6C582.6,65.2,582.2,65.2,581.8,65.2z"
      />
      <path
        class="st3"
        d="M261.3,231.8c-0.6-0.5-1.2-0.9-1.8-1.4v0.1c-0.3,0-0.6,0.1-0.9,0.2c0.8,0.6,1.7,1.3,2.5,1.9
		C261.1,232.4,261.2,232.2,261.3,231.8z"
      />
      <path
        class="st3"
        d="M357.8,96.4c0-0.8-0.3-1.5-0.7-2c-2.3-0.1-4.6-0.2-6.9-0.4c-0.5,0.4-0.8,0.8-1.1,1.3c-0.1,0.2-0.1,0.4-0.2,0.6
		C351.8,96.1,354.8,96.2,357.8,96.4L357.8,96.4z"
      />
      <path
        class="st3"
        d="M257.8,138.3c0.3,0,0.6-0.1,0.9-0.1c-0.3-0.1-0.6-0.2-0.9-0.3C257.8,138,257.8,138.2,257.8,138.3z"
      />
      <path
        class="st3"
        d="M229.5,140.4c0.1,0.2,0.2,0.3,0.3,0.4c5.7-1.2,11.4-2.3,17.1-3.1c-0.1-0.3-0.1-0.7-0.2-1c-1.1,0-2.6,0.8-2.7-1
		c-0.4,0.4-0.6,0.6-1,0.8c-0.2-0.2-0.4-0.4-0.6-0.6c-2,0.6-2.1,0.6-3.4,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8
		c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.4,0.2-0.6,0.3l0,0c-0.2,0.1-0.5,0.2-0.7,0.1
		c-0.9-0.1-0.9-0.2-1.9,0.2c0,0.4,0,0.8-0.1,1.2c-0.1,0-0.2,0-0.3,0C231.9,139.1,230.7,139.6,229.5,140.4z M236.4,138
		c0-0.2-0.1-0.4-0.1-0.6C236.7,137.6,237,137.7,236.4,138z"
      />
      <path
        class="st3"
        d="M546.3,204.4c-0.6-0.1-1-0.5-0.9-1.1c0-0.3-0.3-0.6-0.5-1c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.2-0.2,0.4-0.3,0.6
		c0.2,0.2,0.4,0.4,0.5,0.6c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.5,0.6,1.5,1.1,1.4c1-0.3,1.6,0.1,2.2,0.6c0.2,0.2,0.7,0.1,1.2,0.1
		C547.8,205.4,547.5,204.6,546.3,204.4z"
      />
      <path
        class="st3"
        d="M546.5,198.8v-0.1c-0.1,0.3-0.3,0.5-0.4,0.8C546.4,199.3,546.6,199.1,546.5,198.8z"
      />
      <path
        class="st3"
        d="M455.8,63c0.2-0.3,0.3-0.6,0.5-1c-0.3-0.1-0.4-0.1-0.5-0.1s-0.2,0-0.3,0c0,0.3,0,0.6,0,0.9
		c0,0.2,0,0.4-0.1,0.7C455.6,63.3,455.7,63.2,455.8,63z"
      />
      <path
        class="st3"
        d="M532.8,49.5c3,0,5.9,0,8.9,0c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.5,0.7-1,0.8-1.7l0,0c0-0.2,0.1-0.3,0.1-0.5
		c0-0.1,0-0.3,0-0.4c0-1-0.5-1.8-1.3-2.5l0,0c-0.3-0.3-0.7-0.5-1.1-0.6c0,0,0,0-0.1,0c-0.2,0-0.4,0-0.5,0c-0.8,0-1.7,0.4-2.4,0.9
		c-1.4,1.2-2.8,2.5-4.1,3.8c0,0.1,0,0.2,0.1,0.3c-0.1,0-0.2,0-0.4,0c-0.2,0.2-0.3,0.3-0.5,0.5C532.8,49.1,532.8,49.3,532.8,49.5z"
      />
      <path
        class="st3"
        d="M114.4,124.3c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.2,0.1-1.7,0.2-2.1,0.5c1.3,1.2,2.7,2.3,4,3.5
		c0.6,0,1.1-0.1,1.6-0.3c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5
		c-0.2-0.3-0.2-0.7-0.3-1.1C115.2,125,115,124.6,114.4,124.3z"
      />
      <path
        class="st3"
        d="M546.8,51.1c-0.1,0.2,0.1,0.7,0.3,0.8s0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.8-0.7c0.3,0.1,0.4,0.3,0.7,0.4
		c-0.4,0.8-1.5,1.4-1.3,2.5c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5c0.4-0.3,0.6-0.5,0.9-0.7c0,0.2,0,0.4,0,0.6
		c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1
		c0,0,0,0.1-0.1,0.1c1,0,2.1,0,3.1,0c-0.2-0.2-0.4-0.4-0.6-0.5c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1
		c-0.1-0.3-0.3-0.9-1.4-0.7c-0.3,0.1-0.7-0.4-1.1-0.7c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6
		c-0.3-0.4-0.6-0.3-1.6-0.1c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3
		l0,0l0,0c0.1,0.2,0.1,0.4,0.2,0.5c0.1,0.2,0.2,0.5,0.2,0.7c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7
		c0.3-0.6,0.5-1,0.6-1.3c-0.3-0.5-0.5-0.8-1.3-0.8c0,0.1,0,0.1,0,0.2c-0.5,0-1,0.1-1.5,0.1c-0.4,0-0.8,0-1.2,0
		C547,50.5,546.9,50.8,546.8,51.1z"
      />
      <path
        class="st3"
        d="M362.6,217.1c-0.1-0.2-0.3-0.4-0.4-0.7c-1.4,1.1-2.7,2.2-4.1,3.3C359.6,218.8,361.1,218,362.6,217.1z"
      />
      <path
        class="st3"
        d="M471.2,234.7c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9c0.5,0,1,0,1.5-0.1c1.4-2,2.8-3.9,4.3-5.9
		c0-0.1-0.1-0.2-0.1-0.2c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0c0.1-0.7,0.3-1.5,0.4-2.2c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2
		c0,0,0,0,0.1,0c2.4-0.5,4.1-2.3,4-4.4c-0.1-1.9-1.9-3.4-4.4-3.5c-0.6,0-1.2,0.1-1.8,0.1c0.2-1,0.6-2.1,0.5-3
		c-0.1-0.6-1-1.2-1.7-1.6c-1.3-0.8-2.7-0.9-4.2-0.2c-0.1,0-0.2,0.1-0.3,0.1c-1.8,0.9-2.4,2.1-2.3,3.5c0,0.4,0,0.7,0.1,1.1
		c-0.9-0.3-1.7-0.5-2.5-0.7c0.1-0.5,0.3-1,0.4-1.6s0.3-1.1,0.4-1.7c1.4-0.1,2.6-0.5,3.5-1.4c0.3-0.4,0.6-0.7,0.7-1.1
		c0.2-0.6,0.2-1.2,0.1-1.8c1.6-0.4,3.1-0.7,4.6-1.1c1.3-0.4,2-1.3,2.3-2.4c0.3-1.1-0.2-1.9-1.1-2.5c-0.2-0.2-0.5-0.3-0.8-0.5
		c-5.7,5.9-11.4,11.8-17.1,17.8c0.6-0.1,1.2-0.1,1.8-0.2c0.1,0.7,0.1,1.5,0.2,2.3c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.1-0.9-0.2-1.4-0.3c-0.9-0.2-1.8-0.1-2.5,0.2c-0.9,0.9-1.8,1.9-2.7,2.8c-0.4,1.8,1,3.4,3.2,3.7
		c0.4,0,0.8,0,1.5,0.1c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1c-0.3,1.2-0.4,2.4,0.3,3.5c1.1,1.6,2.8,2.4,5,2.3
		C468.4,237.2,470,236.2,471.2,234.7z M463,222.6c-1.1,0-2.2,0.1-3.2,0.1c0-1,0-2,0-2.9c1.1,0.3,2.3,0.6,3.7,0.9
		C463.4,221.2,463.2,221.9,463,222.6z"
      />
      <path
        class="st3"
        d="M475.7,231.1c0.4-0.2,0.8-0.5,1.2-0.8l0,0c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.1-0.5,0.2-0.8
		c-0.6,0.9-1.3,1.8-1.9,2.7C476.1,230.6,475.9,230.9,475.7,231.1z"
      />
      <path
        class="st3"
        d="M343.1,227.7c6.3-4.3,12.6-8.5,18.9-12.7c14-9.4,28-18.9,42.1-28.3c1.4-1,2.9-2,4.3-3c-2.1-1.6-4-1.9-6,0
		c-0.5,0.5-1.2,0.8-1.9,1.3c-10.3,6.8-20.6,13.6-30.9,20.4c-0.4,0.3-1,0.5-1.5,0.7c-0.1-0.2-0.2-0.3-0.3-0.5
		c12-7.9,24-15.9,36.1-23.9c-1.4-0.8-2.7-1.4-3.8-2.3c-1.2-0.9-2.2-2.2-3.2-3.2c-0.5-0.5-0.9-1.2-1.5-1.4
		c-5.2-1.9-10.4-3.6-15.6-5.4c-20.7-7-41.4-14.1-62.1-21.1c-0.7-0.3-1.7-0.3-2.5-0.1c-3.7,0.7-7.3,0.9-11-0.4
		c-0.5-0.2-1.2-0.1-1.7,0.1c-11.5,3.6-23,7.2-34.4,10.8c-16.5,5.2-33,10.4-49.5,15.5c-1.8,0.6-3.2,1.4-4,3.1c-0.6,1.3-1.7,2-3,2.5
		c-2.3,0.9-4.6,1.9-7.2,2.9c5.6,4.2,10.9,8.2,16.1,12.1c5.3,4,10.6,7.9,15.9,11.9c5.3,4,10.7,8,16,12c3.2,2.4,6.4,4.8,9.5,7.3
		c0.1,0,0.1,0,0.2,0v0.1c1.9,1.5,3.8,3,5.6,4.6c0.7,0,1.5-0.2,2.3-0.9c-0.2,0.8-0.3,1.3-0.4,1.8c-2.3-0.7-3.8-0.5-4.7,0.5l0,0
		c-0.1,0.1-0.1,0.1-0.1,0.2c3.8,2.9,7.7,5.8,11.5,8.7c0.5,0.4,1.5,0.6,2.1,0.4c0.8-0.3,1.7-0.5,2.5-0.7l0,0c0.1-0.2,0.4-0.5,0.5-0.4
		c1,0.3,1.5-0.6,2.4-0.8c0.1,0.2,0.2,0.3,0.2,0.4c0.8-0.2,1.6-0.3,2.5-0.5c0.2-0.6,0-1-0.6-1.3c-0.8,0-0.3,1.3-1.4,0.9
		c0.2-0.7,0.3-1.4,0.4-2c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1.1
		c0.2-0.4,0.4-0.7,0.7-1c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2
		c0,0,0,0.1-0.1,0.1h0.1c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3
		c0.1,0.3,0.2,0.5,0.2,0.7l0,0c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3c-0.3,0.1-0.6,0.1-0.9,0.2
		c0.1,0.2,0.1,0.4,0.2,0.6l0,0l0,0l0,0c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.2,0.3,0.3,0.7,0.5,1c0.8-0.1,1.6-0.1,2.4-0.1
		c0-0.2,0-0.4,0.1-0.5c0.6-0.8,0-1.4-0.5-1.9c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2
		c0.7-1.1,0.2-2.2-0.1-3.3c0.3-0.3,0.6-0.6,1-0.8c0.3-0.2,0.6-0.3,0.9-0.2c0.3,0,0.6,0.2,0.8,0.5c0.1,0.2,0.2,0.3,0.3,0.5
		c0.3,0.4,0.5,0.8,0.8,1.2c-0.1,0.2-0.4,0.5-0.4,0.8c0,0.2,0.5,0.3,0.8,0.6c0.6-1.2,1.3-2.2,3.1-1.9c-0.4,0.3-0.9,0.5-1.1,0.8
		c-0.2,0.5,0.3,1.1,1.1,1.5c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3s0-0.1,0-0.2
		c0-0.2,0.1-0.4,0-0.6c-0.4-0.6-0.4-1.1-0.3-1.5s0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7
		c0.3-0.3,0.6-0.7,1-0.9c0.1,0,0.2,0,0.3,0v1.6c0.1,0.1,0.3,0.2,0.5,0.3s0.3,0.1,0.5,0.1c0.3,0,0.7,0,1.1-0.2c1-0.4,1.2-1.2,1.2-2
		c0.7-0.3,1.3-0.6,2-1c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2
		c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2
		c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.3,0.3-0.3,0.5c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0
		c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2c0.2,0.7,0,1.6,1.2,1.8
		c0.1,0,0.1,0.3,0.1,0.4v0.1c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3
		c0.3,0.1,0.6,0.1,0.9,0.1c1.2,0,2-0.7,2.7-1.5c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3c0,0,0,0,0.1,0
		c0.3,0.2,0.7,0.4,0.8,0.7C339.2,230.3,341.1,229,343.1,227.7z M347.8,223.8c0.3-0.3,0.7-0.7,1-1.1c0.5,0.8,0.4,1-1,1.3
		c-0.1,0-0.1,0-0.2,0C347.6,223.9,347.7,223.8,347.8,223.8z M294.5,237.5c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1
		c-0.1-0.2-0.1-0.4-0.2-0.5C294.3,237.6,294.4,237.6,294.5,237.5z M321.3,190c-2.5,2-5.4,3-8.4,3.6c-2.9,0.6-5.9,0.8-8.9,1.2
		c-5.1-0.2-10-1.1-14.6-3.3c-1.3-0.6-2.7-1.4-3.8-2.4c-2.6-2.2-2.5-4.8,0.3-6.8c0.9-0.6,1.9-1.2,2.9-1.6c9.1-3.7,18.4-4.2,27.8-0.9
		c1.7,0.6,3.3,1.5,4.8,2.5C324.3,184.6,324.3,187.6,321.3,190z"
      />
      <path
        class="st3"
        d="M476.1,59.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.2,0.1-0.4,0.2-0.6
		c-4.3-0.1-8.6-0.1-12.9-0.2c-0.6,0-1.3,0-1.6,0.4c-0.8,0.9-1.4,1.9-2.1,3c0.4,0.1,0.6,0.1,0.8,0.1c6,0.2,12,0.3,18,0.5
		c0.2-0.2,0.3-0.3,0.5-0.4c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5
		c0.1-0.3,0.3-0.5,0.5-0.9c-0.2,0-0.5,0-0.7,0c-0.6,0.2-1.1,0.5-1.6,0.6c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		C476.9,59.1,476.5,59.2,476.1,59.3z"
      />
      <path
        class="st3"
        d="M417.9,60.9c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0.1,0.2,0.1,0.2c0.3,0.6,0.9,0.9,1.5,1.1c0.4-0.5,0.8-0.9,1.1-1.4
		c-0.4-0.1-0.5-0.2-0.6-0.2C419.2,61,418.6,60.9,417.9,60.9z"
      />
      <path
        class="st3"
        d="M357.8,219.9c-0.2,0-0.4,0-0.5,0.1c-2.4,1.6-4.8,3.2-7.1,4.7c0.1,0.1,0.3,0.3,0.4,0.4c2-1.4,4.1-2.8,6.1-4.2
		C357.1,220.6,357.5,220.2,357.8,219.9z"
      />
      <path
        class="st3"
        d="M181.8,268.1c-0.3-0.8-0.7-1.6-1.3-2.3c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.7-1-1-2,0-3.4
		c0.2-0.1,0.6-0.3,1-0.5c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4c0.6-0.4,0.7-0.7,0.8-1.1c-9.5-11.9-18.9-23.7-28.4-35.6
		c-4.2-5.2-8.5-10.4-12.7-15.6c-7.8-9.7-15.5-19.3-23.2-29c-0.5-0.6-0.9-1.5-1.1-2.3c-1.5-6.4-2.9-12.9-4.4-19.3c-0.2,0-0.3,0-0.4,0
		c-1.7-0.5-3.6-0.1-5.4-0.2c-0.3-0.4-0.5-0.8-0.8-1.1c-0.5-0.5-1.1-0.6-1.8-0.4c-0.7,0.2-1.3,0.7-1.3,1.2c0,0.1,0,0.1,0,0.2
		c0,0.5-0.1,1-0.2,1.4c-0.1,0.3-0.2,0.6-0.4,0.9c-0.1,0.1,0.1,0.4,0.2,0.7c-1.2,0-2.5-1-3.5,0.5c-0.3-0.1-0.7-0.2-1-0.2
		s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0.1-0.5,0.3-0.7,0.6c-0.1,0.1-0.1,0.1-0.1,0.2c-0.5,0.6-0.3,1.2,0.4,2
		c-0.3,0.9-0.7,1.7-0.6,2.5c0,0.1,0.1,0.2,0.1,0.3s0.1,0.2,0.1,0.3s0.1,0.2,0.2,0.3c0.3,0.4,0.6,0.8,0.9,1.2c0.2,0.3,0.5,0.6,0.9,1
		c-1.2,0.6-2.1,1.5-3.5,0.8c-0.4-0.2-0.8-0.1-1,0.4c-0.2,0.6-0.5,0.7-0.9,0.1c-0.1-0.2-0.5-0.1-0.8-0.2c0.1,3.2,0.2,6.3,0.3,9.5
		c0,1.1,0.4,2.4,0.9,3.4c7.1,13.1,14.3,26.1,21.4,39.2c3.3,6,6.7,12,10,18c3.5,6.4,7,12.8,10.5,19.1c0.2-0.1,0.3-0.3,0.5-0.4l0,0
		c0.2-0.2,0.5-0.4,0.7-0.6c-0.2-0.2-0.5-0.3-0.8-0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.1-0.9-0.2-1.5
		c0.9,0.2,1.5,0.5,2.2,0.5s1.5-0.2,2.1-0.5c0.1,0,0.2-0.1,0.3-0.1c0.2-0.2,0.2-0.3-0.3-0.5c0-0.2,0-0.4,0.1-0.8
		c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0.2,0.9,0.3,1.2,0.5c0.6,0.3,1.1,0.7,1.3,1.4c-0.5,0.2-1,0.3-1.4,0.5c-0.5,0.2-0.8,0.6-0.4,1
		c0.3,0.4,0.2,0.6-0.1,1c-0.7,0.9-0.6,1.8,0.1,2.6c0.6,0.6,1.8,0.8,2.7,0.5c1.2-0.5,1.9-1.3,1.7-2.4v-0.1c0-0.1,0-0.1,0.1-0.2
		c0.5,0.1,0.9,0.3,0.7,0.8c0,0.1,0,0.1-0.1,0.2c-0.2,0.5-0.3,1-0.5,1.5c-0.3,0.6-0.6,1.3-0.8,1.9c-0.3,0.6-0.5,1.3-0.7,1.9
		c-0.6-0.6-0.4-1.7-1.6-2.1c-0.1,0.2-0.2,0.4-0.2,0.6c0.1,1.3,1.3,2.3,1.1,3.7c-0.1,0.4,0.8,0.5,1.4,0.2c0.2-0.1,0.4-0.4,0.6-0.7
		c0.3,0.1,0.7,0.2,1,0.4c1.2,0.6,2.3,0.5,3.4-0.2c1-0.7,1.4-1.6,1.1-2.5c-0.3-1.1-1.2-1.7-2.6-1.7c-0.2,0-0.4,0-0.5,0
		c0.7-2.1,2.1-3,4-2.5c0.3,0.1,0.7,0.3,0.8,0.5c0.3,1.1,1.2,1.7,2.6,1.9c-1,1.7-2.2,3.3-1.3,5.2c-0.5,0.1-0.9,0.2-1.4,0.3
		c-1.7,0.5-2.7,1.8-2.5,3.2c0.1,1.2,1.4,2.1,2.9,2.2c1.6,0.1,3-0.8,3.5-2.2c0.1-0.3,0.2-0.7,0.3-1.1c0.6-0.1,0.9,0.1,0.9,0.6
		c0,0.8,0.1,1.5,0.1,2.4c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1c-0.1,0-0.3-0.1-0.4,0c-1.7,0.6-2.9,0.4-3.8-0.7
		c-0.1-0.2-0.2-0.4-0.4-0.5c-1.2-1.3-3.4-1.5-5.1-0.5c-0.1,0.1-0.2,0.2-0.3,0.3c2.4,4.3,4.7,8.6,7.1,12.9c0.4,0,0.7-0.1,1.1-0.1
		c0.1,0.7,0.1,1.5,0.2,2.3c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2c0-0.1-0.1-0.1-0.1-0.2c0.4,0.7,0.8,1.4,1.2,2.1
		c0-0.3,0-0.7,0-1c1.1,0.3,2.3,0.6,3.7,0.9c-0.1,0.6-0.3,1.3-0.5,1.9c-0.7,0-1.4,0-2.1,0.1c2.6,4.7,5.2,9.4,7.8,14.1
		c1-0.5,1.9-1.1,2.5-2.1c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9c1.8,0,3.6-0.2,4.9-1.5l0,0c0.6-0.5,0.9-1.1,1.1-1.8
		c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0-0.2,0-0.4c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.2-0.5-0.4-0.7c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0
		c0.1-0.7,0.3-1.5,0.4-2.2c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2c0,0,0,0,0.1,0c2.4-0.5,4.1-2.3,4-4.4
		c-0.1-1.9-1.9-3.4-4.4-3.5c-0.6,0-1.2,0.1-1.8,0.1c0.2-1,0.6-2.1,0.5-3c-0.1-0.6-1-1.2-1.7-1.6c-1.3-0.8-2.7-0.9-4.2-0.2
		c-0.1,0-0.2,0.1-0.3,0.1c-1.8,0.9-2.4,2.1-2.3,3.5c0,0.4,0,0.7,0.1,1.1c-0.9-0.3-1.7-0.5-2.5-0.7c0.1-0.5,0.3-1,0.4-1.6
		c0.1-0.6,0.3-1.1,0.4-1.7c1.4-0.1,2.6-0.5,3.5-1.4c0.3-0.4,0.6-0.7,0.7-1.1c0.2-0.6,0.2-1.2,0.1-1.8c1.6-0.4,3.1-0.7,4.6-1.1
		c1.3-0.4,2-1.3,2.3-2.4s-0.2-1.9-1.1-2.5c-1.1-0.8-2.3-1.5-3.5-2.3c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-0.8-0.7-0.9-1.3
		c-0.1-1.3-1.2-2.1-2.8-2c-1.7,0.2-2.4-0.9-3.7-1.2c0.6-0.7,0.9-1.2,1.9-1.5c0.1,0,0.1-0.1,0.2-0.1c0.5-0.1,0.9-0.4,1.3-0.7
		c0.4-0.3,0.8-0.6,1.3-0.8c1.2,0.4,1.3,1.2,1.1,2.1c-0.6,0.3-1.4-0.1-1.8,0.7c0.4,0.2,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.7,1.1,1.4
		c0.2-0.7,0.3-1.1,0.3-1.4c1-0.1,1.9-0.1,2.7,0.5c0.9,0.7,2.1,0.4,3.1-0.2c0.4-0.2,0.6-0.4,1.2-0.3c1.2,0.1,2.4-1,2.4-1.9
		c0,0,0,0,0-0.1c0-1-0.8-1.5-2-1.5c-0.2,0-0.4,0-0.6,0.1c-0.5,0.1-0.8,0.1-1.2-0.1c-1.4-0.6-2.6-0.3-3.6,0.8c-0.3,0.3-0.6,0.4-0.8,0
		c0.7-0.8,1.9-1.1,2.5-2.1c0.5-0.8,1.2-1.6,1.5-2.5c0.4-0.8,0.4-1.7,0.7-2.7c0.2-0.1,0.3-0.1,0.5-0.2c0.4-0.1,0.8-0.3,1.2-0.4
		c0,0.5-0.1,1-0.1,1.6c0.9,0.2,2.1-0.4,2.3,1.1c0,0-0.3,0.4-0.7,0.7l0,0h-0.1c-0.4-0.2-0.8-0.4-1.2-0.6c-0.2,0.2-0.3,0.3-0.3,0.5
		c-0.1,0.4,0.1,0.6,0.5,0.8l0,0c0.3,0.1,0.7,0.3,0.7,0.5c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1c0.5,0.3,1.1,0.5,1.8,0.6
		c0.1,0.1,0.1,0.2,0.2,0.3c0.3,0.6,0.6,1.2,0.9,1.7c0.2,0.3,0.4,0.7,0.6,1c0.8,1.3,1.2,2.7,1.1,4.1c0,0.5,0,1,0.1,1.5
		c0.2,0.7,0.5,1.3,1.3,1.8c-0.7,0.2-1.3,0.3-1.8,0.4l0,0c-0.4,0.1-0.7,0.2-1,0.4c-1.3,0.7-2.1,2.1-1.8,3.4c0.3,1.4,1.8,2.3,3.5,2.2
		c0.3,0,0.6,0,1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.5,0.3-1.1,0.2-1.8
		C181.9,268.5,181.8,268.3,181.8,268.1z M163.8,257c0.4-0.5,0.7-0.3,1-0.1C164.5,257,164.1,257,163.8,257z"
      />
      <path
        class="st3"
        d="M447.1,44.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7
		c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5
		c-0.2,0-0.4-0.1-0.7-0.2c-0.2,0.4-0.1,0.7,0,1c3.8,0,7.6,0.1,11.4,0.1c0.5-0.5,0.9-1.1,1.4-1.7c-0.1-0.2-0.2-0.6-0.3-0.9
		c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6c0.2-0.6,0.4-1.1,0.6-1.5h-0.1c-0.2,0-0.5,0-0.7,0c-0.2,0.1-0.4,0.4-0.6,0.4
		l0,0c0,0.1,0,0.3,0,0.4c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.3-0.2-0.5-0.3-0.8-0.5c-0.6,0-1.2,0-1.8,0c-0.3,0.1-0.6,0.2-0.9,0.3
		c0-0.1,0-0.2,0-0.3c-3.6,0-7.2-0.1-10.8-0.1C446.6,43,446.9,43.5,447.1,44.1z"
      />
      <path
        class="st3"
        d="M529.2,49.3c0.4,0,0.9,0,1.1-0.3c0.2-0.2,0.3-0.3,0.5-0.5c-0.6,0.1-1.2,0.2-1.7,0.4c-0.2,0.1-0.3,0.2-0.4,0.3
		C528.9,49.2,529.1,49.2,529.2,49.3z"
      />
      <path
        class="st3"
        d="M454.1,65.4c0.3-0.3,0.5-0.7,0.8-1c-0.4,0.1-0.7,0.2-1.1,0.2C453.9,64.8,454,65.1,454.1,65.4z"
      />
      <path
        class="st3"
        d="M355.9,225.3c0.1,0,0.1-0.1,0.2-0.1h0.1c0.4-0.2,0.9-0.5,1.6-0.1c-0.6,0.4-1.1,0.8-1.7,1.3
		c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,1,1.5,1.8,1.8c0.2,0.1,0.5,0.1,0.7,0.1c0.7,0,1.4-0.1,2.2-0.2c0.4,0.2,1,0.5,1.8,0.8
		c0.1,0.4,0.3,0.9,0.4,1.4c1.6-1.2,3.3-2.4,4.9-3.7c23.1-17.2,46.3-34.4,69.4-51.6c0.4-0.3,0.7-0.6,1.2-1c-1.5-1-2.9-1.9-4.2-2.8
		c-0.8-0.6-1.5-0.6-2.4,0c-24.1,16.6-48.3,33.1-72.4,49.6c-2.4,1.7-4.9,3.3-7.3,5c0.6,0.2,1.3,0.1,2.7-0.2c0.1,0,0.3-0.1,0.4-0.1
		C355.3,225.6,355.6,225.5,355.9,225.3z"
      />
      <path
        class="st3"
        d="M149.9,137.8C149.9,137.7,149.8,137.7,149.9,137.8c-0.5-0.1-1.1,0.8-1.6,0.2c-0.4-0.4-0.8-0.8-1.3-1.4
		c-0.2,0.5-0.4,0.9-0.7,1.3c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6c0.1,0.3,0.1,0.6,0.2,0.8c2.2,1.7,4.4,3.3,6.6,5
		c0-0.1,0-0.1,0-0.2c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9c0.1-0.5-1-0.9-0.2-1.5C150.6,138.8,150.1,138.3,149.9,137.8z"
      />
      <path
        class="st3"
        d="M286.6,136c-0.5-0.3-1-0.5-1.6-0.6c-0.1,0.2-0.2,0.4-0.4,0.7C285.2,136,285.9,136,286.6,136z"
      />
      <path
        class="st3"
        d="M527.8,50c-0.1,0.2-0.3,0.3-0.4,0.5l-0.1,0.1c-0.2,0.4-0.3,0.9-0.3,1.4c0.7-0.6,1.3-1.2,2-1.9
		c-0.3-0.1-0.4-0.2-0.5-0.2C528.3,50.1,528,50,527.8,50z"
      />
      <path
        class="st3"
        d="M441.4,171.8c-1.2-0.8-2.5-1.5-3.6-2.4c-1.3-1-2.3-0.9-3.4,0.5c1.3,0.9,2.5,1.7,3.7,2.5
		C439.8,173.5,439.9,173.5,441.4,171.8z"
      />
      <path
        class="st3"
        d="M433.7,224.3c0.1-0.3,0.2-0.6,0.3-1c-0.3-0.1-0.6-0.2-1.1-0.4c-0.1,0.9-0.7,1.4-1.6,1.2
		c-1-0.2-1.6,0.3-2.4,0.9c-0.5-0.4-1-0.7-1.6-1.1c-0.2,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1c0-0.3,0-0.4,0-0.6
		c-0.5,0-1.4,0.5-1-0.6c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7
		c0.4-1.2,0.4-1.2,1.8-1.8c-0.1-0.7,0-1.5-1.3-1.6c-0.6-0.1-0.7-0.5-0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9c-2.1-0.4-2.4,1.3-3.7,1.9
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2c-0.3-0.2-0.5-0.3-0.8-0.5
		c-0.2,0.4-0.3,0.8-0.6,1c-0.9,0.4-1.9,0.7-2.8,1.1c-0.1-0.3-0.2-0.5-0.2-0.6l0,0c0.1-0.6,0.1-1.2-0.2-1.7c-0.2-0.3-0.6-0.6-1.2-0.7
		c-0.5-0.1-0.8-0.9-1.1-1.3c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6
		c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2
		c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9c-0.3,0-0.5,0-0.8,0c-13,9.9-26,19.8-38.9,29.7c-0.2,0.3-0.4,0.6-0.6,1
		c-0.1-0.1-0.3-0.2-0.4-0.3c-1.6,1.2-3.3,2.5-4.9,3.7c0.2,0.1,0.5,0.3,0.8,0.4c0.8,0.3,1.6,0.5,2.7,0.3l0,0
		c5.5-4.3,11-8.6,16.5-12.8c0.2,0.2,0.3,0.4,0.5,0.6c-5.5,4.3-11,8.6-16.4,12.8c0,0.5,0.1,1,0.1,1.5c-0.4,0.3-0.8,0.5-1.1,0.8
		c-1.1,1-1.5,2.3-0.9,3.4c0.6,1.1,2.2,1.8,3.7,1.6c1-0.1,1.9-0.7,2.5-1.3c0.3-0.4,0.6-0.7,0.7-1.2c0.1-0.2,0.1-0.5,0.2-0.7
		c0.1-0.4,0.1-0.8,0.2-1.2c-0.2,0-0.5,0.1-0.5,0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1c0.5-0.2,0.9-0.3,1.3-0.5
		c1.7-0.7,2.4-2.2,1.7-3.6c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0c0.3,0.3,0.7,0.7,1,1
		c0.5-0.5,1-1,1.6-1.5c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7c0-0.1,0.1-0.2,0.1-0.3
		c-0.1-0.2-0.2-0.4-0.1-0.6c0-0.8,0.9-1.5,0.9-2.4c0.6,0.1,1,0.2,1.5,0.3c0.1,0,0.1,0,0.2,0c0.2-0.7,0.4-1.4,0.4-2
		c0-0.3,0-0.6,0-0.9c0-0.3-0.1-0.7-0.1-1c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8
		c0.3,0.4,0.7,0.8,1.1,1.2l0,0c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8c2.4,0.8,5,0.3,7.5-1.1
		l0,0c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3
		c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0-0.7s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5
		l0,0c-0.2-0.1-0.4-0.3-0.6-0.4c-0.2-0.1-0.5-0.3-0.7-0.4c-0.3-0.2-0.5-0.4-0.6-0.8c-0.1-0.2-0.2-0.3-0.4-0.4
		c-0.4-0.2-1.1-0.2-1.7,0.1l0,0c-0.3,0.1-0.5,0.4-0.8,0.6l-0.1,0.1c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.1-0.8-0.2-1.4
		c0.3,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2
		c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3
		c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9c0.4,0,0.9-0.5,1.4-0.8c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9
		c0,0,0.1,0,0.1,0.1c0.5,0.4,0.8,0.8,1.2,1.2c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.6,0.5,0.9,0.7c0.4,0.2,0.9,0.4,1.6,0.4
		c0.4-0.4,1.1-0.9,1.5-1.5c0.1-0.1,0.2-0.2,0.2-0.3c0.6-0.6,1.5-0.6,2.3-0.8c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4
		c-0.4,0.3-0.7,0.8-0.7,1.2c-0.1,0.7,0,1.4,0,2.2c0,0.2,0,0.4,0,0.6c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1
		c0.6-0.1,1.1-0.2,1.6-0.3c-0.2,0.7-0.3,1.5-0.6,2.5c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7c0,0.3,0.1,0.6,0.1,0.9v0.1
		c0.1,1.1,0.7,2,2,2.3c1.1,0.3,2.6-0.1,3.4-0.9c0.9-1,1.1-2,0.4-3c-0.1-0.2-0.2-0.3-0.4-0.5c0.9-0.9,2.3-0.7,3.4-1.2
		c0.5-0.6,1.1-1.2,1.3-1.8c0.3-0.8,0-1.6-0.7-2.2c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7
		c-0.1,0.4-0.2,0.8-0.3,1.2c0.3,0.3,0.5,0.6,0.9,0.9c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3
		c0,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1
		c0.3-0.3,0.7-0.5,1.1-0.8c0.2,0.1,0.3,0.2,0.4,0.3c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1
		c0.3-0.1,0.9-0.1,1.2,0.1c0.7,0.6,1.8,0.3,2.7,0.6l0,0c-0.1-0.4-0.2-0.7-0.3-0.9c0.4,0,0.9-0.1,1.3-0.1c0.2-0.2,0.4-0.4,0.6-0.6
		c-0.1-0.2-0.3-0.4-0.4-0.7c0.7-0.3,1.3-0.6,1.9-0.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.4-0.2-0.9-0.3-1.3-0.6s-0.5-0.7-0.9-1.3
		c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3s0.1-0.4-0.1-0.5C434.4,224.7,434,224.5,433.7,224.3z M409,225.7
		c-0.1,0.2-0.1,0.6-0.3,0.6c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-1,0.6-1.5,1.5-2.3,2.2c-0.3,0.3-0.7,0.5-1.2,0.7
		c0.1-0.3,0.2-0.6,0.3-0.9c0.2-0.5,0.3-1,0.5-1.5c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0C407.7,224.4,408.2,224.7,409,225.7
		c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1C409.3,225.6,409.2,225.6,409,225.7z"
      />
      <path
        class="st3"
        d="M137.6,258.2c-0.2-0.1-0.3-0.1-0.5-0.2c0.7,1.2,1.4,2.5,2.1,3.7c0.5-0.3,1-0.6,1.3-1.1
		c-0.5,0.1-0.9,0.2-1.3,0.3c-0.8-0.6-1.1-1.3-0.6-2.1C138.3,258.6,138,258.4,137.6,258.2z"
      />
      <path
        class="st3"
        d="M520.1,48.5c-1.3-0.4-2.4,0-3.3,0.6c1.5,0,3,0,4.5,0.1C520.9,48.9,520.6,48.6,520.1,48.5z"
      />
      <path
        class="st3"
        d="M140.6,263.6c-0.2-0.2-0.4-0.3-0.6-0.3c1.1,1.9,2.1,3.9,3.2,5.8c0.1-0.1,0.1-0.1,0.2-0.1c1-0.8,1.3-2,0.8-3
		c-0.4-0.9-1.2-1.3-2.3-1.5c-0.3-0.1-0.9,0-1-0.2C140.9,263.9,140.8,263.8,140.6,263.6z"
      />
      <path
        class="st3"
        d="M147.2,283.8c0.8-0.1,1.6-0.1,2.3-0.2c-2.2-3.9-4.3-7.8-6.5-11.8c-0.3,0.9-0.3,1.8,0.3,2.6
		c0.2,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,2.9-0.7,4.4c0.1,0.4,0.2,0.7,0.4,1.1c-1.4,0.7-2.5,1.7-2.1,3.2c0.3,0.9,1,1.5,2.1,1.6
		C145.5,285.7,146.6,284.9,147.2,283.8z"
      />
      <path
        class="st3"
        d="M580.4,75c-0.1-0.3-0.2-0.5-0.3-0.8c-0.3,0-0.7-0.2-0.9-0.2c-0.8,0.3-1.1,0-1.6-0.3c0,0-0.1,0-0.1,0.1
		c-0.3,0.2-0.6,0.4-1,0.6c0.1,0.1,0.2,0.2,0.3,0.3C577.9,74.8,579.1,74.9,580.4,75z"
      />
      <path
        class="st3"
        d="M481.4,81.8c3.2-3.1,6.2-6.3,9.6-9.8c-1-0.1-1.5-0.1-2-0.2c-9.6-0.4-19.3-0.7-28.9-1.2
		c0.3,0.3,0.7,0.4,1.2,0.4c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0.1,0.2,0.2,0.1,0.2c-0.5,0.6-0.9,1.2-0.8,2
		c0,0.2-0.2,0.4-0.3,0.5c-0.6-0.2-1.1-0.4-1.8-0.7c-0.3-0.4,0.4-1.3-0.4-1.8c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4
		c0.1,0.4,0.2,0.9,0.5,1.8c2,0,3.9-0.7,5.9-0.3c0.5,1.1,0.5,1.1-1.3,2.3c0.5,0.2,0.9,0.4,1.3,0.6c-0.3,1.4-1.6,0-2.2,0.9
		c0.3,0.2,0.7,0.4,1,0.6c-0.4,0.5-0.9,1-1.4,1.5c5.2,0.4,10.3,0.8,15.5,1.2C480.5,82.1,481.1,82.1,481.4,81.8z M468.4,75.8l-0.1-0.1
		c0.1,0,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0.1C468.6,75.7,468.5,75.8,468.4,75.8z"
      />
      <path
        class="st3"
        d="M553.7,90.4c0.5-0.4,1-0.9,1.8-1.5c-0.9-0.1-1.4-0.2-2-0.2c-11.2-0.9-22.4-1.6-33.6-2.7
		c-3.4-0.3-6.1,0.2-8.2,2.8c-0.2,0.3-0.5,0.5-0.8,0.7c-2.8,2.5-5.6,4.9-8.6,7.5c0.6,0.2,0.9,0.3,1.2,0.3c10.9,1.9,21.7,3.9,32.6,5.7
		c0.6,0.1,1.5-0.1,2-0.5C543.4,98.6,548.6,94.5,553.7,90.4z"
      />
      <path
        class="st3"
        d="M457.5,80.4c1.7,0.1,3.5,0.3,5.2,0.4c0.2-0.1,0.3-0.2,0.4-0.3c0.3-0.1,0.7-0.1,0.9-0.3c0.3-0.3,0.6-0.7,0.6-1
		s-0.4-0.7-0.7-0.7c-0.4,0-1,0.2-1.3,0.5s-0.4,0.7-0.6,1.2c-1.3-1.3-1.3-1.3-2.9-0.6c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4
		c0-0.2,0-0.4-0.1-0.7c-0.2,0-0.4,0-0.4,0.1c-0.3,0.6-0.9,0.8-1.7,1c-0.1-0.4-0.2-0.7-0.3-1.1c-0.1-0.5-0.3-1-0.4-1.5
		c0.7-0.5,1.1-1,0.8-1.8c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9c0.1-0.5-1-0.9-0.2-1.5c0.1-0.1-0.3-0.7-0.6-1.2h-0.1
		c-0.4-0.1-1,0.8-1.5,0.2l-0.1-0.1c-1.8,0.3-3.2,1.1-4.2,3.1c-1.1,2-2.6,3.7-4.1,5.8c0.8,0.1,1.3,0.2,1.8,0.2
		C451,79.9,454.3,80.1,457.5,80.4z"
      />
      <path
        class="st3"
        d="M485.6,60.7c0.2,0.4,0.4,0.8,0.3,1.1c2.3,0.1,4.6,0.1,6.9,0.2c-0.1-0.2-0.2-0.3-0.3-0.5
		c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1
		c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8c-0.1-0.3-0.2-0.7-0.3-1c-0.2-0.4-0.8-0.5-1.2-0.1c0,0,0,0-0.1,0.1
		c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3-0.2-0.6-0.4-1.1-0.8C485.5,59.6,485.3,60.2,485.6,60.7z"
      />
      <path
        class="st3"
        d="M420.6,57.1L420.6,57.1c0,0.3,0,0.5,0,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.7,0.2-2.1,0.3-2.5,1.1c0.3,0,0.7,0,1,0
		c1.3,0,2.2-0.3,2.9-1c-0.1,0-0.2,0-0.3,0c-0.2-0.3-0.2-0.7-0.3-1.1C421.4,57.7,421.2,57.3,420.6,57.1z"
      />
      <path
        class="st3"
        d="M515.1,83.9c3.5-3,7-6.1,10.5-9.2c0.3-0.3,0.7-0.6,1-0.9c0-0.2-0.1-0.3-0.1-0.5c-1.6,0-3.3,0.1-4.9,0
		c-8.8-0.4-17.5-0.8-26.3-1.1c-0.8,0-2-0.2-2.4,0.3c-3.2,3.1-6.3,6.4-9.7,9.8c0.6,0.1,0.8,0.2,1.1,0.2c9.6,0.8,19.3,1.5,28.9,2.2
		C513.8,84.7,514.6,84.3,515.1,83.9z"
      />
      <path
        class="st3"
        d="M465.9,47.9c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.7,0,1.4,0,2.1,0c-0.3-0.3-0.7-0.4-1.2-0.5
		C466.2,48,466.1,47.9,465.9,47.9z"
      />
      <path
        class="st3"
        d="M132.1,276.1c0.3-0.1,0.6-0.2,0.9-0.3c-0.4,0-0.7,0-1.1-0.1C131.9,275.8,132,276,132.1,276.1z"
      />
      <path
        class="st3"
        d="M459.2,62c-0.4,0-0.9,0.1-1,0.4c-0.6,0.8-1.2,1.6-1.8,2.4c0.6,0.1,1.1,0.1,1.7-0.4c0.1-0.4,0.2-0.9,0.3-1.4
		c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0c0.1-0.1,0.3-0.1,0.4-0.2
		c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.5,0.6-0.6,1
		c-0.2,0.5-0.6,1.1-1.1,1.8c0.1,0.1,0.1,0.3,0.2,0.5s0.2,0.4,0.4,0.6c0.3,0.4,0.6,0.7,0.7,1.2c8.8,0.3,17.6,0.6,26.4,1.2
		c4.3,0.3,7.4-0.6,9.9-4c1-1.4,2.3-2.5,3.6-3.8c-0.3-0.2-0.4-0.3-0.4-0.3c-0.9,0-1.9,0-2.8-0.1c-0.1,0.1-0.1,0.2-0.2,0.2
		c-0.4,0.3-0.8,0.5-1.2,0.6c-0.7,0.2-1.2-0.1-1.6-0.9c-2.7-0.1-5.4-0.1-8.2-0.2c0,0,0,0-0.1,0c-0.1,0.9-0.7,1.4-1.4,1.9
		c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1
		c0.1-0.6,0.2-1.2,0.2-1.9C474.1,62.4,466.7,62.2,459.2,62z"
      />
      <path
        class="st3"
        d="M145.8,288.1c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1
		c-0.3,1.2-0.4,2.4,0.3,3.5c1.1,1.6,2.8,2.4,5,2.3c0.3,0,0.6-0.1,0.9-0.1c-3.5-6.4-7-12.7-10.5-19.1
		C148.4,285.2,146.3,286.3,145.8,288.1z"
      />
      <path
        class="st3"
        d="M535.6,60.9c0.2,0,0.4,0,0.6,0c1.7-0.1,2.9-0.9,3.8-2c-2.5,0-5.1-0.1-7.6-0.1C533.1,60,534.1,60.8,535.6,60.9z
		"
      />
      <path
        class="st3"
        d="M423.4,60.2c0.5,0,0.7,0.1,1,0.1s0.7,0,1,0c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-0.9-0.4
		C423.9,59.5,423.6,59.8,423.4,60.2z"
      />
      <path
        class="st3"
        d="M417.9,162.3c-30.9-15.3-63.8-22.9-98.2-24.8c-2-0.1-3.9-0.2-5.9-0.2c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.2
		c-0.5,0-1.1,0-1.6,0c-0.6,0-1.3,0-1.9,0c0-0.3,0-0.6,0-0.8c-0.9,0-1.8,0-2.8,0v0.1c0,0.3,0.2,0.6,0.5,0.8c0,0,0.1,0,0.1,0.1
		c0.5,0.3,1.1,0.5,1.8,0.3c0.1,0.8,0.5,1.2,1.2,1.4c0.3,0.1,0.7,0.1,1.1,0c-0.1,0.4-0.2,0.7-0.3,1c-0.3,0.6-1,0.7-2.3,0.4
		c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2-0.4-0.6-0.7-1-1h-0.1c-0.8-0.2-1.4-0.4-1.9-0.8v-2.7c-5.4,0-10.8,0-16.2,0.3c0,0.3-0.1,0.5-0.1,0.8
		c-0.5-0.2-0.9-0.4-1.3-0.7c-1.6,0.1-3.3,0.1-4.9,0.2c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.2,0.4-0.2,0.6
		c0.3,0.7,0.9,0.5,1.5,0.3l0,0c0.3,0.1,0.5,0.2,0.8,0.2c-1.1,1.5-2.5,1.4-4,1.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.1-0.2-0.3-0.5-0.4-0.7c-0.2-0.4-0.3-0.8-0.4-1.3c-0.7,0-1.3,0.1-2,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.7,0.4-0.7,0.4-0.1,1
		c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.6,0.2,1.2,0.3,1.8c0.2,1,0.3,2.1,0.5,3.1c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.3-1.1
		c-0.3,0.3-0.5,0.4-0.8,0.8c-0.3-0.6-0.5-1.2-0.8-1.9c-0.3,0-0.7-0.2-0.9-0.2c-0.9,0.3-1.2,0-1.8-0.5c-0.2-0.1-0.2-0.3-0.3-0.4
		c-0.1-0.3,0.2-0.7,0.1-1c0-0.1,0-0.1-0.1-0.2c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.2,0-0.3c-4.5,0.4-9,0.8-13.4,1.4
		c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.1-0.1c-0.5,0.1-1.1,0.1-1.6,0.2v0.1c0.2,0.5,0,1.2-1,1.3c-0.2-0.3-0.4-0.5-0.6-0.8
		c-0.7,0.2-0.5,0.7-0.4,1.1c0,0.1,0.3,0.1,0.6,0.1c-0.8,0.4-1.6,0.8-2.5,1.3c0.2,0.2,0.3,0.4,0.6,0.7c-0.3,0.1-0.5,0.2-0.6,0.1
		c-0.6-0.3-0.6-0.8-0.2-1.3c-1-1.1-2.6-0.8-4-0.9c0-0.8,0.8-0.5,1.3-0.8c-5,0.7-9.9,1.6-14.9,2.6c0.1,0.3,0.3,0.7,0.6,0.9l0.1,0.1
		c0.2,0.1,0.2,0.6,0.1,0.8c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6
		c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0c-0.6,0-1.3,0.1-1.7,0.5c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.6,0.1-1.2-0.1-1.8
		c-0.8,0.2-1.5,0.3-2.3,0.5c-16.3,3.7-32.2,8.7-47.4,15.9c-0.7,0.3-1.3,0.6-2,1c0.3,0.3,0.5,0.5,0.6,0.6
		c8.1,6.1,16.3,12.3,24.4,18.3c0.4,0.3,1.2,0.4,1.7,0.2c2.4-0.9,4.7-1.8,7-2.8c1-0.5,1.9-1.3,2.5-2.1c1-1.3,1.8-2.7,3.5-3.2
		c6.8-2.1,13.6-4.2,20.4-6.3c21.6-6.8,43.2-13.6,64.9-20.3c0.9-0.3,2-0.1,3,0.1c1.3,0.2,2.6,0.5,3.8,0.8c0-0.1,0.1-0.3,0.1-0.4
		c-0.7-0.3-1.5-0.5-2.1-0.9c-0.3-0.2-0.7-0.6-0.7-0.8c0-0.3,0.4-0.6,0.7-0.8c2.1-1.2,4.3-1.5,6.5-0.1c0.3,0.2,0.6,0.6,0.9,0.9
		c-0.3,0.3-0.6,0.7-1,0.9c-0.8,0.3-1.6,0.5-2.4,0.8c0,0.1,0.1,0.3,0.1,0.4c1.2-0.2,2.5-0.3,3.7-0.6c1.3-0.4,2.5-0.3,3.8,0.2
		c16,5.5,32.1,10.9,48.1,16.4c10.1,3.4,20.2,6.9,30.3,10.4c0.6,0.2,1.1,0.8,1.5,1.4c0.4,0.6,0.5,1.5,1,1.9c1.1,0.9,2.4,1.6,3.6,2.5
		c1.7,1.2,3.1,1.2,4.9-0.1c6-4.2,12.2-8.1,18.6-12.4C423.4,165.2,420.7,163.7,417.9,162.3z M283.7,139.4L283.7,139.4
		C283.7,139.3,283.8,139.3,283.7,139.4C283.8,139.3,283.8,139.4,283.7,139.4z M229,146.6L229,146.6C229,146.6,229,146.7,229,146.6
		C229,146.7,229,146.6,229,146.6z M218.4,171.5c-0.1-0.2-0.2-0.5-0.2-0.7c28.8-9.1,57.6-18.1,86.4-27.2c0.1,0.2,0.2,0.5,0.2,0.7
		C276,153.4,247.2,162.4,218.4,171.5z M401.9,174c-13.1-4.5-26.2-8.9-39.3-13.4c0.1-0.2,0.2-0.5,0.2-0.7
		c13.1,4.5,26.2,8.9,39.2,13.4C402,173.5,402,173.8,401.9,174z"
      />
      <path
        class="st3"
        d="M546,56.9c-0.3,0-0.6,0-0.8,0c-1.2,0-2.4,0-3.5-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c1.6,0,3.2,0,4.8,0.1
		C546.2,57.2,546.1,57,546,56.9z"
      />
      <path
        class="st3"
        d="M506.2,58.8c-1.2,1-2.4,2-3.5,3c0.1,0.2,0.3,0.4,0.4,0.6c0.2,0,0.5,0,0.7,0.1c9.5,0.2,19,0.4,28.6,0.8
		c0.3-0.5,0.4-1,0.2-1.5c-0.2-0.7-0.8-1.4-1.8-2.1c-0.1-0.1-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0.2-0.1,0.4-0.2,0.5-0.3
		c-8-0.1-16.1-0.2-24.1-0.4C507,58.4,506.5,58.5,506.2,58.8z"
      />
      <path
        class="st3"
        d="M528.8,55.1c3.5,0.1,7.1,0.1,10.6,0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.4-0.3-0.9-0.5-1.4-0.7
		c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0
		c0.1,0,0.2-0.1,0.3-0.1c0.4-0.1,0.8-0.3,1.2-0.6c-2.7,0-5.3-0.1-8,0c-0.8,0-1.7,0.4-2.4,0.9c-1.4,1.1-2.7,2.4-4.3,3.9
		C527.3,55,528,55.1,528.8,55.1z"
      />
      <path
        class="st3"
        d="M261.4,247.3c0.1,0.2,0.2,0.3,0.4,0.5c-0.8,0.6-1.5,1.2-2.3,1.9c0.7,0.2,1.4,0.2,2.1,0.1
		c1-0.2,1.9-0.7,2.5-1.5c0.4-0.6,0.8-1.2,1.2-1.8c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2,0-0.6-0.1-1c0.5-0.1,0.9-0.2,1.3-0.2
		c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4c0.3-0.3,0.5-0.6,0.6-0.9c0.2-0.6,0.3-1.2,0.1-2c-2.6-2-5.2-4-7.7-5.9
		c-0.2,0-0.5,0-0.7,0c-1.1,0.2-1.8,0.7-2.4,1.4c-0.2,0.2-0.3,0.4-0.4,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2
		c-0.1,0.2,0,0.6,0.2,0.8l0,0c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.8,0.8,1.6,1.5,3.2,1.4c-0.3,0.9-0.6,1.7-0.8,2.4
		c-1.1,0.4-2.1,0.9-3.2,1.4c-0.2-0.2-0.6-0.5-0.9-0.9c0.1-0.1,0.1-0.3,0.3-0.4c0.4-0.3,0.6-0.7,0.6-1.1c0-0.2,0-0.3-0.1-0.5
		c-0.3-0.5-1-0.8-1.6-0.7c-0.8,0.1-1.2,0.6-1.3,1.2c-0.3,1.1-0.3,1.2-0.7,1.6c0,0,0,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2
		c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1,0-0.3,0.1-0.4,0.2c-0.4,0.2-0.6,0.4-0.6,0.7c0,0.1,0,0.1,0,0.2c0,0.2,0.4,0.3,0.8,0.6
		c-0.1,0.2-0.3,0.5-0.6,0.8c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2l0,0
		c0.4,0.3,0.7,0.6,1.1,0.9c1.3,0.4,2.3-0.3,3.4-0.9c0.2,0.8,0.4,1.4,0.6,2.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0.1,0.2,0.1
		c0.3,0.1,0.6,0.2,0.8,0.3C259.5,248.7,260.4,248,261.4,247.3z"
      />
      <path
        class="st3"
        d="M450.4,69.4c-0.1-0.1-0.2-0.1-0.3-0.2c0,0.1,0,0.1,0,0.2C450.2,69.4,450.3,69.4,450.4,69.4z"
      />
      <path
        class="st3"
        d="M262.5,137.8c0-0.3,0.1-0.5,0.1-0.7s-0.2-0.4-0.3-0.7c-1.9,0.2-3.8,0.5-5.7,0.7c0.4,0.2,0.7,0.5,1.1,0.7
		c0.1-0.4,0.3-0.5,0.7-0.5c0.1,0,0.3,0,0.4,0s0.3,0,0.4,0c0.6,0,1.2,0,1.6-0.7c0.3,0.3,0.5,0.5,0.7,0.8c-0.3,0.2-0.6,0.4-1.1,0.7
		C261,138,261.7,137.9,262.5,137.8z M261.6,137.4C261.6,137.4,261.5,137.4,261.6,137.4c-0.1,0-0.1,0-0.1,0H261.6z"
      />
      <path
        class="st3"
        d="M573.6,55.6c0,0.1,0,0.1,0,0.2c0.3,0,0.7,0,1,0c0.6,0,1.2,0,1.8,0c-0.6-0.3-1.3-0.4-2.1-0.3
		C574.1,55.6,573.9,55.6,573.6,55.6z"
      />
      <path
        class="st3"
        d="M240.4,242.9c0-0.1,0-0.1,0.1-0.2c-1-0.9-2-1.7-2.9-2.6c0,0.1-0.1,0.2-0.1,0.3c-0.2-0.3-0.5-0.6-0.7-0.9v-0.1
		c-0.3-0.3-0.7-0.6-1-0.9c-0.1,0-0.2,0-0.3,0l0.1-0.1c-0.3-0.2-0.5-0.4-0.8-0.7c-0.1,0.2-0.2,0.5-0.3,0.7c-0.7,0.2-1.6,0.5-2.5,0.8
		c0-0.3,0-0.6-0.5-0.5c-0.1,0.3-0.3,0.8,0.4,0.5c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7c0.6,0.7,1.7,0.9,3.5,0.9
		c0.4,0.4,0.7,0.8,1.1,1.1c0.2,0.1,0.3,0.2,0.5,0.3C238.7,244.4,239.9,244,240.4,242.9z"
      />
      <path
        class="st3"
        d="M171.8,161.9c1.4,1.1,2.1,0.1,3-0.5C173.5,160.3,172.9,161.5,171.8,161.9z"
      />
      <path
        class="st3"
        d="M123,292c-0.1,0.1-0.2,0.2-0.4,0.3c-0.5-0.4-1-0.7-1.6-1.1c-0.2,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1
		c0-0.3,0-0.4,0-0.6c-0.5,0-1.4,0.5-1-0.6c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3
		c-0.3-0.2-0.6-0.4-0.9-0.7c0.4-1.2,0.4-1.2,1.8-1.8c-0.1-0.7,0-1.5-1.3-1.6c-0.6-0.1-0.7-0.5-0.6-0.9c0.1-0.3,0.2-0.6,0.4-0.9
		c-2.1-0.4-2.4,1.3-3.7,1.9c-0.1-0.3-0.2-0.6-0.3-0.9c-0.6-1.5-0.8-1.6-3-1.3c0.9-0.7,0.5-1.6,0.1-1.9c-0.8-0.8-0.5-1.4,0.2-2.2
		c-0.3-0.2-0.5-0.3-0.8-0.5c-0.2,0.4-0.3,0.8-0.6,1c-0.7,0.3-1.4,0.6-2.1,0.9c2.4,5,4.7,10,7.1,15l0,0c0.4,0,0.8,0.1,1.3,0.1
		c0.3-0.3,0.7-0.5,1.1-0.8c0.2,0.1,0.3,0.2,0.4,0.3c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1
		c0.3-0.1,0.9-0.1,1.2,0.1c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1c0.2,0,0.4,0,0.6-0.1C124.6,295.3,123.8,293.7,123,292z"
      />
      <path
        class="st3"
        d="M510.3,53.6c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6
		c-0.2-0.1-2.2,0.5-2.3,0.6c-0.3,0.4-0.2,0.9,0.2,1.3c0.3,0,0.7,0,1,0c0.1-0.1,0.1-0.2,0.2-0.3s0.1-0.2,0.2-0.4c0,0,0,0,0-0.1
		c0,0,0,0,0.1,0c0.2,0.1,0.5,0.1,0.6,0.2c-0.1,0.2-0.1,0.4-0.2,0.6c4.7,0.1,9.4,0.2,14.1,0.2c0.5,0,1.1-0.2,1.5-0.5s0.7-0.7,1.1-1
		c-0.2-0.1-0.4-0.3-0.6-0.4c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4
		c0.1-0.1-0.2-0.3-0.3-0.6c-0.6,0.3-1.1,0.8-1.6,1c-0.3,0.1-0.7,0.1-1.1,0v-0.1c0-0.5-0.1-1-0.3-1.4c-2,0-4.1-0.1-6.1-0.1
		c-0.1,0.1-0.1,0.1-0.2,0.2c0,0.4-0.1,0.9-0.1,1.4c-0.3-0.1-0.5-0.1-0.8-0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5
		c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2C511.3,53.1,510.8,53.3,510.3,53.6z"
      />
      <path
        class="st3"
        d="M127.6,291.6c0.1-0.3,0.2-0.6,0.3-1c-0.3-0.1-0.6-0.2-1.1-0.4c-0.1,0.9-0.7,1.4-1.6,1.2c-0.6-0.1-1,0-1.4,0.2
		c0.8,1.8,1.6,3.5,2.5,5.3c0.2,0,0.5,0,0.8-0.1c-0.2-0.4-0.5-0.7-0.8-1.2c0.8-0.3,1.5-0.7,2.2-0.9c-0.5-0.2-1-0.3-1.4-0.6
		c-0.4-0.3-0.5-0.7-0.9-1.3c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3c0.1-0.1,0.1-0.4-0.1-0.5
		C128.2,292,127.9,291.8,127.6,291.6z"
      />
      <path
        class="st3"
        d="M479.4,61.7c0.4,0,0.8,0,1.1,0c0-0.1,0.1-0.2,0.1-0.2c0.3-0.2,0.7-0.3,1-0.5c-0.4-0.2-0.7-0.4-1.3-0.7
		C480.3,61.1,479.9,61.5,479.4,61.7z"
      />
      <path
        class="st3"
        d="M453.1,69.5c0.1,0,0.3,0,0.4,0c-0.1-0.1-0.1-0.2-0.2-0.2C453.2,69.4,453.1,69.5,453.1,69.5z"
      />
      <path
        class="st3"
        d="M424.5,70.1c-0.1-0.1-0.5,0.1-0.7,0.1c-0.8,0.1-1.2-0.1-1.2-0.7c0-0.1,0-0.2,0-0.4c-0.5,0-0.9,0-1.4-0.1
		c0,0.1,0,0.3,0,0.4c-1.2,0.4-2.2,1.1-2.2,2.3c0,1.1,0.9,1.6,2.1,1.7c0.2,1,0.4,1.8,0.6,2.7c0,0.3-0.1,0.7-0.3,1
		c-0.1,0.1-0.2,0.3-0.2,0.4c0.9,0.1,1.9,0.1,2.8,0.2l0,0c0-0.9-0.3-1.8-0.6-2.7c-0.5-1.3-0.6-2.5,0.4-3.8c0.2,0,0.4,0.1,0.6,0
		c0.3-0.1,0.6-0.3,0.8-0.5C424.9,70.5,424.7,70.2,424.5,70.1z"
      />
      <path
        class="st3"
        d="M297.3,238.5c2.1-0.1,4.2,0,6.3,0.1c-0.2-0.2-0.3-0.3-0.5-0.5c0,0,0,0-0.1,0c-0.4-0.3-1-0.6-1.6-1
		c-1.3-0.1-2.2,0.9-3.3,0.4C297.7,238.1,297.5,238.3,297.3,238.5z"
      />
      <path
        class="st3"
        d="M358,236.7c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3
		c-0.1,0.2-0.1,0.4-0.1,0.5c0,0,0,0,0,0.1c1.2-0.9,2.5-1.9,3.7-2.8C358.4,236.8,358.2,236.7,358,236.7z"
      />
      <path
        class="st3"
        d="M608.9,65.4c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5
		c0.3-0.4,0.5-0.7,0.7-1c-1.8-0.6-3.7-1.1-5.5-1.7c0,0.1,0,0.2,0,0.3c0,0-0.1,0.1-0.1,0.3c-0.5-0.2-1.1-0.2-1.5-0.2
		c-0.5,0-1.1,0.2-1.6,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3
		c-0.3-1-0.9-1.5-2.2-1.6c-0.8,0.7-1.7,1.3-2.6,2v0.1c0,0.4,0.2,0.8,0.5,1.2c0.2,0.3,0.5,0.5,0.7,0.7c0.1,0,0.2,0,0.4,0
		c0.7,0,1.4-0.1,2-0.4c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.7,0.2,1.4,0.4,2.1c0.3,1-0.1,2.2-0.2,3.5
		c-2-0.7-2.8-2.5-5-2.7c-0.5,0.9-1,1.7-1.5,2.7c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.2,0.4-0.2,0.6c0.3,0.7,0.9,0.5,1.5,0.3l0,0
		c0.3,0.1,0.5,0.2,0.8,0.2c-1.1,1.5-2.5,1.4-4,1.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.2-0.3-0.5-0.4-0.7
		c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3c0-0.4-0.1-0.8-0.3-1.2c-0.4,0.3-0.7,0.6-1.1,0.9c-0.1,0.3-0.1,0.6-0.2,0.9
		c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3c-0.7,0.4-0.7,0.4-0.1,1c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.6,0.2,1.2,0.3,1.8
		c0.2,1,0.3,2.1,0.5,3.1c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.3-1.1c-0.3,0.3-0.5,0.4-0.8,0.8c-0.1-0.2-0.2-0.5-0.3-0.7
		c-1.2,0.1-2.4,0.1-3.6,0.1c-0.9,0.1-2,0.2-2.7,0.8c-4.7,3.6-9.3,7.2-13.8,10.9c-0.5,0.4-0.8,1.1-1.1,1.5c-0.9,0.4-1.7,0.8-2.4,1.3
		c-5.5,4.3-11,8.6-16.4,12.9c-2.2,1.7-2.7,3.5-1.8,6.2c0.2,0,0.5,0,0.7-0.1c7.4-1.9,14.9-3.8,22.3-5.7c0.4-0.1,0.8-0.3,1.2-0.6
		c9.1-6.7,18.2-13.5,27.2-20.3c1.9-1.4,3.9-2.8,5.7-4.3c2.4-2,5.9-3.2,6.2-7.1c0,0,0.1,0,0.3-0.1c0,0.6,0.1,1.2,0.2,2
		c3.3-2.4,6.4-4.8,9.7-7.3v-0.5c-1.1-0.3-2.1-0.7-3.2-1C608.9,64.7,608.9,65,608.9,65.4z M589.9,72.1L589.9,72.1
		C589.9,72,589.9,72,589.9,72.1C589.9,72,589.9,72.1,589.9,72.1z"
      />
      <path
        class="st3"
        d="M609.3,62.8c0.9,0.3,1.9,0.6,2.8,0.9v-1.3c-0.7-0.2-1.5-0.5-2.2-0.7C609.7,62,609.5,62.4,609.3,62.8z"
      />
      <path
        class="st3"
        d="M533.9,45.7c-0.1,0.1-0.1,0.1-0.2,0.2c0.8-0.7,1.5-1.4,2.4-2.2c-0.6,0.3-1.1,0.6-1.5,1
		C534.3,45.1,534.2,45.4,533.9,45.7z"
      />
      <path
        class="st3"
        d="M472.9,93c9,1.3,17.8,2.5,26.6,3.7c0.4,0.1,0.9-0.1,1.2-0.3c4.1-3.5,8.1-7,12.2-10.6c-0.3-0.2-0.4-0.3-0.5-0.3
		c-9.7-0.8-19.5-1.5-29.2-2.2c-0.5,0-1.3,0.3-1.7,0.7c-2.7,2.7-5.4,5.4-8,8.1C473.3,92.3,473.2,92.6,472.9,93z"
      />
      <path
        class="st3"
        d="M240.6,118.4c-0.1,0.2,0.1,0.7,0.3,0.8c0.2,0.1,0.7-0.1,1-0.2c0.3-0.2,0.5-0.4,0.8-0.7
		c0.3,0.1,0.4,0.3,0.7,0.4c-0.4,0.8-1.5,1.4-1.3,2.5c0.9-0.2,1-0.9,1.5-1.3c0.7,0.3,1.8-0.6,2.1,0.5c0.4-0.3,0.6-0.5,0.9-0.7
		c0,0.2,0,0.4,0,0.6c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1
		c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1c-0.3,0.5-0.6,1-1,1.6c0.5,0.4,0.4,1.3,0.6,2c0.1,0.3-0.3,0.8-0.5,1.1
		c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.3-0.5,0.5-0.7,0.8c0.4,0.1,0.8,0.2,1.2,0.3
		c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.9,0.1,1.4-0.1c1.2,0.7,2-0.6,3.2-0.6c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.2,0.3-0.3,0.4
		c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6c-0.5-0.1-1,0.7-0.9,1.3c0,0.1,0,0.2,0.1,0.3
		c0.2,0.3,0.5,0.5,0.7,0.7c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5c0.1,0,0.2,0.1,0.3,0.1
		c0.2,0,0.5,0.1,0.6,0.3c0.7,1,0.6,1,2,1.2c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8c0.2,0.3,0.1,0.7,0,1
		c4.4-0.6,8.8-1.2,13.2-1.6c0.3,0,0.7,0.1,1,0.1c0,0.2,0,0.3,0.1,0.5c-0.9,0.1-1.8,0.2-2.7,0.3c0.2,0,0.4,0.1,0.5,0.1
		c-0.7,0.6,0.1,0.4,0.5,0.6c-0.4,0.3-0.9,0.5-1.3,0.8c2.4-0.3,4.8-0.5,7.1-0.7c0-0.3,0.3-0.6,0.5-0.9c0.3,0.1,0.6,0.2,1,0.3
		c0-0.5,0.1-1,0.1-1.4c-0.9-0.1-1.7-0.2-2.6-0.2c0.3,0.2,0.4,0.4,0.6,0.5c-0.4,0.5-1,0.6-1.7,0.6V136h-0.1c0,0,0,0,0,0.1
		c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.5-0.9,0-1.6,0.8-2.4c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.2-0.2,0.4-0.5,0.6-0.7
		s0.4-0.5,0.6-0.8c-0.1-0.1-0.2-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4
		c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2c0.6-0.8,1.4-1.3,2.2-1.2c0.9,0.2,1.4-0.4,2-0.7c0,0,0.1,0,0.1-0.1
		c0.9-0.3,0.9-1.1,0.2-1.6c-0.5-0.4-1.1-0.7-1.6-1.1c-0.9-0.8-2-1-3.2-0.9c-0.2,0-0.5,0-0.7,0.1c0,0.4,0.5,0.9-0.1,1.2
		c-0.1,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6
		l-0.1-0.1c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3
		c-0.6-0.4-0.5-1.4-1.7-0.9c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1
		c-0.5-0.4-1-0.8-1.5-1.3c-0.5,0.3-1,0.5-1.4,0.8l0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1c0.5,0.5,1,1,1.5,1.5
		c-0.4,0.8-0.8,1.6-1.2,2.5c-0.4-0.3-0.5-0.7-0.8-0.8c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1c-0.1-0.3-0.3-0.9-1.4-0.7
		c-0.3,0.1-0.7-0.4-1.1-0.7c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6c-0.3-0.4-0.6-0.3-1.6-0.1
		c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4s0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3l0,0l0,0c0.1,0.2,0.1,0.4,0.2,0.5
		c0.1,0.2,0.2,0.5,0.2,0.7c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7c0.3-0.6,0.5-1,0.6-1.3c-0.3-0.6-0.6-1-1.7-0.8
		c-0.2,0-0.4,0-0.6-0.1c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1C241.1,117.4,240.8,117.9,240.6,118.4z M266.7,124.7
		c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.2-0.3,0.3-0.4,0.4c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1
		C266.5,124.9,266.6,124.8,266.7,124.7z M259.8,121.8L259.8,121.8l-0.1,0.1L259.8,121.8z M250.3,131.1c-0.1,0-0.3-0.1-0.4-0.1
		c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C250.4,130.9,250.3,131.1,250.3,131.1z"
      />
      <path
        class="st3"
        d="M240.1,271.7c-0.6-0.1-1-0.5-0.9-1.1c0-0.3-0.3-0.6-0.5-1c-0.4,0.2-0.7,0.3-1,0.4c-0.5-0.2-0.4-1.1-1.4-0.7
		c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8c-0.3,0-0.6-0.1-1.1-0.1
		c0.5-0.6,0.9-1.2,1.4-1.9c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.8,0.3,1.4,0.9,2.2,1c0.7,0.1,1.4-0.3,1.3-0.8
		c-0.1-0.5-0.3-1.1-1-1.2c-1-0.1-1.6-0.4-2-1.2c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7c0.9-1-0.2-0.8-0.3-1.2
		c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.3,0.1-0.7,0.3-0.9c1.1-0.8,1.1-0.7,3.4,0
		c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4c-0.9,0-1.8,0.3-2.6-0.1c-0.3-0.2-1.2,0.3-1.9,0.6c-0.7,0.3-1.3,0.5-1.8,0l0,0
		l0,0c0.5-0.4,0.7-0.6,0.7-0.8c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.7c0-0.1,0-0.1,0-0.2c0.1,0,0.2,0,0.3,0c1.1,0,1.1,1,1.9,1.4
		c0.2-0.3,0.3-0.7,0.6-1.4c0.2,0.4,0.4,0.6,0.5,0.8c0.6-0.2,1.1-0.8,1.2-1.3v-0.1c0-0.1,0-0.3,0-0.4c-0.2-0.5-0.6-0.9-1-1.4
		l-0.1-0.1c0.2,0,0.4,0,0.7,0c-0.1-0.7,0-1.3,0.3-1.9c0.2-0.5,0.6-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.3,0.3-0.6,0.4-0.9
		c0.1-0.3-0.7-0.7-0.8-0.5c-0.3,0.9-1.5,0.6-2,1.2c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8c-0.4-0.1-0.8-0.2-1.3,0
		c0,0.3,0,0.6,0,0.8c-0.1,1-0.8,1.8-2.1,2.4c0.3-0.8,0.7-1.6,1-2.4c-0.8-0.7,1.2-1.7-0.2-2.4c-0.7,0.2-0.3,0.8-0.5,1.2
		c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.1-1.3-0.2-2.2-0.2
		c-0.2,0.2-0.7,0.5-1.1,0.8c-0.7-0.5-1.3-1-1.9-1.4c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.7-0.9,0.6
		c-0.1,0-0.2-0.1-0.3-0.2l0,0c-0.3,0-0.7-0.1-1-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7c-0.5-0.2-1.1-0.4-1.7-0.7
		c-0.2,0.5-0.3,0.9-0.5,1.4c-0.6-0.2-1.1-0.3-1.5-0.4c0.2-0.1,0.4-0.2,0.7-0.4c-0.5-0.1-0.8-0.2-1.1-0.3v-0.1c0.5-0.3,1.1-0.7,1.6-1
		c0.1-0.1,0.4,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2c0.2,0.3,0.3,0.6,0.5,0.9
		c0.2,0.4,0.4,0.8,0.6,1.1l0,0c0.6-0.4,0.7-0.9,0.8-1.4c0-0.4-0.1-0.8-0.1-1.3c1,0.1,1.1,0.6,1.1,1.4c0.3-0.2,0.5-0.4,0.7-0.5
		s0.4-0.2,0.7-0.4c-0.6-0.5-0.4-1.3-0.1-1.9c0.3-0.6,1.3-1,2.1-1.6c0.2,0,0.7,0.1,1.4,0.2c0-1,0-2,0-2.9c0.5,0,1.1,0,1.6,0
		c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3c0.2,0.1,0.4,0.1,0.5,0.1c-31.1-27.5-62.3-55-93.5-82.5
		c-0.4-0.1-0.8-0.2-1.1-0.4h-0.1c-1.3-0.5-2.4-1.1-3.5-1.8c-0.3-0.2-0.7-0.4-1-0.7c-0.7,0.7-1.3,1.3-2,1.9c-1.3-0.3-2.6-0.5-2.7-2
		c-0.5,0.3-0.7,0.5-1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5s-1.8,0.6-2.2,0.7c-1.3,0.6-2.7,0.8-4.2,0.6c-0.7-0.1-1.3-0.2-2.1-0.4
		c0.4-0.2,0.7-0.2,0.9-0.4c0.6-0.3,0.7-0.8,0.3-1.2c-0.5-0.5-1-0.9-1.3-1.1c-0.2-1.2-0.4-2.2-0.6-3.3c0-0.1,0-0.2-0.1-0.3
		c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.4,0.1-0.7,0.1-1.1c0-0.9-0.3-1.8-0.6-2.7c-0.5-1.3-0.6-2.5,0.4-3.8c0.2,0,0.4,0.1,0.6,0
		c0.3-0.1,0.6-0.3,0.8-0.5c-0.2-0.3-0.4-0.6-0.7-0.7c-0.1-0.1-0.5,0.1-0.7,0.1c-0.8,0.1-1.2-0.1-1.2-0.7c-0.1-1.2-0.2-2.5-0.4-3.8
		c-0.3-0.3-0.6-0.6-0.9-0.8c0,1.5-0.1,3.1-0.1,4.6c-1.2,0.4-2.2,1.1-2.2,2.3c0,1.1,0.9,1.6,2.1,1.7c0.2,1,0.4,1.8,0.6,2.7
		c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2
		c0,1.1-0.1,2.1-0.3,3.2c-0.1,0.4,0.1,0.7,0.3,1.1c0.4,0.7,0.3,1.3-0.1,1.8c-0.1,0.1-0.2,0.1-0.3,0.2c1.5,6.5,2.9,13,4.4,19.4
		c0.2,0.7,0.6,1.4,1,2c7.9,10,15.9,20,23.9,30c4.5,5.7,9.2,11.3,13.7,16.9c8.5,10.6,16.9,21.1,25.4,31.7c0.4-0.4,0.7-0.8,1.1-1.1
		c0.4-1,0.6-2,0.2-2.9c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.6,0.3-1c1.3,1,2.6,1.9,4,2.9
		c0.5,0.4,1,0.7,1.5,1.1c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.5,0.1,0.8,0.2,1.2,0.3c1-0.8,1.1-1.1,0.7-1.5
		c-0.4-0.4-0.7-0.4-2,0.2c-0.6-0.4-0.8-0.8,0-1.2c1-0.6,1.9-1.3,3.2-0.7c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9
		c0,0.8,0,1.4,0.7,1.9s1,1.2,1.1,2c0.1,0.9,0,1.1-0.9,1.5c-0.5,0.2-1,0.3-1.4,0.3c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1
		c1.1,0.9,2.1,1.2,2.9,1c-0.5,1.3-0.3,1.8,0.5,2.1l0,0c2.4,0.9,2.4,0.9,3.4,2c0.3-0.2,0.9-0.5,0.9-0.7c0.1-1.1-0.2-2.1-1.3-2.8
		c0,0.3,0.1,0.6,0.1,0.9c0,0.1-0.3,0.3-0.5,0.5c-0.3-0.5-0.6-1.1-0.9-1.7c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.3,0.1-0.4,0.2
		c-0.3-0.2-0.6-0.5-1-0.9c0.7-0.2,1.3-0.7,2-1.4c0.1-0.1,0.2-0.3,0.3-0.4c0.3-0.3,0.3-0.8,0.4-1.1l0,0c0.2-1.4-0.3-2.7-1.3-3.8
		c-0.5-0.5-0.4-1.1-0.2-1.7c0.2-0.6,0.4-1.1,0.6-1.7c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3c-0.5,0.4-0.8,0.7-1.1,0.9
		c-0.1,0-0.2-0.1-0.2-0.1c-0.2-2-0.9-3.9-0.3-6c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0h-0.1c1.5,0.4,1.1,1.7,1.4,2.6c0.5,0.1,1,0.4,1.3,0.3
		c1.2-0.4,1.7,0.1,2,0.9c0.1,0.2,0.7,0.4,0.3,0.7c-0.5,0.4,0.4,1.3-1.1,1.4c0.5,0.6,0.9,1.1,1.2,1.6c0.2,0.3,0.5,0.7,0.5,1.1
		c0,0.3-0.4,0.7-0.7,0.8c-0.6,0.2-0.8-0.2-0.9-0.6c-0.7,0.7-0.8,1.4-0.3,2.2c1-0.8,1.8,0.1,2.7,0c-0.2-0.2-0.4-0.4-0.8-0.7
		c1.1-0.4,2-0.7,3.4-1.2c-0.5,0.5-0.7,0.7-1,0.9c0,0,0,0.1,0.1,0.1c0.7-0.4,1.5-0.7,2.2-1.1c0,0.1,0.1,0.3,0.1,0.4
		c0.1,0.3,0.2,0.9,0.1,0.9c-0.7,0.2-0.6,1-1.2,1.2c-0.9,0.4-1.3,1.1-1.7,1.8c-0.5,0.7-0.9,1.2-1.9,1.4c0.5,0.5,0.8,0.8,1.2,1.2
		c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1,0.2-0.2,0.4-0.4,0.6c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0.2,0.2,0.4,0.3,0.7c-0.9,0.2-1.3,1-2.3,1
		c-0.3,0-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1c-0.9,0.5-1.7,1-2.5,1.4c0.2,0.8,0.4,1.3,1.2,1.6c0.7,0.3,1.3,0.9,1.6,1.5
		c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3c-0.1-0.4-0.1-0.9-0.2-1.4c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5
		c0.3,1.3,0.5,1.4,2.2,1.6c0.4,0,0.7,0.3,1,0.5c0.2,0.1,0.3,0.3,0.4,0.5c0.7,0.7,1.1,0.7,2,0.1c0.5-0.4,0.9-0.6,1.7-0.8
		c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5c-1,0.1-1.6,0.2-2.3,0.3c0.3,0.8,0.7,1.6,1.5,1.6s1.3-0.2,0.8,0.7
		c-0.2,0.4,1.2,0.1,0.5,0.8c0.7,0.1,0.8,0.6,1,1.1c0.1,0.3,0.3,0.6,0.7,0.6c1.1,0,0.8-1.1,1.5-1.2c0.4,0.5,0.9,0.9,1.3,1.4
		c0.1,0.2,0.3,0.3,0.4,0.5c0.6-0.3,1.1-0.5,1.6-0.7c0,0,0,0,0-0.1c0.1-0.2,0.1-0.4,0.3-0.5c0.3-0.2,0.7-0.4,1.4-0.6
		c-0.4-0.4-0.8-0.7-1-1.1c-0.3-0.4-0.5-0.9-0.6-1.3c0-0.1,0.3-0.2,0.5-0.4c0.1,0.1,0.2,0.2,0.2,0.3c1.3-0.2,2.1-0.8,2.6-1.9
		c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0.2,0.5-0.1,0.9-0.7,1.1c-0.4,0.9-0.4,0.9,0.3,2.1c1.3-0.4,2,0,2.3,1.1
		c0.2,0.6,0.6,0.8,1.5,1l0.1-0.1c-0.1-0.3-0.1-0.7-0.2-1.1c0.2-0.1,0.7-0.5,0.9-0.5c0.9,0.3,1.5-0.1,2-0.8c0.3,0.4,0.5,0.6,0.7,0.8
		c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.5,0.6,1.5,1.1,1.4c1-0.3,1.6,0.1,2.2,0.6c0.2,0.2,0.7,0.1,1.2,0.1
		C241.6,272.7,241.3,271.9,240.1,271.7z M191.8,206.9c-5.6,2-11.2,4-16.9,6c-1.2,0.4-3.3-0.7-3.4-2c0-0.4,0.7-1,1.1-1.2
		c4.2-1.6,8.4-3.1,12.6-4.6c0.3-0.1,0.6-0.3,1.3-0.5c-1.7-1.6-3.2-2.9-4.7-4.3c-3.2-2.9-6.4-5.8-9.5-8.8c-0.7-0.7-1.3-0.8-2.3-0.5
		c-3.9,1.3-7.8,2.5-11.7,3.8c-1.2,0.4-1.9,0.1-2.6-0.8c-0.9-1.2-0.9-1.5,0.6-2c3.9-1.3,8-2.3,11.8-4c3.4-1.4,5.7-0.8,8.3,1.8
		c5.1,5,10.6,9.7,15.9,14.5C193.8,205.8,193.8,206.2,191.8,206.9z M214,247.5L214,247.5c0-0.1,0.1-0.1,0.1-0.1
		C214.1,247.5,214,247.5,214,247.5z M211.4,262.1c0.3-0.3,0.5-0.6,0.7-0.9C212.5,262,212.5,262,211.4,262.1z M221,268
		c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.2,0.4-0.3,0.5-0.5c0.1,0.1,0.2,0.1,0.2,0.2C221.4,267.7,221.2,267.8,221,268z"
      />
      <path
        class="st3"
        d="M443.5,170.5c23.9-17.8,47.8-35.5,71.7-53.3c0.4-0.3,0.7-0.6,1.4-1.1c-1.6-0.2-2.7-0.8-4.1,0.1
		c-20.7,14.3-41.5,28.4-62.3,42.6c-4.3,3-8.7,5.9-13.2,9.1c1.5,1,2.8,1.7,4,2.6C441.8,171.3,442.5,171.3,443.5,170.5z"
      />
      <path
        class="st3"
        d="M320.3,183.6c-1-0.7-2.1-1.4-3.2-1.9c-6.5-2.7-13.3-3.1-20.1-1.6c-0.4,0.5-0.8,1-1.4,1.2c-2.5,1-5.1,1.8-7.5,3
		c-1.6,0.8-1.6,2-0.1,3.1c1.3,0.9,2.8,1.6,4.1,2.5c0.4,0.3,0.7,0.7,1,1.1c0,0.1-0.1,0.3-0.1,0.4c8,2.5,15.9,2.3,23.7-0.5
		c1.3-0.5,2.5-1.2,3.7-2C322.5,187.1,322.5,185.3,320.3,183.6z M318,188.7c0.4-0.4,0.8-0.8,1.2-1.1c1.2-1,1.2-1.9,0.1-2.9
		c-0.8-0.7-1.7-1.2-2.6-1.8c-0.4-0.2-0.7-0.5-1.3-1c2.2-0.1,5.4,2.3,5.6,3.9C321.2,187.2,320,188.5,318,188.7z"
      />
      <path
        class="st3"
        d="M435.7,164.9c20.2-13.8,40.4-27.6,60.6-41.3c4.2-2.8,8.3-5.7,12.7-8.7c-1.4-0.9-2.3-0.2-3.2,0.4
		c-21.7,14.4-43.5,28.8-65.2,43.1c-3,2-6.1,4-9.1,6.1C433.5,166.3,433.6,166.4,435.7,164.9z"
      />
      <path
        class="st3"
        d="M517.1,115.4c0.9-0.3,1.7-0.9,2.4-1.6c0.2-0.2,0-1-0.2-1.4c-0.1-0.1-0.9-0.1-1.2,0.2c-1.1,0.7-2.1,1.4-3.5,2.4
		C515.6,115.1,516.4,115.5,517.1,115.4z"
      />
      <path
        class="st3"
        d="M539.6,110.6c2,1.1,3.7,2,5.3,2.9c2.2,1.2,2.4,1.2,4.2-0.6c0.4-0.4,0.6-1.1,0.9-1.5c0.5,0,1,0.1,1.3-0.1
		c2.4-1.7,4.7-3.5,7.1-5.3c0-0.1-0.1-0.2-0.1-0.3C552.2,107.4,546.1,108.9,539.6,110.6z"
      />
      <path
        class="st3"
        d="M432.9,166.7c-2.1-1.8-2.4-1.8-4-0.2C431.3,168.2,431.3,168.2,432.9,166.7z"
      />
      <path
        class="st3"
        d="M497.5,59.7c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.3-0.7,2.5-0.1,3.7c1,0,2,0.1,3.1,0.1c0.5,0,1-0.2,1.4-0.4
		c1.1-0.9,2.2-1.9,3.3-2.8c-0.1-0.2-0.2-0.4-0.3-0.6c-0.2,0-0.4-0.1-0.6-0.2c-0.9,0-1.7,0-2.6,0c-0.2,0.2-0.4,0.4-0.5,0.7
		c-0.2,0.4-0.3,0.9-0.5,1.3c-0.3,0.5-0.7,1-1.1,1.6c-0.3-1.2-0.4-1.7,0.3-3.6c-0.2,0-0.4,0-0.5,0C498.1,58.7,497.8,59.1,497.5,59.7z
		"
      />
      <path
        class="st3"
        d="M201.9,181.9c-1.8-2.1-2.3-2.1-4.3-0.8C199.6,183.2,199.9,183.3,201.9,181.9z"
      />
      <path
        class="st3"
        d="M176.1,165.2c5.3,4.1,10.7,8.1,16,12.2c1.4,1.1,2.6,1.2,4.1,0.1c-0.5-0.4-0.9-0.7-1.3-1
		c-5.7-4.3-11.5-8.5-17.1-12.9c-1.4-1.1-2.3-0.9-3.5,0.2C174.9,164.3,175.5,164.7,176.1,165.2z"
      />
      <path
        class="st3"
        d="M508.1,56.9L508.1,56.9c0.7,0,1.3,0,2,0c10.3,0.2,20.7,0.3,31,0.5c-0.2-0.2-0.3-0.4-0.5-0.6
		c-10.8-0.2-21.6-0.3-32.4-0.5C508.3,56.5,508.2,56.7,508.1,56.9z"
      />
      <path
        class="st3"
        d="M508.6,113.7c2.8,0.8,4-1.8,6-2.8C511.9,110.4,510.5,112.6,508.6,113.7z"
      />
      <path
        class="st3"
        d="M417.1,177.7c2.3-1.9,4.8-3.4,7.3-5.1c1.8-1.2,3.5-2.4,5.3-3.7c-2.4-1.8-2.4-1.8-4.6-0.3
		c-0.7,0.5-1.4,0.9-2.1,1.4c-3.7,2.5-7.4,4.9-11.3,7.5C413.6,178.5,415.2,179.3,417.1,177.7z"
      />
      <path
        class="st3"
        d="M411.6,181.4c-1-0.5-2-1.1-3.1-1.7c-0.5,0.3-1.1,0.8-1.9,1.3C410,182.9,410.1,182.9,411.6,181.4z"
      />
      <path
        class="st3"
        d="M141,111.4c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7
		c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5
		c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7c-0.8-0.5-1.4-1.1-2.4-1
		c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.2-0.1-0.6-0.2-1.1
		c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2
		c0-0.4-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6
		c0.5,0.1,0.6,0.3,0.6,0.6c0,0.3-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8
		c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8
		c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6
		c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1-0.4,1.6-0.6
		c0.3,0.8-0.7,1.6-0.7,2.5c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1c0.2,1.4,0.6,1.7,2.9,1.9c-1.2,0.5-1.6,1.2-1.7,2c0,0.3,0,0.6,0,1
		c0.1,0.5-0.2,1-0.3,1.4c-0.5,0.1-0.9,0.2-1.5,0.3c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2
		c0,0,0-0.1,0.1-0.1l0,0c0.9-0.1,1.9,0.5,2.8-0.3c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1
		c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0
		c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8c0.1,0.1,0.1,0.3,0.2,0.5
		c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.4,0.7,0.8,0.7,1.3c0.1,0.7,0.7,1.1,1.5,1c1.3-0.2,1.7,0.5,2.3,1.3c0.3-0.1,0.6-0.2,0.9-0.3
		c0.1,0.1,0.2,0.2,0.1,0.2c-0.5,0.6-0.9,1.2-0.8,2c0,0.2-0.2,0.4-0.3,0.5c-0.6-0.2-1.1-0.4-1.8-0.7c-0.3-0.4,0.4-1.3-0.4-1.8
		c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4c0.1,0.4,0.2,0.9,0.5,1.8c2,0,3.9-0.7,5.9-0.3c0.5,1.1,0.5,1.1-1.3,2.3
		c0.5,0.2,0.9,0.4,1.3,0.6c-0.3,1.4-1.6,0-2.2,0.9c0.3,0.2,0.7,0.4,1,0.6c-0.4,0.5-0.9,0.9-1.4,1.5c4.8,3.6,9.5,7.1,14.3,10.7
		c1,0.8,1.8,0.7,2.9,0.2c7.3-3.2,14.6-6.5,22-9.2c7.7-2.8,15.6-5.1,23.5-7.1c-0.1,0-0.1-0.1-0.2-0.1c1.2-0.4,2.4-0.9,2.8-1.9
		c0.2-0.5,0.2-1.2,0.1-1.6c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4c-0.6-0.1-1.3-0.1-2,0.1c-0.2-0.6-0.6-1.1,0-1.6
		c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2c0.3-1,0.5-2,1.2-2.9c0,0,0.1,0,0.1,0.1c1.3,0.6,2.5,1.1,4,0.4
		c0.7-0.3,1.4-0.8,1.8-1.3l0.1-0.1c0.4-0.6,0.6-1.2,0.4-1.8c-0.2-0.7-0.8-1.4-1.8-2.1c-0.1-0.1-0.2-0.1-0.3-0.2
		c0.1-0.1,0.2-0.2,0.4-0.2c0.4-0.2,0.8-0.5,1.2-0.8c0.6,1.4,1.7,2.4,3.4,2.5c0.2,0,0.4,0,0.6,0c2-0.1,3.3-1.1,4.3-2.6
		c0.2,0.1,0.4,0.2,0.6,0.3l0,0c1,0.1,1.9,0.1,2.9,0.1c0.7,0,1.2,0,1.7,0.2c0.1-0.5,0.2-0.9,0.4-1.4c0.2-0.6-0.2-0.9-0.8-1.2
		c-1.2-0.6-2.3,0.1-3.5,0.3c-0.2,0.3-0.4,0.7-0.5,1c-0.7-0.9-1.3-1.9-2.1-2.6c-0.4-0.3-0.9-0.5-1.4-0.7c-0.4-0.1-0.8-0.2-1.1-0.4
		c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.5-0.3l0,0c0.1,0,0.2-0.1,0.3-0.1
		c1-0.3,1.9-0.9,2.5-1.6c0.4-0.5,0.7-1,0.8-1.7l0,0c0-0.1,0.1-0.3,0.1-0.5c0-0.1,0-0.3,0-0.4c0-1-0.5-1.8-1.3-2.5l0,0
		c-0.3-0.3-0.7-0.5-1.1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2c-1.9-0.6-4.2,0.1-5.5,1.5c-0.3,0.3-0.5,0.6-0.7,0.9c-0.5,0.7-1.2,1.2-2.1,1.4
		c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.3,0.4,0.4c0.2,0,0.4-0.2,0.9-0.5c0.1,0.4,0.2,0.8,0.4,1.3c-0.2,0-0.4,0-0.6,0
		c-0.4,0-0.7,0-1,0c-1.1,0-2,0.2-2.8,0.5c-0.8,0.4-1.4,0.9-1.8,1.6l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4c0,0.2,0.2,0.4,0.2,0.6
		c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2s-0.3-0.2-0.4-0.3l-0.1-0.1c0,0,0-0.1,0.1-0.1
		c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6c-0.6,0.3-1.1,0.8-1.6,1c-0.3,0.1-0.7,0.1-1.1,0v-0.1c0-1.3-0.5-2.4-2.1-2.9
		s-2.9,0.2-4,1.1c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.4-0.1,0.9-0.1,1.4c-0.3-0.1-0.5-0.1-0.8-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.5,0.5-0.9,1-1.4,1.5c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2c-0.5,0.3-1,0.6-1.5,0.8c-0.1,0-0.1,0.1-0.2,0.1
		c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6c-0.2-0.1-2.2,0.5-2.3,0.6c-0.4,0.6-0.1,1.3,0.8,1.9l0,0
		c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.4c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.2,0.1,0.5,0.1,0.6,0.2
		c-0.3,0.9-0.5,1.7-0.8,2.7c-0.2,0.1-0.4,0.1-0.6,0.2c-0.8,0.3-1.5,0.6-1.8,1.5c-1-0.1-2-0.1-3-0.6s-2-0.1-2.5,0.9
		c-0.2,0.4-0.3,0.9-0.5,1.3c-0.3,0.5-0.7,1-1.1,1.6c-0.4-1.6-0.4-1.8,1.2-6c-0.4,0.3-0.8,0.4-0.9,0.6c-0.2,0.5-0.2,1-0.4,1.5
		s-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6c-0.4,0.3-0.8,0.5-1.2,0.6
		c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0c0.4-0.4,0.5-0.7,0-1
		s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8c-0.1-0.3-0.2-0.7-0.3-1
		c-0.2-0.4-0.8-0.5-1.2-0.1c0,0,0,0-0.1,0.1c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3-0.2-0.6-0.4-1.1-0.8c-0.3,0.8-0.5,1.4-0.2,2
		c0.4,0.7,0.7,1.4-0.6,1.9c-0.1,0.9-0.7,1.4-1.4,1.9c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8
		c-0.1,0-0.2-0.1-0.3-0.1s-0.2-0.1-0.3-0.1c0.1-0.8,0.2-1.6,0.3-2.4c-0.5,0-0.9,0-1.2,0c0.1-0.2,0.1-0.4,0.2-0.5
		c0.3-0.2,0.7-0.3,1-0.5c-0.4-0.2-0.7-0.4-1.3-0.7c-0.2,1-0.8,1.4-1.8,1.6c-0.3,0.1-0.7,0.1-1.1,0.2c0.5-0.5,0.8-0.7,1-0.9
		c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.4,0.4-0.7,0.8-1.2
		c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c-1,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.4,0.1-0.8,0.2-1.2,0.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.3,0.2-0.7,0.2-1.1c0.1-0.5,0.2-0.9,0.7-1.3
		c-0.2-1.1,1-2.3,0-3.3c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.2-0.2-0.5c-0.9,0.6-2,1-1.9,2.2c-0.9-0.1-1.4-0.9-2.4-0.6
		c-0.3,0.1-1-0.4-1-0.7c-0.1-0.8-0.9-1-1.5-1.4c0.2-0.3,0.4-0.7,0.7-1.2c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1
		c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.7-0.3-0.9-0.4s-0.6-0.1-0.6-0.2c-0.1-0.8-0.8-0.9-1.5-1.1
		c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.5,0.5-1.1,1.1-2.2,0.4c0.5-0.6,1-1.3,1.6-2c-0.1-0.2-0.2-0.6-0.3-0.9
		c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6c0.2-0.6,0.4-1.1,0.6-1.5c-0.7-0.5-1,0.3-1.5,0.4l0,0c0,0.1,0,0.3,0,0.4
		c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.5-0.3-0.9-0.6-1.4-0.9c-0.2,0.1-0.4,0.1-0.6,0.2c-0.5,0.1-0.9,0.3-1.5,0.4c0-0.8,0-1.5-0.1-2.1
		c-3.6,0.5-7.2,1-10.8,1.5C140.4,110.1,140.7,110.7,141,111.4z M235.1,124.9c0,0.1,0,0.1,0,0.2c-0.1,0-0.1-0.1-0.2-0.1
		C234.9,125,235,124.9,235.1,124.9z M169.6,120.3c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.3l-0.3-0.1
		C169.5,120.5,169.5,120.4,169.6,120.3z M162.3,142.9c0,0,0.1,0,0.1,0.1c-0.1,0-0.2,0.1-0.3,0.1L162,143
		C162.2,143,162.3,142.9,162.3,142.9z M151.7,126.8c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.1,0.2-0.2,0.2
		C151.7,127.1,151.7,126.9,151.7,126.8z M151.6,129.3v0.1V129.3L151.6,129.3z"
      />
      <path
        class="st3"
        d="M39.8,166.9c-0.3,0.3-0.5,0.5-0.7,0.8c0.2,0,0.4,0.1,0.5,0.1C39.7,167.4,39.7,167.2,39.8,166.9z"
      />
      <path
        class="st3"
        d="M469.8,192.6c-0.2,0.2-0.4,0.4-0.6,0.6c0.1,0.2,0.2,0.3,0.3,0.5C469.6,193.2,469.7,192.9,469.8,192.6z"
      />
      <path
        class="st3"
        d="M352.6,92.9c0.9,0,1.9,0.1,2.8,0.1C354.6,92.6,353.6,92.6,352.6,92.9z"
      />
      <path
        class="st3"
        d="M476.9,54.3c0.1-0.5,0.1-1-0.4-1.5c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.1-0.3-0.2-0.5c-0.8,0.6-1.7,1-1.8,1.9
		C475,54.3,475.9,54.3,476.9,54.3C476.8,54.3,476.9,54.3,476.9,54.3z M475.8,53.5l-0.3-0.1c0.1-0.1,0.1-0.3,0.2-0.4
		c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2C476.1,53.3,476,53.4,475.8,53.5z"
      />
      <path
        class="st3"
        d="M201.4,184.2c0.4,0.3,0.7,0.6,1,0.9c18.9,14.4,37.8,28.8,56.7,43.2c0.4-0.5,0.8-0.9,1.1-1.4
		c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1-0.1,0.2-0.1c-18.6-14-37.2-27.9-55.8-42
		C203.8,183.1,202.7,183.2,201.4,184.2z"
      />
      <path
        class="st3"
        d="M91.5,174.8c-0.1-3.2-0.2-6.4-0.3-9.6c0,0-0.1,0-0.1,0.1c-0.2,0.2-0.1,0.5-0.1,0.8c-0.2-0.1-0.4-0.1-0.5-0.2
		c-0.2,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.2,0.3-0.2,0.5c0,0.1,0.1,0.2,0.1,0.3l0,0c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.5,0.4
		c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0c0.6,0.7,1.4,0.7,2.2,1c-0.3,0.6-0.4,1.4-1.6,1.1c0.2,0.3,0.2,0.5,0.3,0.8
		c-0.3,0.4-0.6,0.8-1,1.2c0.2,0.1,0.4,0.3,0.7,0.5c-0.2,0.2-0.5,0.4-0.7,0.7c0.3,0.4,0.6,0.7,0.9,1c0.1,0.3,0,0.6-0.2,0.9
		c-0.2,0.4-0.6,0.7-1,1c1.3,0.2,2.5,0.5,3.9,0.7C91.5,175.9,91.5,175.3,91.5,174.8z"
      />
      <path
        class="st3"
        d="M396.1,99.4c1.3,0.1,2.5,0.2,3.8,0.4c0,0,0,0,0-0.1c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3
		c-0.2,0-0.3,0-0.5,0v-0.1c0-0.1,0-0.1,0-0.2c0-0.4,0.1-0.8-0.6-0.8c-0.3,0-0.7,0.1-0.8,0.3c-0.2,0.2-0.1,0.5-0.1,0.8
		c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3C396,99.1,396,99.2,396.1,99.4L396.1,99.4z M398.7,98.8c0,0.1,0,0.2,0.1,0.2
		c-0.2,0-0.3-0.1-0.5-0.1C398.4,98.9,398.5,98.9,398.7,98.8z"
      />
      <path
        class="st3"
        d="M350.5,228.8c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3s-0.3,0.2-0.4,0.3s-0.2,0.1-0.3,0.3
		c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2c-3,2.1-6.1,4.1-9.1,6.2c0.1,0.5,0.4,1.1,0.6,1.6
		c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2
		c0.4,0.2,0.7,0.4,1,0.3c0.3-0.1,0.5-0.1,0.7-0.1c0.3,0,0.6,0,0.9,0.3c0.3-0.6,1.1-0.3,1.5-0.6c0.2-0.2,0.4-0.3,0.6-0.5
		c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1
		c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9c-0.1-0.3-0.1-0.6-0.1-0.9C350.4,229.7,350.5,229.2,350.5,228.8z"
      />
      <path
        class="st3"
        d="M536.1,174.4c0-0.3,0-0.5,0-0.8c-0.2,0.2-0.4,0.5-0.5,0.7C535.8,174.3,535.9,174.3,536.1,174.4z"
      />
      <path
        class="st3"
        d="M546.5,175.6c0.4-0.9,0.3-1.7-0.5-2.2c-0.6-0.4-0.6-0.9-0.1-1.5c-0.6-0.1-1.1-0.3-1.7-0.4
		c-0.2,0.6-0.5,1.2-0.7,1.7c-0.2-0.3-0.5-0.6-0.7-0.9c0.2-0.4,0.3-0.7,0.5-1.1c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8
		c0.3-0.2,0.7-0.4,1-0.6c-1.1,0.5-2.1,1-3.2,1.5c-0.1,0.3-0.2,0.5-0.3,0.8c-0.7,0.2-1.6,0.5-2.5,0.8c0-0.1,0-0.2,0-0.2
		c-0.2,0.1-0.3,0.2-0.5,0.3c0.1,0,0.2,0,0.4-0.1c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7c0.6,0.7,1.7,0.9,3.5,0.9
		c0.4,0.4,0.7,0.8,1.1,1.1c0.2,0.1,0.3,0.2,0.5,0.3C544.8,177.1,546.1,176.7,546.5,175.6z"
      />
      <path
        class="st3"
        d="M477.3,188.9c-0.2,0-0.4,0-0.6,0.1c-0.5,0.1-0.8,0.1-1.2-0.1c-0.7-0.3-1.3-0.4-1.9-0.2
		c-1.2,1.2-2.3,2.5-3.5,3.7c0.9-0.1,1.7,0,2.5,0.6c0.9,0.7,2.1,0.4,3.1-0.2c0.4-0.2,0.6-0.4,1.2-0.3c1.2,0.1,2.4-1,2.4-1.9
		c0,0,0,0,0-0.1C479.2,189.4,478.5,188.8,477.3,188.9z"
      />
      <path
        class="st3"
        d="M550.5,165.9c-0.6,0.3-1.2,0.6-1.8,0.9c0.1,0.1,0.3,0.2,0.5,0.3c0.4-0.2,0.9-0.5,1.4-0.7
		C550.6,166.2,550.5,166,550.5,165.9z"
      />
      <path
        class="st3"
        d="M506.8,188.7c-0.1,0-0.3,0.1-0.4,0.2l-0.1-0.1c-0.3,0.4-0.6,0.8-0.8,1.2c0.1,0.1,0.2,0.2,0.4,0.2l0,0
		c2.4,0.9,2.4,0.9,3.4,2c0.3-0.2,0.9-0.5,0.9-0.7c0.1-1.1-0.2-2.1-1.3-2.8c0,0.3,0.1,0.6,0.1,0.9c0,0.1-0.3,0.3-0.5,0.5
		c-0.3-0.5-0.6-1.1-0.9-1.7C507.3,188.5,507.1,188.6,506.8,188.7z"
      />
      <path
        class="st3"
        d="M516.1,182.2c-0.1,0-0.1,0.1-0.2,0.1c0.1,0,0.2,0,0.3,0C516.2,182.2,516.1,182.2,516.1,182.2z"
      />
      <path
        class="st3"
        d="M511.1,192.2c-0.4,0.2-0.8,0.4-1.2,0.7c0.1,0.3,0.1,0.5,0.2,0.7C510.5,193.1,510.8,192.6,511.1,192.2z"
      />
      <path
        class="st3"
        d="M456.4,204.3c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.2-0.2-0.4-0.4-0.5c-1.2-1.3-3.4-1.5-5.1-0.5
		c-1.6,1-2.1,2.8-1.1,4.2c0.2,0.3,0.5,0.5,0.8,0.8c-0.3,1.2-0.8,2.3-0.8,3.5C451.8,209.1,454.1,206.7,456.4,204.3z"
      />
      <path
        class="st3"
        d="M72.5,299.4c0.2-0.3,0.4-0.6,0.6-0.9s0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8c0.3,0.4,0.7,0.8,1.1,1.2l0,0
		c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8c2.4,0.8,5,0.3,7.5-1.1l0,0c0.9,0.6,1.7,0.9,2.4,0.9
		c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5c-0.3-1.1-1.4-1.6-3.5-1.5c-0.2-0.1-0.3-0.2-0.4-0.3c-0.3-0.3-0.4-0.6-0.5-0.9
		c0-0.2,0-0.4,0-0.6s0-0.5,0-0.7s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5l0,0c-0.2-0.1-0.4-0.3-0.6-0.4
		s-0.5-0.3-0.7-0.4l0,0c-1.1-0.2-2.1-0.5-3.2-0.7c-0.1,0.1-0.2,0.2-0.3,0.3l-0.1,0.1c0-0.1,0-0.1,0-0.2s0-0.2-0.1-0.3
		c-9.1-2-18.3-4-27.4-6c-0.2,0-0.4,0-0.6-0.1c-0.4-0.3-0.9-0.7-1.3-1.1c0.5-0.1,1.1-0.4,1.5-0.3c7.3,1.6,14.6,3.2,21.9,4.8
		c2.2,0.5,4.4,1,6.7,1.5c0-0.1,0-0.1,0-0.2s0-0.1,0-0.2c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2c0.3-0.2,0.7-0.4,0.8-0.6
		c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3c0.3-0.2,0.4-0.5,0.6-0.8
		c0.3-0.5,0.7-0.8,1.4-0.9c0.4,0,0.9-0.5,1.4-0.8c0.1,0.4,0.3,0.9,0.4,1.5c-0.8,0.3-1.4,0.5-2.3,0.9c0,0,0.1,0,0.1,0.1
		c0.5,0.4,0.8,0.8,1.2,1.2c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.6,0.5,0.9,0.7c0.4,0.2,0.9,0.4,1.6,0.4c0.4-0.4,1.1-0.9,1.5-1.5
		c0.1-0.1,0.2-0.2,0.2-0.3c0.6-0.6,1.5-0.6,2.3-0.8c0.5,0.7,0.7,1.3,0.1,1.9c-0.1,0.1-0.3,0.3-0.5,0.4c-0.4,0.3-0.7,0.8-0.7,1.2
		c-0.1,0.7,0,1.4,0,2.2c0,0.2,0,0.4,0,0.6c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1c0.6-0.1,1.1-0.2,1.6-0.3
		c-0.1,0.5-0.2,1.1-0.4,1.7c1.3,0.3,2.5,0.6,3.8,0.8c0.8-0.4,1.9-0.4,2.7-0.7c0.5-0.6,1.1-1.2,1.3-1.8c0.3-0.8,0-1.6-0.7-2.2
		c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7c-0.1,0.4-0.2,0.8-0.3,1.2c0.3,0.3,0.5,0.6,0.9,0.9
		c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.2,0.1l0.1-0.1l0.1-0.1
		c-2.7-5.8-5.4-11.5-8.1-17.1c0.2-0.1,0.3-0.2,0.5-0.3l0,0c0-0.1,0-0.2-0.1-0.3c-0.2-0.3-0.6-0.6-1.2-0.7c-0.5-0.1-0.8-0.9-1.1-1.3
		c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4
		c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9
		c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0c0.2-0.1,0.5-0.3,0.9-0.5c-0.5-0.1-0.8-0.2-1.1-0.3
		c0.4-0.5,0.1-1.2,1-1.7c0.2,0.4,0.3,0.7,0.6,1c0.7,0.8,2,0.9,2.7,0.1s1.5-1.1,2.5-1.6c0.5,0.5,0.9,1,1.4,1.5
		c-0.6,0.8-1.9,1.3-1.7,2.4c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1c0.6,0.4,1.3,0.6,2.3,0.3c0.2-0.1,0.5,0.3,0.8,0.4
		c0.3-0.2,0.6-0.4,0.9-0.6c0.2,0.1,0.3,0.1,0.5,0.2s0.4,0.2,0.7,0.3c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1
		c0.6,0.1,1.2,0.1,2,0.2c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2
		c0.3,0.3,0.2,0.6-0.3,0.9c-0.3,0.2-0.6,0.4-0.8,0.6c-0.4,0.5-0.5,1-0.2,1.4c0.3,0.3,0.9,0.7,1.3,0.6c1.2-0.3,2.4,0.1,3.5,0
		c0,0.8-0.9,1.8,0.5,2.3c0.1,0,0.1,0.4,0.1,0.5c-0.2,0.8-0.1,1.5,0.8,1.8c0.7,0.3,1.3,0.1,1.8-0.2c-15.6-33.5-31.2-66.8-46.8-100.2
		c-0.3,0.4-0.7,0.7-1.5,0.5c0.1,0.5,0.2,0.8,0.3,1.3c0.5-0.1,1-0.1,1.8-0.2c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.6,0.6
		c-0.3,0.3-0.5,0.6-0.8,1.1c-0.3-0.2-0.5-0.4-0.7-0.6c-0.2-0.2-0.4-0.5-0.5-0.7c0,0.9,0,1.8,0,2.7c-0.2,0-0.4,0-0.5,0
		c-0.1-0.5-0.2-0.9-0.2-1.4c0-0.8,0-1.6,0-2.4c-0.3-0.3-0.6-0.6-1-0.9c-0.8,0.1-1.5,0-2.1-0.3c-0.5-0.2-0.9-0.5-1.3-0.9
		c-0.5,0.4-0.9,0.8-1.3,1.2c0-0.9,0.3-1.5,1.1-2c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		c0-0.1-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c-0.2-0.8-0.7-1.4-1.4-1.6c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2
		c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.7,0.3-1c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.2,0.5-0.3s0.5-0.2,0.8-0.3
		c0.1,0,0.3-0.1,0.4-0.1l0,0l0,0c-0.9-0.2-1.9-0.3-2.8-0.5c-0.2,0.1-0.4,0.3-0.6,0.4c-0.5,0.4-1.1,0.6-1.4,0.2
		c-0.8-0.9-2.1-1.2-3.3-1.4l0,0c-0.4-0.1-0.9-0.1-1.3-0.2c-0.2,0-0.3-0.1-0.5-0.2c0,0,0,0-0.1,0c13.8,29.2,27.5,58.1,41.2,87
		c-0.2,0.1-0.3,0.2-0.5,0.3c-0.3-0.4-0.6-0.8-0.8-1.2c-4.5-9.6-9.1-19.1-13.6-28.7c-2.9-6.1-5.8-12.1-8.6-18.2
		c-1.7-3.6-3.3-7.3-5-10.9c-4.3-9.1-8.7-18.2-13-27.3c-0.4-0.9-0.9-1.3-1.9-1.4c-3.5-0.5-6.9-1.2-10.5-1.8c-0.2,2-0.3,3.9-0.4,5.7
		c-0.2,0-0.4,0-0.5,0c0-1,0-1.9,0-2.9c0.1-2.1,0.1-2.7-1-3.1c0,0.4,0,0.9,0.1,1.4c0,0.1,0,0.2,0.1,0.3l-0.1,0.1
		c-0.9,0.2-0.9,0.2-1.3-1.3c-0.5,0.1-1.1,0.2-1.8,0.3c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6c-0.5,1-0.2,2,0.7,3
		c-1.5,0-2.7,0.3-3.5,1.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.7,0.9c-0.3-0.4-0.5-0.8-0.9-1.1c-0.6-0.5-1.4-0.2-1.7,0.5
		c-0.1,0.2-0.1,0.4-0.1,0.6l0,0c0,0.3,0.2,0.6,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1c0.1,0.3,0.2,0.7,0.4,1
		c0.2,0.5,0.6,1,1.3,1.3c0.4,0.1,0.7,0.4,1,0.7c0.2,0.2,0.5,0.5,0.7,0.7c-0.4,0.4,0,0.6,0.1,0.9c0.1,0.2,0.1,0.3,0.1,0.5
		c0,0.4-0.1,0.7-0.9,0.9c-0.3-0.6-0.8-1.1-1-1.7c-0.8-2.2-1.9-2.5-4.5-1.2c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.2-0.3-0.3-0.5
		c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.4-0.1-0.7,0.3-1.1c0.3-0.3,0.3-0.8,0.4-1.2c0-0.1,0-0.3,0.1-0.4
		c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c-0.3,0.5-0.7,0.9-0.9,1.4c-0.2,0.6-0.5,0.9-1.3,0.9c-0.5,0-0.9-0.1-1.3-0.4
		c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1c-0.3,0.9-0.8,1.7-0.2,2.6c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3
		c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2c-0.4,0.8-1,1.3-1.7,1.8c-0.8,0.5-1.6,1.2-2,1.9s-0.5,1.6-0.6,2.3
		c0,0.3,0.1,0.7,0.2,1c0,0.1,0.1,0.2,0.1,0.3c0.2,0.8,0.6,1.4,1.3,1.9c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.3-0.2,0.6-0.4,1
		c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5,0.4-0.4,0.7-0.3,1.1c0.1,0.3,0.2,0.6,0.1,0.8c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		l0,0h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.5-0.1-0.9-0.7-1.1
		c-0.2-0.1-0.3-0.4-0.4-0.6c-0.4-0.6-0.6-1.2-1.1-1.7c-0.2-0.2-0.4-0.4-0.5-0.5s-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3
		c-0.7-0.2-1.4-0.1-2.5,0.3c-0.3,0.1-0.5,0.2-1.1,0.4c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9
		c-0.3,0-0.7-0.1-1-0.1c-0.5-0.1-1-0.4-1.2-1.1c-0.2,0.5-0.3,0.7-0.4,1c-1,0.3-1.9,0.6-2.7,0.9c-0.3,0.3-0.3,0.7-0.6,1v0.3v6.7
		c1.1,0.6,2.2,1.1,3.2,1.7c0-0.1,0.1-0.3,0.3-0.7c0.7,0.1,1.5,0.3,2.1,0.4c0.4,1,0.2,2.1,1.1,3.1c0.3-1.1-1.2-1.7-0.1-2.8
		c0.9,0.2,2.2-0.4,3,0.7c0,0.1,0.1,0.1,0.1,0.2c0,0-0.1,0-0.1,0.1c-0.6,0.3-1.2,0.7-1.9,1.1c0,1-0.1,2.1-0.1,3.2c0,0.1,0,0.1,0,0.2
		c-0.5,0-1.1,0-1.6,0c-0.6,0-1.3,0-1.9,0c0-0.4,0.1-0.8,0-1.2c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c0,0,0,0-0.1,0
		c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.3,0.2,0.6,0.5,0.8
		c0.6,0.4,1.2,0.6,1.9,0.4c0.1,0.8,0.5,1.2,1.2,1.4c0.3,0.1,0.7,0.1,1.1,0c-0.1,0.4-0.2,0.7-0.3,1c-0.3,0.6-1,0.7-2.3,0.4
		c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2-0.4-0.6-0.7-1-1c-0.8-0.2-1.5-0.5-2-0.9v2.5v2.1v0.7v3v82.1c0.5,0.3,1.1,0.6,2,0.2
		c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4
		c0.2-0.9,1.1-1,1.8-1.2c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4
		c0.2,1,0.5,2.1,0.7,3.2c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.3,0.3-0.3,0.5c-0.5,0.9,0.1,1.8,1.2,1.7
		c0.1,0,0.1,0,0.2,0c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2
		c0.2,0.7,0,1.6,1.2,1.8c0.1,0,0.1,0.3,0.1,0.4v0.1c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8
		c0.1-0.1,0.2-0.2,0.3-0.3c0.3,0.1,0.6,0.1,0.9,0.1c1.2,0,2-0.7,2.7-1.5c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3
		c0,0,0,0,0.1,0c0.6,0.4,1.2,0.8,0.9,1.7c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1
		s0.1,0.3-0.1,0.6c-0.1,0.2,0.8,0.1,0.9,0.7c0.1,0.6,0.5,1.2,0.7,1.9c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5
		c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2c0.4,0.2,0.7,0.4,1,0.3s0.5-0.1,0.7-0.1
		c0.3,0,0.6,0,0.9,0.3c0.3-0.6,1.1-0.3,1.5-0.6c0.2-0.2,0.4-0.3,0.6-0.5c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8
		c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9
		c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.5,0.1-0.9,0.1-1.3c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.5-1.4-1.1-2.5-1.5c-0.3-0.1-0.6-0.2-1-0.2
		c0.5-0.2,0.8-0.5,1-0.8c0.5-0.5,0.8-1,1.6-1.1c0,0.4-0.1,0.8-0.2,1.2c0.2,0,0.4-0.1,0.6-0.2c0.4-0.2,0.7-0.4,1-0.7
		c0.3-0.3,0.6-0.6,0.9-0.8c1.8,1.8,1.8,1.8,4.5,1.3c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.1,0,0.1-0.1,0.2-0.1h0.1
		c0.4-0.2,0.9-0.5,1.6-0.1c-0.6,0.4-1.1,0.8-1.7,1.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,1,1.5,1.8,1.8c0.2,0.1,0.5,0.1,0.7,0.1
		c0.7,0,1.4-0.1,2.2-0.2c0.4,0.2,1,0.5,1.8,0.8c0.2,0.8,0.7,1.7,0.4,2.7c-2.6,0.2-3.6,0.7-3.9,2.1c-0.2,0.8,0.1,1.4,0.8,1.9
		c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0.1,0.6,0.3,1,0.4c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1c-0.3-0.2-0.5-0.4-0.8-0.5
		c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4-0.1-0.7-0.1-1.1-0.1c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1
		c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3
		c0.3,0.2,0.6,0.3,0.9,0.5c0.8,0.3,1.6,0.5,2.7,0.3c0.2,0,0.3,0,0.5-0.1c0,0.2,0,0.3,0,0.5l0,0c0,0.6,0.1,1.1,0.1,1.7
		c-0.4,0.3-0.8,0.5-1.1,0.8c-1.1,1-1.5,2.3-0.9,3.4s2.2,1.8,3.7,1.6c1-0.1,1.9-0.7,2.5-1.3c0.3-0.4,0.6-0.7,0.7-1.2
		c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.2-1.2c-0.2,0-0.5,0.1-0.5,0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1
		c0.5-0.2,0.9-0.3,1.3-0.5c1.7-0.7,2.4-2.2,1.7-3.6c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0
		c0.3,0.3,0.7,0.6,1,1c0.5-0.5,1-1,1.6-1.5c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7
		c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6c0-0.8,0.9-1.5,0.9-2.4c0.6,0.1,1,0.2,1.5,0.3c0.1,0,0.1,0,0.2,0
		c0.2-0.7,0.4-1.4,0.4-2c0-0.3,0-0.6,0-0.9C72.6,300.1,72.6,299.7,72.5,299.4z M98.2,295.6c0.2-0.5,0.3-1,0.5-1.5
		c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0c1,0.1,1.5,0.4,2.2,1.4c0.1-0.1,0.2-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1
		c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.6-0.3,0.6c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-1,0.6-1.5,1.5-2.3,2.2
		c-0.3,0.3-0.7,0.5-1.2,0.7C98,296.2,98.1,295.9,98.2,295.6z M61.2,173.3L61.2,173.3L61.2,173.3L61.2,173.3z M60.8,182.9
		c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.4-0.3-0.5-0.4l0,0c0.2-0.1,0.4-0.2,0.7-0.4
		c0.4-0.2,0.7-0.4,1.2-0.7C61.3,182.1,61,182.5,60.8,182.9z M34.7,184.4C34.7,184.4,34.7,184.3,34.7,184.4L34.7,184.4
		C34.8,184.4,34.8,184.4,34.7,184.4z M7.4,189.8L7.4,189.8l0.1-0.1L7.4,189.8z M41.6,291.2c-0.1,0-0.1,0-0.2,0
		c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1C43.1,290.8,43,291,41.6,291.2z"
      />
      <path
        class="st3"
        d="M465.4,107.2c13.6,1.8,27.1,4.1,40.6,6.1c0.5,0.1,1.1,0.1,1.4-0.1c1.5-0.9,2.8-1.8,4.6-3
		c-0.8-0.2-1.3-0.3-1.8-0.4c-12.1-1.7-24.1-3.7-36.2-5.1c-19.5-2.3-39.1-4.2-58.6-6.3c-3.6-0.4-7.3-0.7-10.9-1
		c0.2,0.2,0.4,0.5,0.7,0.8c-1.2,0.6-2.1,1.5-3.5,0.8c-0.4-0.2-0.8-0.1-1,0.4c0,0.1-0.1,0.1-0.1,0.2c6.8,0.6,13.6,1.3,20.4,2.1
		C435.8,103.6,450.6,105.2,465.4,107.2z"
      />
      <path
        class="st3"
        d="M453.4,216.6c0.7-0.1,1.4-0.1,2-0.2c5.9-6.1,11.7-12.2,17.6-18.3c-0.7-0.4-1.4-0.9-2.1-1.4
		c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-0.8-0.7-0.9-1.3c-0.1-0.7-0.5-1.3-1.1-1.6c-3.1,3.2-6.2,6.5-9.3,9.7c1.5,0,2.9-0.8,3.4-2.2
		c0.1-0.3,0.2-0.7,0.3-1.1c0.6-0.1,0.9,0.1,0.9,0.6c0,0.8,0.1,1.5,0.1,2.4c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1
		c-0.1,0-0.3-0.1-0.4,0c-0.7,0.3-1.3,0.3-1.9,0.3c-2.7,2.8-5.3,5.6-8,8.3c0,0,0,0.1,0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		c-0.6,0.6-1.2,1.2-1.8,1.8c-0.1,0.3-0.1,0.7,0,1.1c0.3,0.9,1,1.5,2.1,1.6C451.6,218.4,452.7,217.6,453.4,216.6z"
      />
      <path
        class="st3"
        d="M562.9,162.9c0.7-0.2,1.3-0.8,1.9-1.3c0.6-0.6,1.1-1.3,1.7-2c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.1,0.2-0.2
		c0.4-0.3,0.9-0.2,1.4-0.2c0,0.1,0,0.1,0,0.2c0.3-0.6,0.7-1.3,1.2-2c-0.8,0.3-1.3,0.5-1.7,0.7c-5.5,2.6-10.9,5.2-16.4,7.8
		c0.3,0.3,0.5,0.6,0.8,0.8c-1.6,0.4-2.9,1.2-3.9,3c1-0.5,1.8-0.8,2.4-1.3c1.2-0.9,1.9-1.2,3.3-1.4c1.3-0.1,1.9-0.5,2.9-2.1
		c0.9,0.3,1.3,1.3,2.5,1.1c0.2,0,0.4,0.4,0.5,0.7s0,0.6,0,0.9c0,0.1-0.1,0.2-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3
		c0.1,0.1,0.3,0.2,0.3,0.3c-0.1,0.3-0.3,0.5-0.5,0.8c0.3,0,0.5,0,0.7,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5
		c-0.1,0.3-0.2,0.7-0.2,1.1c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.2-0.1c0.1,0,0.3-0.1,0.5-0.1c0.1,0.3,0.3,0.6,0.4,0.8
		c0.2,0,0.3,0,0.4,0c0.1-0.1,0.3-0.2,0.4-0.3c0.9-1.5,1.7-3,2.6-4.6c0-0.2,0-0.4,0-0.6c0.2-0.1,0.3-0.2,0.5-0.2
		c0.9-1.6,1.8-3.2,2.7-4.8c0.1-0.2,0.2-0.4,0.4-0.7l0,0c-1.6,0.5-2.2,1.5-2.1,2.9c0,0.1-0.1,0.3-0.2,0.5c-1.6,0.2-2.7,1-3.4,2.2
		c0,0.1-0.2,0.1-0.3,0.1c0-0.6-0.5-0.3-1-0.2C561.3,164.3,561.4,163.3,562.9,162.9z M561.9,165.7L561.9,165.7L561.9,165.7
		C561.9,165.7,561.8,165.7,561.9,165.7z M560.8,168.3L560.8,168.3L560.8,168.3C560.8,168.2,560.8,168.3,560.8,168.3z M560.8,166.1
		C560.8,166.1,560.7,166,560.8,166.1c0-0.1,0-0.1,0.1-0.1l0.1,0.1C560.9,166.1,560.8,166.1,560.8,166.1z"
      />
      <path
        class="st3"
        d="M574.6,74c0.8-0.6,1.7-1.3,2.5-1.9l0,0c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1
		s-0.1-0.1-0.2-0.2l0,0c-0.1-0.1-0.3-0.2-0.4-0.4l0,0c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3,0.3-0.6,0.5-1
		c0.3,0.1,0.6,0.2,1,0.3c0-0.5,0.1-1,0.1-1.4c-0.9-0.1-1.7-0.2-2.6-0.2c0.3,0.2,0.4,0.4,0.6,0.5c-0.4,0.5-1,0.6-1.7,0.6v-0.1H574
		c0,0,0,0,0,0.1c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.5-0.9,0-1.6,0.8-2.4c0.4-0.4,0.8-0.9,1.1-1.3l0,0
		c0.2-0.2,0.4-0.5,0.6-0.7l0,0c-7.3-0.2-14.5-0.4-21.8-0.6c0,0.1,0,0.3,0,0.4s0,0.2,0.1,0.3c0.2,0.3,0.5,0.5,0.7,0.7
		c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0.1,0.6,0.3
		c0.7,1,0.6,1,2,1.2c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8c0.3,0.6-0.4,1.2,0.2,1.8c-0.8,0.4-1.4,0.8-2.1,1.2
		c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.4-0.3,0.8-0.6,1.3-0.8c0.9-0.4,1.5-0.9,1.8-1.8
		c0.8,0,1.7,0.3,2.3-0.6c0.7,0.5,1.4,0.9,2,1.3c0.1-0.4,0.3-0.5,0.7-0.5c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.6,0,1.2,0,1.6-0.7
		c0.3,0.3,0.5,0.5,0.7,0.8c-0.3,0.2-0.7,0.4-1.2,0.8c0.8-0.1,1.2-0.1,1.7-0.1c-0.3,0.4-0.6,0.6-0.7,0.8c-0.7-0.1-1.3-0.2-1.9-0.4
		c-0.5-0.1-1-0.4-1.5-0.6c0,0.6,0,1.2,0,2.2c-0.6-0.6-0.9-0.8-1.1-1.1c-0.3,0.4-0.9,0.6-0.6,1.3c0.2,0.4,0,1-0.7,1.2
		c3.8,0.2,7.6,0.3,11.3,0.5C573.4,74.6,574.1,74.3,574.6,74z M567.7,70.1L567.7,70.1L567.7,70.1L567.7,70.1z M568.6,70.8
		c0.1-0.5,0.1-0.7,0.1-1s-0.2-0.5-0.5-1c0.7,0.1,1.2,0.2,1.6,0.3c-0.7,0.6,0.1,0.4,0.5,0.6C569.8,70,569.3,70.3,568.6,70.8z"
      />
      <path
        class="st3"
        d="M553.4,60.8c-0.4-0.1-1-0.3-1.6-0.4c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.3-0.5,0.5-0.7,0.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.9,0.1,1.4-0.1c1.2,0.7,2-0.6,3.2-0.6c-0.2,0.3-0.4,0.6-0.6,0.9
		c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6c-0.2,0-0.3,0.1-0.5,0.2
		c1,0,1.9,0,2.9,0.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0c-0.1,0.1-0.1,0.2-0.1,0.2
		c6.3,0.2,12.6,0.3,18.9,0.5c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4
		c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2c0.6-0.8,1.4-1.3,2.2-1.2c0.7,0.1,1.1-0.2,1.6-0.4c-7.8-0.1-15.7-0.2-23.5-0.4
		c0,0.3-0.3,0.7-0.5,0.9C554.1,60.3,553.7,60.5,553.4,60.8z"
      />
      <path
        class="st3"
        d="M554.2,57c0.2,0.1,0.3,0.3,0.3,0.6c6.1,0.1,12.2,0.2,18.3,0.3c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0-0.1-0.1
		c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.2,0.2-0.3,0.3c2.2,0,4.3,0.1,6.5,0.1
		c-0.1-0.1-0.2-0.3-0.4-0.4c-0.1-0.1-0.2-0.1-0.3-0.2C570.6,57.3,562.4,57.1,554.2,57L554.2,57z"
      />
      <path
        class="st3"
        d="M133.6,105.8c-0.1,0.1-0.1,0.3-0.2,0.4c0.5-0.1,1-0.1,1.5-0.2C134.6,105.8,134.2,105.7,133.6,105.8z"
      />
      <path
        class="st3"
        d="M133.9,107.7c0,0.1,0.1,0.1,0.1,0.2c-0.3,0.3-0.6,0.6-1,1c0.2,0.2,0.4,0.5,0.6,0.7c0.2,0,0.4-0.1,0.7-0.1
		c0.8-0.7,1.1-0.7,2.2-0.4h0.1c4.5-0.7,9.1-1.4,13.6-2c-0.4-0.2-0.9-0.2-1.4-0.2c0.4-0.5,0.5-1,0.6-1.4
		C144.2,106.3,139.1,107,133.9,107.7z"
      />
      <path
        class="st3"
        d="M487.9,200.8c-0.3-0.8-0.7-1.6-1.3-2.3c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.7-1-1-2,0-3.4
		c0.2-0.1,0.6-0.3,1-0.5c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4c1.4-0.9,0.6-1.9,0.4-2.9c0.6-0.6,1.1-1.1,1.6-1.6
		c0.4-1,0.6-2,0.2-2.9c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.2-0.6,0.3-1c1.3,1,2.6,1.9,4,2.9
		c0.5,0.4,1,0.7,1.5,1.1c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.5,0.1,0.8,0.2,1.2,0.3c1-0.8,1.1-1.1,0.7-1.5
		s-0.7-0.4-2,0.2c-0.6-0.4-0.8-0.8,0-1.2c1-0.6,1.9-1.3,3.2-0.7c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9c0,0.8,0,1.4,0.7,1.9
		s1,1.2,1.1,2c0.1,0.9,0,1.1-0.9,1.5c-0.5,0.2-1,0.3-1.4,0.3c-1.5,0.1-1.5,0-2.1,1.2l0.1,0.1c0.9,0.8,1.7,1.1,2.5,1.1
		c0.5-0.8,1.1-1.5,1.6-2.3c0.4-0.6,0.8-1.3,1-2c0.1-0.3,0.2-0.7,0.3-1c-0.2-0.5-0.6-1-1-1.5c-0.5-0.5-0.4-1.1-0.2-1.7
		c0.2-0.6,0.4-1.1,0.6-1.7c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3c-0.5,0.4-0.8,0.7-1.1,0.9c-0.1,0-0.2-0.1-0.2-0.1
		c-0.2-2-0.9-3.9-0.3-6c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0h-0.1c1.1,0.3,1.2,1,1.3,1.8c4.4-13.4,8.9-26.9,13.3-40.3
		c0.3-0.9,1-1.9,1.8-2.5c5.5-4.2,11.1-8.4,16.7-12.6c0.9-0.7,1.7-1.3,2.8-2.1c-2.1-1.2-4-2.2-6-3.2c-1.2-0.6-2.5-1.3-3.9-1.6
		c-5.5-1.1-11-2-16.5-3.2c-1.9-0.4-2.7,0.7-4,1.7c1,0.2,1.7,0.4,2.3,0.6c0.7,0.2,1.4,0.5,2.1,0.8c1.7,0.9,2,2.4,1.1,4.1
		c-0.2,0.4-0.5,0.7-0.8,1.2c1.7,0.4,3.2,0.8,4.8,1.2c0,0.2-0.1,0.4-0.1,0.6c-0.4,0-0.7,0-1.1-0.1c-1.2-0.3-2.4-0.6-3.7-0.8
		c-0.6-0.1-1.4,0-1.9,0.4c-2.4,1.7-4.7,3.5-7.1,5.4c-0.3,0.3-0.6,0.6-0.8,1c-8.6,17.8-17.2,35.6-25.8,53.4c-0.3,0.6-0.7,1.1-1.1,1.6
		c-1.6,1.6-3.1,3.3-4.7,4.9c0.5,0,0.9,0.2,1.1,1c0,0-0.3,0.4-0.7,0.7l0,0h-0.1c-0.4-0.2-0.8-0.4-1.2-0.6c-0.2,0.2-0.3,0.3-0.3,0.5
		c-0.1,0.4,0.1,0.6,0.5,0.8l0,0c0.3,0.1,0.7,0.3,0.7,0.5c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1c0.5,0.3,1.1,0.5,1.8,0.6
		c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.3,0.5,0.4,0.7c1.5-1.4,3-2.7,4.5-4.1c0,0,0.1,0,0.1,0.1c-1.4,1.5-2.8,2.9-4.3,4.4
		c-0.1-0.1-0.2-0.2-0.3-0.3c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0.3,0.4,0.7,0.6,1c0.8,1.3,1.2,2.7,1.1,4.1c0,0.5,0,1,0.1,1.5
		c0.2,0.7,0.5,1.3,1.3,1.8c-0.7,0.2-1.3,0.3-1.8,0.4l0,0c-0.4,0.1-0.7,0.2-1,0.4c-1.3,0.7-2.1,2.1-1.8,3.4c0.3,1.4,1.8,2.3,3.5,2.2
		c0.3,0,0.6,0,1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.5,0.3-1.1,0.2-1.8
		C488.1,201.2,488,201,487.9,200.8z"
      />
      <path
        class="st3"
        d="M265.2,230.3c0.9,0.3,1.7,0.6,2.6,0.5c-0.7-0.1-1.1-0.4-1.6-0.7c-1.4-1-2.8-2.1-4.2-3.1
		c-0.1,0.1-0.2,0.1-0.3,0.2c-1,0.4-1.6,0.9-1.9,1.6c1.2,0.9,2.4,1.8,3.6,2.7c0.5-0.2,0.9-0.4,1.2-0.8c0.1-0.1,0.3-0.3,0.4-0.5
		C265.2,230.2,265.2,230.3,265.2,230.3z"
      />
      <path
        class="st3"
        d="M138.3,103.4c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0,0.4,0.1,0.9,0.1,1.3c3.6-0.5,7.1-1,10.7-1.4
		c-0.1-0.1-0.2-0.3-0.4-0.4c-1.5,0.3-2.4-0.1-3.2-1.2c-0.1-0.1-0.2-0.2-0.3-0.3c-1.6,0.2-3.2,0.5-4.8,0.7
		C138.3,103.2,138.3,103.3,138.3,103.4z"
      />
      <path
        class="st3"
        d="M138.1,101.8c0.2,0,0.5-0.1,0.7-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0
		c0,0.2-0.2,0.6-0.1,0.7C137.8,101.4,138,101.6,138.1,101.8z"
      />
      <path
        class="st3"
        d="M141.1,101.2c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.3,0C141.3,101.3,141.2,101.2,141.1,101.2z"
      />
      <path
        class="st3"
        d="M561.8,84.1c3.5-2.8,7.1-5.6,10.9-8.6c-0.6-0.1-0.7-0.2-0.9-0.2c-3.8-0.2-7.6-0.3-11.4-0.5
		c-0.6,0.3-1.3,0.7-2,1c0.2,0.2,0.3,0.4,0.6,0.7c-0.3,0.1-0.5,0.2-0.6,0.1c-0.6-0.3-0.6-0.8-0.2-1.3c-0.3-0.4-0.8-0.6-1.3-0.7
		c-6.9-0.3-13.8-0.6-20.6-0.9c0,0,0,0,0.1,0.1c0.5,0.8,1.1,1.5,1.6,2.2c0.8-0.2,0.8-1,1.2-1.4c0.1-0.2,0.3-0.3,0.7-0.2
		c0.5,0.5,0.6,1,0.7,1.6v0.1c0.1,0.4,0.3,0.7,0.6,1l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6
		c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0c-0.6,0-1.3,0.1-1.7,0.5
		c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.8,0.1-1.6-0.3-2.2c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.5-0.1-1-0.3-1.5-0.5
		c-0.3-0.1-0.6-0.2-0.8-0.2c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4-0.1-1,0.1-1.4,0.2c-0.9,0.2-1.7,0.3-2.6-0.4c1.2-0.4,2.2-0.8,2.7-1.7
		c-0.5,0.1-1.1,0.4-1.5,0.7c-2.8,2.4-5.5,4.8-8.3,7.2c-1.2,1-2.3,2.1-3.7,3.3c0.7,0.1,1,0.1,1.4,0.2c12.3,1,24.6,1.9,36.9,2.9
		c1.5,0.1,2.7-0.2,3.8-1.2C559.4,85.8,560.6,85,561.8,84.1z M535.1,79.4C535.1,79.4,535.1,79.3,535.1,79.4
		C535.2,79.3,535.2,79.3,535.1,79.4C535.2,79.3,535.1,79.4,535.1,79.4z"
      />
      <path
        class="st3"
        d="M155.8,147.4c-1.3-1.3-1.3-1.3-2.9-0.6c0-0.1,0-0.2,0-0.3s0-0.2,0-0.4s0-0.4-0.1-0.7c-0.2,0-0.4,0-0.4,0.1
		c-0.2,0.5-0.6,0.7-1.2,0.8c6.1,4.6,12.2,9.3,18.4,13.9c1.3,1,2.3,1.1,3.5-0.2c-0.2-0.2-0.3-0.3-0.4-0.4c-5-3.8-10-7.5-15-11.3
		c-0.4,0-0.9,0.1-1.7,0.2c0.5-0.4,0.7-0.6,0.9-0.8c-0.3-0.2-0.6-0.5-0.9-0.7C155.9,147.2,155.9,147.3,155.8,147.4z"
      />
      <path
        class="st3"
        d="M51.6,163.7c0.1-1.4-0.8-2.4-2-3.2c-1.2-0.9-2.7-0.5-4,0c-1.3,0.4-2.2,1.2-2.7,2.1c-0.2,0.4-0.3,0.8-0.4,1.2
		c-0.2,1-0.8,1.8-1.7,2.3c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.2,0,0.3c-0.1,1.1,0.3,1.6,1.4,1.7c2.7,0.4,5.3,0.9,8,1.3
		c0.4,0.1,0.8,0,1.4,0.1c-1.2-2.6-2.3-4.9-3.4-7.3c0.2-0.1,0.4-0.2,0.5-0.3c0.2,0.4,0.5,0.8,0.7,1.2c0.9,1.9,1.8,3.8,2.8,5.7
		c0.3,0.5,0.9,1,1.5,1.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.1,0.2-0.2c0.7-0.8,1.7-1.4,2.1-2.4c0.2-0.3,0.2-0.7,0.2-1.1
		c0-1.5-0.7-2.2-2.6-2.2c-0.6,0-1.2,0.1-1.9,0.1C51.7,164.2,51.6,164,51.6,163.7z"
      />
      <path
        class="st3"
        d="M150.4,145.7c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.5-0.3-1-0.4-1.5c0.3-0.2,0.6-0.5,0.7-0.8c-2.3-1.7-4.6-3.4-6.9-5.2
		c-0.7,0.3-1.5,0.6-2.2,1C144.5,141.2,147.4,143.5,150.4,145.7z"
      />
      <path
        class="st3"
        d="M236.9,236.8c0.3-0.2,0.7-0.4,1.1-0.6c-23.1-19.8-46.3-39.5-69.4-59.3c-0.1,0.1-0.1,0.2-0.2,0.3
		c22.7,20,45.4,40,68.1,60.1C236.6,237.1,236.8,236.9,236.9,236.8z"
      />
      <path
        class="st3"
        d="M535.1,173.2c-4.9,2.3-9.5,4.5-14.1,6.7c-0.3,0.1-0.5,0.4-0.8,0.7v0.1c0.1,0.3,0.2,0.9,0.1,0.9
		c-0.7,0.2-0.6,1-1.2,1.2c-0.9,0.4-1.3,1.1-1.7,1.8c-0.2,0.3-0.4,0.6-0.7,0.8c-0.3,0.4-0.5,0.8-0.8,1.1c0.2,0.2,0.5,0.5,0.7,0.7
		c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1,0.2-0.2,0.4-0.4,0.6c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0.2,0.2,0.4,0.3,0.7c-0.9,0.2-1.3,1-2.3,1
		c-0.3,0-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1c-0.6,0.9-1.3,1.8-1.9,2.7c0.1,0.1,0.3,0.3,0.5,0.4c0.7,0.3,1.3,0.9,1.6,1.5
		c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3c-0.1-0.4-0.1-0.9-0.2-1.4c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5
		c0.3,1.3,0.5,1.4,2.2,1.6c3.6-5.8,7.1-11.6,10.7-17.4c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0
		c-0.3,0.1-0.5,0.7-0.9,0.6c-0.1,0-0.2-0.1-0.3-0.2l0,0c-0.3,0-0.7-0.1-1-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7
		c-0.5-0.2-1.1-0.4-1.7-0.7c-0.2,0.5-0.3,0.9-0.5,1.4c-0.6-0.2-1.1-0.3-1.5-0.4c0.2-0.1,0.4-0.2,0.7-0.4c-0.5-0.1-0.8-0.2-1.1-0.3
		v-0.1c0.5-0.3,1.1-0.7,1.6-1c0.1-0.1,0.5,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2
		c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0.4,0.4,0.8,0.6,1.1l0,0c0.6-0.4,0.7-0.9,0.8-1.4c0-0.4-0.1-0.8-0.1-1.3c1,0.1,1.1,0.6,1.1,1.4
		c0.3-0.2,0.5-0.4,0.7-0.5c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.2,0.2-0.3,0.3-0.5c-0.4-0.5-0.2-1.2,0.1-1.7c0.3-0.6,1.1-0.9,1.8-1.4
		C534.7,174,534.8,173.7,535.1,173.2z M517.6,194.8c0.3-0.3,0.5-0.6,0.7-0.9C518.6,194.7,518.6,194.7,517.6,194.8z"
      />
      <path
        class="st3"
        d="M499.6,56.2c-0.1,0-0.3,0-0.4,0c-0.2,0.1-0.3,0.2-0.4,0.3c0,0.1,0,0.2-0.1,0.3c0.2,0,0.4,0,0.6,0
		C499.5,56.6,499.5,56.4,499.6,56.2z"
      />
      <path
        class="st3"
        d="M92.8,166.2c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2,0C92.8,166.1,92.8,166.2,92.8,166.2z"
      />
      <path
        class="st3"
        d="M426.7,86.1c-0.7-0.1-1.3-0.2-2.1-0.4c0.4-0.2,0.7-0.2,0.9-0.4c0.6-0.3,0.7-0.8,0.3-1.2
		c-0.5-0.5-1-0.9-1.3-1.1c-0.2-1.2-0.4-2.2-0.6-3.3c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.1-0.5-0.1-0.7c0-0.1,0-0.2,0-0.2
		c-0.9-0.1-1.8-0.1-2.7-0.2c0.1,0.1,0.2,0.3,0.4,0.5c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2c0,1.1-0.1,2.1-0.3,3.2
		c-0.1,0.4,0.1,0.7,0.3,1.1c0.4,0.7,0.3,1.3-0.1,1.8c-0.3,0.3-0.7,0.5-1.2,0.6c-0.3,0.1-0.7,0.2-0.9,0.1c-1.7-0.5-3.6-0.1-5.4-0.2
		c-0.3-0.4-0.5-0.8-0.8-1.1c-0.5-0.5-1.1-0.6-1.8-0.4c-0.7,0.2-1.3,0.7-1.3,1.2c0,0.1,0,0.1,0,0.2v0.1c3.2,0.2,6.5,0.4,9.7,0.7
		c5.2,0.4,10.5,1,15.7,1.5c0.6,0.1,1.4-0.1,1.7-0.5c1.1-1.4,2.2-2.9,3.4-4.5c-0.3-0.2-0.6-0.3-0.8-0.5c-0.7,0.7-1.3,1.3-2,1.9
		c-1.3-0.3-2.6-0.5-2.7-2c-0.5,0.3-0.7,0.5-1,0.6c-0.4,0.2-0.9,0.4-1.3,0.5s-1.8,0.6-2.2,0.7C429.5,86,428.1,86.3,426.7,86.1z"
      />
      <path
        class="st3"
        d="M601.8,77.2c-0.5,6.4-1.2,12.8-1.8,19.2c-0.4,4.7-0.8,9.5-1.2,14.2c-0.8,9-1.7,18-2.5,26.9
		c-0.1,0.7-0.1,1.5,0.1,2.3c0.5-0.8,1-1.6,1.5-2.4c0.2,0.1,0.4,0.2,0.6,0.3c-0.8,1.5-1.5,3-2.4,4.8c0.7-0.3,1.2-0.4,1.6-0.6
		c4.5-2.1,9.1-4.3,13.6-6.4c0.3-0.1,0.6-0.3,0.9-0.4V74v-6.3c-2.8,2.1-5.6,4.3-8.5,6.4C602.5,74.9,602,75.8,601.8,77.2z"
      />
      <path
        class="st3"
        d="M573.2,153.4c6.9-3.3,13.9-6.5,20.8-9.9c0.6-0.3,1.1-1.2,1.2-1.8c1.2-12.1,2.4-24.2,3.5-36.3
		c0.6-6.6,1.1-13.3,1.7-19.9c0.3-3,0.5-6,0.8-9.4c-0.8,0.4-1.2,0.7-1.7,1c-3.2,2.4-6.3,4.7-9.5,7.1c-4.1,3.1-8.3,6.3-12.4,9.4
		c-8.8,6.6-17.6,13.2-26.3,19.8c-0.7,0.5-1.3,1.5-1.5,2.4c-3.4,14.9-6.7,29.8-10,44.7c-0.6,2.5-1.1,4.9-1.6,7.4
		c0.1,0,0.2,0.1,0.3,0.1c1.1-1.7,2.2-3.4,3.3-5c0.2,0.1,0.3,0.2,0.5,0.3c-1.1,1.8-2.1,3.6-3.3,5.6c0.7,0.3,1.1-0.2,1.4-0.6
		c0.2,0.1,0.4,0.3,0.5,0.5c8.8-4.1,17.5-8.3,26.3-12.4c2-1,4.4-1.6,5.3-4c0-0.1,0.3-0.1,0.6-0.1c-0.1,0.5-0.3,0.9-0.4,1.4
		C572.9,153.5,573.1,153.5,573.2,153.4z M548.2,163.1c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7c-0.9,0.2-1.7,0.4-2.9,0.6
		c0.9-0.9,1.5-1.5,2.1-2.1c0.6-1.1,1.9-1.3,3-1.9c0.2,0.7,0.3,1.4,0.5,2.3C548.9,163.6,548.6,163.3,548.2,163.1z"
      />
      <path
        class="st3"
        d="M156.2,146.5c0.5,0.4,0.9,0.7,1.4,1.1c0.1,0,0.1,0,0.2-0.1c0.3-0.3,0.6-0.7,0.6-1s-0.4-0.7-0.7-0.7
		c-0.4,0-1,0.2-1.3,0.5C156.3,146.3,156.3,146.4,156.2,146.5z"
      />
      <path
        class="st3"
        d="M560.2,74.1c0.3,0,0.6,0,1,0c-0.2-0.2-0.3-0.4-0.5-0.7C560.3,73.6,560.2,73.8,560.2,74.1z"
      />
      <path
        class="st3"
        d="M526.2,64.5C526.2,64.5,526.3,64.5,526.2,64.5c1.4,0.7,2.6,1.2,4.1,0.5c0.6-0.3,1.1-0.7,1.6-1.1
		c-9.7-0.3-19.3-0.5-29-0.7c-0.6,0-1.4,0.4-1.8,0.8c-2.2,2.1-4.2,4.3-6.3,6.4c-0.2,0.2-0.4,0.5-0.5,0.8c0.2,0.1,0.3,0.2,0.4,0.2
		c10.8,0.5,21.6,0.9,32.5,1.4c0.5,0,1.1-0.3,1.6-0.7c0.3-0.3,0.6-0.5,0.9-0.8c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.7-0.3-1.1-0.4
		c-0.6-0.1-1.3-0.1-2,0.1c-0.2-0.6-0.6-1.1,0-1.6c-0.5-0.1-1-0.1-1.6-0.2c0.1-0.4,0.2-0.8,0.3-1.2C525.2,66.4,525.4,65.4,526.2,64.5
		z"
      />
      <path
        class="st3"
        d="M195.2,182.1c0.4,0.3,0.7,0.6,1.1,0.9c14.9,11.4,29.7,22.8,44.6,34.2c5.5,4.2,11,8.4,16.5,12.6
		c0.2-0.1,0.5-0.3,0.7-0.5c-20.8-15.9-41.7-31.7-62.5-47.6C195.4,181.9,195.3,182,195.2,182.1z"
      />
      <path
        class="st3"
        d="M558.3,176.6c0.1-0.2,0.2-0.4,0.3-0.6C558.4,176.2,558.3,176.3,558.3,176.6L558.3,176.6z"
      />
      <path
        class="st3"
        d="M537,169.2c3-13.7,6.1-27.4,9.2-41.1c0.9-4.2,1.9-8.5,2.9-13c-0.6,0.4-1,0.7-1.4,0.9
		c-6.7,5-13.5,10.1-20.2,15.2c-0.8,0.6-1.5,1.6-1.9,2.5c-4.4,13-8.7,26.1-13,39.1c-0.1,0.5-0.3,0.9-0.5,1.4c0.1,0,0.2,0,0.2,0
		c1.2-0.4,1.7,0.1,2,0.9c0.1,0.2,0.7,0.4,0.3,0.7c-0.5,0.4,0.4,1.3-1.1,1.4c0.5,0.6,0.9,1.1,1.2,1.6c0.2,0.3,0.5,0.7,0.5,1.1
		c0,0.3-0.4,0.7-0.7,0.8c-0.6,0.2-0.8-0.2-0.9-0.6c-0.6,0.5-0.8,1.1-0.5,1.8c2.2-1,4.3-2,6.4-3.1c0.8-0.4,1.5-1,2-1.7
		c3.9-5.5,7.8-11,11.7-16.6c0.3-0.4,0.6-0.8,1-1.2c0.2,0.1,0.3,0.3,0.5,0.4c-4,5.7-8,11.4-12.1,17.2c0.6,0.1,1-0.1,1.3-0.2
		c3.7-1.8,7.4-3.5,11.2-5.2C536.3,170.9,536.8,170.3,537,169.2z"
      />
      <path
        class="st3"
        d="M276.7,244.6c0.2,0,0.4,0,0.6-0.1c0,0,0,0,0.1,0c-0.5-0.2-0.9-0.3-1.1-0.3
		C276.4,244.3,276.6,244.4,276.7,244.6z"
      />
      <path
        class="st3"
        d="M563.9,168.3c-0.2,0.3-0.4,0.7-0.6,1C563.7,169,564,168.7,563.9,168.3z"
      />
      <path
        class="st3"
        d="M66,171.6c-0.7-0.4-1.3-0.8-2.1-0.9c-0.5-0.1-1,0-1.6,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.5
		l0,0c0.8,0.1,1.7,0.3,2.6,0.4C65.5,172,65.7,171.8,66,171.6z"
      />
      <path
        class="st3"
        d="M439.9,42.4c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2C440.2,42.4,440,42.4,439.9,42.4z"
      />
      <path
        class="st3"
        d="M449.6,56c1.2,0,2.3,0,3.5,0.1c0.1,0,0.2-0.1,0.3-0.1c0.4-0.2,0.8-0.3,1.2-0.5c-1.5,0-3.1,0-4.6-0.1
		C449.8,55.6,449.7,55.8,449.6,56z"
      />
      <path
        class="st3"
        d="M444.6,34.2c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0c0,0.2-0.2,0.6-0.1,0.7c1,0.5,0.8,1.4,0.8,2.2
		c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4c-0.4,0.2-0.8,0.2-1.1-0.3c-0.3-0.7-0.9-1-1.9-0.8
		c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.9,0,1.7,0,2.6,0h0.1c5.1,0,10.1,0.1,15.2,0.1c0-0.4,0-0.8-0.1-1.2
		c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4c-0.7-0.6-1.3-0.1-2,0c-0.2-0.2-0.4-0.5-0.6-0.7c-1.5,0.3-2.4-0.1-3.2-1.2
		c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5C446.2,35,445.5,34.6,444.6,34.2z"
      />
      <path
        class="st3"
        d="M545.3,69.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8c-0.2-0.1-0.5-0.2-0.7-0.3
		c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.4,0.2-0.6,0.3l0,0c-0.2,0.1-0.5,0.2-0.7,0.1c-0.9-0.1-0.9-0.2-1.9,0.2c0,0.4,0,0.8-0.1,1.2
		c-0.1,0-0.2,0-0.3,0c-1.4,0.1-2.6,0.6-3.9,1.4l0,0c6.5,0.3,12.9,0.5,19.4,0.8c0.2,0,0.5-0.1,0.6-0.3c-0.5-0.1-1-0.2-1.6-0.3
		c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0.2-0.4,0.4-0.5c-0.3-0.1-0.6-0.3-0.8-0.5c-0.7-0.6-0.7-1.6-0.9-2.6c-1.1,0-2.6,0.8-2.7-1
		c-0.4,0.4-0.6,0.6-1,0.8c-0.2-0.2-0.4-0.4-0.6-0.6C546.7,69.1,546.5,69.2,545.3,69.1z M542.6,70.7c0-0.2-0.1-0.4-0.1-0.5
		C542.9,70.3,543.1,70.4,542.6,70.7z"
      />
      <path
        class="st3"
        d="M271.4,243.3c0.2-0.1,0.3-0.2,0.5-0.3c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C271.5,242.8,271.5,243,271.4,243.3z"
      />
      <path
        class="st3"
        d="M518.8,180.9c-0.3,0.2-0.6,0.3-1,0.5c0,0,0,0.1,0.1,0.1c0.3-0.1,0.6-0.3,0.9-0.4
		C518.8,180.9,518.8,180.9,518.8,180.9z"
      />
      <path
        class="st3"
        d="M250.6,247c-0.5,0.2-0.9,0.4-1.1,0.9c0,0,0,0.1-0.1,0.1c0.1,0,0.4,0,0.7,0c-0.1,0.2-0.3,0.5-0.4,0.7
		c0.4,0,0.8,0,1.2,0.1c-0.3,0.2-0.5,0.4-0.8,0.6c0.3,0.3,0.7,0.6,1,0.9l0,0c0.1,0,0.1-0.1,0.1-0.1c0.1-0.6,0.7-1.1,1.1-1.6
		C251.9,248.1,251.3,247.5,250.6,247z"
      />
      <path
        class="st3"
        d="M536.7,109.3c0-0.6,0.1-1,0.1-1.5c0-3,0-3-3-3.6c-24.1-4.8-48.3-8.1-72.7-11.1c-10-1.2-20-2-30-3
		c-5.5-0.5-10.9-1.1-16.4-1.6c-1.5-0.1-3-0.2-4.5-0.3c-0.1,0.3-0.2,0.5-0.3,0.8c-0.1,0.1,0.1,0.4,0.2,0.7c-1.2,0-2.5-1-3.5,0.5
		c-0.3-0.1-0.7-0.2-1-0.2s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2s-0.5,0.3-0.7,0.6c-0.1,0.1-0.1,0.1-0.1,0.2
		c-0.2,0.3-0.2,0.5-0.2,0.7c1.9,0.2,3.8,0.3,5.8,0.5c5.8,0.5,11.6,1.1,17.3,1.7c6,0.6,11.9,1.2,17.9,1.8c4.2,0.4,8.5,0.9,12.7,1.4
		c4.9,0.6,9.7,1.1,14.6,1.8c15.1,2.2,30.3,4.5,45.4,6.8C523.3,106.7,529.9,108,536.7,109.3z"
      />
      <path
        class="st3"
        d="M275.3,242.5c-3.6-2.8-7.2-5.5-10.9-8.3c0.2,0.7,0.7,1.4,1.8,1.9c-0.1,0.1-0.2,0.2-0.3,0.2
		c2.5,1.9,5,3.9,7.6,5.8c0,0,0,0,0.1,0s0.1,0,0.2,0c0,0.1,0,0.1,0.1,0.2c0.4,0.2,0.8,0.4,1.2,0.6
		C275.1,242.9,275.2,242.7,275.3,242.5z"
      />
      <path
        class="st3"
        d="M238.2,238.7c0.4,0.4,0.8,0.7,1.2,1.1c0-0.2,0.1-0.4,0.3-0.7C239.2,239,238.8,238.9,238.2,238.7z"
      />
      <path
        class="st3"
        d="M285.7,128.9c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2c0.2,0.3,0.5,0.5,0.8,0.7c0.9,0,1.6-0.1,2.3-0.4
		c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.4,0.2,0.9,0.3,1.3c3.3-0.5,12.9-0.7,14.4-0.2c0,0.1,0,0.3,0,0.4
		c-4.8,0-9.6,0-14.4,0c0,0.2,0.1,0.3,0.1,0.5c0.1,0.4,0.1,0.8,0.1,1.2c5.3-0.2,10.6-0.3,15.9-0.2v-1c0,0.1,0.1,0.2,0.1,0.3
		c0.1,0,0.1,0,0.2-0.1c-0.1-0.2-0.1-0.3-0.2-0.5H306v-3.6h0.1c0.6,0.3,1.2,0.6,1.8,0.9c0.1,0,0.1,0.1,0.2,0.1
		c0.4,0.2,0.8,0.4,1.2,0.6c0-0.1,0.1-0.3,0.3-0.7c0.7,0.1,1.5,0.3,2.1,0.4c0.4,1,0.2,2.1,1.1,3.1c0.3-1.1-1.2-1.7-0.1-2.8
		c0.9,0.2,2.2-0.4,3,0.7c0,0.1,0.1,0.1,0.1,0.2c0,0-0.1,0-0.1,0.1c-0.6,0.3-1.2,0.7-1.9,1.1c0,0.3,0,0.7,0,1.1
		c12.6,0.4,25.3,1.6,37.8,3.8c26.4,4.6,51.6,12.7,75,25.8c1.3,0.7,2,0.3,3-0.8c-5.4-2.7-10.6-5.3-15.8-7.9c0.1-0.1,0.1-0.3,0.2-0.4
		c0.5,0.2,1,0.3,1.4,0.5c4.5,2.2,9,4.4,13.5,6.7c1.3,0.7,2.1,0.6,3.2-0.2c23.8-15.8,47.7-31.6,71.5-47.3c0.7-0.5,1.4-1,2.4-1.6
		c-0.9-0.2-1.5-0.3-2-0.4c-16.6-2.4-33.1-5.1-49.7-7.2c-19.3-2.4-38.7-4.4-58.1-6.5c-0.1,0.1-0.1,0.2-0.4,0.3
		c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0c0.6,0.7,1.4,0.7,2.2,1c-0.3,0.6-0.4,1.4-1.6,1.1c0.2,0.3,0.2,0.5,0.3,0.8
		c-0.3,0.4-0.6,0.8-1,1.2c0.2,0.1,0.4,0.3,0.7,0.5c-0.2,0.2-0.5,0.4-0.7,0.7c0.3,0.4,0.6,0.7,0.9,1c0.1,0.3,0,0.6-0.2,0.9
		c-0.3,0.4-0.8,0.8-1.2,1.2c-0.1,0.1-0.2,0.2-0.3,0.3c0.5,0.7,0.4,1.5,0.5,2.3c-0.3,0.1-0.6,0.1-1,0.2c0-0.3,0-0.5,0-0.7
		c-0.9-0.3-1.5-0.3-1.9-0.1c-0.3,0.2-0.6,0.5-0.9,1.1c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.1-0.9,0.3
		c-0.3,0.2-0.5,0.4-0.5,0.7c-0.1,0.5-0.3,0.6-0.8,0.9c-0.7,0.4-0.8,1.1-0.5,1.9c0.1,0,0.2-0.1,0.2-0.1c1.2-0.5,2.2-0.5,3,0.2l0,0
		c0,0,0,0,0.1,0.1h-0.1c0,0,0,0-0.1,0c-0.8,0.2-1.8-0.2-2.6,0.4l0,0c-0.2,0.1-0.9-0.1-1.2-0.6c-0.4-0.7-1.3-1.1-1.8-1.8
		c-0.2-0.2-0.7,0-0.9-0.1c-0.1,0-0.2-0.1-0.1-0.4l0,0c0-0.2,0.1-0.4,0.1-0.5v-0.1c-0.2,0-0.5,0-0.6,0.2c0,0.1,0,0.1,0,0.2
		c-0.4,0.1-0.8,0.3-1.2,0.4c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.5-0.6-0.8-1-1c-0.7-0.3-1.6-0.1-2.4,0.6c-0.5,0.5-0.8,1.1-1.8,0.8
		c0.1,0.5,0.2,0.8,0.3,1.3c0.5-0.1,1-0.1,1.8-0.2c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.5,0.6-0.8,1.1
		c-0.3-0.2-0.5-0.4-0.7-0.6c-0.4-0.5-0.7-1-1.1-1.6c-0.3-0.4-0.6-0.8-1.1-1.1c-0.8,0.1-1.5,0-2.1-0.3c-0.5-0.2-0.9-0.5-1.3-0.9
		c-0.5,0.4-0.9,0.8-1.3,1.2c0-0.9,0.3-1.5,1.1-2c0,0,0.1,0,0.1-0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		c0-0.1-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c-0.2-0.8-0.7-1.4-1.4-1.7c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2
		c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.7,0.3-1c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.5-0.2,0.8-0.3
		c0.1,0,0.3-0.1,0.4-0.1l0,0c0.2-0.2,0.5-0.7,0.6-0.7c1.1,0.2,1.4-0.7,2.2-1.1c-0.7-0.4-1.3-0.8-2.1-0.9c-0.5-0.1-1,0-1.6,0.2
		c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.3,0.5c-0.3,0.5-0.7,0.9-1.4,0.9h-0.1c-0.4,0-1,0.4-1.4,0.7c-0.5,0.4-1.1,0.6-1.4,0.2
		c-0.8-0.9-2.1-1.2-3.3-1.4l0,0c-0.4-0.1-0.9-0.1-1.3-0.2c-0.7-0.2-0.8-0.4-0.9-0.8c0.1-0.1,0.1-0.2,0.2-0.2
		c0.3-0.3,0.7-0.5,0.9-0.8c0.7-0.8,1.7-1.4,2.1-2.4c0.2-0.3,0.2-0.7,0.2-1.1c0-0.9-0.3-1.4-0.8-1.8c-4.4-0.2-8.7-0.5-13.1-0.7
		c-0.2,0.8-0.8,1.5-1.6,2c-0.3,0.2-0.5,0.3-0.7,0.5c-0.7,0.5-1.1,1.1-1.4,1.7c-0.3,0.7-0.3,1.5-0.1,2.3c0,0.1,0,0.2,0.1,0.3
		l-0.1,0.1c-0.9,0.2-0.9,0.2-1.3-1.3c-0.5,0.1-1.1,0.2-1.8,0.3c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6c-0.5,1-0.2,2,0.7,3
		c-1.5,0-2.7,0.3-3.5,1.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.3,0.3-0.5,0.5-0.7,0.9c-0.3-0.4-0.5-0.8-0.9-1.1c-0.6-0.5-1.4-0.2-1.7,0.5
		c-0.1,0.2-0.1,0.4-0.1,0.6l0,0c0,0.3,0.2,0.6,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1c0.1,0.3,0.2,0.7,0.4,1
		c0.2,0.5,0.6,1,1.3,1.3c0.4,0.1,0.7,0.4,1,0.7c0.2,0.2,0.5,0.5,0.7,0.7c-0.4,0.4,0,0.6,0.1,0.9c0.1,0.2,0.1,0.3,0.1,0.5
		c0,0.4-0.1,0.7-0.9,0.9c-0.3-0.6-0.8-1.1-1-1.7c-0.8-2.2-1.9-2.5-4.5-1.2c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.2-0.3-0.3-0.5
		c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1-0.4-0.1-0.7,0.3-1.1c0.3-0.3,0.3-0.8,0.4-1.2c0-0.1,0-0.3,0.1-0.4
		c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c-0.3,0.5-0.7,0.9-0.9,1.4c-0.2,0.6-0.5,0.9-1.3,0.9c-0.5,0-0.9-0.1-1.3-0.4
		c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.2-0.7-0.3-1c-0.3,0.9-0.8,1.7-0.2,2.6c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3
		c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2c-0.4,0.8-1,1.3-1.7,1.8c-0.8,0.5-1.6,1.2-2,1.9c-0.4,0.7-0.5,1.6-0.6,2.3
		c0,0.3,0.1,0.7,0.2,1c0,0.1,0.1,0.2,0.1,0.3c0.2,0.8,0.6,1.4,1.3,1.9c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.3-0.2,0.6-0.4,1
		c-0.2-0.3-0.4-0.5-0.6-0.7c-0.5,0.4-0.4,0.7-0.3,1.1c0.1,0.3,0.2,0.6,0.1,0.8c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		l0,0h-0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.3-0.1-0.4s0-0.2-0.1-0.3c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.5-0.1-0.9-0.7-1.1
		c-0.2-0.1-0.3-0.4-0.4-0.6c-0.4-0.6-0.6-1.2-1.1-1.7c-0.2-0.2-0.4-0.4-0.5-0.5s-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3
		c-0.7-0.2-1.4-0.1-2.5,0.3c-0.3,0.1-0.5,0.2-1.1,0.4c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9
		c-0.3,0-0.7-0.1-1-0.1c-0.5-0.1-1-0.4-1.2-1.1c-0.2,0.5-0.3,0.7-0.4,1c-0.4,0.1-0.8,0.3-1.2,0.4c-0.2,0.1-0.4,0.1-0.7,0.2
		c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.2,0.4-0.3,0.6v0.3v0.2
		c-0.6,0-1.1,0-1.6-0.4c-0.1-0.1-0.3-0.2-0.5-0.1c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3
		c0.1,0.3,0.4,0.6,0.8,0.7c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.3,0.1,0.6,0,0.9,0c0.5-0.1,0.9-0.4,1.4-0.6
		c-0.4,0.5-0.7,1-1.1,1.4c-1.1,1.3-1.4,2.8-1.4,4.3c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5
		c0.3-0.4,0.5-0.7,0.7-1c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.4-0.2-0.4c-1.3-0.2-1.2-1.9-2.7-2
		c-0.4,0-0.8-0.4-1-0.7c-0.4-0.5-0.7-1.1-1.1-1.7c-0.8-1-1.2-2.2-1.2-3.4c0-1.1-0.3-1.9-1.4-2.6c0.7-0.2,1.2-0.3,1.6-0.5
		c1.6-0.6,2.4-2.3,1.6-3.6c-0.6-1.2-2.4-1.6-3.9-1c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5c0.9,1,0.7,2.2-0.6,3
		c-1.5,0.9-2,1.6-1.7,2.7c0.3,1,1.2,1.4,3,1.3c0.2,0,0.3,0,0.6,0c0,0.5,0,1,0.1,1.5c0,0-0.1,0.1-0.1,0.3c-0.5-0.2-1.1-0.2-1.5-0.2
		c-0.5,0-1.1,0.2-1.6,0.5c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3
		c-0.3-1.1-1-1.6-2.4-1.6c-0.4,0-0.7,0.1-1.1,0.1l0.1-0.1l0,0l0,0C286.2,128.4,286,128.7,285.7,128.9z M407.8,153.5
		c1,0.4,1.9,0.8,2.9,1.2c-0.1,0.2-0.2,0.4-0.2,0.6c-1-0.4-1.9-0.8-2.9-1.2C407.7,153.9,407.7,153.7,407.8,153.5z M393.8,111.5
		c0.6,0.3,1.3,0.6,1.3,1.4c-0.8,0.1-1.5,0.3-2.3,0.4C392.5,112.6,393.7,112.2,393.8,111.5z M367.3,106L367.3,106L367.3,106
		L367.3,106z M366.5,114.9c0.4-0.2,0.7-0.4,1.2-0.7c-0.3,0.6-0.6,1-0.8,1.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1-0.1-0.2-0.2-0.3-0.2
		c-0.2-0.1-0.4-0.3-0.5-0.4l0,0C366.1,115.1,366.3,115,366.5,114.9z M340.9,117.1C340.9,117.1,340.9,117,340.9,117.1h0.1H340.9z
M313.6,122.4l-0.1,0.1l-0.1-0.1H313.6z M305.5,126.5c0.1-0.1,0.3,0,0.4,0c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.1-0.4,0.2
		C305.4,126.7,305.4,126.6,305.5,126.5z"
      />
      <path
        class="st3"
        d="M601.1,54.8c-0.2,0.2-0.3,0.5-0.5,0.6c-0.3,0.4-0.8,0.6-1.3,1.1c0.6,0.2,1,0.4,1.5,0.6
		c0.3,0.1,0.6,0.2,0.9,0.3c-0.3-0.7-0.5-1.5-0.5-2.3C601.1,55,601.1,54.9,601.1,54.8z"
      />
      <path
        class="st3"
        d="M102.6,220c-3.6-7-7.2-14-10.8-20.9c-3.3-6.5-6.6-13-10-19.5c-0.2,0.1-0.3,0.3-0.3,0.5
		c-0.1,0.5-0.3,0.6-0.8,0.9c-0.7,0.4-0.8,1.1-0.5,1.9c0.1,0,0.2-0.1,0.2-0.1c1.2-0.5,2.2-0.5,3,0.2l0,0c0,0,0,0,0.1,0.1h-0.1
		c0,0,0,0-0.1,0c-0.8,0.2-1.8-0.2-2.6,0.4l0,0c-0.2,0.1-0.9-0.1-1.2-0.6c-0.4-0.7-1.3-1.1-1.8-1.8c-0.2-0.2-0.7,0-0.9-0.1
		c-0.1,0-0.2-0.1-0.1-0.4l0,0c0-0.2,0.1-0.4,0.1-0.5V180c-0.2,0-0.5,0-0.6,0.2c0,0.1,0,0.1,0,0.2c-0.4,0.1-0.8,0.3-1.2,0.4
		c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.5-0.6-0.8-1-1c-0.6-0.3-1.4-0.1-2.1,0.4c3.2,6.9,6.5,13.8,9.7,20.7c2.6,5.5,5.2,11.1,7.8,16.6
		c3.9,8.4,7.9,16.9,11.8,25.3c5.9,12.5,11.7,25.1,17.6,37.6c0.1,0,0.1-0.1,0.2-0.1c2.6,1.3,4-0.8,5.7-1.8c1,0.8,1.7,1.6,0.8,2.9
		c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.3,0.1,0.5,0.2c0.7,1.4,0.5,3,0.7,4.8c1.1-0.9,1.1-1.8,0.8-2.7c-0.4-1.1-0.9-2.2-1-3.4
		c-0.1-0.7-0.1-1.2-0.1-1.6c0.1-1.4,0.7-1.5,2.9-2c0.6-0.1,1.2-0.3,1.7-0.5c-7.7-15-15.4-30-23-45
		C106.4,227.6,104.6,223.8,102.6,220z M130.9,275.8C130.9,275.8,130.9,275.9,130.9,275.8c0,0.1-0.1,0.1-0.1,0.2c0-0.1,0-0.1,0-0.2
		C130.7,275.8,130.8,275.8,130.9,275.8z"
      />
      <path
        class="st3"
        d="M139.2,269.4c0.2,0,0.4,0.1,0.6,0.2c0.7,0.2,1.4,0.2,2.1,0.1c-9.1-16.6-18.2-33.1-27.3-49.7
		c-2.6-4.8-5.4-9.5-8-14.3c-4.8-8.6-9.6-17.3-14.3-26c-0.6-1.2-1.3-1.8-2.7-2c-0.7-0.1-1.4-0.2-2.1-0.3c0.1,0.4,0,0.8,0.1,1.2
		c-0.3,0.1-0.6,0.1-1,0.2c0-0.3,0-0.5,0-0.7c-0.9-0.3-1.5-0.3-1.9-0.1c-0.3,0.2-0.6,0.5-0.9,1.1c-0.2-0.1-0.4-0.2-0.6-0.2
		c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0.1-0.5,0.2c6.7,13.3,13.5,26.6,20.3,39.8c2.5,5,5.2,9.9,7.7,14.9c7.1,13.8,14.1,27.6,21.2,41.4
		c0.4-0.3,0.8-0.6,1.1-0.8c1.3,1,1.9,1.1,2.6,0.5c0.7-0.7,0.4-1.1-1-2c0.7-1,0.7-1,0.4-2.5c0.6,0,1.2,0,1.8,0l0,0
		c0.1-0.1,0.3-0.2,0.4-0.3C138.1,269.3,138.2,269.1,139.2,269.4z M86.6,180.6c-0.3-0.7,0.9-1.1,1-1.8c0.6,0.3,1.3,0.6,1.3,1.4
		C88.2,180.3,87.5,180.5,86.6,180.6z"
      />
      <path
        class="st3"
        d="M274.1,126.6c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3
		c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-1.7,1.5-1.9,2.9-0.5,4.6c0.2,0.2,0.4,0.5,0.6,0.7
		c0.1,0.1,0.2,0.3,0.4,0.4c0,0.2-0.1,0.5-0.1,0.7c0.5,0,0.9-0.1,1.4-0.1c0-0.7-0.2-1.3-0.9-1.8c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.3-0.5-0.4-1-0.4-1.6c0.6-0.5,1.2-0.9,2.1-0.9c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5
		C275.8,127.8,275.1,127.1,274.1,126.6z"
      />
      <path
        class="st3"
        d="M450.4,198.6c-0.4-0.9-1.2-1.3-2.3-1.5c-0.3-0.1-0.9,0-1-0.2c-0.1-0.3-0.2-0.5-0.4-0.6
		c-0.3-0.3-0.8-0.4-1.3-0.5c-0.2,0-0.5-0.1-0.7-0.1h-0.1c0-0.1,0-0.1,0-0.2c0.1-1,1.5-1.3,2.1-2.2c-0.3,0.1-0.6,0.1-0.9,0.2
		c-0.7,0.4-1.5,0.4-2.5,0c-2.7-1.1-5.4-2.1-8.2-3c-0.5-0.2-1.4-0.2-1.8,0.1c-4.6,3.5-9.1,7-13.7,10.6c-0.1,0.1-0.2,0.2-0.4,0.5
		c3.3,1.3,6.5,2.6,9.6,3.8c0.7,0.3,1.9,0.5,1.3,1.5c-0.5,0.8-1.2,2-2.6,1.4c-4.4-1.8-8.8-3.6-13.2-5.4c-1-0.4-1.1-1.1-0.2-1.8
		c6.2-4.8,12.4-9.6,18.7-14.4c0.4-0.3,1.2-0.4,1.6-0.3c2.3,0.8,4.6,1.7,7,2.5l0.1-0.1c0.4-0.3,0.7-0.6,1.1-0.9l0,0
		c0.2-0.2,0.5-0.4,0.7-0.6c-0.2-0.2-0.5-0.3-0.8-0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.1-0.9-0.2-1.5
		c0.9,0.2,1.5,0.5,2.2,0.5s1.5-0.2,2.1-0.5c0.1,0,0.2-0.1,0.3-0.1c0.2-0.2,0.2-0.3-0.3-0.5c0-0.2,0-0.4,0.1-0.8
		c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0.2,0.9,0.3,1.2,0.5c0.6,0.3,1.1,0.7,1.3,1.4c-0.5,0.2-1,0.3-1.4,0.5c-0.5,0.2-0.8,0.6-0.4,1
		c0.3,0.4,0.2,0.6-0.1,1c-0.7,0.9-0.6,1.8,0.1,2.6c0.6,0.6,1.8,0.8,2.7,0.5c1.2-0.5,1.9-1.3,1.7-2.4v-0.1c0-0.1,0-0.1,0.1-0.2
		c0.5,0.1,0.9,0.3,0.7,0.8c0,0.1,0,0.1-0.1,0.2c-0.2,0.5-0.3,1-0.5,1.5c-0.3,0.6-0.6,1.3-0.8,1.9c-0.3,0.6-0.5,1.3-0.7,1.9
		c-0.6-0.6-0.4-1.7-1.6-2.1c-0.1,0.2-0.2,0.4-0.2,0.5c0.1,1.3,1.3,2.3,1.1,3.7c-0.1,0.4,0.8,0.5,1.4,0.2c0.2-0.1,0.4-0.4,0.6-0.7
		c0.3,0.1,0.7,0.2,1,0.4c1.2,0.6,2.3,0.5,3.4-0.2c1-0.7,1.4-1.6,1.1-2.5c-0.3-1.1-1.2-1.7-2.6-1.7c-0.2,0-0.4,0-0.5,0
		c0.7-2.1,2.1-3,4-2.5c0.3,0.1,0.7,0.3,0.8,0.5c0.3,1.1,1.2,1.7,2.6,1.9c-1,1.7-2.2,3.3-1.3,5.2c-0.5,0.1-0.9,0.2-1.4,0.3
		c-1.7,0.5-2.7,1.8-2.5,3.2c0.1,0.7,0.6,1.3,1.4,1.7c3.1-3.2,6.1-6.4,9.2-9.6c-1.6,0.1-2.3-0.9-3.7-1.2c0.6-0.7,0.9-1.2,1.9-1.5
		c0.1,0,0.1-0.1,0.2-0.1c0.5-0.1,0.9-0.4,1.3-0.7s0.8-0.6,1.3-0.8c1.2,0.4,1.3,1.2,1.1,2.1c-0.6,0.3-1.4-0.1-1.8,0.7
		c0.3,0.1,0.5,0.2,0.8,0.4c0.8-0.8,1.5-1.6,2.3-2.4c-0.1,0-0.3,0-0.4,0c0.3-0.3,0.5-0.4,0.7-0.3c1.5-1.6,3.1-3.2,4.6-4.8
		c0.2-0.7,0.4-1.5,0.5-2.3c0.2-0.1,0.3-0.1,0.5-0.2c0.4-0.1,0.8-0.3,1.2-0.4c0,0.2,0,0.4,0,0.6c1.2-1.3,2.5-2.6,3.7-3.9
		c1-1,1.8-2.2,2.4-3.4c6.9-14.2,13.8-28.4,20.6-42.6c1.1-2.3,2.2-4.6,3.3-6.9c-0.1-0.1-0.2-0.1-0.3-0.2
		c-20.8,15.8-41.6,31.7-62.4,47.6c0.4,0.5,0.7,0.9,1.1,1.3c-0.1,0.1-0.1,0.3-0.2,0.4c-1.1-0.8-1.9-0.9-3.1,0
		c-13.4,10.2-26.7,20.4-40.1,30.6c0.7,0.2,1.4,0.1,1.9-0.4c0.7-0.8,1.5-1.1,2.5-1.6c0.5,0.5,0.9,1,1.4,1.5c-0.6,0.8-1.9,1.3-1.7,2.4
		c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1c0.6,0.4,1.3,0.6,2.3,0.3c0.2-0.1,0.5,0.3,0.8,0.4c0.3-0.2,0.6-0.4,0.9-0.6
		c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.4,0.2,0.7,0.3c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.1-0.6,0.2-1c0.6,0.1,1.2,0.1,2,0.2
		c-0.2-0.4-0.3-0.6-0.5-0.9c0-0.1,0.1-0.2,0.1-0.2c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2c0.3,0.3,0.2,0.6-0.3,0.9
		c-0.3,0.2-0.6,0.4-0.8,0.6c-0.4,0.5-0.5,1-0.2,1.4c0.3,0.3,0.9,0.7,1.3,0.6c1.2-0.3,2.4,0.1,3.5,0c0,0.8-0.9,1.8,0.5,2.3
		c0.1,0,0.1,0.4,0.1,0.5c-0.2,0.8-0.1,1.5,0.8,1.8c1,0.4,1.9-0.1,2.6-0.8c2.6,1.3,4-0.8,5.7-1.8c1,0.8,1.7,1.6,0.8,2.9
		c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.3,0.1,0.5,0.2c0.7,1.4,0.5,3,0.7,4.8c1.1-0.9,1.1-1.8,0.8-2.7c-0.4-1.1-0.9-2.2-1-3.4
		c-0.1-0.7-0.1-1.2-0.1-1.6c0.1-1.4,0.7-1.5,2.9-2c1.1-0.3,2.2-0.5,3.4-1.1c-0.4,0-0.8,0-1.3-0.1c0-0.1-0.1-0.2,0-0.2
		c0.4-0.3,0.8-0.6,1.2-0.9c1.3,1,1.9,1.1,2.6,0.5c0.7-0.7,0.4-1.1-1-2c0.7-1,0.7-1,0.4-2.5c0.6,0,1.2,0,1.8,0l0,0
		c0.1-0.1,0.3-0.2,0.4-0.3c1-0.9,1.1-1.1,2.1-0.8c0.2,0,0.4,0.1,0.6,0.2c1.3,0.4,2.5,0.2,3.6-0.7
		C450.6,200.8,450.9,199.6,450.4,198.6z M436.9,208.6c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0v0.1C437,208.6,436.9,208.6,436.9,208.6z"
      />
      <path
        class="st3"
        d="M599.1,47.5c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5c0.2,0.3,0.4,0.6,0.5,0.9
		c0.3-0.3,0.6-0.7,0.9-0.9c-0.2-0.3-0.5-0.6-0.9-0.9c0.7-0.2,1.2-0.3,1.6-0.5c1.6-0.6,2.4-2.3,1.6-3.6
		C602.3,47.3,600.6,46.9,599.1,47.5z"
      />
      <path
        class="st3"
        d="M359.1,233.2c0.4-0.3,0.8-0.6,1.3-0.9C359.7,232.5,359.3,232.8,359.1,233.2z"
      />
      <path
        class="st3"
        d="M340.9,231.8c2.1-1.4,4.1-2.8,6.2-4.2c-0.2-0.1-0.4-0.2-0.7-0.3c-1.9,1.3-3.8,2.5-5.7,3.8
		c-1,0.7-1.9,1.3-2.9,2h0.1c0.3,0,0.4,0,0.5,0.1s0,0.2,0,0.4C339.2,233,340.1,232.4,340.9,231.8z"
      />
      <path
        class="st3"
        d="M279,243.4C279,243.4,279.1,243.4,279,243.4c0.1,0,0.2,0,0.2-0.1C279.2,243.3,279.1,243.3,279,243.4z"
      />
      <path
        class="st3"
        d="M100.6,303.1c0.8-0.8,1-1.6,0.7-2.5c-1.6-0.4-3.3-0.7-4.9-1.1c-0.4,0.2-0.8,0.4-1.2,0.6c0,0.2,0,0.4,0.1,0.7
		c0,0.3,0.1,0.6,0.1,0.9v0.1c0.1,1.1,0.7,2,2,2.3C98.2,304.3,99.8,303.9,100.6,303.1z"
      />
      <path
        class="st3"
        d="M223.6,143.1c-0.1,0-0.1,0-0.2,0c-16.6,4-32.8,9.6-48.3,17.4c0.7,0.2,1.4,0.2,1.9,0c10.4-5,21.1-9,32.1-12.2
		c6.1-1.8,12.2-3.3,18.3-4.7c-0.2,0-0.3-0.1-0.5-0.1c-0.3-0.1-0.6-0.2-0.8-0.2c-0.4-0.1-0.7-0.2-1.1-0.3
		C224.6,142.8,224.1,143,223.6,143.1z"
      />
      <path
        class="st3"
        d="M580.6,59.5c-0.2,0-0.5,0-0.7,0c-0.2,0.2-0.3,0.4-0.2,0.7c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1
		c0-0.3,0-0.7-0.1-1.3c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-0.6,0.5-1,1.1-1.2,1.6
		c0.7,0,1.4,0,2.1,0.1c0.3-0.1,0.6-0.2,1-0.2c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5
		C582.1,60.5,581.5,60,580.6,59.5z"
      />
      <path
        class="st3"
        d="M555.7,180.6c0,0,0,0.1-0.1,0.1c0.1,0,0.2,0,0.3,0c0.2-0.3,0.3-0.5,0.5-0.8C556.1,180,555.9,180.2,555.7,180.6
		z"
      />
      <path
        class="st3"
        d="M532,47.4c0.3-0.3,0.6-0.6,0.9-0.8c-0.3,0.2-0.7,0.4-1.2,0.5c0,0.1,0.1,0.1,0.1,0.2
		C531.9,47.3,532,47.4,532,47.4z"
      />
      <path
        class="st3"
        d="M476.3,56.4c0.1-0.1,0.1-0.2,0.2-0.3c0-0.1,0-0.2,0-0.3c-7.2-0.1-14.4-0.2-21.6-0.3c0,0.2,0,0.4,0,0.6
		C462,56.2,469.2,56.3,476.3,56.4z"
      />
      <path
        class="st3"
        d="M515.6,107c-16.9-2.5-33.8-5.1-50.7-7.6c-6-0.9-12.1-1.5-18.2-2.2c-8.6-0.9-17.1-1.7-25.7-2.6
		c-5.5-0.5-10.9-1.1-16.4-1.6c-0.3,0-0.6,0-0.9-0.1c-0.3,0.9-0.6,1.6-0.5,2.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.2,0.1,0.3
		c0,0,0,0.1,0.1,0.1c4.2,0.4,8.4,0.7,12.6,1.1c9.6,0.9,19.3,1.7,28.9,2.7c6.5,0.7,13.1,1.4,19.6,2.2c16,2.2,32.1,4.4,48.1,6.7
		c1.8,0.3,2.5-0.7,4.1-1.6C515.9,107.1,515.7,107,515.6,107z"
      />
      <path
        class="st3"
        d="M453.1,50.2c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7c-0.2-0.1-0.4-0.3-0.6-0.4c-0.6,0-1.3,0-1.9,0
		c-0.1,0.3-0.2,0.6-0.2,1c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c0-0.1,0-0.2,0-0.3c-1.9,0-3.8,0-5.8-0.1c0,0.2,0,0.4,0,0.6
		c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2
		c-0.1,0.2-0.2,0.3-0.2,0.5c-0.4,1-0.5,1.9,0.6,2.4c7.6,0.1,15.1,0.2,22.7,0.4c-0.4-0.2-0.8-0.4-1.3-0.2c-0.3,0.1-1-0.4-1-0.7
		c-0.1-0.8-0.9-1-1.5-1.4c0.2-0.3,0.4-0.7,0.7-1.2c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1c0.1-0.1,0.2-0.1,0.2-0.2
		c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.7-0.3-0.9-0.4h-0.1c-5.2-0.1-10.5-0.1-15.7-0.2C452.9,49.4,453.1,49.7,453.1,50.2z"
      />
      <path
        class="st3"
        d="M349.2,225.5c0.1-0.1,0.2-0.1,0.2-0.2c-0.5,0.4-1.1,0.7-1.6,1.1c0.1,0,0.3-0.1,0.4-0.1
		C348.6,226,348.9,225.8,349.2,225.5z"
      />
      <path
        class="st3"
        d="M536.8,201.2C536.9,201.2,536.9,201.2,536.8,201.2C536.9,201.1,536.9,201.1,536.8,201.2L536.8,201.2z"
      />
      <path
        class="st3"
        d="M612,20.2c-1.4,0.3-2.6,1.4-3.6,3c-0.3-0.3-0.6-0.6-0.9-0.9c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.3,0.4-0.1,0.6,0.7,1.2c0.2-0.1,0.4-0.2,0.7-0.4l0,0c0.1,0.3,0.1,0.6,0.2,1.1c-0.4,0.1-0.7,0.1-1,0.1c-2.2,0-4.4,2.1-3.9,4.2
		c0.1,0.3,0.2,0.6,0.4,0.8c0.6,0.9,1.5,1.4,2.7,1.5c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0v0.1c0,0.5-0.1,1-0.1,1.5
		c0,0.1,0,0.2,0,0.3c-0.4,0-0.7,0.1-1.1,0.1c-0.2,0-0.4,0-0.5,0c-0.5,0.1-0.9,0.2-1.3,0.4c-2,0.9-2.9,3-2,4.5
		c0.1,0.2,0.2,0.4,0.3,0.6c-0.4-0.1-0.7-0.2-1.1-0.3c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5c-0.4,1.1,0.1,2.2,1.2,2.7
		c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-0.9,0.5-1.8,0.3-2.7c1.3,0.3,2.6,0.7,4.4,0.2c-0.6,1.4-0.3,2.5,0.3,3.5
		c0.3,0.1,0.6,0.2,0.9,0.3c0.9,0.4,1.9,0.5,2.9,0.3v-4v-3.2v-4.3v-1v-1.7v-6.5V22v-1.4L612,20.2C612.1,20.1,612,20.1,612,20.2z"
      />
      <path
        class="st3"
        d="M409.8,234.2c-0.7,0.4-1.2,0.6-1.7,0.9c-0.9,0.7-1.7,1.4-2.6,2.1c-0.6,0.5-0.4,1.2,0.3,1.3
		c0.9,0.1,1.4,0.6,2,1c0.5,0.4,1,0.6,1.5,0.7c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6
		c0.3,1.4,1.8,2.3,3.4,2.2c0.3,0,0.7,0,1-0.1c1.8-0.4,3-1.8,3-3.4c0-0.1,0-0.2,0-0.4c-0.3-1.8-2.1-2.8-4.2-2.4c-0.1,0-0.1,0-0.2,0.1
		c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.2c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7c-0.1-0.1-0.3-0.1-0.4-0.2
		c-0.5-0.1-0.9-0.2-1.5-0.2c0.2-0.4,0.3-0.7,0.6-1.2c0.4,0.5,0.7,0.9,1.1,1.2c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0,0.7,0.1,1.1,0.1
		c1.2,0.1,2.2-0.3,2.9-1c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.8-0.6-1.9-0.8-3.1-0.5
		c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4c-0.2,0.5-0.6,1-0.7,1.6
		C409.5,233.2,409.7,233.7,409.8,234.2z"
      />
      <path
        class="st3"
        d="M393,254c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9l-0.1-0.1
		c-0.5-0.5-1.4-0.6-2-0.2c-0.4,0.2-0.6,0.5-0.8,0.7c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2c-1.3,1.2-1.3,1.2-0.5,2.5
		c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6
		c0.7-0.3,0.5-0.8,0.4-1.2C393.2,255,393.1,254.5,393,254z"
      />
      <path
        class="st3"
        d="M476.6,203.8c-2.4,0.6-3.5,2-3.1,4c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5
		s-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9C477.7,203.6,477.1,203.6,476.6,203.8z"
      />
      <path
        class="st3"
        d="M485.9,211.1c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C486.1,211.6,486,211.3,485.9,211.1z"
      />
      <path
        class="st3"
        d="M408.3,241.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.4,0.2-0.8,0.5-1.1,0.7c-0.4-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.2-1.3,0
		c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.5-0.1
		c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1c0.8-0.8,1.5-1.5,2.2-2.2
		c0.4,0.2,0.8,0.4,1.2,0.5c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1
		c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3s0-0.3-0.1-0.4C408.6,241.6,408.5,241.3,408.3,241.1z"
      />
      <path
        class="st3"
        d="M482.5,196.8c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8c-0.5-0.1-1.1-0.1-1.7,0
		c-0.8,0.2-1.4,0.6-1.9,1.1c-0.1,0.2-0.1,0.4-0.2,0.5s-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1,0.3-0.1,0.6,0,0.9
		c0.2,1.1,1.1,1.8,2.3,2c0.5,0.1,1,0.1,1.5,0C481.2,198.8,482.2,197.9,482.5,196.8z"
      />
      <path
        class="st3"
        d="M454.2,270c-1.4,0.2-2.4,1.1-2.6,2.1h3.1c0.5-0.6,0.9-1.3,1.4-1.9C455.5,270,454.9,269.9,454.2,270z"
      />
      <path
        class="st3"
        d="M456.7,270.6c-0.4,0.5-0.7,1-1.1,1.5h1.9c0-0.1,0-0.2,0-0.3C457.4,271.4,457.1,270.9,456.7,270.6z"
      />
      <path
        class="st3"
        d="M556.8,169.9c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0c-0.8,0.1-1.5,0.4-2.4,1.1c0.4-1.1-0.4-1.3-0.8-1.7
		c-0.6-0.6-1.4-0.5-2.2-0.2c-0.7,0.2-1.3,0.6-1.9,0.8c0.3,1.1,0.8,1.9,2.1,2.2c1.4,0.3,2.1-0.5,3.1-1.2c0.1,0.5,0.3,1,0.7,1.3
		c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7
		s0.5-0.8,0.4-1.6C558,170,557.4,170,556.8,169.9C556.9,169.9,556.8,169.9,556.8,169.9z"
      />
      <path
        class="st3"
        d="M539,227.6c0.6-1.2-0.1-2.4-1.5-2.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6
		c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2c-0.2,0.1-0.2,0.5-0.2,0.7l0,0c0.1,0.3,0.4,0.6,0.6,0.9c-0.2,0.4-0.4,0.8-0.5,1.2
		c-0.3,1.3,0.5,2.3,2,2.6C537.1,229.5,538.5,228.8,539,227.6z"
      />
      <path
        class="st3"
        d="M492.3,189.1c1.1,0.4,2.6,0,3.4-0.8s1-2,0.4-2.9c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9
		c-0.1,0.4-0.3,0.8-0.4,1.2C490.5,187.7,491.1,188.7,492.3,189.1z"
      />
      <path
        class="st3"
        d="M500.5,190.5c-0.1-0.4-0.7-0.8-1.2-1c-0.9-0.3-1.8-0.4-2.7-0.6c-0.8-0.1-1.5,0.1-2,0.7
		c-0.6,0.6-0.5,1.3-0.2,1.9c0.3,0.5,1,0.7,1.9,0.5c0.4-0.1,0.8-0.2,1.3-0.3c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0,0.8-0.1,1.1-0.1
		c0.3,0,0.7,0.2,1.1,0.4c0.4-0.5,0.8-1,1.2-1.6C501.2,191.4,500.7,191.2,500.5,190.5z"
      />
      <path
        class="st3"
        d="M528.3,228.6c0.6-1,1.1-2,1.7-2.9c0-0.3,0-0.5-0.1-0.8c-0.2-0.4-0.5-0.8-1.1-1.1c-0.4,0.4-0.6,0.8-0.6,1.1
		c-0.1,0.7,0.5,1.3,0.9,1.9c-0.4,0.4-0.8,0.7-1.1,1.1C528,228.2,528.2,228.4,528.3,228.6z"
      />
      <path
        class="st3"
        d="M532.1,227.2c-0.2-0.1-0.5-0.3-0.7-0.3c-0.3-0.1-0.6-0.1-1-0.2c-0.5,0.9-1,1.7-1.5,2.6
		c0.2,0.2,0.4,0.4,0.6,0.6c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1c0.8,0.1,1.3-0.3,1.6-0.9c0.1-0.1,0.1-0.2,0.2-0.4
		C533.4,228.9,533,227.8,532.1,227.2z"
      />
      <path
        class="st3"
        d="M397.6,239.9c0,0.3,0.2,0.6,0.3,0.9c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6
		c0.2-0.4,0.2-0.7,0.2-1.1c-0.2-1.2-1.6-2-3.1-1.7C398.4,237.5,397.4,238.7,397.6,239.9z"
      />
      <path
        class="st3"
        d="M494.2,196.5c-0.4-1.1-1.5-1.6-2.8-1.5c-1,0.1-2,0.9-2.3,1.7c-0.4,1,0.1,2,1.1,2.5c1.1,0.5,2.2,0.3,3.2-0.5
		c0.5-0.4,1-0.8,1.7-1.3C494.2,197.5,494.4,196.9,494.2,196.5z"
      />
      <path
        class="st3"
        d="M396.2,232.6c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.8-1.9-1-3.1-0.6c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		C395.7,231.5,395.8,232.1,396.2,232.6z"
      />
      <path
        class="st3"
        d="M396.8,247c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.6-1.5-1.3-1.9-2.8-1.6c-0.3,0.1-0.6,0.2-1,0.4
		c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9c0.8,0.3,1.6,0.1,2.9-0.8
		c1.3,1,1.8,1.1,2.6,0.6C397.1,248.2,397.3,247.5,396.8,247z"
      />
      <path
        class="st3"
        d="M576.8,177.2C576.7,177.2,576.7,177.2,576.8,177.2c-1.3,0.3-2.2,1.3-2.1,2.4c0,0.1,0,0.1,0,0.2
		c0.1,0.4,0.3,0.8,0.6,1.1c0.6-1.2,1.3-2.5,1.9-3.7C577,177.2,576.9,177.1,576.8,177.2z"
      />
      <path
        class="st3"
        d="M579.7,179.8c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.2-0.9-0.9-1.5-1.8-1.7c-0.7,1.4-1.4,2.7-2.1,4.1
		c0.2,0.1,0.5,0.2,0.8,0.2s0.7,0,1,0c0.2,0,0.5-0.1,0.7-0.2C579,180.9,579.5,180.4,579.7,179.8z"
      />
      <path
        class="st3"
        d="M310.7,243.6c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.7-0.7,1.2
		c-0.1,0.2-0.1,0.5,0,0.7c0,0.1,0,0.1,0.1,0.2c0.2,0.8,1,1.3,2,1.4c0.3,0,0.6,0,0.9,0c0.5-0.1,0.9-0.3,1.2-0.5
		c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0.7-1,0.6-1.5c0-0.1,0-0.2,0-0.3C313.4,244,312,243.3,310.7,243.6z"
      />
      <path
        class="st3"
        d="M396.1,229.7C396.1,229.7,396.1,229.8,396.1,229.7C396.1,229.8,396.1,229.8,396.1,229.7
		C396.1,229.7,396.2,229.7,396.1,229.7L396.1,229.7z"
      />
      <path
        class="st3"
        d="M394.8,228.6c-0.1-0.4-0.1-0.9-0.3-1.3c-0.4-1.1-2.4-1.5-3.5-0.7c-0.4,0.3-0.8,0.9-0.8,1.5c0,0.1,0,0.2,0,0.2
		c0,0.1,0,0.3,0.1,0.4c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.2,0,0.4,0,0.6,0l0,0
		c0.3,0,0.6,0,0.8,0.1c1,0.4,1.8,0.2,2.7-0.3c0.1-0.2,0.2-0.4,0.3-0.7C395.8,228.9,395.3,228.7,394.8,228.6z"
      />
      <path
        class="st3"
        d="M555.5,197.6c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C555,198.3,555.3,198.1,555.5,197.6z"
      />
      <path
        class="st3"
        d="M513.4,201.7c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.9,0.1-1.4,0.6-2,1.2c0.2,0.5,0.3,0.9,0.5,1.3c0.2,0.4,0.4,0.8,0.7,1.2c0.2,0.3,0.6,0.5,0.9,0.5
		C512.3,203.3,513.7,202.1,513.4,201.7z"
      />
      <path
        class="st3"
        d="M414.1,244.4c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3
		c0.3,1.1,1.5,1.6,2.8,1.3c1.2-0.3,1.9-1.3,1.7-2.3C414.4,244.9,414.3,244.6,414.1,244.4z"
      />
      <path
        class="st3"
        d="M558.3,212.5c-0.1-0.4-0.4-0.7-0.9-0.9c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7c0.9-0.2,1.6-0.3,2.2-0.5
		c0.5-0.2,1-0.4,1.5-0.6c0.1-0.1,0.2-0.1,0.3-0.2C558.3,213.8,558.5,213.1,558.3,212.5z"
      />
      <path
        class="st3"
        d="M315.6,242.3c0.2,0,0.3-0.1,0.4-0.1c-0.8-0.3-1.8-0.5-2.7-0.7C313.7,242.1,314.6,242.5,315.6,242.3z"
      />
      <path
        class="st3"
        d="M317.2,239.3c-0.8-0.2-1.6-0.5-2.4-0.7c-0.8,0.2-1.5,0.8-1.7,1.4c1.4,0.3,2.8,0.7,4.2,1.1
		c0.2-0.3,0.3-0.6,0.2-1C317.5,239.8,317.4,239.5,317.2,239.3z"
      />
      <path
        class="st3"
        d="M584.4,201.2c0.2,0,0.5,0,0.7,0c-0.1-1-0.4-1.7-1-2.1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C583.7,201.2,584.1,201.2,584.4,201.2z"
      />
      <path
        class="st3"
        d="M309.6,239.2c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C307.4,238.9,308.4,239.4,309.6,239.2z"
      />
      <path
        class="st3"
        d="M508.7,197.9c0-0.3-0.1-0.6-0.1-0.9c-0.4,0.6-0.9,1.2-1.3,1.9c0.2,0.2,0.5,0.2,0.9,0.1
		C508.7,198.7,508.7,198.3,508.7,197.9z"
      />
      <path
        class="st3"
        d="M506.5,197c0,0.1-0.1,0.2,0,0.3c0.1,0.4,0.2,0.8,0.4,1.1c0.8-1.2,1.7-2.4,2.5-3.6c-0.1-0.6-0.6-1.2-1.1-1.8
		C506.7,194.2,505.5,195.3,506.5,197z"
      />
      <path
        class="st3"
        d="M321.2,234.5L321.2,234.5v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.8c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9s0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3s0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C321.4,235.7,321.5,235,321.2,234.5z"
      />
      <path
        class="st3"
        d="M471.9,236.4c-0.7,1-1.4,2-2.1,3c0.5,0.5,1.3,0.8,2.2,0.6c1.2-0.3,2-1.4,1.7-2.3
		C473.5,237,472.7,236.5,471.9,236.4z"
      />
      <path
        class="st3"
        d="M601.7,187.1L601.7,187.1c0.6-0.1,1.1-0.4,1.4-0.7c0.4-0.4,0.6-0.9,0.5-1.5c-0.2-0.9-1.2-1.5-2.4-1.3
		c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4C599.9,186.8,600.8,187.3,601.7,187.1z"
      />
      <path
        class="st3"
        d="M563,182.6L563,182.6c-0.1-0.2-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.5-1-0.7c-0.1,0-0.2-0.1-0.3-0.1
		c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.3l0.1-0.1
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.2-0.1-0.2-0.2C563.3,182.9,563.2,182.8,563,182.6z"
      />
      <path
        class="st3"
        d="M503.2,183.3c-0.1-0.1-0.2-0.1-0.3-0.2l0,0c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-1.3,0.3-1.8-0.5-2.2
		c-0.9-0.5-1.8-0.2-2.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2c-0.4,1.9-0.1,2.2,2.2,2.4c0.2,0,0.4,0.1,0.5,0.2l0,0c0.3,0.2,0.5,0.3,0.7,0.3
		C502.7,184.1,502.8,183.8,503.2,183.3z"
      />
      <path
        class="st3"
        d="M589.5,181.9c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C589.9,183,589.9,182.3,589.5,181.9z"
      />
      <path
        class="st3"
        d="M553.8,177.3c0.2-0.2,0.5-0.3,0.7-0.5s0.4-0.3,0.6-0.5c-0.3-0.7-0.5-1.5-0.8-2.1c0-0.1-0.1-0.2-0.1-0.2
		c-0.2-0.4-0.6-0.8-1.2-0.7c-0.1,0-0.1,0-0.2,0c-0.3,0.3-0.5,0.6-0.7,0.9c-0.4,0.6-0.5,1.3-0.8,2c-0.2,0.6,0.3,1,0.9,1.4
		C552.8,177.8,553.3,177.6,553.8,177.3z"
      />
      <path
        class="st3"
        d="M566.5,189.7L566.5,189.7c0.6-0.1,1-0.5,1.3-0.9s0.4-0.8,0.3-1.1l0,0c-0.2-0.9-1.3-1.5-2.4-1.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0.2-1,0.5-1.2,0.9c-0.1,0.3-0.2,0.6-0.1,1c0,0.2,0.1,0.3,0.2,0.4
		C564.7,189.5,565.6,189.9,566.5,189.7z"
      />
      <path
        class="st3"
        d="M552.6,188.3L552.6,188.3c0.6-0.2,1.2-0.2,1.8-0.4s1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1
		c-0.2,0-0.4,0-0.6,0.1c-0.4-0.7-0.5-0.9-0.9-1.1C553.3,186.8,552.9,187.5,552.6,188.3C552.5,188.3,552.6,188.3,552.6,188.3z"
      />
      <path
        class="st3"
        d="M550.8,187.2c0.3,0.3,0.6,0.5,1,0.7l0,0c0.4-0.7,0.8-1.4,1.2-2c-0.1,0-0.2,0-0.3-0.1c-0.3,0-0.5-0.2-0.7-0.3
		c-0.7-0.6-1.3-0.3-2,0.1c0.1,0.5,0.3,1,0.6,1.4C550.6,187.1,550.7,187.1,550.8,187.2z"
      />
      <path
        class="st3"
        d="M347.4,265C347.3,265,347.3,265,347.4,265c0.3,1,0.6,2,0.9,3c1-0.3,1.7-1.1,1.5-1.9
		C349.5,265.2,348.5,264.8,347.4,265z"
      />
      <path
        class="st3"
        d="M346,266c-0.2,0.3-0.2,0.7-0.1,1c0.1,0.4,0.4,0.7,0.8,0.9c-0.1-0.4-0.2-0.7-0.3-1.1
		C346.2,266.6,346.1,266.3,346,266z"
      />
      <path
        class="st3"
        d="M342.8,271c-0.8,0.1-1.4,0.6-1.6,1.1h3.7C344.8,271.4,343.8,270.8,342.8,271z"
      />
      <path
        class="st3"
        d="M446.2,208.7c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C447.2,209.3,446.8,208.9,446.2,208.7z"
      />
      <path
        class="st3"
        d="M327.2,237.6c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1h0.1
		c0.7-0.5,1.4-0.9,2-1.4c0-0.2,0-0.4,0-0.6C327.3,237.8,327.2,237.7,327.2,237.6z"
      />
      <path
        class="st3"
        d="M314.6,230.8c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C315.2,231.3,315,231,314.6,230.8z"
      />
      <path
        class="st3"
        d="M482.4,222.5c0-0.2-0.1-0.3-0.2-0.4c-0.6,0.8-1.1,1.6-1.7,2.4c0.2,0,0.3,0,0.5,0c0.5-0.1,0.9-0.4,1.2-0.8
		c0.1-0.1,0.2-0.3,0.2-0.4C482.4,223,482.5,222.8,482.4,222.5L482.4,222.5z"
      />
      <path
        class="st3"
        d="M480.2,221.5c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0,0.2,0.2,0.4,0.4,0.6c0.6-0.8,1.2-1.7,1.8-2.5
		C480.7,221.4,480.4,221.5,480.2,221.5z"
      />
      <path
        class="st3"
        d="M582.6,188.4c0.1,0.8,1,1.3,1.9,1.2c1-0.2,1.9-1.2,1.7-2c-0.1-0.7-1.4-1.2-2.3-1
		C583,186.8,582.4,187.6,582.6,188.4z"
      />
      <path
        class="st3"
        d="M528.4,208.7c-0.2,0.4-0.4,0.9-0.6,1.3c0.8,1.3,0.8,1.3,2.4,1.5c0.8,0.1,1.3-0.3,1.1-1
		c-0.1-0.4-0.5-0.8-0.4-1.1c0.4-0.8-0.1-1.1-0.5-1.5c-1.1,0.3-0.6,0.8-0.6,1.3c-0.4-0.2-0.8-0.4-1.2-0.6
		C528.5,208.6,528.5,208.7,528.4,208.7z"
      />
      <path
        class="st3"
        d="M524.8,234.8c0-0.1,0.1-0.1,0.1-0.2h-0.1C524.8,234.7,524.8,234.7,524.8,234.8z"
      />
      <path
        class="st3"
        d="M526.8,233.8c-0.2,0.1-0.4,0.2-0.6,0.2c-0.3,0.6-0.7,1.1-1,1.7c0,0.1-0.1,0.1-0.1,0.2c0.2,0.3,0.4,0.6,0.8,0.8
		c0.9-0.4,1.6-0.8,2.3-1.1c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7
		C527.5,233.7,527.1,233.7,526.8,233.8z"
      />
      <path
        class="st3"
        d="M579.1,197.4c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5s-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C578.4,197,578.7,197.3,579.1,197.4z"
      />
      <path
        class="st3"
        d="M592.6,220.9c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5
		c0.1,0.8,0.9,1.3,1.8,1.1C591.9,222.5,592.7,221.6,592.6,220.9z"
      />
      <path
        class="st3"
        d="M518.2,247.9c-0.2,0.4-0.4,0.8-0.7,1.2c0.6-0.2,1.1-0.6,1.7-1.1C518.8,248,518.5,247.9,518.2,247.9z"
      />
      <path
        class="st3"
        d="M515.3,247.9c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8
		c0.1,0,0.2,0,0.3-0.1c0.3-0.5,0.6-1,0.9-1.5C516.6,247.9,515.9,247.9,515.3,247.9z"
      />
      <path
        class="st3"
        d="M584.5,222.1c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.2,0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9c0.2,0,0.5,0.1,0.8,0
		c0.9-0.2,1.4-1,1.3-1.7C586.2,222.3,585.4,221.9,584.5,222.1z"
      />
      <path
        class="st3"
        d="M417.8,247.4c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C419.6,247.6,418.7,247.2,417.8,247.4z"
      />
      <path
        class="st3"
        d="M517.9,249.8c-0.8,0.2-1.3,0.9-1.2,1.6c0.1,0.7,1,1.2,1.9,1s1.4-1,1.3-1.7
		C519.6,249.9,518.8,249.5,517.9,249.8z"
      />
      <path
        class="st3"
        d="M602.2,189.6c-0.8,0-1.6,0.3-2,1.2c0.3,0.3,0.5,0.7,0.8,0.9c0.6,0.4,1.2,0.3,1.9-0.1c0.5-0.3,0.8-0.6,0.7-1.2
		C603.5,189.9,603,189.6,602.2,189.6z"
      />
      <path
        class="st3"
        d="M544.1,187.8c0,0,0,0.1,0.1,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0.2,0.2,0.3,0.3,0.5,0.3c0.3,0.1,0.6,0.1,0.9-0.1
		c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7c-0.5-0.5-1.3-0.6-1.9-0.1C543.8,186.8,543.7,187.2,544.1,187.8z"
      />
      <path
        class="st3"
        d="M317.9,228c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C316.3,227.8,317,228.2,317.9,228z"
      />
      <path
        class="st3"
        d="M306.7,269.4h-0.1c0,0.3-0.1,0.7-0.1,1.1s0,0.9-0.1,1.3c0.1,0,0.1,0,0.2,0h0.1c0.8-0.2,1.3-0.9,1.1-1.5
		C307.7,269.8,307.2,269.5,306.7,269.4z"
      />
      <path
        class="st3"
        d="M307.6,258.2c0-0.2-0.2-0.4-0.3-0.5c0,0.5-0.1,1.1-0.1,1.6C307.5,259,307.7,258.6,307.6,258.2z"
      />
      <path
        class="st3"
        d="M565.8,190.2c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C566.5,190.2,566.1,190.1,565.8,190.2z"
      />
      <path
        class="st3"
        d="M324,269.6C323.9,269.6,323.9,269.6,324,269.6c-0.2,0.1-0.4,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8
		c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3c0.6-0.2,1-0.4,1.2-0.7C324.6,271,324.5,270.4,324,269.6L324,269.6z"
      />
      <path
        class="st3"
        d="M584.5,218.4c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C583.7,219.9,584.3,219.4,584.5,218.4z"
      />
      <path
        class="st3"
        d="M592.9,225.1c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7s1.1-0.8,1-1.3
		C594.3,225.3,593.5,225,592.9,225.1z"
      />
      <path
        class="st3"
        d="M518.5,238c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0s0.5-0.2,0.7-0.4
		c0.3-0.2,0.4-0.6,0.3-0.9C519.8,238.2,519.2,237.9,518.5,238z"
      />
      <path
        class="st3"
        d="M320.9,244.5c0.1,0,0.2,0.1,0.3,0.1c0.3,0,0.6-0.1,0.8-0.2c-0.1-0.1-0.2-0.3-0.3-0.4
		C321.4,244.2,321.2,244.3,320.9,244.5z"
      />
      <path
        class="st3"
        d="M522.5,245c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		S522.9,244.8,522.5,245z"
      />
      <path
        class="st3"
        d="M489.4,206.7c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.3-0.4,0.6-0.9,1-1.3l0,0
		C490.8,206.8,490.1,206.5,489.4,206.7z"
      />
      <path
        class="st3"
        d="M567.3,201.5C567.2,201.5,567.2,201.5,567.3,201.5c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.8,0.1,1.3
		c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7c-0.2-0.3-0.3-0.4-0.4-0.6C568.8,201.4,567.9,201.2,567.3,201.5z"
      />
      <path
        class="st3"
        d="M589.5,198.6c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.5-0.1-0.7,0
		c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.1,0.8c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,1-0.6,1-1
		C589.5,198.8,589.5,198.7,589.5,198.6z"
      />
      <path
        class="st3"
        d="M464.1,242c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.7,0.9,1.4,0.7c0.3-0.5,0.7-0.9,1-1.4
		C465.4,242.2,464.7,241.9,464.1,242z"
      />
      <path
        class="st3"
        d="M503.1,198.5c-0.4,0.5-0.7,1.1-1.1,1.6c-0.4,0.1-0.8,0.2-1.3,0.3c0.3,0.5,0.6,0.9,0.9,1.5
		c0.8-0.9,1.5-1.5,2-2.2C504.1,199.1,504.1,198.7,503.1,198.5z"
      />
      <path
        class="st3"
        d="M523.2,203.8c0.8,0.9,0.9,0.9,2.2,0.5c-0.1-0.1-0.1-0.2-0.2-0.4c-0.4-0.8-0.9-1.5-0.9-2.3
		c0-0.2-0.4-0.4-0.7-0.7c0.2,1.3,0.2,1.3-0.6,2.6C523.1,203.7,523.1,203.8,523.2,203.8z"
      />
      <path
        class="st3"
        d="M392.1,252.2c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.6,0.1-1.1,0.7-1,1.2
		C390.7,252,391.4,252.4,392.1,252.2z"
      />
      <path
        class="st3"
        d="M611.5,218.4c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.5,0.8,0.8,1.4,0.7c0.1,0,0.2,0,0.3-0.1v-1.9
		C611.9,218.4,611.7,218.4,611.5,218.4z"
      />
      <path
        class="st3"
        d="M519,202.5c0-0.1-0.5-0.1-0.8-0.1c-0.1,0.1-0.1,0.2-0.2,0.3c-0.2,0.6-0.1,1.3,0.6,1.7c0.3-0.2,0.7-0.5,0.8-0.4
		c0.8,0.5,1-0.1,1.1-0.5c0.1-0.3-0.1-0.6-0.1-0.8C519.8,202.5,519.3,203.3,519,202.5z"
      />
      <path
        class="st3"
        d="M495.9,181.5c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C496.9,180.7,496.4,181.2,495.9,181.5z"
      />
      <path
        class="st3"
        d="M539.8,218.1c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C540.6,217.9,540.1,217.9,539.8,218.1z"
      />
      <path
        class="st3"
        d="M537.2,205.7c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0c1.1-0.8,0.5-1.3,0-1.8
		C538.3,204.9,537.5,204.9,537.2,205.7z"
      />
      <path
        class="st3"
        d="M394.1,242.1c0.4,0.7,1,0.8,1.7,0.5c0.3-0.1,0.5-0.2,0.6-0.4c0.4-0.3,0.6-0.8,0.5-1.5
		c-0.5,0.2-0.9,0.3-1.3,0.5c-0.3,0.1-0.5,0.2-0.8,0.4C394.6,241.7,394.4,241.9,394.1,242.1L394.1,242.1z"
      />
      <path
        class="st3"
        d="M472.8,232.7c-0.4,0.4-0.7,0.7-1,1c0,0.1,0.1,0.1,0.1,0.2C472.2,233.5,472.5,233.1,472.8,232.7z"
      />
      <path
        class="st3"
        d="M472.7,235.3L472.7,235.3c0.5-0.6,0.9-1,1.3-1.5c0-0.1-0.1-0.1-0.1-0.2C473.5,234.2,473.1,234.7,472.7,235.3z"
      />
      <path
        class="st3"
        d="M554.9,253.9c0.2,0.8,0.6,1.5,0.8,2.3c0.1-1.3,0.2-2.6,0.3-4C554.9,252.9,554.7,253.1,554.9,253.9z"
      />
      <path
        class="st3"
        d="M535.4,206.5c0.1-0.3,0-0.6,0-0.9c0-0.3,0.1-0.7,0.2-1.1c-0.5,0-0.9,0-1.3-0.1c0.1-0.2,0.2-0.4,0.5-0.8
		c-0.5,0.2-0.8,0.3-1.1,0.4l0,0l0,0C534,205,534.6,205.8,535.4,206.5z"
      />
      <path
        class="st3"
        d="M507.6,192.3c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7s-0.1,0.8,0.3,0.9c0.4,0.1,0.9,0,1.3-0.2
		C507.3,193.1,507.4,192.7,507.6,192.3z"
      />
      <path
        class="st3"
        d="M509.6,176c0.2-0.3,0.5-0.6,0.7-0.9c0-0.1,0.1-0.2,0.1-0.3c-0.4,0-0.8,0.1-0.8-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C508.3,175.8,508.3,175.8,509.6,176z"
      />
      <path
        class="st3"
        d="M380.8,259.6c1-0.6,1.8-1.1,2.7-1.6C381.9,257.4,381.3,257.7,380.8,259.6z"
      />
      <path
        class="st3"
        d="M334.1,269.4c1.5-0.5,1.7-0.8,1.2-1.9C334.1,268.2,334.1,268.2,334.1,269.4z"
      />
      <path
        class="st3"
        d="M517.7,201.8c-0.1-0.3-0.3-0.6-0.5-0.9c-0.1-0.1-0.6-0.1-0.8,0c-0.1,0.1-0.3,0.4-0.2,0.5
		c0.1,0.6,0.5,0.9,1.1,1C517.4,202.2,517.6,202,517.7,201.8z"
      />
      <path
        class="st3"
        d="M522,227.6c0,0.5,0.5,0.8,1.1,0.7s0.9-0.4,0.9-0.8c0-0.6-0.5-0.9-1.1-0.8C522.3,226.8,522,227.1,522,227.6z"
      />
      <path
        class="st3"
        d="M523.9,211c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C524.4,212,524.4,211.4,523.9,211z"
      />
      <path
        class="st3"
        d="M557.4,217c0.2,0.2,0.7,0.3,1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.5-1.3-0.5
		C557.8,216.2,557.6,216.6,557.4,217z"
      />
      <path
        class="st3"
        d="M538.3,230.9c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C539.4,231.5,538.9,231.3,538.3,230.9z"
      />
      <path
        class="st3"
        d="M533.5,205.7c-0.2-0.1-0.4-0.2-0.6-0.2c-0.5-0.2-0.9-0.3-1.4-0.5c-0.1,0-0.5,0.3-0.5,0.4
		c0.1,0.2,0.3,0.4,0.5,0.5l0,0c0.5,0.2,1.1,0.4,1.8,0.6C533.8,206.3,534,205.9,533.5,205.7z"
      />
      <path
        class="st3"
        d="M500.3,187.6L500.3,187.6c-0.2-0.2-0.5-0.3-0.7-0.3h-0.1c-0.3,0.1-0.6,0.5-0.6,0.7c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5C500.6,188.2,500.5,187.9,500.3,187.6z"
      />
      <path
        class="st3"
        d="M443.7,216.3c0.1,0.6,0.1,0.8,0.3,1c0.4-0.4,0.7-0.7,1.1-1.1C444.8,215.9,444.3,216,443.7,216.3z"
      />
      <path
        class="st3"
        d="M539.7,212.5c1,0.3,1.1,1.7,2.7,1.1c-0.3-0.5-0.6-1-0.9-1.5C540.8,212.2,540.3,212.3,539.7,212.5z"
      />
      <path
        class="st3"
        d="M422.2,242.7c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6c0.5-0.1,0.9-0.5,0.8-0.9
		C423.2,242.8,422.6,242.5,422.2,242.7z"
      />
      <path
        class="st3"
        d="M335.5,235.4c-0.4,0-0.8,0.3-0.8,0.7c0.3-0.2,0.6-0.4,0.9-0.6C335.6,235.4,335.5,235.4,335.5,235.4z"
      />
      <path
        class="st3"
        d="M459,236.8c-0.3,0.2-0.7,0.6-0.6,0.8s0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C460,236.9,459.4,236.6,459,236.8z"
      />
      <path
        class="st3"
        d="M593.4,208.5c0.6,0.6,0.6,1.5,2.1,1.2C594.8,208.3,594.8,208.3,593.4,208.5z"
      />
      <path
        class="st3"
        d="M380.6,249.7c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C380.5,249.8,380.6,249.8,380.6,249.7z"
      />
      <path
        class="st3"
        d="M526.4,204.8c0.6,0.4-0.4,1.3,0.6,1.6h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2
		C527.8,205.5,527.6,205.1,526.4,204.8z"
      />
      <path
        class="st3"
        d="M541.6,214.8c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C542.7,215.8,542.3,215.3,541.6,214.8z"
      />
      <path
        class="st3"
        d="M538.3,211.4c0.1-0.3,0.3-0.5,0.4-0.8c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.2-0.1,0.3-0.2,0.4
		C538.2,211.1,538.2,211.2,538.3,211.4z"
      />
      <path
        class="st3"
        d="M538.8,212.1c0.1,0.1,0.4,0.1,0.6,0c0,0,0,0,0.1,0s0.2-0.4,0.2-0.5c-0.1-0.1-0.2-0.2-0.3-0.3
		C539.1,211.5,539,211.8,538.8,212.1z"
      />
      <path
        class="st3"
        d="M546.6,196c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.5,0.5,1.1,1.1,1.3c0.1-0.2,0.2-0.4,0.3-0.6
		C546.5,196.5,546.4,196.3,546.6,196z"
      />
      <path
        class="st3"
        d="M511.5,186.2c-0.2-0.5-0.4-1-0.6-1.6c-0.2,0.1-0.5,0.2-0.7,0.3c-0.1,0.2-0.1,0.4,0.1,0.6
		c0.2,0.3,0.3,0.7,0.8,0.7C511.2,186.2,511.3,186.2,511.5,186.2z"
      />
      <path
        class="st3"
        d="M557.8,207.8c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C557,207.5,557.7,207.8,557.8,207.8z"
      />
      <path
        class="st3"
        d="M555.3,167.5c-0.3,0.4-0.6,0.8-0.8,1.1c0.1,0.1,0.1,0.1,0.2,0.2c0.6-0.3,1.3-0.5,2-0.9
		C556.1,167.8,555.8,167.7,555.3,167.5z"
      />
      <path
        class="st3"
        d="M384.8,264.2c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C385.5,264.4,385.1,264.3,384.8,264.2z"
      />
      <path
        class="st3"
        d="M611.2,162.9c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C612,163,611.7,162.7,611.2,162.9z"
      />
      <path
        class="st3"
        d="M514,183.5c-0.1,0-0.3-0.1-0.4-0.1c-0.3,0.2-0.7,0.3-1,0.5C513.2,184.2,513.3,184.2,514,183.5z"
      />
      <path
        class="st3"
        d="M385.3,258.4c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C384.9,258.8,385.3,258.6,385.3,258.4z"
      />
      <path
        class="st3"
        d="M512.8,177.8c0.7-0.4,0.4-1,0.4-1.5C512,176.7,512,176.8,512.8,177.8z"
      />
      <path
        class="st3"
        d="M558.2,174c-0.8,1-1.3,1.7-1.2,2.5C557.5,175.9,558.4,175.4,558.2,174z"
      />
      <path
        class="st3"
        d="M533.3,212.6c-0.3,0.3-0.5,0.5-0.7,0.8c0.3,0.1,0.6,0.4,0.8,0.3c0.3-0.1,0.5-0.4,0.6-0.7
		C534,212.9,533.6,212.7,533.3,212.6z"
      />
      <path
        class="st3"
        d="M539.5,177.9c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C540,178.1,539.7,178,539.5,177.9z"
      />
      <path
        class="st3"
        d="M547.9,190.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C548.7,190,548.3,190.3,547.9,190.7z"
      />
      <path
        class="st3"
        d="M352.3,260.1c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C352.9,260.2,352.6,260.1,352.3,260.1z"
      />
      <path
        class="st3"
        d="M318.1,260c0.7-0.7,0.8-1.2,0.2-1.9C317.6,258.7,317.6,259.2,318.1,260z"
      />
      <path
        class="st3"
        d="M532.1,222.1L532.1,222.1L532.1,222.1L532.1,222.1c-0.1,0-0.1,0-0.1,0.1s0,0.2,0,0.2
		C532,222.3,532,222.2,532.1,222.1z"
      />
      <path
        class="st3"
        d="M532.9,223.3c0.1-0.3,0.1-0.5,0-0.7l-0.1-0.1c-0.2,0.3-0.3,0.6-0.5,0.8c0.1,0.1,0.3,0.2,0.4,0.2
		C532.8,223.5,532.9,223.4,532.9,223.3z"
      />
      <path
        class="st3"
        d="M420.5,234.3c-0.2,0.4-0.6,0.7-0.5,0.9s0.5,0.3,0.8,0.4c0.1,0,0.5-0.4,0.4-0.6
		C421.1,234.8,420.8,234.6,420.5,234.3z"
      />
      <path
        class="st3"
        d="M495,201.2c1.3-0.8,0.1-1.1,0.1-1.7C493.9,200.3,495,200.6,495,201.2z"
      />
      <path
        class="st3"
        d="M583.5,205.5c0.5,0.4,0.3,1.1,1.3,1.3C584.7,205.5,584.7,205.5,583.5,205.5z"
      />
      <path
        class="st3"
        d="M564.4,210.5c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C565,210.1,564.8,210.2,564.4,210.5z"
      />
      <path
        class="st3"
        d="M535,175.1c-0.2,0.3-0.4,0.7-0.6,1l0.1,0.1C535.1,175.9,535.2,175.5,535,175.1z"
      />
      <path
        class="st3"
        d="M533.9,175.4c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0.1,0C533.8,175.5,533.8,175.4,533.9,175.4z"
      />
      <path
        class="st3"
        d="M396.6,249.9c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C397.7,249.1,397.2,249.5,396.6,249.9z"
      />
      <path
        class="st3"
        d="M554.8,178c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C555.4,178.8,555,178.4,554.8,178z"
      />
      <path
        class="st3"
        d="M562.3,218.7c0.1,0.8,0.1,0.8,0.9,1.3C563.1,219.5,563.1,219,562.3,218.7z"
      />
      <path
        class="st3"
        d="M511.9,253.8c0,0.7,0.2,1.1,1,1.6c0,0,0,0,0-0.1C512.9,254.5,512.7,254.1,511.9,253.8z"
      />
      <path
        class="st3"
        d="M537.1,177L537.1,177c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C537.7,176.9,537.3,176.9,537.1,177z"
      />
      <path
        class="st3"
        d="M518.4,219.7c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C519,220.1,518.6,220,518.4,219.7z"
      />
      <path
        class="st3"
        d="M388,261.3c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C388.4,260.8,388.2,261.1,388,261.3z"
      />
      <path
        class="st3"
        d="M595.2,203.3c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C595,203.6,595.3,203.4,595.2,203.3z"
      />
      <path
        class="st3"
        d="M558.5,193.9c-0.2-0.7-0.3-1.2-1.2-1.2C557.2,193.3,557.6,193.6,558.5,193.9z"
      />
      <path
        class="st3"
        d="M611.8,174c0.1,0,0.2,0,0.3,0v-1c0,0,0,0-0.1,0C612,173.3,611.9,173.6,611.8,174z"
      />
      <path
        class="st3"
        d="M539.6,206.8c0.3,0.2,0.6,0.4,1,0.6c0.1-0.2,0.2-0.3,0.3-0.5C540.6,206.6,540.2,206.6,539.6,206.8z"
      />
      <path
        class="st3"
        d="M353.3,270.5c0.2-0.5,0.4-1,0.7-1.6C352.9,269.7,352.9,269.7,353.3,270.5z"
      />
      <path
        class="st3"
        d="M579.4,184c-0.4-0.2-0.7-0.3-1-0.4c-0.1,0.2-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.3,0.8,0.3
		C579,184.5,579.2,184.2,579.4,184z"
      />
      <path
        class="st3"
        d="M521.6,204.7c0.1,1,0.1,1.2,0.7,1.3c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6
		C522.1,205.4,521.9,205.1,521.6,204.7z"
      />
      <path
        class="st3"
        d="M547.4,179.3c0.1,0.1,0.2,0.2,0.3,0.2s0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.6c0.1-0.1-0.2-0.3-0.3-0.5
		c-0.3,0.3-0.5,0.6-0.8,0.8C547.5,179.2,547.5,179.2,547.4,179.3z"
      />
      <path
        class="st3"
        d="M547.4,168.9c0-0.2-0.4-0.3-0.7-0.5c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4
		C547.2,169.3,547.4,169.1,547.4,168.9z"
      />
      <path
        class="st3"
        d="M380.8,261.6c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C381.4,261.7,381,261.5,380.8,261.6z"
      />
      <path
        class="st3"
        d="M322.9,233.7c0.1-0.1,0.1-0.2,0.2-0.3s-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2
		C322.6,234,322.8,233.9,322.9,233.7z"
      />
      <path
        class="st3"
        d="M335.5,255.1c0.8-0.2,0.9-0.5,0.6-1.2C335.5,254.2,335.2,254.5,335.5,255.1z"
      />
      <path
        class="st3"
        d="M514.5,187.3c0.1-0.2,0.2-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.3-0.7c-0.2,0-0.4,0.1-0.6,0.1
		C514.4,186.8,514.4,187,514.5,187.3z"
      />
      <path
        class="st3"
        d="M516.5,207.6c-0.2,0-0.4,0-0.6-0.1c-0.1,0.4-0.1,0.8-0.2,1.2c0.1,0,0.3,0,0.4,0
		C516.3,208.4,516.4,208,516.5,207.6z"
      />
      <path
        class="st3"
        d="M539.1,228.6c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.4,0.7,1,1.1c0-0.2,0-0.3-0.1-0.4
		C540,229.1,539.8,228.7,539.1,228.6z"
      />
      <path
        class="st3"
        d="M395.8,253.5c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C396.3,253.8,396.1,253.7,395.8,253.5z"
      />
      <path
        class="st3"
        d="M488.4,213.8c0.6-0.2,1.1-0.5,0.7-1.3C488.8,213.1,488.6,213.5,488.4,213.8z"
      />
      <path
        class="st3"
        d="M509.4,172.5c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C509.1,171.5,509.2,171.9,509.4,172.5z"
      />
      <path
        class="st3"
        d="M508.3,173.9c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C507.8,174.6,508.2,174.6,508.3,173.9z"
      />
      <path
        class="st3"
        d="M499.2,184.7c0.7,0.2,1.1,0.3,1.8,0.5C500.6,184.5,500.2,184.3,499.2,184.7z"
      />
      <path
        class="st3"
        d="M490.3,191.7c0.4,0.2,0.8,0.4,1.5,0.8C491.5,191.7,491.1,191.6,490.3,191.7z"
      />
      <path
        class="st3"
        d="M519.7,222.4c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C519.8,221.7,519.7,222.1,519.7,222.4z"
      />
      <path
        class="st3"
        d="M558.9,187.1c0.7-0.1,1.1-0.1,1.9-0.2C560,186.7,559.5,186.4,558.9,187.1z"
      />
      <path
        class="st3"
        d="M320.3,245c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.3,0.3,0.5,0.5c0,0,0.1-0.1,0.2-0.2l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C320.4,245.1,320.3,245,320.3,245z"
      />
      <path
        class="st3"
        d="M486.4,220.9c0.3-0.5,0.4-0.8,0.6-1.1C486.4,220,486,220.3,486.4,220.9z"
      />
      <path
        class="st3"
        d="M501.7,185.3c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C501.5,185.4,501.6,185.3,501.7,185.3z"
      />
      <path
        class="st3"
        d="M598.4,170.5L598.4,170.5c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C598.9,170.4,598.6,170.2,598.4,170.5z"
      />
      <path
        class="st3"
        d="M522.4,208.4c-0.2,0.1-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.2,0.7-0.7
		C522.9,208.4,522.6,208.4,522.4,208.4z"
      />
      <path
        class="st3"
        d="M351.1,253c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C351.4,253.1,351.2,253,351.1,253z"
      />
      <path
        class="st3"
        d="M337.1,270.5c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9c-0.1-0.1-0.1-0.1-0.2-0.2
		C337.8,269.9,337.5,270.2,337.1,270.5z"
      />
      <path
        class="st3"
        d="M560.3,188.6c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C560.9,188.9,560.7,188.7,560.3,188.6z"
      />
      <path
        class="st3"
        d="M596,188.8c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C595.6,188.3,595.8,188.5,596,188.8z"
      />
      <path
        class="st3"
        d="M384.8,252.5c0.2-0.1,0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.3,0.3-0.5,0.5
		C384.4,252.4,384.7,252.6,384.8,252.5z"
      />
      <path
        class="st3"
        d="M556.8,178.2c-0.4,0.1-0.7,0.3-1.1,0.5c0.5,0.6,0.9,0.2,1.3-0.2C557,178.4,556.9,178.3,556.8,178.2z"
      />
      <path
        class="st3"
        d="M373.6,256.2c-0.3-0.3-0.5-0.5-0.7-0.7C372.7,256.2,372.7,256.2,373.6,256.2z"
      />
      <path
        class="st3"
        d="M578.5,197.8c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C578.9,198.3,578.7,198.1,578.5,197.8C578.5,197.9,578.5,197.8,578.5,197.8z"
      />
      <path
        class="st3"
        d="M398.7,225c0-0.1-0.2-0.2-0.4-0.3c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C398.5,225.2,398.7,225.1,398.7,225z"
      />
      <path
        class="st3"
        d="M527.7,244.2c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C528,243.9,527.8,244.1,527.7,244.2z"
      />
      <path
        class="st3"
        d="M343.1,238.8c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.3,0.3c0.2,0.1,0.3,0.2,0.5,0.2
		C342.8,239.1,342.9,239,343.1,238.8z"
      />
      <path
        class="st3"
        d="M388.8,267.2c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C389.2,267.4,389,267.3,388.8,267.2z"
      />
      <path
        class="st3"
        d="M510.3,182.5L510.3,182.5C510.3,182.4,510.3,182.4,510.3,182.5c-0.3,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8
		c0.3-0.2,0.5-0.3,0.6-0.4v0.1l0,0c0.1,0.1,0.1,0.3,0.2,0.5c0.1-0.1,0.2-0.1,0.4-0.2c0.7-0.6,0.6-0.7,0.2-1.1
		C510.6,182.1,510.4,182.3,510.3,182.5z"
      />
      <path
        class="st3"
        d="M511.7,175.7h0.1c0.1-0.1,0.3-0.3,0.4-0.4c-0.2-0.1-0.2-0.1-0.3-0.1C511.9,175.3,511.8,175.5,511.7,175.7z"
      />
      <path
        class="st3"
        d="M558.7,189.6c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C559.2,189.2,558.9,189.4,558.7,189.6z"
      />
      <path
        class="st3"
        d="M399.2,250.5c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C399.4,250.2,399.2,250.4,399.2,250.5z"
      />
      <path
        class="st3"
        d="M609.2,214.6c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C609.5,214.3,609.4,214.4,609.2,214.6z"
      />
      <path
        class="st3"
        d="M551.9,173.2c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0-0.2,0.1-0.3,0.2-0.7
		C552.5,172.8,552.2,173,551.9,173.2z"
      />
      <path
        class="st3"
        d="M316.5,229c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C316.2,228.8,316.4,228.9,316.5,229z"
      />
      <path
        class="st3"
        d="M506.6,211c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C506.7,210.5,506.6,210.7,506.6,211z"
      />
      <path
        class="st3"
        d="M605.6,205.1c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C606,205.2,605.8,205.2,605.6,205.1z"
      />
      <path
        class="st3"
        d="M516.2,202.7c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.2,0.2-0.2,0.2c0,0.1,0.1,0.3,0.2,0.4
		C516.1,203.1,516.1,202.9,516.2,202.7z"
      />
      <path
        class="st3"
        d="M544.2,178.2c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.3,0,0.5,0.1,0.6,0c0.2,0,0.4-0.2,0.5-0.5C544.1,178.4,544.1,178.3,544.2,178.2z"
      />
      <path
        class="st3"
        d="M540.8,179.9c0.3-0.1,0.6-0.2,0.9-0.3c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.2-0.6,0.3-0.9,0.5
		C540.7,179.7,540.8,179.8,540.8,179.9z"
      />
      <path
        class="st3"
        d="M520.6,213.3c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C520.6,212.8,520.6,213,520.6,213.3z"
      />
      <path
        class="st3"
        d="M611.2,169.7c0,0.3,0,0.6,0,0.9C611.6,170.3,611.7,170,611.2,169.7z"
      />
      <path
        class="st3"
        d="M611.2,170.6C611.2,170.6,611.1,170.6,611.2,170.6c-0.1,0.1-0.1,0.1-0.1,0.1
		C611.1,170.7,611.1,170.7,611.2,170.6L611.2,170.6z"
      />
      <path
        class="st3"
        d="M331.6,262.5c0.1,0.2,0.2,0.4,0.2,0.5c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.2-0.3-0.3-0.4
		C331.7,262.4,331.6,262.4,331.6,262.5z"
      />
      <path
        class="st3"
        d="M551.2,182.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.3-0.2,0.4-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C551.4,182.1,551.3,182.2,551.2,182.2z"
      />
      <path
        class="st3"
        d="M505.6,184.1c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C505.8,184.2,505.7,184.1,505.6,184.1z"
      />
      <path
        class="st3"
        d="M389.8,249.7c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1
		C389.9,250.1,389.8,249.9,389.8,249.7z"
      />
      <path
        class="st3"
        d="M512,190.2c0.1,0.1,0.3,0.2,0.4,0.1l0,0c0.1-0.1,0.2-0.2,0.2-0.3c-0.2-0.1-0.4-0.1-0.5-0.1
		C512.1,189.9,512,190.1,512,190.2z"
      />
      <path
        class="st3"
        d="M571.5,179.1c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0C571.5,179.2,571.5,179.1,571.5,179.1z"
      />
      <path
        class="st3"
        d="M571.9,178.5c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C572.1,178.6,572,178.6,571.9,178.5z"
      />
      <path
        class="st3"
        d="M536.2,203.3c-0.1,0.1-0.3,0.2-0.3,0.3s0.2,0.2,0.4,0.3c0.1-0.2,0.2-0.3,0.1-0.4
		C536.4,203.3,536.2,203.3,536.2,203.3z"
      />
      <path
        class="st3"
        d="M507.2,263.5c0.2,0.2,0.4,0.4,0.6,0.6C507.8,263.8,508.1,263.5,507.2,263.5z"
      />
      <path
        class="st3"
        d="M507.8,264.1C507.7,264.1,507.7,264.2,507.8,264.1c0,0.1,0.1,0.1,0.1,0.1C507.8,264.2,507.8,264.2,507.8,264.1
		L507.8,264.1z"
      />
      <path
        class="st3"
        d="M399.3,234.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.3,0.3-0.2,0.4c0,0.1,0.2,0.1,0.4,0.1
		C399.2,234.4,399.3,234.2,399.3,234.2z"
      />
      <path
        class="st3"
        d="M535.3,247.1c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C535.4,246.9,535.3,247,535.3,247.1z"
      />
      <path
        class="st3"
        d="M569.5,165.3c-0.1,0-0.2,0.2-0.2,0.2c0,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.4-0.3
		C569.8,165.4,569.7,165.3,569.5,165.3z"
      />
      <path
        class="st3"
        d="M609.3,167.7c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.1h0.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4
		C609.4,167.5,609.3,167.6,609.3,167.7z"
      />
      <path
        class="st3"
        d="M519.9,211.4c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C519.7,211.6,519.8,211.5,519.9,211.4z"
      />
      <path
        class="st3"
        d="M612.1,165v-0.5c-0.1,0.1-0.2,0.2-0.3,0.3C611.9,164.9,612,164.9,612.1,165z"
      />
      <path
        class="st3"
        d="M510.3,189.4c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.4,0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1
		C510.4,189,510.4,189.2,510.3,189.4z"
      />
      <path
        class="st3"
        d="M508.3,201.8c0.2,0,0.3,0.1,0.5,0c0.1,0,0.2-0.2,0.5-0.4c-0.4,0-0.5,0-0.6,0.1
		C508.5,201.6,508.4,201.7,508.3,201.8z"
      />
      <path
        class="st3"
        d="M610.8,165.9c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5c-0.1,0.3-0.2,0.5-0.1,0.6
		C610.6,165.8,610.7,165.9,610.8,165.9z"
      />
      <path
        class="st3"
        d="M433.8,230.4c0.1-0.1,0.1-0.2,0.1-0.3c-0.1,0.1-0.1,0.1-0.2,0.2C433.7,230.3,433.8,230.3,433.8,230.4z"
      />
      <path
        class="st3"
        d="M490.1,216c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C490.3,216.2,490.1,216.1,490.1,216z"
      />
      <path
        class="st3"
        d="M336.4,243.4c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0-0.3,0C336.5,243.3,336.4,243.4,336.4,243.4z
		"
      />
      <path
        class="st3"
        d="M519.2,211.3L519.2,211.3c-0.1-0.1-0.1-0.1-0.1-0.1L519.2,211.3C519.2,211.3,519.2,211.3,519.2,211.3z"
      />
      <path
        class="st3"
        d="M519,210.7c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C519.2,210.7,519.1,210.7,519,210.7z"
      />
      <path
        class="st3"
        d="M550.4,193.2l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1H551c-0.1,0-0.3,0-0.4,0
		C550.5,193.2,550.4,193.2,550.4,193.2z"
      />
      <path
        class="st3"
        d="M504.2,207.1l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C504.3,206.8,504.3,206.9,504.2,207.1z"
      />
      <path
        class="st3"
        d="M554.8,184.8c0.1-0.2,0.2-0.3,0.2-0.4c0,0-0.1-0.1-0.2-0.1c-0.1,0.1-0.2,0.3-0.2,0.4
		C554.6,184.7,554.7,184.7,554.8,184.8z"
      />
      <path
        class="st3"
        d="M396.6,244.9c0.1,0.1,0.2,0.1,0.4,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.4-0.1
		C396.7,244.7,396.6,244.9,396.6,244.9z"
      />
      <path
        class="st3"
        d="M509.8,173.9c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C510.1,174.1,509.9,174,509.8,173.9z"
      />
      <path
        class="st3"
        d="M544.8,223.3l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C544.9,223.2,544.9,223.2,544.8,223.3z"
      />
      <path
        class="st3"
        d="M597.1,188.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C597.1,188.3,597.1,188.3,597.1,188.2z"
      />
      <path
        class="st3"
        d="M364.8,245.2C364.8,245.2,364.8,245.3,364.8,245.2c-0.1,0.1-0.1,0.1-0.1,0.2h0.1
		C364.8,245.3,364.8,245.2,364.8,245.2z"
      />
      <path
        class="st3"
        d="M364.9,244.8c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C365.1,244.8,365,244.8,364.9,244.8z"
      />
      <path
        class="st3"
        d="M544.4,179.3C544.4,179.3,544.4,179.2,544.4,179.3c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1,0,0.2,0,0.3
		C544,179.5,544.2,179.4,544.4,179.3z"
      />
      <path
        class="st3"
        d="M603.7,169.3c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.1-0.2-0.1C603.6,168.9,603.6,169,603.7,169.3z"
      />
      <path
        class="st3"
        d="M436.1,267.7c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1
		C436.2,267.8,436.1,267.7,436.1,267.7z"
      />
      <path
        class="st3"
        d="M415.1,209.8c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C415.3,209.9,415.2,209.8,415.1,209.8z"
      />
      <path
        class="st3"
        d="M373.3,243.5c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C373.4,243.3,373.4,243.4,373.3,243.5z"
      />
      <path
        class="st3"
        d="M511.8,189.6c0.1,0,0.2-0.1,0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C511.7,189.5,511.8,189.6,511.8,189.6z"
      />
      <path
        class="st3"
        d="M536.8,204.1c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.4,0.1
		C536.7,204.3,536.8,204.2,536.8,204.1z"
      />
      <path
        class="st3"
        d="M554.2,183.7l0.1-0.1c-0.5,0.2-0.7,0.2-0.8,0.3c0.1,0.1,0.1,0.2,0.2,0.3C553.7,184.1,553.9,184,554.2,183.7z"
      />
      <path
        class="st3"
        d="M598.7,188.8c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C598.7,188.9,598.7,188.9,598.7,188.8z"
      />
      <path
        class="st3"
        d="M611.1,170.7c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0,0.2,0.1,0.3,0.1C611,171.1,611,170.9,611.1,170.7z"
      />
      <path
        class="st3"
        d="M468.4,243.4C468.4,243.4,468.4,243.5,468.4,243.4c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C468.5,243.3,468.4,243.3,468.4,243.4z"
      />
      <path
        class="st3"
        d="M557.7,186.9C557.7,186.9,557.8,186.9,557.7,186.9c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0
		c-0.1-0.1-0.1-0.2-0.2-0.2C557.9,186.8,557.7,186.8,557.7,186.9z"
      />
      <path
        class="st3"
        d="M368.7,253.7c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C368.9,253.4,368.8,253.6,368.7,253.7z"
      />
      <path
        class="st3"
        d="M515.8,199.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C515.9,199.5,515.9,199.4,515.8,199.4z"
      />
      <path
        class="st3"
        d="M501.8,205.5c0-0.1,0.1-0.1,0.1-0.2h-0.1C501.8,205.3,501.8,205.4,501.8,205.5z"
      />
      <path
        class="st3"
        d="M425.4,217.1c0.1-0.1,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.1,0-0.2-0.1l-0.1,0.1l0.1,0.1
		C425.2,217,425.3,217,425.4,217.1z"
      />
      <path
        class="st3"
        d="M604.1,188.2c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C604.3,188.2,604.2,188.2,604.1,188.2z"
      />
      <path
        class="st3"
        d="M598.1,189.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C598.2,189.8,598.2,189.7,598.1,189.7z"
      />
      <path
        class="st3"
        d="M599.9,215.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C600,215.1,600,215.3,599.9,215.4z"
      />
      <path
        class="st3"
        d="M555.2,199c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C555,198.9,555.1,198.9,555.2,199z"
      />
      <path
        class="st3"
        d="M555.4,173c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L555.4,173z"
      />
      <path
        class="st3"
        d="M507.8,264.3C507.8,264.2,507.9,264.2,507.8,264.3C507.8,264.2,507.8,264.2,507.8,264.3
		C507.8,264.2,507.8,264.2,507.8,264.3z"
      />
      <path
        class="st3"
        d="M537.6,176.1L537.6,176.1c0-0.1-0.1-0.1-0.1-0.1L537.6,176.1C537.5,176.1,537.5,176.1,537.6,176.1z"
      />
      <path
        class="st3"
        d="M534.4,176.3L534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3C534.5,176.2,534.5,176.2,534.4,176.3
		C534.5,176.3,534.5,176.3,534.4,176.3z"
      />
      <path
        class="st3"
        d="M534.1,176.6c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.1,0-0.2,0.1C534.2,176.4,534.2,176.5,534.1,176.6z"
      />
      <path
        class="st3"
        d="M548.5,173.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C548.2,173.1,548.3,173.1,548.5,173.1
		C548.4,173.2,548.5,173.1,548.5,173.1z"
      />
      <path
        class="st3"
        d="M565.1,174l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C565.3,174,565.2,174,565.1,174z"
      />
      <path
        class="st3"
        d="M559.6,169l0.1,0.1c0.1,0,0.1,0,0.2,0C559.8,169.1,559.8,169,559.6,169C559.8,169,559.7,169,559.6,169z"
      />
      <path
        class="st3"
        d="M504.2,180.1c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C504.1,180.2,504.1,180.2,504.2,180.1
		C504.2,180.2,504.2,180.1,504.2,180.1z"
      />
      <path
        class="st3"
        d="M498.8,181c0,0,0.1,0.1,0.1,0.2l0,0l0,0C498.9,181.1,498.9,181,498.8,181z"
      />
      <path
        class="st3"
        d="M420.8,229.6l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C420.6,229.7,420.7,229.6,420.8,229.6z"
      />
      <path
        class="st3"
        d="M513.2,176.1C513.2,176.1,513.1,176.2,513.2,176.1c0,0.1,0,0.1,0,0.1l0,0C513.2,176.2,513.2,176.2,513.2,176.1
		z"
      />
      <path
        class="st3"
        d="M513.2,175.8v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C513.3,175.9,513.2,175.8,513.2,175.8z"
      />
      <path
        class="st3"
        d="M507,173.5l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C507.3,173.5,507.1,173.5,507,173.5z"
      />
      <path
        class="st3"
        d="M450.3,225.3c0.1,0,0.1,0.1,0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C450.5,225.2,450.4,225.3,450.3,225.3z"
      />
      <path
        class="st3"
        d="M428,230.5c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C428.1,230.5,428,230.5,428,230.5z"
      />
      <path
        class="st3"
        d="M510.5,242.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C510.5,242.7,510.5,242.8,510.5,242.8z"
      />
      <path
        class="st3"
        d="M487.4,218.6c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C487.5,218.5,487.5,218.5,487.4,218.6z"
      />
      <path
        class="st3"
        d="M495,193.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2
		C494.9,193.4,495.1,193.4,495,193.3z"
      />
      <path
        class="st3"
        d="M532.1,209.8L532.1,209.8c-0.1,0.2-0.1,0.3,0,0.5c0.1,0,0.1,0,0.2,0C532.2,210.1,532.2,210,532.1,209.8z"
      />
      <path
        class="st3"
        d="M394.3,240c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2C394.5,240.1,394.4,240,394.3,240z"
      />
      <path
        class="st3"
        d="M542.2,208.4c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C542.3,208.2,542.2,208.3,542.2,208.4z"
      />
      <path
        class="st3"
        d="M560.5,192.3c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C560.7,192.4,560.7,192.3,560.5,192.3
		C560.6,192.2,560.6,192.3,560.5,192.3z"
      />
      <path
        class="st3"
        d="M536.3,211.5C536.2,211.5,536.2,211.5,536.3,211.5c-0.1,0.1,0,0.1,0,0.2l0,0l0,0
		C536.3,211.6,536.3,211.5,536.3,211.5L536.3,211.5z"
      />
      <path
        class="st3"
        d="M546.4,194.8c0.1,0,0.2,0,0.3,0l0,0c0,0,0-0.1,0.1-0.1c-0.1,0-0.2,0-0.3,0
		C546.5,194.7,546.5,194.7,546.4,194.8C546.4,194.7,546.4,194.8,546.4,194.8z"
      />
      <path
        class="st3"
        d="M508,203.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C508,203.3,508,203.3,508,203.3z"
      />
      <path
        class="st3"
        d="M501.4,204.9c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C501.5,204.7,501.4,204.8,501.4,204.9z
		"
      />
      <path
        class="st3"
        d="M331.4,241.4c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C331.4,241.5,331.4,241.5,331.4,241.4z"
      />
      <path
        class="st3"
        d="M468.1,242.8c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1S468,242.7,468.1,242.8z"
      />
      <path
        class="st3"
        d="M573.8,179.6l0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C573.6,179.5,573.7,179.6,573.8,179.6z"
      />
      <path
        class="st3"
        d="M522.5,216.4c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0C522.5,216.5,522.5,216.4,522.5,216.4z"
      />
      <path
        class="st3"
        d="M549.3,185.4c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C549.2,185.3,549.2,185.4,549.3,185.4z"
      />
      <path
        class="st3"
        d="M544.3,222.6c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C544.4,222.5,544.4,222.5,544.3,222.6z"
      />
      <path
        class="st3"
        d="M584,178.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L584,178.4z"
      />
      <path
        class="st3"
        d="M528.6,215.3v0.1h0.1C528.7,215.5,528.7,215.4,528.6,215.3C528.7,215.4,528.7,215.3,528.6,215.3z"
      />
      <path
        class="st3"
        d="M528.9,216.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1C529.1,216.1,529,216.1,528.9,216.1z"
      />
      <path
        class="st3"
        d="M357,254.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0C357.1,254.5,357.1,254.6,357,254.6z"
      />
      <path
        class="st3"
        d="M504.7,196.8c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C504.7,196.7,504.7,196.8,504.7,196.8z"
      />
      <path
        class="st3"
        d="M558.4,185.1L558.4,185.1c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C557.8,185.3,557.9,185.2,558.4,185.1
		L558.4,185.1z"
      />
      <path
        class="st3"
        d="M358.7,229.1c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0-0.1-0.1-0.1-0.1-0.2C358.8,229,358.7,229,358.7,229.1z"
      />
      <path
        class="st3"
        d="M580.2,181c0.1,0.1,0.2,0.2,0.4,0.2c-0.1-0.1-0.1-0.3-0.2-0.4C580.4,180.9,580.3,180.9,580.2,181z"
      />
      <path
        class="st3"
        d="M580.6,181.3C580.6,181.2,580.6,181.2,580.6,181.3C580.6,181.2,580.6,181.3,580.6,181.3L580.6,181.3
		L580.6,181.3C580.7,181.3,580.7,181.3,580.6,181.3L580.6,181.3z"
      />
      <path
        class="st3"
        d="M549.3,187.9C549.3,187.9,549.3,188,549.3,187.9c0.2,0.1,0.4,0.1,0.6,0.1c0-0.1,0-0.1,0-0.2
		C549.7,187.8,549.5,187.8,549.3,187.9z"
      />
      <path
        class="st3"
        d="M585.8,205.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C586.1,205.6,586,205.6,585.8,205.7
		C585.8,205.6,585.8,205.7,585.8,205.7z"
      />
      <path
        class="st3"
        d="M570.9,181.8c-0.3,0.1-0.5,0.2-0.7,0.4c-0.9,0.6-1.1,1.6-0.6,2.5c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1
		c0.7-0.1,1.2-0.2,1.6-0.5c0.5-0.9,0.9-1.7,1.4-2.6c-0.4-0.2-0.8-0.5-1.3-0.7C572.4,181.6,571.6,181.6,570.9,181.8z"
      />
      <path
        class="st3"
        d="M580.7,181.6c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0-0.1-0.2-0.1-0.3-0.1
		C580.7,181.4,580.6,181.5,580.7,181.6z"
      />
      <path
        class="st3"
        d="M567.4,211.2c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C567.3,211,567.3,211.1,567.4,211.2z"
      />
      <polygon class="st3" points="366.3,255 366.4,255 366.3,254.9 	" />
      <path
        class="st3"
        d="M510.7,198.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0.1C510.6,198.5,510.6,198.6,510.7,198.6z"
      />
      <path
        class="st3"
        d="M403.3,246.8c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C403.4,246.8,403.4,246.8,403.3,246.8
		C403.4,246.8,403.3,246.7,403.3,246.8z"
      />
      <path
        class="st3"
        d="M575.4,184.7l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C575.4,184.6,575.3,184.7,575.4,184.7z"
      />
      <path
        class="st3"
        d="M308.1,243.8C308.1,243.8,308.2,243.9,308.1,243.8c0.1,0.1,0.1,0.1,0.1,0l0,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1
		C308.2,243.7,308.2,243.7,308.1,243.8z"
      />
      <path
        class="st3"
        d="M395.7,225c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C395.8,225.1,395.8,225.1,395.7,225z"
      />
      <path
        class="st3"
        d="M319.1,237.5L319.1,237.5L319.1,237.5c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C319.1,237.4,319.1,237.4,319.1,237.5z"
      />
      <path
        class="st3"
        d="M502.9,197.5c0-0.1,0-0.1,0-0.2C502.9,197.4,502.9,197.5,502.9,197.5l-0.1,0.1L502.9,197.5z"
      />
      <path
        class="st3"
        d="M351.1,228.8l0.1-0.1c0,0-0.1,0-0.1-0.1C351.1,228.6,351.1,228.7,351.1,228.8
		C351.1,228.7,351.1,228.8,351.1,228.8z"
      />
      <polygon class="st3" points="552.2,193.3 552.1,193.2 552.1,193.3 	" />
      <polygon class="st3" points="499.6,194.4 499.8,194.3 499.7,194.2 	" />
      <polygon class="st3" points="546.4,183.9 546.2,183.9 546.3,184 	" />
      <path
        class="st3"
        d="M578.3,176.6C578.3,176.6,578.4,176.7,578.3,176.6c0.1,0,0.1-0.1,0.1-0.2l0,0
		C578.4,176.5,578.3,176.6,578.3,176.6z"
      />
      <path
        class="st3"
        d="M578.4,176.4L578.4,176.4C578.4,176.5,578.4,176.5,578.4,176.4C578.4,176.5,578.4,176.5,578.4,176.4
		c0.1-0.1,0.2-0.2,0.3-0.4l0,0l0,0C578.6,176.2,578.5,176.3,578.4,176.4z"
      />
      <path
        class="st3"
        d="M579,175.9c-0.1,0-0.1-0.1-0.2-0.1c0,0.1,0,0.1-0.1,0.2C578.8,176,578.9,176,579,175.9z"
      />
      <path
        class="st3"
        d="M552.5,181c0,0,0,0.1-0.1,0.1C552.5,181.1,552.5,181.1,552.5,181C552.5,181.1,552.5,181,552.5,181z"
      />
      <polygon class="st3" points="597,185.4 597,185.5 597.1,185.4 	" />
      <polygon class="st3" points="610.6,167.2 610.6,167.1 610.5,167.1 	" />
      <polygon class="st3" points="315.1,230.2 315.2,230.2 315.2,230.1 	" />
      <path
        class="st3"
        d="M506.1,206.7l0.1,0.1l0.1-0.1l-0.1-0.1C506.2,206.6,506.1,206.6,506.1,206.7z"
      />
      <path
        class="st3"
        d="M352.1,240.6c0,0.1,0,0.1,0,0.2l0.1-0.1C352.2,240.6,352.2,240.6,352.1,240.6z"
      />
      <polygon class="st3" points="506.6,207.2 506.7,207.3 506.7,207.2 	" />
      <path
        class="st3"
        d="M500.4,189.4c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C500.5,189.3,500.5,189.4,500.4,189.4z"
      />
      <path
        class="st3"
        d="M596.6,187.8c-0.1,0-0.2,0-0.3,0C596.4,187.9,596.5,187.9,596.6,187.8c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C596.9,188,596.7,187.9,596.6,187.8z"
      />
      <path
        class="st3"
        d="M514.5,186.2L514.5,186.2C514.6,186.2,514.6,186.2,514.5,186.2C514.6,186.3,514.6,186.2,514.5,186.2
		C514.5,186.2,514.5,186.2,514.5,186.2z"
      />
      <path
        class="st3"
        d="M510.6,187.1c0-0.1,0-0.2,0-0.2C510.6,186.9,510.5,187,510.6,187.1C510.5,187.1,510.6,187.1,510.6,187.1
		L510.6,187.1L510.6,187.1z"
      />
      <polygon class="st3" points="602.5,166.7 602.4,166.6 602.4,166.7 	" />
      <path
        class="st3"
        d="M596.4,189.2L596.4,189.2C596.5,189.2,596.5,189.2,596.4,189.2c-0.1-0.1-0.2-0.2-0.4-0.3c0,0,0-0.1-0.1-0.1
		c0,0.1,0,0.1,0,0.2C596.1,189,596.3,189.1,596.4,189.2z"
      />
      <path
        class="st3"
        d="M546.9,200c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C546.8,200.2,546.8,200.1,546.9,200z"
      />
      <path
        class="st3"
        d="M540.2,178.9c0,0-0.1-0.1-0.2-0.1l0,0l0,0C540.1,178.9,540.2,178.9,540.2,178.9z"
      />
      <path
        class="st3"
        d="M555.4,198.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C555.4,198.5,555.4,198.6,555.4,198.6z"
      />
      <path
        class="st3"
        d="M447.6,195.9l0.1,0.1l0.1-0.1l-0.1-0.1C447.7,195.8,447.6,195.8,447.6,195.9z"
      />
      <path
        class="st3"
        d="M558.8,170L558.8,170c-0.1,0.1-0.1,0.1-0.1,0.1l0,0L558.8,170z"
      />
      <path
        class="st3"
        d="M546.3,172.6l-0.1-0.1l-0.1,0.1l0.1,0.1C546.2,172.7,546.2,172.6,546.3,172.6z"
      />
      <path
        class="st3"
        d="M569,167.3c0,0.1,0,0.2,0.1,0.2l0.1-0.1C569.2,167.3,569.1,167.3,569,167.3z"
      />
      <path
        class="st3"
        d="M507.4,179.4c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C507.5,179.3,507.4,179.4,507.4,179.4z"
      />
      <path
        class="st3"
        d="M559.6,167.8l0.1-0.1C559.7,167.7,559.6,167.7,559.6,167.8C559.6,167.7,559.6,167.8,559.6,167.8z"
      />
      <path
        class="st3"
        d="M559.7,167.7L559.7,167.7c0.1-0.1,0.1-0.1,0.1-0.1C559.8,167.6,559.8,167.6,559.7,167.7L559.7,167.7z"
      />
      <path
        class="st3"
        d="M526.9,206.5l0.1,0.1C526.9,206.6,526.9,206.5,526.9,206.5L526.9,206.5z"
      />
      <path
        class="st3"
        d="M527,206.7C527,206.7,527,206.6,527,206.7L527,206.7c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C527.2,206.6,527.1,206.7,527,206.7z"
      />
      <path
        class="st3"
        d="M420.9,230.3l-0.1,0.1l0.1,0.1l0.1-0.1C421,230.4,421,230.4,420.9,230.3z"
      />
      <polygon class="st3" points="391.4,238.8 391.5,238.7 391.4,238.7 	" />
      <polygon class="st3" points="486,219.5 486.1,219.5 486.1,219.4 	" />
      <polygon class="st3" points="487.9,219.4 488,219.4 488,219.3 	" />
      <path
        class="st3"
        d="M542,207.7c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C541.9,207.8,542,207.7,542,207.7z"
      />
      <path
        class="st3"
        d="M598.2,198.4l0.1,0.1l0.1-0.1l-0.1-0.1C598.2,198.3,598.2,198.3,598.2,198.4z"
      />
      <polygon class="st3" points="376.1,247.5 376.2,247.4 376.1,247.4 	" />
      <path
        class="st3"
        d="M598.8,199l-0.1,0.1l0.1,0.1l0.1-0.1C598.9,199.1,598.8,199,598.8,199z"
      />
      <polygon class="st3" points="543.9,211.7 544,211.7 544,211.6 	" />
      <path
        class="st3"
        d="M566.8,210.6L566.8,210.6C566.7,210.6,566.7,210.7,566.8,210.6c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0.1,0v-0.1
		C567.1,210.8,566.9,210.7,566.8,210.6z"
      />
      <polygon
        class="st3"
        points="478.3,234.9 478.4,235 478.4,234.9 478.4,234.9 478.4,234.9 	"
      />
      <path
        class="st3"
        d="M584.1,216.2c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1C584.3,216.2,584.2,216.2,584.1,216.2z"
      />
      <path
        class="st3"
        d="M350.2,267.4c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C350.3,267.3,350.3,267.4,350.2,267.4z"
      />
      <path
        class="st3"
        d="M531.1,231.3L531.1,231.3c0.1-0.1,0.1-0.1,0.1-0.1l0,0L531.1,231.3z"
      />
      <path
        class="st3"
        d="M603.1,221.6c0,0.1,0,0.2-0.1,0.3C603.1,221.7,603.1,221.7,603.1,221.6c0.1,0,0.1-0.1,0.1-0.1
		C603.1,221.5,603.1,221.5,603.1,221.6L603.1,221.6z"
      />
      <path
        class="st3"
        d="M509.9,248.8l0.1,0.1l0.1-0.1C510,248.7,510,248.7,509.9,248.8C509.9,248.7,509.9,248.7,509.9,248.8z"
      />
      <path
        class="st3"
        d="M535.5,246.4l-0.1-0.1l-0.1,0.1l0.1,0.1C535.5,246.5,535.5,246.5,535.5,246.4z"
      />
      <polygon class="st3" points="500,266.3 500.1,266.3 500,266.2 	" />
      <path
        class="st3"
        d="M534.3,200.7c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C534.4,200.5,534.3,200.6,534.3,200.7z"
      />
      <path
        class="st3"
        d="M369.2,73.7c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1
		c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2
		c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5c-0.7,0-1.2-0.1-1.7-0.1c-1.9,0.2-3.3,1.2-3.8,2.7
		c-0.1,0.2-0.1,0.4-0.1,0.5c2.5,0.2,5.1,0.4,7.6,0.7C369.2,74.5,369.2,74.1,369.2,73.7z"
      />
      <path
        class="st3"
        d="M426.6,68c0.1,0.2,0.3,0.3,0.6,0.5c0.4,0,0.8,0,1.2,0.1c0.5-0.2,1.1-0.4,1.6-0.6c1.1-0.6,0.6-1.6,0.9-2.5
		c1.6,0.2,2.8,0.8,4,1.3c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9c0.3,0.8,0.5,1.5,0.7,2.2c1.4,0.1,2.9,0.1,4.3,0.2
		c0-0.1,0-0.1,0.1-0.2c0.3,0.1,0.6,0.2,0.9,0.3c1.5,0.1,2.9,0.1,4.4,0.2c-0.4-0.7-0.8-1.3-0.8-2.2c0.1-0.9-1.4-1.4-2.4-0.8
		c-0.8,0.5-1.5,0.4-2.3,0.3c-0.4-0.1-0.8-0.2-1.2-0.3c-1.5-0.4-2.9-1.1-4.4-1.8c0.6-0.2,0.9-0.3,1.7-0.6c-0.7-0.1-1.4-0.3-2-0.4
		c-0.7-0.1-1.3-0.2-1.9-0.3c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0c0,0.5-0.4,0.6-0.7,0.8c-0.5,0.3-0.9,0.7-1,1.1
		C425.9,66.7,426,67.3,426.6,68z"
      />
      <path
        class="st3"
        d="M431.8,71.8c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1.1,1.2,2,1.1c0.1,0,0.1,0,0.2,0
		c1.2-0.3,1.7-1.2,1.3-2.9c1,0.1,2,0.2,3.2,0.2c-0.7-0.7-0.9-1-0.9-1.4c-1.3-0.1-2.6-0.1-3.9-0.2c0.1,0.2,0.1,0.4,0.2,0.6
		c0,0.1,0.1,0.3,0.1,0.4C432.8,70.8,432.1,71.2,431.8,71.8z"
      />
      <path
        class="st3"
        d="M443.4,70.4c0-0.2,0-0.3,0-0.4c-0.6,0-1.2,0-1.7-0.1C442.2,70.1,442.8,70.2,443.4,70.4z"
      />
      <path
        class="st3"
        d="M310.8,113.1c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.7-0.1,1.4-0.2,1.9-0.5
		c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.2-0.3,0.2-0.4s0-0.2,0-0.4
		c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.2,0-0.5-0.1-0.7c-0.1-1.3-0.9-2.3-2.2-3c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,1.9
		C310.3,111.7,310.2,112.4,310.8,113.1C310.7,113,310.7,113.1,310.8,113.1z"
      />
      <path
        class="st3"
        d="M393.8,57.3c0.6-0.1,1.2-0.4,1.7-0.7c-0.9,0-1.7,0-2.6-0.1c-0.9,0-1.5,0.1-2.1,0.4
		C391.6,57.4,392.7,57.5,393.8,57.3z"
      />
      <path
        class="st3"
        d="M389,54.7c0,0.1,0.1,0.3,0.1,0.4c2.6,0,5.2,0.1,7.8,0.1c0.1-0.2,0.2-0.4,0.3-0.6c-2.8,0-5.5-0.1-8.3-0.1
		C389,54.5,389,54.6,389,54.7z"
      />
      <path
        class="st3"
        d="M389.2,52.9c2.7,0,5.4,0.1,8.2,0.1l0,0c-0.4-1.9-2.6-3.1-4.9-2.6C390.8,50.8,389.7,51.8,389.2,52.9z"
      />
      <path
        class="st3"
        d="M499.3,42.2c2.4,0,4.8,0.1,7.2,0.1l0,0c0.3-0.7,0.3-1.7-0.3-2.1c-0.6-0.5-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C499.1,41.7,499.1,42,499.3,42.2z"
      />
      <path
        class="st3"
        d="M502.5,44.5c0.2,0,0.4,0.2,0.5,0.3c0,0.8-0.3,1.3-1.1,1.8c-1,0.6-1.2,1.5-0.8,2.3c1.2,0,2.3,0,3.4,0
		c0.6-0.7,0.5-1.5-0.2-2c-0.4-0.3-0.8-0.5-1.3-0.8c0.4-0.9,0.9-1.6,1.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2c0.3-0.2,0.5-0.4,0.7-0.7
		c-2,0-4,0-5.9-0.1C500.6,43.7,501.3,44.4,502.5,44.5z"
      />
      <path
        class="st3"
        d="M502.1,49.7c0.5,0.2,1,0.2,1.5,0C503.2,49.7,502.6,49.7,502.1,49.7z"
      />
      <path
        class="st3"
        d="M488.1,46c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1,0,1.5c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1
		c0.2,0.2,0.5,0.3,0.7,0.5c1,0,2,0,3,0h-0.1c-1.3-0.2-2.1-0.8-2.4-1.7c-0.2-0.7-0.6-1.3-0.9-2c-0.1-0.3-0.4-0.6-0.4-0.8
		c0.1-0.3,0.1-0.5,0-0.7c-0.4,0.4-0.8,0.9-1.2,1.3C488.2,45.2,488.2,45.6,488.1,46z"
      />
      <path
        class="st3"
        d="M494.7,56.1c0.1,0.2,0.1,0.4,0.3,0.6c0.8,0,1.6,0,2.5,0c0-0.1,0.1-0.2,0.1-0.3c0.2,0,0.4,0,0.8,0.1
		c0-0.1,0-0.2,0-0.3c-0.3,0-0.6,0-0.9,0c0,0.1,0,0.1,0,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C496.4,56.1,495.5,56.1,494.7,56.1z"
      />
      <path
        class="st3"
        d="M487.2,43.5c0.1-0.1,0.2-0.2,0.2-0.3c-0.1-0.2-0.1-0.3-0.2-0.5c-0.1,0-0.2,0-0.3,0l0,0
		c0.1,0.2,0.2,0.4,0.2,0.6C487.2,43.3,487.2,43.4,487.2,43.5z"
      />
      <path
        class="st3"
        d="M487.1,42.1c0.5,0,0.9-0.1,1.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1
		c0,0,0,0.1-0.1,0.1c-0.3,0.4-0.5,0.7-0.5,1C486.9,42.1,487,42.1,487.1,42.1z"
      />
      <path
        class="st3"
        d="M490.6,49.5c0.2,0.4,0.2,0.8,0.1,1.3c0,0.2,0.5,0.4,0.8,0.6c0.2-0.3,0.6-0.6,0.6-0.9c0-0.3-0.2-0.7-0.4-1
		C491.3,49.6,490.9,49.5,490.6,49.5z"
      />
      <path
        class="st3"
        d="M493.8,49.6c-0.6,0-1.1,0-1.7,0c0,0,0,0.1,0.1,0.1c0.8,1.3,1.6,2.6,2.5,3.9c0.2,0.3,0.4,0.7,0.4,1
		c1,0,2,0,2.9,0c-0.2-0.6-0.4-1.2-1.3-1.5c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4C494.4,50.7,494.1,50.1,493.8,49.6z"
      />
      <path
        class="st3"
        d="M394.7,60.6c0.6,1.5,2.4,2.4,4.3,2c1.3-0.3,2.2-1,2.7-2.1c-2.3-0.1-4.7-0.1-7-0.2
		C394.7,60.4,394.7,60.5,394.7,60.6z"
      />
      <path
        class="st3"
        d="M400.3,56.7c-1.1,0-2.1,0-3.2-0.1c-0.2,0.1-0.3,0.1-0.5,0.2c-1.2,0.6-1.9,1.7-2,2.7c2.5,0.1,4.9,0.1,7.4,0.2
		c0.1-0.4,0.2-0.8,0.2-1.3c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2c-0.3,0-0.7,0.1-1,0.1C401.4,57.4,400.8,57,400.3,56.7z"
      />
      <path
        class="st3"
        d="M371.8,78.5c-0.1-0.2-0.2-0.4-0.3-0.7c-1.3,0.2-2.6,0.5-3.9,0.7c0,0.2,0,0.5,0,0.8c0.2,1,0.9,1.7,1.9,2.1
		C370.3,80.4,371,79.4,371.8,78.5z"
      />
      <path
        class="st3"
        d="M371.9,81.6c2-0.4,3.5-2.1,3.2-3.8c-0.1-0.3-0.2-0.6-0.4-0.9c-0.2,0.3-0.5,0.6-0.7,1c-0.8,1.3-1.7,2.5-2.7,3.8
		C371.5,81.6,371.7,81.6,371.9,81.6z"
      />
      <path
        class="st3"
        d="M533.7,70.8c1.2,0.2,2.4,0,3.3-1c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.2-0.3,0.3-0.5c0.2-0.4,0.3-0.9,0.4-1.3
		c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.1c-1.5,1.4-3.1,2.8-4.8,4.3
		c0.2,0.1,0.4,0.2,0.7,0.2C533.5,70.8,533.6,70.8,533.7,70.8z"
      />
      <path
        class="st3"
        d="M531.2,69.1c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c1.6-1.4,3.2-2.7,4.7-4.1c-1.1-0.5-2.5-0.5-3.6,0.2
		l-0.1,0.1c-0.3,0.2-0.6,0.4-0.8,0.7c-0.6,0.7-0.8,1.6-0.5,2.5C531.1,69,531.1,69,531.2,69.1z"
      />
      <path
        class="st3"
        d="M407.6,52.9c0.2-0.2,0.3-0.4,0.5-0.6c-0.7-0.2-1.3-0.3-2-0.4c-1.2-0.1-2.2,0.4-3,1.2c1.1,0,2.3,0,3.4,0.1
		C406.9,53.2,407.4,53.2,407.6,52.9z"
      />
      <path
        class="st3"
        d="M402.3,55.3c2.1,0,4.3,0.1,6.4,0.1c0.2-0.2,0.3-0.4,0.4-0.6c-2.3,0-4.6-0.1-6.9-0.1
		C402.3,54.9,402.3,55.1,402.3,55.3z"
      />
      <path
        class="st3"
        d="M406,57.3c0.3-0.1,0.7-0.2,1.1-0.5c-1.2,0-2.4-0.1-3.7-0.1C404.1,57.3,405,57.4,406,57.3z"
      />
      <path
        class="st3"
        d="M603.9,43.3c-0.6,0.4-1.1,0.9-1.3,1.6c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4
		c0.1-0.9-0.5-1.5-0.7-2.3c-0.5-0.2-0.9-0.4-1.4-0.5C605.9,42.5,604.8,42.8,603.9,43.3z"
      />
      <path
        class="st3"
        d="M608.3,43.3C608.4,43.3,608.4,43.4,608.3,43.3C608.4,43.4,608.4,43.3,608.3,43.3
		C608.4,43.3,608.4,43.3,608.3,43.3L608.3,43.3z"
      />
      <path
        class="st3"
        d="M400.4,65.8c0.2,0.7,0.7,1.3,1.4,1.6c1,0,2,0.1,3,0.1c0.7-0.3,1.3-0.8,1.7-1.4c0.3-0.5,0.5-1.1,0.4-1.7
		c0-0.2-0.1-0.3-0.2-0.5c-0.5-1.2-2.1-1.8-3.6-1.5C401.3,62.8,400,64.4,400.4,65.8z"
      />
      <path
        class="st3"
        d="M413.8,60.8c-2.1-0.1-4.2-0.1-6.3-0.2c0,0.1,0,0.1,0,0.2c0.3,1.5,1.9,2.4,3.7,2
		C412.6,62.6,413.5,61.8,413.8,60.8z"
      />
      <path
        class="st3"
        d="M410.1,57.6c-1.3,0.3-2.3,1.2-2.5,2.2c2.1,0.1,4.2,0.1,6.3,0.2c0-0.1,0-0.3,0-0.4
		C413.6,58.1,411.9,57.2,410.1,57.6z"
      />
      <path
        class="st3"
        d="M526.5,48.9c1.7-0.4,2.8-1.9,2.5-3.3c-0.3-1.4-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.2,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C523,48.4,524.7,49.3,526.5,48.9z"
      />
      <path
        class="st3"
        d="M394.9,72.3c0.6,0.3,1.4,0.4,2.1,0.2c1-0.2,1.9-0.9,2.3-1.7c0.3-0.5,0.4-1,0.2-1.6c-0.1-0.4-0.4-0.8-0.7-1.1
		c-1.4-0.1-2.8-0.1-4.3-0.2c0,0-0.1,0-0.1,0.1c-0.9,0.6-1.4,1.6-1.1,2.6C393.5,71.4,394.1,72,394.9,72.3z"
      />
      <path
        class="st3"
        d="M349.2,92.6c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-1.2-1.2-2.2-1.5-3.4-0.9
		c-0.7,0.3-1.1,0.9-1.3,1.5c2.5,0.1,5,0.2,7.5,0.4C349.2,92.7,349.2,92.6,349.2,92.6z"
      />
      <path
        class="st3"
        d="M346.5,95.4c0.5,0.2,1,0.1,1.5-0.1c0.7-0.3,1.1-0.8,1.3-1.3c-1.5-0.1-3-0.2-4.6-0.2c-0.9,0-1.9-0.1-2.8-0.1
		c0.4,0.6,1.3,0.9,2.9,0.7C345.5,94.9,346,95.2,346.5,95.4z"
      />
      <path
        class="st3"
        d="M413.4,65.2c-0.2,0.3-0.1,0.8-0.8,0.9c0.2,0.2,0.4,0.4,0.8,0.6c-0.8,0.3-1.7,0.5-1.9,1.2
		c0.9,0,1.8,0.1,2.7,0.1c0.4,0,0.9,0,1.1-0.3c0.9-1.1,1.8-2.3,2.7-3.4c0,0-0.1-0.1-0.1-0.2c-0.5-0.4-1.1-0.6-1.9-0.6
		C414.8,63.6,414,64.2,413.4,65.2z"
      />
      <path
        class="st3"
        d="M418.6,66.1c-0.4,0.5-0.8,1.1-1.3,1.6C418,67.3,418.5,66.8,418.6,66.1z"
      />
      <path
        class="st3"
        d="M412.4,69.1c0.6,0.1,1-0.1,1.4-0.4c-0.7,0-1.4-0.1-2.1-0.1C411.8,68.9,412,69.1,412.4,69.1z"
      />
      <path
        class="st3"
        d="M534.9,42.6c0.2,0,0.4,0,0.6,0c0.5-0.7,0.6-1.6,0.2-2.3c-0.2-0.3-0.4-0.6-0.6-1c0-0.1-0.1-0.1-0.1-0.2
		c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.3,0-2,0.1c-1,0.1-1.8,0.6-2.2,1.2c-0.2,0.2-0.3,0.5-0.4,0.8c-0.2,0.5-0.1,1.1,0.1,1.5
		C531.9,42.6,533.4,42.6,534.9,42.6z"
      />
      <path
        class="st3"
        d="M534.6,43.4c-1.2,0-2.4,0-3.6,0c0.2,0.1,0.4,0.3,0.6,0.4c0.8,0.3,1.7,0.3,2.5-0.1
		C534.3,43.6,534.5,43.5,534.6,43.4z"
      />
      <path
        class="st3"
        d="M331.5,68.4c0.2,1.2,1.8,2.1,3.4,1.8c1.4-0.3,2.5-1.7,2.3-2.9c-0.2-1.2-1.8-2-3.2-1.7
		C332.5,65.9,331.3,67.2,331.5,68.4z"
      />
      <path
        class="st3"
        d="M404.3,76.1c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.8-0.6-2-0.6-3-0.2h-0.1
		c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.2-0.4,0.3-0.5,0.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2
		C400.7,75.9,402.5,76,404.3,76.1C404.3,76.2,404.3,76.1,404.3,76.1z"
      />
      <path
        class="st3"
        d="M399.1,76.6c0.1,0.4,0.3,0.8,0.5,1.3c0.1-0.1,0.2-0.2,0.3-0.1c0.2,0,0.4,0,0.6,0s0.4,0,0.6,0
		c0.1,0,0.3,0,0.4,0c0.8-0.1,1.6-0.4,2.1-0.9C402.2,76.8,400.7,76.7,399.1,76.6z"
      />
      <path
        class="st3"
        d="M411.4,71.3c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.7-0.7-1.2-1.4-1.5c-0.6,0-1.2-0.1-1.8-0.1
		c-0.3,0.1-0.5,0.2-0.7,0.3c-0.3,0.2-0.6,0.4-0.8,0.6c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5
		c0.3-0.1,0.6-0.2,0.8-0.3C410.7,72.2,411.1,71.8,411.4,71.3z"
      />
      <path
        class="st3"
        d="M342.7,74.8c0.2-0.1,0.2-0.2,0.3-0.3c-1.8-0.1-3.7-0.2-5.5-0.3c0,0.1,0,0.3,0,0.4
		C339.3,74.7,341,74.8,342.7,74.8z"
      />
      <path
        class="st3"
        d="M341.4,76.3c-1,0-1.9-0.1-2.9-0.1c0.7,0.4,1.7,0.6,2.6,0.2C341.3,76.4,341.4,76.3,341.4,76.3z"
      />
      <path
        class="st3"
        d="M339.6,72.1c-0.5,0.1-0.8,0.4-1.2,0.6c1.4,0.1,2.7,0.1,4.1,0.2C342,72.1,340.9,71.8,339.6,72.1z"
      />
      <path
        class="st3"
        d="M364.7,62.1h-0.1c0.5,0,1,0,1.5,0C365.6,62.1,365.2,62,364.7,62.1z"
      />
      <path
        class="st3"
        d="M365.4,66.6c1.6-0.3,2.6-1.5,2.4-2.8c0,0,0,0,0-0.1c-1.7,0-3.4-0.1-5.2-0.1c-0.2,0.4-0.3,0.8-0.3,1.3
		C362.6,66.1,363.9,66.9,365.4,66.6z"
      />
      <path
        class="st3"
        d="M552.3,7.7c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C552.1,6,552.1,6.9,552.3,7.7z"
      />
      <path
        class="st3"
        d="M602.2,54.4c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6c1.4-0.3,2.4-1.5,2.2-2.6c-0.2-1.2-1.5-2-3-1.7
		c-1,0.2-1.7,0.8-2.1,1.5C602.2,53.7,602.2,54.1,602.2,54.4z"
      />
      <path
        class="st3"
        d="M517,37.1c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.9-0.3,1.3-1.2,1.1-2c-0.1-0.3-0.2-0.6-0.5-0.9
		c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.2,0.5-0.3,1-0.4,1.4c-0.3,0.1-0.7,0.2-0.9,0.4c-0.1,0-0.1,0.1-0.1,0.1c-0.8,0.6-0.7,1.2,0.1,1.8c0.2,0.1,0.3,0.2,0.5,0.3
		c0.1,0,0.3,0,0.4-0.1C516.7,38.4,517.1,37.8,517,37.1z"
      />
      <path
        class="st3"
        d="M408.4,79.6c-0.1-0.1-0.2-0.1-0.3-0.2c-0.9,1.1-1.8,2.1-2.6,3.2c0.5,0.4,1.2,0.4,1.9,0.3
		c0.9-0.2,1.5-0.7,1.8-1.5C409.4,80.7,409.1,80.1,408.4,79.6z"
      />
      <path
        class="st3"
        d="M407.1,78.2c-0.1-0.1-0.2-0.2-0.4-0.2c-0.9-0.2-1.4,0.1-2.3,1.3c0.2,0.3,0.5,0.6,0.7,0.9
		c-0.1,0.1-0.2,0.1-0.2,0.2c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0-0.2,0.1-0.3,0.1c0.3,0.5,0.5,1,0.8,1.4
		C405.4,80.4,406.2,79.3,407.1,78.2z"
      />
      <path
        class="st3"
        d="M325.6,96.8c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.2,0.4-0.3,0.6-0.5l0,0c-1.6-0.1-3.1-0.2-4.7-0.3
		c0,0.4,0.1,0.7,0.3,1.1C323.3,97.4,324.5,97.6,325.6,96.8z"
      />
      <path
        class="st3"
        d="M326.7,94.6c-0.2-0.4-0.4-0.7-0.6-1.1c-0.2-0.3-0.5-0.4-0.5-0.7c-0.5,0-1.1,0-1.6-0.1c0,0.4-0.4,0.6-0.7,0.9
		c-0.3,0.3-0.4,0.5-0.6,0.8C324,94.5,325.3,94.6,326.7,94.6L326.7,94.6z"
      />
      <path
        class="st3"
        d="M372.2,112c0.2,0.4,0.7,0.8,1.5,1.2c1-0.4,1.5-1,1.6-1.9c0-0.1,0-0.2,0-0.3c-0.1-0.7-0.9-1-1.6-1.3
		c0.2-0.2,0.3-0.3,0.4-0.4l0.1-0.1c0.4-0.5,0.3-0.7-0.1-1.3l-0.1-0.1c0-0.1-0.1-0.2,0-0.2c0.6-0.4,0.1-0.8-0.1-1
		c-0.3-0.2-0.7-0.4-1.1-0.5h-0.1c-0.6-0.1-1.3,0.4-1.1,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8
		c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2l-0.1,0.1C372.2,110.7,371.8,111.4,372.2,112z"
      />
      <path
        class="st3"
        d="M378.2,100.3c-0.2,0-0.4-0.1-0.6-0.1c-0.8,0.7-1.6,1.5-2.6,2.4c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0.1,0.7,0.2,1,0.3
		l0,0c0.1,0,0.3,0.1,0.4,0.1c0.8,0.4,1.6,0.5,2.4,0c1,1.3,1,1.3,2.6,1c0.1-0.5,0.2-1,0.3-1.6c0,0,0,0-0.1,0c-0.7-0.1-1.3-0.3-2-0.4
		c-0.3-0.9-0.7-1.4-1.6-1.7c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.1-0.4-0.1-0.6-0.2C378.3,100.3,378.2,100.3,378.2,100.3z"
      />
      <path
        class="st3"
        d="M537.7,37.1c0.2,1.1,1.6,1.8,3,1.5s2.2-1.4,2-2.5s-1.5-1.7-2.9-1.5C538.4,34.9,537.5,36,537.7,37.1z"
      />
      <path
        class="st3"
        d="M557.6,32.1c0.3-1.2-1.2-2.2-2.6-1.9c-1,0.2-1.7,0.9-1.9,1.8c-0.1,0.8,0.3,1.6,1.2,1.8
		c0.4,0.1,0.8,0.2,1.2,0.3c0.5,0.1,1,0.3,1.4,0.6c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.4-0.3-0.5
		C557.4,33,557.5,32.6,557.6,32.1z"
      />
      <path
        class="st3"
        d="M415,77.8c-0.9-0.1-1.8-0.1-2.7-0.2c0.3,0.2,0.7,0.4,1.1,0.5C414.1,78.2,414.6,78.1,415,77.8z"
      />
      <path
        class="st3"
        d="M413.8,74.3c-0.4-0.6-0.6-0.9-0.9-1c-0.3,0.4-0.6,0.8-0.9,1.1c0.2,0.5,0.2,1.1-0.2,1.7
		c-0.1,0.2-0.1,0.4-0.1,0.6c1.4,0.1,2.8,0.2,4.2,0.3c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.3-0.8,0.2-1.2c-0.1-0.5-0.5-0.9-1.1-1.1
		c-0.3-0.1-0.6-0.2-0.9-0.2C414.1,74.4,414,74.4,413.8,74.3z"
      />
      <path
        class="st3"
        d="M547.6,42.7C547.6,42.7,547.6,42.6,547.6,42.7c0.2-0.3,0.2-0.5,0.2-0.7c0-0.1,0-0.2,0-0.3
		c-0.2-1.1-1.5-1.8-2.8-1.5c-0.9,0.2-1.5,0.8-1.8,1.5c-0.1,0.3-0.2,0.7-0.1,1.1C544.6,42.7,546.1,42.7,547.6,42.7z"
      />
      <path
        class="st3"
        d="M543.4,43.4c0.3,0.3,0.7,0.6,1.1,0.7c0.4,0.1,0.8,0.2,1.2,0.1c0.6-0.1,1.1-0.4,1.4-0.8
		C545.9,43.4,544.6,43.5,543.4,43.4z"
      />
      <path
        class="st3"
        d="M572.7,21.7c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6s1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C574.1,21.6,573.4,21.5,572.7,21.7z"
      />
      <path
        class="st3"
        d="M432.2,42.7c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.2-0.1,0.4-0.3,0.6-0.4c-1.7,0-3.3,0-5,0
		C431.7,42.5,431.9,42.7,432.2,42.7z"
      />
      <path
        class="st3"
        d="M437.3,39.5c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.1,0.1-0.3,0.2-0.5,0.3c1.9,0,3.9,0,5.8,0.1
		C437.9,41,437.9,40.4,437.3,39.5z"
      />
      <path
        class="st3"
        d="M371.3,60.9c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C368.7,60.6,370,61.2,371.3,60.9z"
      />
      <path
        class="st3"
        d="M388.4,50.2c1-0.2,1.8-1.1,1.9-1.9c-1.5,0-3,0-4.6-0.1c-0.1,0.2-0.1,0.5,0,0.7C386,49.8,387.2,50.4,388.4,50.2
		z"
      />
      <path
        class="st3"
        d="M387.5,46.4c-0.6,0.1-1.1,0.5-1.4,1c1.4,0,2.7,0,4.1,0.1C389.7,46.6,388.6,46.1,387.5,46.4z"
      />
      <path
        class="st3"
        d="M587.4,57.9c-0.1,0.1-0.1,0.1-0.1,0.2c0.8,0,1.5,0,2.3,0C589,57.9,588.1,58.1,587.4,57.9z"
      />
      <path
        class="st3"
        d="M591.8,59.7c-1.5,0-2.9,0-4.4-0.1c0.5,0.5,1.1,0.9,1.6,1.4c0.5,0,1-0.2,1.4-0.1c0.2,0.1,0.5,0.1,0.7,0.1
		c0.5-0.4,1-0.8,1.5-1.2C592,59.8,591.9,59.7,591.8,59.7z"
      />
      <path
        class="st3"
        d="M375.3,64.9c0.5,0.3,1.1,0.5,1.8,0.3c0.7-0.1,1.3-0.6,1.7-1.1c-1.4,0-2.8-0.1-4.2-0.1c0,0.1,0,0.2,0.1,0.3
		C374.8,64.5,375,64.7,375.3,64.9z"
      />
      <path
        class="st3"
        d="M376.5,61.5c-0.7,0.1-1.2,0.5-1.6,0.9c1.3,0,2.7,0.1,4,0.1C378.5,61.8,377.6,61.3,376.5,61.5z"
      />
      <path
        class="st3"
        d="M400.1,87.8c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.1-0.1,0.1-0.1c-0.3,0-0.5,0-0.8,0c-0.5,0-1-0.1-1.5-0.1
		C398.8,87.8,399.4,88,400.1,87.8z"
      />
      <path
        class="st3"
        d="M399.4,84.1c-1,0.2-1.8,0.9-1.9,1.7c0,0,0,0.1,0,0.2c2.5,0.2,3.2,0.2,4.3-1C401.4,84.3,400.5,83.9,399.4,84.1z
		"
      />
      <path
        class="st3"
        d="M558.6,31.4c0.5,0.3,1.2,0.5,2.2,0.7c-0.2,1,0.1,1.7,1.2,2.2c0.6-1.2,0.6-1.2-0.5-2.5c0.9-0.9,0.9-1,0.6-1.4
		c-0.4-0.4-0.8-0.9-1.3-1.2c-0.5-0.4-1.1-0.7-1.8-0.8C557.7,29.7,557.6,30.7,558.6,31.4z"
      />
      <path
        class="st3"
        d="M592.4,54.4c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C592.1,54.1,592.3,54.2,592.4,54.4z"
      />
      <path
        class="st3"
        d="M333.3,81.3c0-1,0-2.1,0-3.1c-0.4-0.2-0.9-0.3-1.5-0.2c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c-0.7,0.5-1.2,1.3-1.1,2
		c0.2,1,1.4,1.5,2.6,1.3C332.8,81.5,333.1,81.4,333.3,81.3z"
      />
      <path
        class="st3"
        d="M385.5,60.2c-0.4-0.1-0.7-0.1-1.1-0.2c0.2,0.3,0.5,0.5,0.9,0.6C385.4,60.4,385.4,60.3,385.5,60.2z"
      />
      <path
        class="st3"
        d="M383.9,59c0,0.1,0.1,0.2,0.1,0.3c1.2,0.1,2.3-0.1,3-0.8c0-0.7-0.1-1.4-0.3-2.1c-0.1,0-0.2,0-0.3,0
		c-0.5,0-0.9,0-1.4,0C384.1,57.2,383.7,58,383.9,59z"
      />
      <path
        class="st3"
        d="M340.2,85.6c-0.1-0.4-0.3-0.6-0.6-0.9c-0.9,0-1.8-0.1-2.6-0.1c-0.8,0.4-1.3,1.2-1.1,2c0.1,0.6,0.7,1,1.4,1.2
		c0.4,0,0.9,0,1.3,0.1C339.7,87.6,340.5,86.6,340.2,85.6z"
      />
      <path
        class="st3"
        d="M350.9,90c0.3,0,0.6-0.1,0.9-0.2c-0.8,0-1.6-0.1-2.3-0.1c0,0.6,0.2,1.3,0.4,1.9C350.3,91,350.6,90.5,350.9,90z
		"
      />
      <path
        class="st3"
        d="M349.4,88.4c1.3,0.1,2.5,0.1,3.8,0.2l0,0c0.3-1.1-0.7-1.6-1.5-2.1c-0.9,0.4-1.6,0.7-2.4,1.1
		C349.4,87.8,349.4,88.1,349.4,88.4z"
      />
      <path
        class="st3"
        d="M391.7,66c1.1-0.3,1.9-1.3,1.7-2.2c-0.2-0.9-1.3-1.5-2.4-1.3c-1.2,0.2-2,1.3-1.8,2.3
		C389.4,65.7,390.6,66.3,391.7,66z"
      />
      <path
        class="st3"
        d="M565.3,47.1c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7c1-1,1.2-2.3,2.9-2.3h0.1c0,0,0-0.1-0.1-0.1
		c-0.1-0.3-0.2-0.5-0.3-0.8c-0.7,0.4-1.4,0.8-2,1.2c0.2-0.5,0.5-0.8,0.8-1.1c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3
		c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6c0.6,1.2,0.3,2-0.5,2.7C565.5,46,565.5,46.4,565.3,47.1z"
      />
      <path
        class="st3"
        d="M308.4,65.7c-0.2-0.8-1.2-1.4-2.2-1.3V68c0.2,0,0.3,0,0.5-0.1C307.9,67.7,308.6,66.7,308.4,65.7z"
      />
      <path
        class="st3"
        d="M576.7,54.6c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2c-0.4,0.1-0.8,0.3-1.1,0.5
		c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5c0.4,0.8-0.2,1.5-0.5,2.2l0,0C576.2,54,576.4,54.3,576.7,54.6z"
      />
      <path
        class="st3"
        d="M394.9,82.6C394.9,82.6,395,82.6,394.9,82.6c0.5,0.2,1.1,0.1,1.7-0.2c-0.7-1.2-0.1-2.8-1.6-3.9
		c-0.6,0.4-1.2,0.7-1.5,1.1c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.3,0.3,0.6,0.6,0.9,0.9
		C394.5,82.4,394.7,82.5,394.9,82.6z"
      />
      <path
        class="st3"
        d="M378.3,74c0.6-0.5,0.7-1.3,0.2-1.8c-0.4,0.5-0.8,1.1-1.3,1.7c0.4,0.1,0.7,0.2,0.9,0.2
		C378.2,74.1,378.2,74.1,378.3,74z"
      />
      <path
        class="st3"
        d="M376.4,71.8c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c0.6,0.4,1.2,0.9,1.8,1.3
		c0.2-0.1,0.3-0.1,0.4-0.3c0.5-0.6,1-1.2,1.5-1.9c-0.1,0-0.2,0-0.2,0C376.7,71.7,376.5,71.7,376.4,71.8z"
      />
      <path
        class="st3"
        d="M368.3,103c-0.1-0.9-0.7-1.3-1.7-1.5c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6c-0.8,0.2-1.1,0.8-1,1.4
		c0.1,0.5,0.4,0.9,0.8,1.3c0.5,0.4,1.2,0.5,2,0.2c0.1-0.9-1.7-1.1-0.5-2.2C366.8,103.2,367.5,103.8,368.3,103z"
      />
      <path
        class="st3"
        d="M449.4,60.9c0.9,0,1.9,0,2.8,0.1v-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.3-0.2-0.6-0.3-0.8-0.4c0-0.1,0-0.2,0.1-0.3
		c0-0.1,0.1-0.1,0.1-0.2c0.2-0.3,0.5-0.5,1-0.7c0.2-0.1,0.5-0.2,0.7-0.2c-0.6-0.5-1-1-1.6-1.5c-0.1,0-0.2,0-0.3,0
		c-0.6,0.4-1.2,0.7-1.6,1.1c-0.2,0.1-0.2,0.3-0.3,0.4c-0.1,0.3,0.1,0.7,0.2,1c0,0.1-0.2,0.3-0.4,0.5
		C449.3,60.7,449.3,60.8,449.4,60.9z"
      />
      <path
        class="st3"
        d="M541.7,53c0.1,0.4,0.3,0.8,0.7,1s0.9,0.3,1.4,0.2c1-0.2,1.7-1.1,1.6-1.9c-0.1-0.6-0.7-1-1.4-1.1
		c-0.3,0-0.5,0-0.8,0C542.1,51.4,541.5,52.1,541.7,53z"
      />
      <path
        class="st3"
        d="M497.9,31.9c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C495.5,31.7,496.6,32.2,497.9,31.9z"
      />
      <path
        class="st3"
        d="M557.8,38.3c-0.2-0.8-1.2-1.3-2.2-1.1s-1.7,1.1-1.5,1.9c0.2,0.8,1.2,1.2,2.1,1C557.3,39.8,558,39.1,557.8,38.3
		z"
      />
      <path
        class="st3"
        d="M442.8,32.9c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C441.4,32,441.8,32.5,442.8,32.9z"
      />
      <path
        class="st3"
        d="M581.6,58L581.6,58c0.2-0.2,0.4-0.4,0.6-0.6c-0.6,0-1.2,0-1.9,0c0.1,0.2,0.3,0.4,0.6,0.6
		C581.1,58,581.3,58,581.6,58z"
      />
      <path
        class="st3"
        d="M580.5,54.6c0.1,0.3,0.2,0.6,0,0.8c-0.1,0.2-0.2,0.3-0.3,0.4c0.8,0,1.6,0,2.4,0c-0.1-0.2-0.1-0.4-0.2-0.6
		c-0.1-0.4-0.1-0.8-0.3-1.1s-0.5-0.6-1.2-0.7C580.4,54.3,580.4,54.2,580.5,54.6z"
      />
      <path
        class="st3"
        d="M426.1,75.6c-1,0.2-1.6,0.9-1.6,1.7c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2c1,0.1,2,0.2,2.9,0.2
		c0.4-0.4,0.6-0.9,0.5-1.3C428,75.9,427.1,75.4,426.1,75.6z"
      />
      <path
        class="st3"
        d="M364.9,59.3c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C362.9,58.9,363.9,59.5,364.9,59.3z"
      />
      <path
        class="st3"
        d="M606.6,20.3c0.4,0.5,1.1,0.8,1.9,0.7c0.9-0.2,1.6-1,1.5-1.8c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C606.5,20.1,606.6,20.2,606.6,20.3z"
      />
      <path
        class="st3"
        d="M332.4,96.2c0-0.1-0.1-0.2-0.2-0.3c-0.9,0-1.8-0.1-2.7-0.1c-0.5,0.4-0.7,1-0.5,1.5c0.3,0.7,1.3,1.1,2.2,0.8
		C332.2,97.8,332.7,97,332.4,96.2z"
      />
      <path
        class="st3"
        d="M587.9,65.7c-0.5,0.2-0.9,0.4-1.3,0.8c0.1,0.5-0.2,1.1,0.1,1.5c1.5,0.6,1.5,0.6,2.9-0.2
		c0.1-0.5,0.2-1.1,0.3-1.5C589.4,65.7,588.6,65.8,587.9,65.7z"
      />
      <path
        class="st3"
        d="M419.4,83.4c0.1,0,0.1,0,0.1,0c1-0.2,1.6-1,1.4-1.8c-0.1-0.3-0.2-0.5-0.4-0.7c-0.4-0.4-1-0.6-1.6-0.5
		c-0.9,0.2-1.6,1-1.5,1.8C417.6,83,418.4,83.5,419.4,83.4z"
      />
      <path
        class="st3"
        d="M541.2,34c0.9-0.3,1.6-1.3,1.4-2c-0.2-0.7-0.9-1.1-1.7-0.9c-1.1,0.3-2,1.4-1.8,2.2
		C539.2,33.7,540.6,34.2,541.2,34z"
      />
      <path
        class="st3"
        d="M348.8,68.6c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C347.7,67.1,348,67.9,348.8,68.6z"
      />
      <path
        class="st3"
        d="M496.9,48.8c1,0,2.1,0,3.1,0c0-0.7,0-1.4,0-2.2c-0.9,0.5-1.6,0.8-2.1,1.2C497.4,48.1,497.1,48.4,496.9,48.8z"
      />
      <path
        class="st3"
        d="M498.4,50.4c0.4-0.2,0.8-0.4,1.2-0.7c-0.9,0-1.9,0-2.8,0C496.9,50.4,497.6,50.7,498.4,50.4z"
      />
      <path
        class="st3"
        d="M331.7,91.2c-0.2-0.7-1-1.1-1.9-1c-0.1,0-0.1,0-0.2,0c-0.8,0.2-1.4,0.8-1.4,1.5c1.2,0.1,2.3,0.1,3.5,0.2
		C331.7,91.7,331.8,91.5,331.7,91.2z"
      />
      <path
        class="st3"
        d="M330.2,93c-0.3,0-0.6,0-0.9,0C329.6,93.1,329.9,93.1,330.2,93z"
      />
      <path
        class="st3"
        d="M354.4,72.5c-0.1,0.4-0.2,0.8-0.2,1.1c1,0.1,2,0.1,3,0.2C356.8,73,355.9,72.6,354.4,72.5z"
      />
      <path
        class="st3"
        d="M380.3,62.6c0.5,0,1,0,1.5,0c0.8-0.3,1.3-1,1.1-1.7c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8
		C379.7,62.1,379.9,62.4,380.3,62.6z"
      />
      <path
        class="st3"
        d="M400.7,50.4c0.9-0.2,1.4-1,1.3-1.7c0-0.1-0.1-0.2-0.2-0.3c-1,0-1.9,0-2.9,0c-0.2,0.3-0.4,0.7-0.3,1.1
		C398.8,50.2,399.7,50.6,400.7,50.4z"
      />
      <path
        class="st3"
        d="M377.7,109c0.4,0,0.7,0,0.9-0.1c0.7-0.1,0.8-0.4,1.3-1.5c-0.6-0.3-1.2-0.7-1.7-1c-0.5,0.2-0.8,0.2-1,0.4l0,0
		c-0.3,0.2-0.6,0.5-1,0.8c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0c-0.1,0.2-0.1,0.4-0.1,0.6l0.3,0.1c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0
		C376.6,109,377.2,109,377.7,109z"
      />
      <path
        class="st3"
        d="M411.6,51.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C412,49.8,411.4,50.5,411.6,51.3z"
      />
      <path
        class="st3"
        d="M409.6,47.7c0.3,0,0.6,0,0.9,0c0,0,0,0,0.1,0c0.9-0.2,1.4-0.9,1.3-1.6c0-0.1,0-0.2-0.1-0.3
		c-0.2-0.6-0.9-0.9-1.7-0.8c-0.9,0.1-1.6,1-1.5,1.7C408.6,47.2,409,47.6,409.6,47.7z"
      />
      <path
        class="st3"
        d="M551.6,57.3c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0,0.8,0,1.2,0c0.2-0.1,0.4-0.3,0.6-0.6c-0.8,0-1.7,0-2.5,0
		C551.4,57,551.5,57.1,551.6,57.3z"
      />
      <path
        class="st3"
        d="M549.3,55.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.9,0,1.7,0,2.6,0c-0.4-0.1-0.8-0.3-1.2-0.4
		C550.1,55,549.6,55.1,549.3,55.3z"
      />
      <path
        class="st3"
        d="M337.6,97.3c-0.3-0.6-0.9-0.9-1.7-0.9c-0.9,0.1-1.5,0.4-1.7,1.3c0.8,0.5,1.5,1.1,2.4,1.7
		C337.6,98.8,338,98.1,337.6,97.3z"
      />
      <path
        class="st3"
        d="M440.1,31c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C439.9,33,440.4,32,440.1,31z"
      />
      <path
        class="st3"
        d="M577.5,26.5c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C577.1,26.2,577.3,26.4,577.5,26.5z"
      />
      <path
        class="st3"
        d="M345.7,81.2c-0.4-0.6-0.8-1.2-1.2-1.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.3,0.6-0.4,1.2-0.1,1.7C344.3,81.5,345,81.4,345.7,81.2z"
      />
      <path
        class="st3"
        d="M460.4,72c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1s0.5,0.6,0.8,0.8
		c0.3,0.2,0.7,0.1,1.1,0.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.2-0.7,0.4-1c0.2-0.3,0.4-0.6,0.6-1C460.2,72.4,460.3,72.2,460.4,72z"
      />
      <path
        class="st3"
        d="M376.1,82.3c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.2,0.2,0.3c0.3,0.4,0.9,0.6,1.5,0.4c0.9-0.2,1.4-0.8,1.2-1.5
		c-0.2-0.7-1-1.1-1.8-0.8C376.6,81.8,376.3,82,376.1,82.3z"
      />
      <path
        class="st3"
        d="M602,33.8c0.8-0.1,1.4-0.8,1.3-1.5c-0.1-0.7-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4
		C600.4,33.4,601.1,33.9,602,33.8z"
      />
      <path
        class="st3"
        d="M562,47.7c0.1-0.7,0.2-1.1,0.3-1.5c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2c-0.1,0-0.3,0-0.4,0
		c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4C561.1,47,561.5,47.2,562,47.7z"
      />
      <path
        class="st3"
        d="M438.6,76.6c-0.8,0.2-1.4,0.8-1.2,1.5c0.1,0.3,0.3,0.6,0.6,0.7c0.4,0,0.8,0.1,1.3,0.1c0.7-0.2,1.2-0.8,1.1-1.4
		C440.2,76.9,439.4,76.5,438.6,76.6z"
      />
      <path
        class="st3"
        d="M365.4,91.5c-0.3,0.9,0,1.5,0.8,1.9c0.2,0.1,0.3,0.1,0.5,0.2c0.3,0,0.7,0,1,0c0.3-0.1,0.5-0.2,0.8-0.4
		C368,91.6,367.5,91.3,365.4,91.5z"
      />
      <path
        class="st3"
        d="M348.2,80.7c0.2,0,0.4-0.1,0.5-0.1c0.1-1.5-0.5-2-2.6-2.2C346,80,346.6,80.6,348.2,80.7z"
      />
      <path
        class="st3"
        d="M342.8,97.7c-0.7,0.1-1.1,0.5-1.2,1.1c-0.1,0.9,0.7,1.2,1.6,1.3c0.1-0.1,0.2-0.2,0.3-0.2
		c0.9-0.7,1.1-1.1,0.8-1.6c-0.1-0.1-0.2-0.2-0.3-0.3C343.7,97.8,343.3,97.6,342.8,97.7z"
      />
      <path
        class="st3"
        d="M562.4,26.2c0.7-0.4,1.3-0.7,1.9-0.9c0.1-0.8-0.2-1.3-1.2-1.8c-0.1,1.1-2.1,0.7-2.2,2.1
		C561.4,25.8,561.9,26,562.4,26.2z"
      />
      <path
        class="st3"
        d="M445.2,68.9c0.6,0.1,1.4-0.2,2-0.4c0.1-0.8,0.1-1.5,0.2-2.3c-0.6,0.3-1.2,0.5-1.7,0.8
		c-0.6,0.2-1.1,0.5-1.7,0.7C444.4,68.2,444.7,68.8,445.2,68.9z"
      />
      <path
        class="st3"
        d="M429.9,82.6c0.4,0.5,0.7,0.8,1.1,1c0.5,0.3,1,0.3,1.5-0.1c0.6-0.4,0.7-1.3,0.2-1.8s-1.2-0.4-2.1,0.2
		C430.4,82.2,430.1,82.4,429.9,82.6z"
      />
      <path
        class="st3"
        d="M316.2,120.5c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C315.1,119.9,315.5,120.3,316.2,120.5z"
      />
      <path
        class="st3"
        d="M325.3,103.3c0.7-0.2,1.2-0.9,1.1-1.5s-0.9-1-1.6-0.8s-1.3,0.8-1.2,1.4c0,0.3,0.3,0.6,0.6,0.7
		c0.2,0.1,0.4,0.2,0.7,0.2C325,103.3,325.2,103.3,325.3,103.3z"
      />
      <path
        class="st3"
        d="M371.9,97.5c0.8,0.1,1.6,0.1,2.4,0.2c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.2c-0.5-1.5-1-1.7-2.9-1.6
		C371,96.6,371.4,97.1,371.9,97.5z"
      />
      <path
        class="st3"
        d="M568.1,14.1c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C568.8,13.4,568.5,13.7,568.1,14.1z"
      />
      <path
        class="st3"
        d="M415.8,70.3c-0.7,0.2-1.1,0.7-1,1.3c0.1,0.7,0.8,1,1.6,0.8c0.3-0.1,0.6-0.2,0.8-0.4c0.3-0.3,0.4-0.6,0.3-1
		c0-0.1-0.1-0.1-0.1-0.2C417.2,70.3,416.5,70.1,415.8,70.3z"
      />
      <path
        class="st3"
        d="M393,83.3c-0.1-0.6-0.8-1-1.6-0.8c-0.8,0.1-1.3,0.8-1.2,1.4c0.1,0.6,0.9,1,1.6,0.8
		C392.6,84.6,393.1,84,393,83.3z"
      />
      <path
        class="st3"
        d="M550.4,45c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.2-0.5-0.6-0.7-1.1-0.9v0.1c-0.5,0-1,0.1-1.5,0.1
		c-0.3,0-0.7,0-1,0c-0.1,0.1-0.3,0.2-0.3,0.4c0,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3C549.6,44.7,549.9,44.9,550.4,45z"
      />
      <path
        class="st3"
        d="M437.2,55.4c0.1,0,0.1-0.1,0.2-0.2c-0.5,0-1,0-1.5,0c0.2,0.2,0.4,0.3,0.8,0.5
		C436.9,55.6,437.1,55.5,437.2,55.4z"
      />
      <path
        class="st3"
        d="M436.2,53.4c-0.1,0.1-0.3,0.2-0.4,0.3c0.6,0,1.3,0,1.9,0c-0.2-0.1-0.3-0.2-0.5-0.3
		C436.9,53.2,436.6,53.3,436.2,53.4z"
      />
      <path
        class="st3"
        d="M509.3,39.9c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.6-0.9-1-1.6-0.8C509.7,38.7,509.1,39.4,509.3,39.9z"
      />
      <path
        class="st3"
        d="M513.4,43.8c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.2-0.3,0.4-0.5,0.5-0.7c-0.8,0-1.6,0-2.4,0
		C512.6,43.5,512.9,43.6,513.4,43.8z"
      />
      <path
        class="st3"
        d="M514.6,42L514.6,42c-0.4-0.3-0.9-0.4-1.4-0.2h-0.1c-0.3,0.1-0.5,0.3-0.6,0.6c0.8,0,1.6,0,2.5,0
		C514.9,42.3,514.8,42.1,514.6,42z"
      />
      <path
        class="st3"
        d="M417.1,43c0-0.1-0.1-0.1-0.1-0.2c-0.4,0.5-0.8,1.1-1.2,1.6c0.1,0,0.3,0,0.4,0C416.9,44.2,417.3,43.6,417.1,43z
		"
      />
      <path
        class="st3"
        d="M414.6,43.5c0.3-0.4,0.6-0.7,0.8-1.1C414.9,42.6,414.6,43,414.6,43.5z"
      />
      <path
        class="st3"
        d="M568.9,12.5c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C567.5,12.4,568.2,12.7,568.9,12.5z"
      />
      <path
        class="st3"
        d="M322.2,108.1c0.6-0.1,1.2-0.8,1-1.3c-0.1-0.5-0.7-0.8-1.4-0.7c-0.7,0.1-1.2,0.7-1.1,1.2
		C320.9,107.8,321.6,108.2,322.2,108.1z"
      />
      <path
        class="st3"
        d="M419.2,55.1c0-0.1-0.1-0.1-0.1-0.2c-0.7,0-1.5,0-2.2,0c-0.1,0.1-0.2,0.2-0.2,0.3s0,0.2,0,0.3
		c0.8,0,1.7,0,2.5,0C419.2,55.4,419.2,55.3,419.2,55.1z"
      />
      <path
        class="st3"
        d="M332.7,43.5c0.7-0.1,1.2-0.7,1.1-1.3s-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C331.3,43.2,332,43.6,332.7,43.5z"
      />
      <path
        class="st3"
        d="M446.9,58.9c-0.1-0.5-0.3-1-0.6-1.4c-0.5,0-1,0-1.6,0c-0.2,0.2-0.3,0.4-0.3,0.7c0.5,0.5,1,0.9,1.5,1.5
		C446.6,59.6,447.1,59.4,446.9,58.9z"
      />
      <path
        class="st3"
        d="M452.3,68c0.1-0.5,0.1-1.1-0.4-1.5c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1
		c0,0.4,0.1,0.8,0.7,0.9C451.1,68.2,451.7,68.1,452.3,68z"
      />
      <path
        class="st3"
        d="M406.7,30.6c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C405.4,30.3,406.1,30.7,406.7,30.6z"
      />
      <path
        class="st3"
        d="M551.2,66c0.5-0.1,1-0.7,0.9-1.1c0-0.1,0-0.1-0.1-0.2s-0.2-0.3-0.3-0.4c-0.6,0-1.2,0-1.9-0.1
		c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.2,0.1,0.4,0.3,0.6C550.3,65.8,550.7,66.1,551.2,66z"
      />
      <path
        class="st3"
        d="M382.8,54.3c0.3,0.3,0.7,0.5,1.2,0.4c0.3-0.1,0.5-0.2,0.7-0.4c-0.3,0-0.6,0-1,0
		C383.4,54.4,383.1,54.4,382.8,54.3z"
      />
      <path
        class="st3"
        d="M384.6,52.9c-0.2-0.1-0.5-0.2-0.9-0.1c-0.1,0-0.2,0.1-0.2,0.1C383.9,52.9,384.2,52.9,384.6,52.9z"
      />
      <path
        class="st3"
        d="M514.8,40.7c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C513.8,40.6,514.4,40.8,514.8,40.7z"
      />
      <path
        class="st3"
        d="M454.1,69.3c0.2,0.4,0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2c-0.3-0.2-0.6-0.3-0.9-0.5
		c-0.2,0.3-0.5,0.6-0.7,1C453.8,68.9,454,69,454.1,69.3z"
      />
      <path
        class="st3"
        d="M390.7,110.3c0.3-0.3,0.7-0.7,0.9-1.1c0.1-0.3,0-0.7-0.2-0.9c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.1-0.9,0l-0.1,0.1
		c-0.4,0.3-0.8,0.7-0.9,1.2C389.2,110.1,389.9,110.2,390.7,110.3z"
      />
      <path
        class="st3"
        d="M329.9,62.7c0,0.2-0.1,0.4-0.1,0.6c0.3-0.2,0.5-0.4,0.7-0.6C330.4,62.7,330.1,62.7,329.9,62.7z"
      />
      <path
        class="st3"
        d="M330.3,59.8c-0.1,0.5-0.1,1-0.2,1.4c0.4,0,0.8,0,1.2,0C331.3,60.8,331,60.3,330.3,59.8z"
      />
      <path
        class="st3"
        d="M544.5,65.6c0.4,0.6,0.7,1.2,1.5,1.3c0.3,0.1,0.7-0.2,1.1-0.3C546.3,64.9,546.2,64.9,544.5,65.6z"
      />
      <path
        class="st3"
        d="M444.1,82.6c-0.1,0-0.2,0-0.3,0c-0.3,0.4-0.6,0.8-0.9,1.2c0.1,0.2,0.3,0.5,0.6,0.5c0.7,0.2,1.2-0.1,1.9-1.4
		c-0.2-0.1-0.4-0.1-0.6-0.2C444.5,82.6,444.3,82.6,444.1,82.6z"
      />
      <path
        class="st3"
        d="M309,117.4c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C309,117.3,309,117.4,309,117.4z"
      />
      <path
        class="st3"
        d="M354.7,86.5c-0.2-0.8-0.3-1.1-0.8-1.4c-0.5,0-0.9,0-1.4,0C352.7,86.4,353.3,86.8,354.7,86.5z"
      />
      <path
        class="st3"
        d="M552.8,3.5c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C551.8,3.2,552.3,3.6,552.8,3.5z"
      />
      <path
        class="st3"
        d="M442.2,36c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2C440.7,36,441.5,35.9,442.2,36z"
      />
      <path
        class="st3"
        d="M435.1,34.1c0.1,0.5,0.7,0.9,1.2,0.8c0.5-0.1,0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C435.3,32.9,435,33.6,435.1,34.1z"
      />
      <path
        class="st3"
        d="M388.6,104.3c-1.6,1.4-1.6,1.4-0.7,2.4C389.7,105.3,389.7,105.3,388.6,104.3z"
      />
      <path
        class="st3"
        d="M486.5,37.9c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C487.2,38.7,487.2,38.3,486.5,37.9z"
      />
      <path
        class="st3"
        d="M517.6,40.1c-0.8,0.2-1.3,0.6-1.5,1.5c1.2-0.2,2.3-0.2,3.3-0.7C519,40.2,518.4,39.9,517.6,40.1z"
      />
      <path
        class="st3"
        d="M397.9,97.3c0.2,0,0.4-0.1,0.6-0.3c-0.5,0-1-0.1-1.6-0.1c0.1,0.1,0.1,0.1,0.2,0.2
		C397.3,97.3,397.6,97.4,397.9,97.3z"
      />
      <path
        class="st3"
        d="M397.7,95.6c0.2,0,0.5,0,0.7,0.1c-0.2-0.1-0.4-0.1-0.6-0.1C397.7,95.5,397.7,95.5,397.7,95.6z"
      />
      <path
        class="st3"
        d="M595.4,44.6c-0.6,0.1-1.1,0.6-1,1.1c0.1,0.4,0.7,0.7,1.2,0.6c0.5-0.1,0.9-0.6,0.9-1.1
		C596.5,44.9,595.9,44.5,595.4,44.6z"
      />
      <path
        class="st3"
        d="M565.3,16.8c0.7-0.3,1-0.8,0.9-1.5c-1.1,0-2,0.2-2.6,1.1C564.1,16.9,564.7,17,565.3,16.8z"
      />
      <path
        class="st3"
        d="M400.6,89.7c0.7-0.6,0.5-0.9-0.9-1.5c-1.1,1.1-1.1,1.3,0,2c0.2-0.1,0.3-0.2,0.4-0.2
		C400.3,89.9,400.5,89.8,400.6,89.7z"
      />
      <path
        class="st3"
        d="M570.3,21c-0.1-0.5-0.8-0.8-1.4-0.6c-0.5,0.2-0.9,0.7-0.7,1.2c0.1,0.4,0.7,0.7,1.3,0.6
		C570,22,570.4,21.5,570.3,21z"
      />
      <path
        class="st3"
        d="M345.6,61.4c-0.1-0.9-0.7-1.4-1.9-1.6C343.3,61.5,343.8,62,345.6,61.4z"
      />
      <path
        class="st3"
        d="M494.6,42.2c0-0.1,0-0.2,0-0.3c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-0.9,0.4-0.9,0.8c0.2,0,0.3,0,0.5,0
		C493.6,42.2,494.1,42.2,494.6,42.2z"
      />
      <path
        class="st3"
        d="M493.8,42.9c-0.1,0-0.3,0-0.4,0C493.5,43,493.6,43,493.8,42.9C493.8,43,493.8,42.9,493.8,42.9z"
      />
      <path
        class="st3"
        d="M484.6,46.6c0.3-0.3,0.6-0.7,0.9-1c0-0.1,0-0.3-0.1-0.4l-0.1-0.1c-0.2,0-0.6,0-0.8,0c-0.5,0.2-0.9,0.5-1.4,0.9
		c0.4,0.3,0.7,0.5,1,0.6C484.2,46.6,484.4,46.6,484.6,46.6z"
      />
      <path
        class="st3"
        d="M507.5,35.8c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C507.9,34.7,507.4,35.3,507.5,35.8z"
      />
      <path
        class="st3"
        d="M493,54.5c0.2-0.7,0.1-1.4-1-2.1c0,0.8-0.3,1.4-0.2,2.1C492.2,54.5,492.6,54.5,493,54.5z"
      />
      <path
        class="st3"
        d="M393.5,77c-0.1-0.4-0.7-0.7-1.2-0.6s-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6C393.1,78.1,393.6,77.4,393.5,77z"
      />
      <path
        class="st3"
        d="M567.7,50c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C568.2,50.6,568,50.3,567.7,50z"
      />
      <path
        class="st3"
        d="M356.7,90.9c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C357,90.6,356.8,90.8,356.7,90.9z"
      />
      <path
        class="st3"
        d="M585,53.7c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C584.6,53.6,584.8,53.7,585,53.7z"
      />
      <path
        class="st3"
        d="M476.2,34.4c-0.2-0.9-0.8-1.4-2.1-1.1C474.6,34.8,474.9,34.9,476.2,34.4z"
      />
      <path
        class="st3"
        d="M482.4,62.8c0.1,0.5,0.3,0.7,0.4,0.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1
		v-0.1c-0.4,0-0.9,0-1.3,0C482.7,62.6,482.6,62.7,482.4,62.8z"
      />
      <path
        class="st3"
        d="M413.4,36.4c-1.3,0.9-1.3,0.9-0.8,2C414.2,37.3,414.2,37.3,413.4,36.4z"
      />
      <path
        class="st3"
        d="M454.7,67.3c0.3,0.3,0.7,0.4,1.1,0.1c0.5-0.3,0.7-0.7,0.6-1.4c-0.3,0.1-0.6,0.1-0.9,0.2
		C455.2,66.5,454.9,66.9,454.7,67.3z"
      />
      <path
        class="st3"
        d="M421.1,43.6c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C419.3,44,419.9,44,421.1,43.6z"
      />
      <path
        class="st3"
        d="M592.7,66.6c0.1-0.6-0.2-0.9-1.1-1c-0.2,0.6-0.4,1.2-0.7,2.2C592,67.5,592.6,67.2,592.7,66.6z"
      />
      <path
        class="st3"
        d="M552.4,14.9c0.3-0.5,0.7-0.8,0.7-1.2s-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C551.5,14.5,551.9,14.6,552.4,14.9z"
      />
      <path
        class="st3"
        d="M570.8,50c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3s0.3,0.2,0.4,0.3c0.6-0.6,0.9,0.3,1.4,0.1
		c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2C570.9,50,570.9,50,570.8,50z"
      />
      <path
        class="st3"
        d="M553.3,39.5c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C552.6,39.7,553.2,39.6,553.3,39.5z"
      />
      <path
        class="st3"
        d="M435.6,62.5c0.3-0.1,0.7-0.5,0.8-0.7c0-0.1,0-0.3-0.1-0.4c-0.4,0-0.8,0-1.2,0c-0.1,0.1-0.3,0.3-0.3,0.5
		C434.5,62.2,435.1,62.7,435.6,62.5z"
      />
      <path
        class="st3"
        d="M307.3,106.1c0.1-0.1,0.1-0.3,0.1-0.4c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1s0,0,0,0.1v1.2
		c0.2,0.1,0.5,0.3,0.7,0.5C307.1,106.6,307.2,106.3,307.3,106.1z"
      />
      <path
        class="st3"
        d="M434.8,21.6c0.5-1.1,0.5-1.1-0.8-1.8C433.7,21.2,433.7,21.2,434.8,21.6z"
      />
      <path
        class="st3"
        d="M308.3,53.6c-0.1,0-0.2,0.1-0.2,0.2c0.4,0,0.8,0,1.2,0C309,53.6,308.7,53.4,308.3,53.6z"
      />
      <path
        class="st3"
        d="M492.8,47.8c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C492.4,46.9,492.2,47.4,492.8,47.8z"
      />
      <path
        class="st3"
        d="M557.6,48.4c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C558.3,49.2,557.9,48.8,557.6,48.4z"
      />
      <path
        class="st3"
        d="M583.5,58.1c-0.7-0.2-1.1-0.2-1.3,0C582.6,58,583,58.1,583.5,58.1z"
      />
      <path
        class="st3"
        d="M444.6,30.2c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9S444.3,30,444.6,30.2z"
      />
      <path
        class="st3"
        d="M581.3,72.4c-0.2,0.3-0.5,0.6-0.6,0.9c0,0.1,0.2,0.2,0.4,0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1
		c0.5-0.1,1.1,0,1.4-0.7C582.5,72.5,581.9,72.4,581.3,72.4z"
      />
      <path
        class="st3"
        d="M581.4,73.6C581.3,73.6,581.3,73.6,581.4,73.6C581.3,73.6,581.3,73.7,581.4,73.6
		C581.3,73.7,581.4,73.7,581.4,73.6C581.4,73.6,581.3,73.6,581.4,73.6C581.3,73.6,581.3,73.6,581.4,73.6L581.4,73.6z"
      />
      <path
        class="st3"
        d="M362.4,88c-0.5-0.6-1-1-1.9-1C360.4,88.5,360.8,88.6,362.4,88z"
      />
      <path
        class="st3"
        d="M425.4,39.5c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C423.9,39.1,424.5,39.3,425.4,39.5z"
      />
      <path
        class="st3"
        d="M484.6,42.1c0.5,0,0.9,0,1.4,0c0.2-0.3,0.3-0.5,0.2-0.7c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5
		c0,0.1,0,0.2,0,0.2C484.4,41.9,484.5,42,484.6,42.1z"
      />
      <path
        class="st3"
        d="M483.7,50.9c0.2-0.3,0.4-0.5,0-0.8c0,0-0.1,0-0.1-0.1c-0.3,0.4-0.6,0.7-1,1.1c0.2,0.1,0.3,0.2,0.5,0.4
		C483.3,51.3,483.6,51.1,483.7,50.9z"
      />
      <path
        class="st3"
        d="M434.2,50.2c-0.2-0.2-0.5-0.3-0.7-0.3c-0.4,0-0.8,0.2-1.3,0.3c0.3,0.2,0.5,0.5,0.7,0.6c0.1,0,0.1,0.1,0.2,0.1
		c0.2,0.1,0.7,0,1-0.2C434.2,50.8,434.4,50.4,434.2,50.2C434.3,50.3,434.2,50.3,434.2,50.2z"
      />
      <path
        class="st3"
        d="M565.7,31c0,0.2,0.5,0.6,0.8,0.6s0.6-0.4,1.1-0.8c-0.5-0.2-0.9-0.6-1.2-0.5C566.1,30.4,565.7,30.8,565.7,31z"
      />
      <path
        class="st3"
        d="M435.6,37.3c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0
		c-0.2,0.1-0.2,0.6-0.1,0.8C434.8,36.8,435.2,37,435.6,37.3z"
      />
      <path
        class="st3"
        d="M587.7,61.8c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C588.4,61.2,587.8,61.2,587.7,61.8z"
      />
      <path
        class="st3"
        d="M559.4,48.5L559.4,48.5c-0.4,1,0.1,1.3,1.9,1C561,48.7,559.9,49.1,559.4,48.5L559.4,48.5z"
      />
      <path
        class="st3"
        d="M319.4,98.4c1-1,0.8-1.3-0.7-1.4C318.6,97.6,318.8,98.1,319.4,98.4z"
      />
      <path
        class="st3"
        d="M427.8,33.2c0.3-1.1,0.3-1.1-1.3-1.4C426.6,32.5,426.8,33,427.8,33.2z"
      />
      <path
        class="st3"
        d="M572.9,52.2L572.9,52.2c0.2,0.2,0.7,0.3,0.9,0.2c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C572.1,51.5,572.5,51.9,572.9,52.2z"
      />
      <path
        class="st3"
        d="M538.1,11.7c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C537.7,12.1,538.1,11.9,538.1,11.7z"
      />
      <path
        class="st3"
        d="M307.1,85.5c-0.3,0.6-0.5,1-0.4,1.2c0.4,0,0.8,0,1.2,0C308,86.1,307.9,85.7,307.1,85.5z"
      />
      <path
        class="st3"
        d="M330.4,87.6c0.1,0,0.2,0,0.4,0c0.2-0.3,0.4-0.5,0.4-0.7c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8
		C329.9,87.4,330.1,87.5,330.4,87.6z"
      />
      <path
        class="st3"
        d="M380.7,106.4c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9C380,106,379.9,106.3,380.7,106.4z"
      />
      <path
        class="st3"
        d="M553.4,28.6c0.3-0.1,0.4-0.4,0.7-0.9c-0.5-0.1-0.9-0.3-1.2-0.2c-0.2,0.1-0.5,0.5-0.4,0.7
		C552.5,28.7,553,28.8,553.4,28.6z"
      />
      <path
        class="st3"
        d="M408,84.2c-0.2-0.1-0.5-0.1-0.8,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.6,0.7,0.7,1.4,0.2
		C408.4,84.6,408.3,84.3,408,84.2z"
      />
      <path
        class="st3"
        d="M430.9,53.2c0-0.1,0-0.3-0.1-0.4c-0.7-0.2-1.1,0-1.4,0.7c0.4,0,0.8,0,1.3,0C430.8,53.5,430.9,53.4,430.9,53.2z
		"
      />
      <path
        class="st3"
        d="M311.3,133.8c-0.4-0.2-0.7-0.5-0.9-0.4c-0.2,0.1-0.6,0.5-0.5,0.7c0,0.2,0.4,0.3,0.7,0.5
		C310.8,134.3,311,134.1,311.3,133.8z"
      />
      <path
        class="st3"
        d="M524.5,40.8c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.8-0.8c0,0-0.1,0-0.1-0.1c-0.4-0.2-0.7-0.4-1-0.4
		c-0.1,0-0.2,0.1-0.3,0.3c-0.1,0.1-0.2,0.3-0.1,0.3c0,0.1,0.1,0.1,0.2,0.2C524.4,40.7,524.4,40.7,524.5,40.8z"
      />
      <path
        class="st3"
        d="M460.6,32.6c0.4-0.5,0.8-0.9,0.2-1.4C459.8,32,459.8,32,460.6,32.6z"
      />
      <path
        class="st3"
        d="M471.8,50c0.2,0.1,0.4,0.2,0.6,0.3c0-0.4,0.1-0.7,0-1c-0.3,0-0.5,0-0.8,0c-0.2,0.3-0.3,0.5-0.1,0.6
		C471.6,49.9,471.7,50,471.8,50z"
      />
      <path
        class="st3"
        d="M440.1,72c0.3,0.1,0.7-0.1,1.1-0.1c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6
		C439.4,71.6,439.6,71.9,440.1,72z"
      />
      <path
        class="st3"
        d="M423.8,40.9c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C422.7,40.7,423,41.1,423.8,40.9z"
      />
      <path
        class="st3"
        d="M564.8,49.9c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5c0.3,0.5,0.5,0.9,0.7,1.3
		C564.7,49.7,564.7,49.8,564.8,49.9z"
      />
      <path
        class="st3"
        d="M509.6,50.2C509.6,50.1,509.6,50.1,509.6,50.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.4,0-0.7,0-1.1,0
		c0.1,0.1,0.1,0.2,0.2,0.3C508.6,50.2,508.9,50.2,509.6,50.2z"
      />
      <path
        class="st3"
        d="M551.7,40.8C551.7,40.8,551.6,40.8,551.7,40.8c-0.1,0-0.2,0-0.2,0.1c-0.2,0.4-0.2,0.6,0.1,0.8
		c0.2,0.1,0.4,0.3,0.8,0.5c0-0.3,0-0.5,0-0.7C552.2,41.3,552,41,551.7,40.8z"
      />
      <path
        class="st3"
        d="M481.9,45c-0.4,0.3-0.8,0.5-1.2,0.8c0.2,0.3,0.4,0.6,0.5,0.9c0.3-0.4,0.6-0.8,0.8-1.2
		C482.2,45.5,482,45.3,481.9,45z"
      />
      <path
        class="st3"
        d="M481.3,46.7L481.3,46.7C481.2,46.7,481.2,46.7,481.3,46.7C481.2,46.8,481.3,46.8,481.3,46.7L481.3,46.7z"
      />
      <path
        class="st3"
        d="M508.5,15.7c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C507.9,16.3,508.1,16.1,508.5,15.7z"
      />
      <path
        class="st3"
        d="M400.5,70.6c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C400,69.7,400,69.7,400.5,70.6z"
      />
      <path
        class="st3"
        d="M429.5,43.6c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C429.7,43.2,429.4,43.5,429.5,43.6z"
      />
      <path
        class="st3"
        d="M438.7,29.6c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4C438,29.1,438,29.5,438.7,29.6z
		"
      />
      <path
        class="st3"
        d="M429.7,74.5c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C430,73.9,429.7,74.4,429.7,74.5z"
      />
      <path
        class="st3"
        d="M555.3,45.3c-0.3-0.4-0.6-0.8-1.2-1.4c-0.1,0.6-0.3,0.9-0.2,1.1C554.2,45.3,554.4,45.8,555.3,45.3z"
      />
      <path
        class="st3"
        d="M339.1,101.7c0.2-0.4,0.1-0.7-0.2-1.1c-0.2,0.2-0.3,0.4-0.3,0.5c-0.2,0.3,0,0.4,0.4,0.9
		C339,101.9,339,101.8,339.1,101.7z"
      />
      <path
        class="st3"
        d="M371.8,91.1c0.2,0.3,0.6,0.4,1.2,0.4c0-0.2-0.1-0.4-0.2-0.5c-0.4,0-0.7,0-1.1-0.1
		C371.8,91,371.8,91.1,371.8,91.1z"
      />
      <path
        class="st3"
        d="M428.6,27.1c0.4-0.9-0.2-1.1-1-1.3C427.5,26.5,427.6,27.1,428.6,27.1z"
      />
      <path
        class="st3"
        d="M442.6,80.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.4,0-0.7-0.1-1-0.1C442,80,442.3,80.1,442.6,80.2z"
      />
      <path
        class="st3"
        d="M442.3,79.1c-0.1-0.2-0.3-0.4-0.4-0.6c-0.1,0.3-0.2,0.5-0.3,0.7C441.9,79.2,442.1,79.2,442.3,79.1z"
      />
      <path
        class="st3"
        d="M489.8,54.5c0.2,0,0.3,0,0.5,0c-0.1-0.1-0.2-0.1-0.3-0.2C489.9,54.4,489.9,54.4,489.8,54.5z"
      />
      <path
        class="st3"
        d="M579.8,65.8c0.1-0.3,0.2-0.5,0.2-0.7c-0.2,0-0.4,0-0.6,0C579.5,65.3,579.6,65.5,579.8,65.8z"
      />
      <path
        class="st3"
        d="M579,64.3c0.2,0,0.3,0,0.5,0c-0.2-0.1-0.4-0.1-0.6-0.2C578.9,64.2,578.9,64.3,579,64.3z"
      />
      <path
        class="st3"
        d="M592.1,52.1c-0.2-0.3-0.4-0.6-0.8-1.1C590.8,51.9,591.2,52.1,592.1,52.1z"
      />
      <path
        class="st3"
        d="M581,66.8c-0.4-0.1-0.7-0.2-0.9-0.2c-0.3,0.3-0.6,0.5-0.9,0.7c0.1,0.1,0.2,0.2,0.3,0.3
		C580.1,67.4,580.7,67.4,581,66.8z"
      />
      <path
        class="st3"
        d="M490.1,52.7c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4c0.3-0.3,0.4-0.6,0.6-0.8
		C490.6,52.9,490.2,52.6,490.1,52.7z"
      />
      <path
        class="st3"
        d="M330.6,109.7c0.6,0,0.9,0,1.2,0c0.1,0,0.2,0,0.2-0.1c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3
		c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2,0.2-0.4,0.4-0.7,0.7C331,109.3,330.8,109.5,330.6,109.7z"
      />
      <path
        class="st3"
        d="M441.7,57.4c-0.4,0-0.7,0-1.1,0l0,0C441,57.8,441.4,57.7,441.7,57.4z"
      />
      <path
        class="st3"
        d="M494.7,12.8c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C494,12.8,494.3,12.9,494.7,12.8z"
      />
      <path
        class="st3"
        d="M444.4,71.1c0.3,0,0.7,0,1,0.1c0-0.2,0.1-0.3,0.1-0.5c-0.3,0-0.7-0.1-1-0.1C444.5,70.7,444.5,70.9,444.4,71.1z
		"
      />
      <path
        class="st3"
        d="M436.7,42.7c-0.2,0.5-0.3,0.9,0.4,1c0.1,0,0.4-0.1,0.4-0.2C437.7,43,437.4,42.8,436.7,42.7z"
      />
      <path
        class="st3"
        d="M463.3,31.8c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C462.7,31.7,463.1,31.7,463.3,31.8z"
      />
      <path
        class="st3"
        d="M476.4,38.2c-0.4-0.1-0.7-0.2-0.8-0.2c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2C475.8,38.7,476.1,38.5,476.4,38.2z"
      />
      <path
        class="st3"
        d="M391.9,79.2c0.7,0.3,1.1,0.1,1.4-0.6C392.5,78.4,392.1,78.6,391.9,79.2z"
      />
      <path
        class="st3"
        d="M441.3,60.7c0.2-0.1,0.4-0.3,0.7-0.5c-0.3-0.1-0.6-0.3-0.7-0.3c-0.2,0.1-0.4,0.3-0.5,0.5
		C440.8,60.4,441.2,60.7,441.3,60.7z"
      />
      <path
        class="st3"
        d="M440.1,49.1c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0,0.4-0.1c0,0,0-0.1,0.1-0.1c-0.4,0-0.8,0-1.1,0
		C439.8,49,439.9,49,440.1,49.1z"
      />
      <path
        class="st3"
        d="M319.1,89.3c-0.1-0.3-0.1-0.5-0.2-0.7c-0.2,0-0.3,0-0.5,0C318.4,88.9,318.6,89.1,319.1,89.3z"
      />
      <path
        class="st3"
        d="M313.9,102.2c-0.1-0.7-0.2-1.1-0.2-1.5c-0.2,0-0.3,0-0.5,0.1C312.8,101.3,312.9,101.7,313.9,102.2z"
      />
      <path
        class="st3"
        d="M577,66.4c0.6,0.2,1,0.7,1.6-0.1C578.2,66,577.8,65.7,577,66.4z"
      />
      <path
        class="st3"
        d="M390.6,102.6L390.6,102.6c0.2-0.1,0.4-0.4,0.6-0.6c-0.4-0.1-0.7-0.2-0.8-0.1c-0.1,0.1-0.2,0.2-0.2,0.3
		c-0.1,0.1-0.1,0.2-0.2,0.3C390.2,102.5,390.5,102.7,390.6,102.6z"
      />
      <path
        class="st3"
        d="M393.9,98.8c-0.5,0.1-0.7,0.2-0.8,0.3c0.2,0,0.3,0,0.5,0C393.7,99,393.8,98.9,393.9,98.8z"
      />
      <path
        class="st3"
        d="M470.9,42.7c-0.3,0-0.5,0-0.8,0c0.1,0.2,0.1,0.3,0.2,0.5C470.6,42.9,470.8,42.8,470.9,42.7z"
      />
      <path
        class="st3"
        d="M477.1,51.2c-0.7,0.5-1,1-0.6,1.6C476.9,52.3,477.3,51.9,477.1,51.2z"
      />
      <path
        class="st3"
        d="M573.7,8.7c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C573.5,8.8,573.6,8.7,573.7,8.7z"
      />
      <path
        class="st3"
        d="M465.3,41.6c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C464.9,41.4,465.1,41.5,465.3,41.6z"
      />
      <path
        class="st3"
        d="M549,57.5c0.3,0,0.6,0,0.9,0c-0.1-0.2-0.3-0.4-0.4-0.6c-0.2,0-0.3,0-0.5,0C548.9,57.2,548.9,57.4,549,57.5z"
      />
      <path
        class="st3"
        d="M558.9,43.8c0.1-0.1,0.2-0.3,0.3-0.4c-0.2,0-0.5,0-0.7,0C558.6,43.5,558.7,43.6,558.9,43.8z"
      />
      <path
        class="st3"
        d="M559,42.8c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0,0.5,0,0.7,0C559.2,42.9,559.1,42.8,559,42.8z"
      />
      <path
        class="st3"
        d="M393.4,106.5c0-0.5-0.2-0.8-0.5-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1
		C392.7,106.1,393,106.3,393.4,106.5z"
      />
      <path
        class="st3"
        d="M437.4,58.5c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C436.9,58.2,437.1,58.3,437.4,58.5z"
      />
      <path
        class="st3"
        d="M571.1,37.1c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C570.8,37.1,571,37.1,571.1,37.1z"
      />
      <path
        class="st3"
        d="M480.5,48.2c0.2-0.5,0.5-0.9,0.7-1.4c-0.4,0.1-0.7,0.1-0.8,0.2c-0.1,0-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C480.5,48.1,480.5,48.1,480.5,48.2z"
      />
      <path
        class="st3"
        d="M542.1,63.4c0.4,0,0.8,0,1.1,0c-0.1-0.6-0.4-1.1-0.8-1.3c-0.4,0.4-0.9,0.7-1.3,1.2
		C541.6,63.3,541.9,63.4,542.1,63.4z"
      />
      <path
        class="st3"
        d="M541.6,64.4c0.4,0,0.7-0.2,1.1-0.3v0.1c0,0,0,0,0.1,0c0.4,0.7,0.5,0.7,1.3,0c-0.4,0-0.7,0-1.1,0
		c-0.8,0-1.4,0.1-2.1,0.2C541,64.4,541.3,64.4,541.6,64.4z"
      />
      <path
        class="st3"
        d="M339.4,104.1c0-0.2-0.3-0.3-0.7-0.5c-0.2,0.3-0.3,0.6-0.3,0.8c0,0.1,0.4,0.3,0.5,0.3
		C339.1,104.5,339.4,104.2,339.4,104.1z"
      />
      <path
        class="st3"
        d="M401.4,32.3c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C401.2,32.7,401.3,32.5,401.4,32.3z"
      />
      <path
        class="st3"
        d="M356.3,81.8c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3,0.3-0.6,0.5-0.8,0.8c0,0,0.1,0.2,0.3,0.4
		C355.8,82.4,356.1,82.1,356.3,81.8z"
      />
      <path
        class="st3"
        d="M333.5,105.5l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4s-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C333.1,106,333.3,105.7,333.5,105.5z"
      />
      <path
        class="st3"
        d="M553,48.3c0,0.8,0.8,0.6,1.2,0.8C554,48.6,553.7,48.2,553,48.3z"
      />
      <path
        class="st3"
        d="M411.4,65.5c0.2-0.8,0.2-1.2-0.7-1.2C410.9,64.7,411.1,65,411.4,65.5z"
      />
      <path
        class="st3"
        d="M547.3,63.2c0.3-0.2,0.5-0.4,0.8-0.6c0.3-0.2,0.5-0.4,0.8-0.6c-0.3,0-0.6,0-0.8,0.1
		C547.6,62.2,547.4,62.5,547.3,63.2z"
      />
      <path
        class="st3"
        d="M434.4,46.8L434.4,46.8c-0.1,0-0.1,0.1-0.1,0.1C434.3,46.9,434.4,46.9,434.4,46.8
		C434.4,46.9,434.4,46.8,434.4,46.8z"
      />
      <path
        class="st3"
        d="M434.4,46.8c0.6-0.1,1.1-0.2,1.7-0.4C435.3,46,435.3,46,434.4,46.8z"
      />
      <path
        class="st3"
        d="M381.7,100.4c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.2,0.4c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3
		c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4c-0.2,0.1-0.3,0.1-0.4,0.2C381.9,100.1,381.8,100.2,381.7,100.4z"
      />
      <path
        class="st3"
        d="M417,79.9c-0.1,0.1-0.2,0.3-0.3,0.4c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.6-0.3,0.9-0.5
		c-0.1-0.1-0.1-0.2-0.2-0.3C417.4,79.8,417.1,79.8,417,79.9z"
      />
      <path
        class="st3"
        d="M335,108.9c0.5-0.1,0.7-0.3,0.6-0.8c0-0.1-0.4-0.2-0.4-0.1C334.7,108.3,334.6,108.6,335,108.9z"
      />
      <path
        class="st3"
        d="M568.4,48c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C569,48.6,568.8,48.4,568.4,48z"
      />
      <path
        class="st3"
        d="M475,47.2c-0.2-0.1-0.3-0.1-0.4-0.1c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1
		c0.2-0.1,0.4-0.3,0.7-0.6C475.3,47.3,475.2,47.2,475,47.2z"
      />
      <path
        class="st3"
        d="M481.6,61.1C481.7,61.1,481.7,61.1,481.6,61.1c0.1,0,0.1,0,0.1,0S481.7,61,481.6,61.1
		C481.7,61,481.7,61,481.6,61.1z"
      />
      <path
        class="st3"
        d="M482.6,61.7c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.6-0.7-0.3-1.1-0.3C481.8,61.5,481.9,61.8,482.6,61.7z"
      />
      <path
        class="st3"
        d="M483.7,60.7c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6c-0.3-0.1-0.4-0.2-0.5-0.2
		C483.9,60.2,483.8,60.5,483.7,60.7z"
      />
      <path
        class="st3"
        d="M369.9,108.5c0.3,0.3,0.7,0.6,1,1c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.3-0.6-0.6-0.9-1
		C370.1,108.3,370,108.4,369.9,108.5z"
      />
      <path
        class="st3"
        d="M539.7,60.4c-0.1,0.5,0.3,0.8,0.9,1.1c0,0,0,0,0.1,0C540.6,60.7,540.4,60.5,539.7,60.4z"
      />
      <path
        class="st3"
        d="M432.6,21.4c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C432.4,21.5,432.5,21.5,432.6,21.4z"
      />
      <path
        class="st3"
        d="M385.7,112.2c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C385,112.4,385.5,112.7,385.7,112.2z"
      />
      <path
        class="st3"
        d="M558.3,34.8c0.3,0.5,0.5,0.8,0.7,1.1c0.1-0.1,0.3-0.2,0.4-0.2C559.3,35.2,559.3,34.8,558.3,34.8z"
      />
      <path
        class="st3"
        d="M381.8,110.2c0.3,0.2,0.7,0.4,1,0c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2s-0.5,0.1-0.8,0.1
		C381.6,110.1,381.7,110.1,381.8,110.2z"
      />
      <path
        class="st3"
        d="M573.8,46c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0C573.7,46.6,573.8,46.3,573.8,46z"
      />
      <path
        class="st3"
        d="M557.2,51.5c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C556.9,50.9,557,51.2,557.2,51.5z"
      />
      <path
        class="st3"
        d="M436.3,47.8c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C436.4,47.4,436.3,47.6,436.3,47.8z"
      />
      <path
        class="st3"
        d="M448.7,61.8c-0.1-0.1-0.1-0.1-0.2-0.1c-0.3,0-0.6,0-0.8,0C447.8,62,448.1,62,448.7,61.8z"
      />
      <path
        class="st3"
        d="M473.7,44.5c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C473.4,44.8,473.5,44.6,473.7,44.5z"
      />
      <path
        class="st3"
        d="M420.5,39c0.4,0.2,0.7,0.4,1.2,0.7C421.6,38.8,421.2,38.7,420.5,39z"
      />
      <path
        class="st3"
        d="M484.4,20.9c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C483.8,21.3,484.1,21.3,484.4,20.9z"
      />
      <path
        class="st3"
        d="M523.7,50.5c0.1-0.2,0.3-0.3,0.4-0.5c-0.2,0-0.3,0-0.5,0c-0.1,0.1-0.2,0.2-0.3,0.3
		C523.4,50.4,523.6,50.4,523.7,50.5z"
      />
      <path
        class="st3"
        d="M441.6,64.7C441.6,64.7,441.7,64.7,441.6,64.7c0.3,0,0.5-0.2,0.6-0.3l0,0c0-0.1-0.2-0.2-0.4-0.4
		c-0.2,0.2-0.4,0.4-0.5,0.5C441.3,64.5,441.5,64.7,441.6,64.7z"
      />
      <path
        class="st3"
        d="M533.8,63.9c-0.2,0-0.3,0-0.5,0C533.4,64,533.6,64,533.8,63.9C533.7,64,533.7,64,533.8,63.9z"
      />
      <path
        class="st3"
        d="M465.2,76.1c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1-0.2-0.2-0.5-0.5c-0.1,0.4-0.3,0.6-0.2,0.7
		C464.8,76,465,76,465.2,76.1z"
      />
      <path
        class="st3"
        d="M408.2,88.7c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0-0.2,0-0.3,0C407.5,88.5,407.6,88.5,408.2,88.7z"
      />
      <path
        class="st3"
        d="M479.8,47c0-0.4,0-0.8,0.1-1.2c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.2C479.6,47,479.7,47,479.8,47z"
      />
      <path
        class="st3"
        d="M553,30.7c-0.2-0.3-0.5-0.5-0.8-1C552.1,30.4,552.3,30.7,553,30.7z"
      />
      <path
        class="st3"
        d="M553.2,41.8c0,0,0.1,0.2,0.2,0.3c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2
		C553.6,41.5,553.4,41.6,553.2,41.8z"
      />
      <path
        class="st3"
        d="M442.9,65.7c0,0,0-0.2,0-0.3c-0.3,0.1-0.6,0.1-0.9,0.2c0,0.1,0.1,0.2,0.1,0.3
		C442.4,65.9,442.6,65.8,442.9,65.7z"
      />
      <path
        class="st3"
        d="M486.1,58.1C486.2,58.1,486.2,58.1,486.1,58.1s-0.3,0-0.5-0.1c0.1,0.1,0.2,0.2,0.3,0.2
		C486,58.2,486.1,58.1,486.1,58.1z"
      />
      <path
        class="st3"
        d="M585.7,48.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0.1,0.1
		C585.4,48.2,585.5,48.4,585.7,48.6z"
      />
      <path
        class="st3"
        d="M447.9,59c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C447.6,58.9,447.7,59.1,447.9,59z"
      />
      <path
        class="st3"
        d="M576.7,0.6c-0.1-0.2-0.3-0.4-0.4-0.6H576l0,0c0.2,0.2,0.3,0.5,0.5,0.7C576.6,0.7,576.7,0.6,576.7,0.6z"
      />
      <path
        class="st3"
        d="M386.9,99.5L386.9,99.5c-0.1,0-0.2,0-0.2,0c0,0.1,0,0.1,0.1,0.2c0.1,0.2,0.2,0.4,0.2,0.6
		c0.1,0,0.2-0.1,0.3-0.1h0.1c0-0.1-0.1-0.1-0.1-0.2C387.1,99.8,387,99.7,386.9,99.5z"
      />
      <path
        class="st3"
        d="M538.5,70.4c-0.7-0.3-1.1-0.4-1.5-0.6C537.1,70.3,537.5,70.6,538.5,70.4z"
      />
      <path
        class="st3"
        d="M537.1,69.8C537,69.8,537,69.7,537.1,69.8C537,69.7,537,69.7,537.1,69.8C537,69.8,537,69.8,537.1,69.8
		C537,69.8,537,69.8,537.1,69.8z"
      />
      <path
        class="st3"
        d="M451,35.9c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8C450.7,35.9,450.8,35.9,451,35.9z"
      />
      <path
        class="st3"
        d="M430.1,30.7c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5
		C430,30.9,430.2,30.8,430.1,30.7z"
      />
      <path
        class="st3"
        d="M433.2,27c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C432.9,27.1,433.2,27,433.2,27z"
      />
      <path
        class="st3"
        d="M543.2,64.9c-0.5,0.3-0.8,0.5-1.3,0.8C542.8,65.6,542.8,65.6,543.2,64.9z"
      />
      <path
        class="st3"
        d="M339.5,93.4c-0.1,0-0.2,0-0.4,0c0,0.1-0.1,0.3-0.1,0.4c0.2,0,0.3,0,0.5,0C339.5,93.7,339.5,93.6,339.5,93.4z"
      />
      <path
        class="st3"
        d="M389.1,98.8c0.1-0.2,0.2-0.4,0.3-0.5c-0.1,0-0.2-0.1-0.2-0.1c-0.2,0.2-0.3,0.4-0.5,0.6
		C388.8,98.7,388.9,98.8,389.1,98.8z"
      />
      <path
        class="st3"
        d="M333.9,95L333.9,95c-0.1-0.1-0.3-0.1-0.4-0.1V95C333.6,95,333.8,95,333.9,95z"
      />
      <path
        class="st3"
        d="M495.3,46.1c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.2-0.1-0.4-0.2-0.5-0.2
		C495.5,45.8,495.4,45.9,495.3,46.1z"
      />
      <path
        class="st3"
        d="M433.5,22.7c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C433,22.5,433.3,22.6,433.5,22.7z"
      />
      <path
        class="st3"
        d="M539.7,77.3c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4c0.1,0.1,0.2,0.3,0.2,0.3
		C539.2,77.6,539.5,77.5,539.7,77.3z"
      />
      <path
        class="st3"
        d="M557.5,73.4c0.6-0.3,1-0.5,1.4-0.6C558.3,72.6,557.8,72.6,557.5,73.4z"
      />
      <path
        class="st3"
        d="M538.4,66.3c0.3-0.1,0.7-0.1,1-0.2V66C539.1,66.1,538.7,66.1,538.4,66.3C538.4,66.2,538.4,66.2,538.4,66.3z"
      />
      <path
        class="st3"
        d="M469.9,36.4c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C469.7,36.7,469.8,36.5,469.9,36.4z"
      />
      <path
        class="st3"
        d="M462.1,8.8c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3C461.8,8.7,462,8.8,462.1,8.8z"
      />
      <path
        class="st3"
        d="M596,40.6c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.2,0,0.3,0C595.7,41.1,595.8,40.8,596,40.6z"
      />
      <path
        class="st3"
        d="M502.3,1.3c0.1-0.2,0.2-0.3,0.3-0.5c0,0-0.1-0.1-0.3-0.2c-0.1,0.2-0.2,0.3-0.3,0.5
		C501.9,1.1,502.2,1.2,502.3,1.3z"
      />
      <path
        class="st3"
        d="M477.4,44.4c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C477.1,44.9,477.2,44.6,477.4,44.4z"
      />
      <path
        class="st3"
        d="M453.7,57.6c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.2-0.2-0.3-0.3
		C453.8,57.6,453.8,57.6,453.7,57.6z"
      />
      <path
        class="st3"
        d="M459.7,37.3c0.1,0,0.3-0.2,0.3-0.3s-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1c0.2,0,0.3,0.1,0.4,0.1
		C459.7,37.3,459.7,37.3,459.7,37.3z"
      />
      <path
        class="st3"
        d="M433.9,30.1c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C433.9,29.9,433.8,30,433.9,30.1z"
      />
      <path
        class="st3"
        d="M610.7,15.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C610.6,15.7,610.7,15.7,610.7,15.7z"
      />
      <path
        class="st3"
        d="M550,38.7c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.2-0.1-0.3-0.1s-0.1-0.1-0.2-0.1v0.1c-0.1,0.1-0.1,0.2-0.1,0.3
		C549.7,38.6,549.9,38.7,550,38.7z"
      />
      <path
        class="st3"
        d="M578.1,60.9c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.3,0.5,0.5,0.7c0.1-0.1,0.2-0.1,0.3-0.2
		C578.5,61.3,578.3,61.1,578.1,60.9z"
      />
      <path
        class="st3"
        d="M440.3,29.6c-0.1-0.3-0.1-0.7-0.7-0.7C439.7,29.2,439.6,29.6,440.3,29.6z"
      />
      <path
        class="st3"
        d="M569.4,35c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C569.5,35.5,569.5,35.3,569.4,35C569.5,35,569.5,35,569.4,35C569.5,35,569.4,35,569.4,35z"
      />
      <path
        class="st3"
        d="M435,48L435,48c-0.1-0.1-0.1-0.1-0.1-0.1C434.9,48,434.9,48,435,48L435,48z"
      />
      <path
        class="st3"
        d="M389.6,74.8c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2
		C389.4,75,389.6,74.8,389.6,74.8z"
      />
      <path
        class="st3"
        d="M388.2,102.4c-0.1,0.1-0.1,0.1-0.2,0.2l0.1,0.1c0.2,0.2,0.3,0.3,0.5,0.5c0.1-0.1,0.2-0.2,0.3-0.2
		c-0.2-0.1-0.3-0.3-0.5-0.4C388.4,102.4,388.3,102.4,388.2,102.4z"
      />
      <path
        class="st3"
        d="M383.7,42c-0.2-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0.1,0.2,0.3,0.4,0.3
		C383.2,42.3,383.4,42.1,383.7,42z"
      />
      <path
        class="st3"
        d="M518.4,14c0.1-0.2,0.2-0.3,0.2-0.4c0-0.1-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C518,13.8,518.2,13.8,518.4,14z"
      />
      <path
        class="st3"
        d="M580.5,51.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3
		c0.1,0,0.1,0.1,0.2,0.1C580.1,51.5,580.3,51.4,580.5,51.2L580.5,51.2z"
      />
      <path
        class="st3"
        d="M452.3,63c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.1-0.2,0.2-0.2,0.3s0.2,0.2,0.4,0.4C452.2,63.2,452.4,63.1,452.3,63z"
      />
      <path
        class="st3"
        d="M467.2,27.5c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c0,0-0.2,0.2-0.1,0.2
		C466.9,27.3,467,27.4,467.2,27.5z"
      />
      <path
        class="st3"
        d="M382.4,106.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.2,0.2
		C382.2,106.9,382.3,106.8,382.4,106.7z"
      />
      <path
        class="st3"
        d="M531.5,47.1C531.6,47.1,531.6,47.1,531.5,47.1c-0.1-0.1-0.4-0.2-0.6-0.4c0,0.1,0.1,0.2,0.2,0.3
		C531.2,47,531.4,47.1,531.5,47.1z"
      />
      <path
        class="st3"
        d="M561.3,17.5c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C561.2,17.7,561.3,17.6,561.3,17.5z
		"
      />
      <path
        class="st3"
        d="M477.5,24.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C477.3,24.6,477.4,24.6,477.5,24.5z"
      />
      <path
        class="st3"
        d="M530.9,46.7L530.9,46.7c-0.1-0.1-0.1-0.1-0.2-0.1C530.8,46.6,530.8,46.6,530.9,46.7L530.9,46.7z"
      />
      <path
        class="st3"
        d="M530.2,46.2c0,0.1-0.1,0.2-0.1,0.3c0.2,0,0.5,0.1,0.7,0.1C530.6,46.5,530.4,46.3,530.2,46.2z"
      />
      <path
        class="st3"
        d="M464.7,28.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C464.5,29,464.6,28.9,464.7,28.8z"
      />
      <path
        class="st3"
        d="M384.6,107.1l0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0.1-0.1,0.1-0.2,0.2C384.4,107,384.5,107,384.6,107.1z"
      />
      <path
        class="st3"
        d="M537.2,9.4c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C537.3,9.3,537.2,9.4,537.2,9.4z"
      />
      <path
        class="st3"
        d="M537.3,9.7v0.1l0,0C537.3,9.8,537.3,9.8,537.3,9.7C537.4,9.8,537.4,9.8,537.3,9.7z"
      />
      <path
        class="st3"
        d="M432.6,36.5c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C432.4,36.3,432.5,36.4,432.6,36.5z"
      />
      <path
        class="st3"
        d="M541.9,42.6c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2c0,0,0,0.1,0.1,0.1s0.1,0,0.2,0
		C541.6,42.7,541.8,42.6,541.9,42.6z"
      />
      <path
        class="st3"
        d="M576.2,63.1c0,0.4,0.1,0.7,0.1,0.9C576.8,63.8,576.4,63.5,576.2,63.1z"
      />
      <path
        class="st3"
        d="M573.9,50.6c-0.1,0,0,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0c0.1-0.1,0.1-0.2,0.1-0.2C574.1,50.6,574,50.5,573.9,50.6z
		"
      />
      <path
        class="st3"
        d="M331.5,105.5c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2s0.2-0.1,0.3-0.1
		C331.7,105.6,331.6,105.5,331.5,105.5z"
      />
      <path
        class="st3"
        d="M430.6,69.8c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C430.8,69.8,430.7,69.8,430.6,69.8z"
      />
      <path
        class="st3"
        d="M389.9,106.2L389.9,106.2c0.1,0.2,0.2,0.2,0.2,0.3c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1-0.1-0.2-0.1-0.2
		C390.1,106,390,106.1,389.9,106.2C389.9,106.1,389.9,106.1,389.9,106.2z"
      />
      <path
        class="st3"
        d="M484.7,53.5c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.2,0.3-0.4,0.5-0.6
		C484.8,53.6,484.8,53.6,484.7,53.5z"
      />
      <path
        class="st3"
        d="M479.5,41.2c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C479.3,41.3,479.4,41.3,479.5,41.2z"
      />
      <path
        class="st3"
        d="M582.9,74c0.1,0,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2
		C582.7,73.9,582.8,74,582.9,74z"
      />
      <path
        class="st3"
        d="M381.3,75.7c0.1,0,0.2,0,0.2-0.1v-0.1c0,0,0,0-0.1,0.1L381.3,75.7z"
      />
      <path
        class="st3"
        d="M380.8,76c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C380.7,75.9,380.7,75.9,380.8,76z"
      />
      <path
        class="st3"
        d="M495.2,50.9L495.2,50.9C495.1,50.9,495.1,50.9,495.2,50.9C495.2,50.9,495.2,51,495.2,50.9L495.2,50.9z"
      />
      <path
        class="st3"
        d="M495.8,50.5c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C495.8,50.8,495.8,50.6,495.8,50.5z"
      />
      <path
        class="st3"
        d="M337.7,91.2c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2
		C337.8,91.3,337.8,91.2,337.7,91.2z"
      />
      <path
        class="st3"
        d="M466,46.3l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1C466.2,46,466,46.1,466,46.3
		C466,46.2,466,46.3,466,46.3z"
      />
      <path
        class="st3"
        d="M505.8,47c0,0.1,0.2,0.2,0.3,0.3c0.1-0.2,0.2-0.3,0.2-0.5c-0.1,0-0.3-0.1-0.4-0.1
		C505.8,46.8,505.7,47,505.8,47z"
      />
      <path
        class="st3"
        d="M555.9,46.2c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2C556,45.9,555.9,46.1,555.9,46.2
		C555.8,46.1,555.8,46.2,555.9,46.2z"
      />
      <path
        class="st3"
        d="M427,41.5c0.1,0,0.2,0,0.3,0v-0.1c0-0.1-0.2,0-0.3-0.1C427.1,41.4,427,41.5,427,41.5z"
      />
      <path
        class="st3"
        d="M427,63.7c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1S426.9,63.9,427,63.7z"
      />
      <path
        class="st3"
        d="M539.7,53.8c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.3-0.4c-0.1,0.2-0.1,0.4-0.2,0.5
		C539.5,53.7,539.6,53.8,539.7,53.8z"
      />
      <path
        class="st3"
        d="M544.3,68.3c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2
		C544.1,68.2,544.2,68.3,544.3,68.3z"
      />
      <path
        class="st3"
        d="M421.1,45.4c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1l-0.1-0.1
		C421.2,45.5,421.1,45.4,421.1,45.4z"
      />
      <path
        class="st3"
        d="M526.1,22.6c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C526.1,23,526.1,22.8,526.1,22.6z"
      />
      <path
        class="st3"
        d="M581.3,43.7c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C581.2,44,581.2,43.9,581.3,43.7z"
      />
      <path
        class="st3"
        d="M540.6,67.2c0,0,0,0.1-0.1,0.2c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2C540.9,67.2,540.7,67.2,540.6,67.2z"
      />
      <path
        class="st3"
        d="M491.8,42.9h-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C491.8,43.1,491.8,43,491.8,42.9z"
      />
      <path
        class="st3"
        d="M447.5,70.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2C447.9,70.2,447.7,70.2,447.5,70.2
		C447.6,70.2,447.5,70.2,447.5,70.2z"
      />
      <path
        class="st3"
        d="M472.6,36.2h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C472.5,36.4,472.6,36.3,472.6,36.2z"
      />
      <path
        class="st3"
        d="M547.4,64.9c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C547.2,64.8,547.3,64.9,547.4,64.9z"
      />
      <path
        class="st3"
        d="M577,42.2c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2C577.1,42.1,577,42.2,577,42.2
		z"
      />
      <path
        class="st3"
        d="M329.3,111.2c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.2
		c0-0.1,0-0.2-0.1-0.2C329.5,111.2,329.4,111.2,329.3,111.2z"
      />
      <path
        class="st3"
        d="M494.2,33.4c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1
		C494.4,33.2,494.3,33.3,494.2,33.4z"
      />
      <path
        class="st3"
        d="M594.6,38.6c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C594.4,38.5,594.5,38.6,594.6,38.6z"
      />
      <path
        class="st3"
        d="M456.7,69.8c0-0.1,0.1-0.1,0.1-0.2s-0.1-0.1-0.2-0.2l0,0l0,0c0,0,0,0,0,0.1l0,0l0,0c-0.1,0.1-0.1,0.2-0.2,0.3
		l0,0C456.5,69.7,456.6,69.8,456.7,69.8z"
      />
      <path
        class="st3"
        d="M474.7,51.1c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C474.7,50.8,474.7,51,474.7,51.1z"
      />
      <path
        class="st3"
        d="M447.8,55.4c0.1,0,0.1,0.1,0.2,0.1s0.1-0.1,0.2-0.1C448,55.4,447.9,55.4,447.8,55.4z"
      />
      <path
        class="st3"
        d="M547.4,32c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C547.2,31.9,547.3,32,547.4,32z"
      />
      <path
        class="st3"
        d="M471.8,52.5c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C471.7,52.4,471.7,52.5,471.8,52.5z"
      />
      <path
        class="st3"
        d="M390.3,70.6c0-0.1,0.1-0.1,0.1-0.2C390.4,70.4,390.3,70.5,390.3,70.6c-0.1,0-0.2,0.1-0.2,0.1
		C390.1,70.6,390.2,70.6,390.3,70.6z"
      />
      <path
        class="st3"
        d="M412.1,66c0.2,0,0.3,0,0.5,0h0.1c0,0,0,0-0.1-0.1C412.4,66,412.3,66,412.1,66z"
      />
      <path
        class="st3"
        d="M382.1,73.7l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C382.1,73.9,382.1,73.8,382.1,73.7z"
      />
      <path
        class="st3"
        d="M381.6,75.2c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2C381.6,75.4,381.6,75.4,381.6,75.2
		C381.6,75.3,381.6,75.2,381.6,75.2z"
      />
      <path
        class="st3"
        d="M381.2,98.8c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2l-0.1-0.1C381.3,98.7,381.3,98.7,381.2,98.8
		C381.2,98.7,381.2,98.8,381.2,98.8z"
      />
      <path
        class="st3"
        d="M502.8,37.5c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C502.8,37.6,502.8,37.5,502.8,37.5z"
      />
      <path
        class="st3"
        d="M477.5,55.9h0.1l0,0C477.5,55.8,477.5,55.8,477.5,55.9C477.4,55.9,477.5,55.9,477.5,55.9z"
      />
      <path
        class="st3"
        d="M417.9,53.3C417.9,53.3,417.9,53.4,417.9,53.3c0,0.1,0.1,0.1,0.2,0.1C418,53.3,418,53.3,417.9,53.3z"
      />
      <path
        class="st3"
        d="M438.7,48c0,0,0.1,0,0.2,0c0,0,0-0.1-0.1-0.1C438.8,47.9,438.7,47.9,438.7,48C438.7,47.9,438.7,48,438.7,48z"
      />
      <path
        class="st3"
        d="M477.4,58c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.1,0-0.2,0C477.6,57.9,477.5,57.9,477.4,58
		C477.5,57.9,477.4,58,477.4,58z"
      />
      <path
        class="st3"
        d="M454.8,63.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C454.7,63.4,454.8,63.4,454.8,63.3L454.8,63.3z"
      />
      <path
        class="st3"
        d="M446.1,46.1c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C446.2,46.1,446.1,46.1,446.1,46.1z"
      />
      <path
        class="st3"
        d="M567.9,39.9L567.9,39.9C567.9,39.8,567.8,39.8,567.9,39.9h-0.2l0,0C567.7,40,567.8,40,567.9,39.9
		C567.9,40,567.9,40,567.9,39.9z"
      />
      <path
        class="st3"
        d="M469.4,40.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C469.5,40.3,469.4,40.4,469.4,40.4z"
      />
      <path
        class="st3"
        d="M581.2,74.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C581.1,73.8,581.1,74,581.2,74.1z"
      />
      <path
        class="st3"
        d="M597.1,35C597.1,35.1,597,35.1,597.1,35c-0.1,0.2-0.1,0.3-0.1,0.3S597,35.2,597.1,35
		C597.1,35.1,597.1,35.1,597.1,35z"
      />
      <path
        class="st3"
        d="M597.2,34.7c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C597.3,34.7,597.2,34.7,597.2,34.7z"
      />
      <path
        class="st3"
        d="M425.1,73.7c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C425.1,73.9,425.1,73.8,425.1,73.7z"
      />
      <path
        class="st3"
        d="M579.4,72.9c0,0.1-0.1,0.2-0.1,0.2l0.1,0.1c0.1-0.1,0.1-0.1,0.2-0.2C579.5,72.9,579.5,72.9,579.4,72.9z"
      />
      <path
        class="st3"
        d="M337.9,93.5l-0.1-0.1h-0.1l0,0c0,0.1,0.1,0.1,0.1,0.2C337.9,93.6,337.9,93.5,337.9,93.5z"
      />
      <path
        class="st3"
        d="M494.2,59.7l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2l0.1-0.1C494.3,59.9,494.3,59.8,494.2,59.7z"
      />
      <path
        class="st3"
        d="M428.6,48c0.1,0,0.2,0,0.3,0l0,0C428.8,47.9,428.7,47.9,428.6,48C428.6,47.9,428.6,47.9,428.6,48z"
      />
      <path
        class="st3"
        d="M560.1,45.6c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C560.2,45.6,560.2,45.5,560.1,45.6
		C560.1,45.5,560.1,45.6,560.1,45.6z"
      />
      <path
        class="st3"
        d="M551.5,47.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0
		C551.6,47.6,551.6,47.6,551.5,47.7z"
      />
      <path
        class="st3"
        d="M383.1,110.7c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C383.3,110.7,383.2,110.7,383.1,110.7z"
      />
      <path
        class="st3"
        d="M415.8,78.5L415.8,78.5C415.8,78.5,415.8,78.6,415.8,78.5c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C416.1,78.5,416,78.5,415.8,78.5C415.9,78.5,415.9,78.5,415.8,78.5z"
      />
      <path
        class="st3"
        d="M316.1,100.5H316v0.1c0.1,0,0.1,0,0.2,0C316.2,100.6,316.2,100.6,316.1,100.5z"
      />
      <path
        class="st3"
        d="M339.8,64.1L339.8,64.1C339.8,64.2,339.9,64.2,339.8,64.1C339.9,64.2,339.8,64.1,339.8,64.1z"
      />
      <path
        class="st3"
        d="M526.3,23.3l-0.1-0.1c0,0,0,0,0-0.1v0.1C526.2,23.3,526.2,23.3,526.3,23.3z"
      />
      <path
        class="st3"
        d="M526.6,23.6c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4L526.6,23.6z"
      />
      <path
        class="st3"
        d="M377.7,87.9c0,0,0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1l-0.1,0.1
		C377.7,87.9,377.7,87.9,377.7,87.9z"
      />
      <path
        class="st3"
        d="M377.6,88.1h0.1c0,0,0,0,0-0.1C377.7,88,377.7,88,377.6,88.1C377.6,88,377.6,88,377.6,88.1z"
      />
      <path
        class="st3"
        d="M377.3,88.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C377.2,88.3,377.2,88.3,377.3,88.4z"
      />
      <path
        class="st3"
        d="M554.7,15.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C554.8,15.6,554.8,15.6,554.7,15.6z"
      />
      <path
        class="st3"
        d="M382.9,109.9c0,0,0,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C382.9,110,382.9,110,382.9,109.9z"
      />
      <path
        class="st3"
        d="M534.9,76.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C535.1,76.3,535,76.2,534.9,76.2z"
      />
      <path
        class="st3"
        d="M534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6
		C534.6,76.5,534.7,76.5,534.7,76.6L534.7,76.6L534.7,76.6z"
      />
      <path
        class="st3"
        d="M466.3,30.5c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C466.2,30.7,466.3,30.6,466.3,30.5z"
      />
      <path
        class="st3"
        d="M333,58.6l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C333.2,58.6,333.1,58.6,333,58.6z"
      />
      <path
        class="st3"
        d="M583.5,46.9c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C583.3,46.9,583.4,46.9,583.5,46.9
		C583.4,46.9,583.4,46.9,583.5,46.9z"
      />
      <path
        class="st3"
        d="M583.8,65.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0-0.1-0.1-0.1C584,65.2,583.9,65.2,583.8,65.3
		C583.8,65.2,583.8,65.3,583.8,65.3z"
      />
      <path
        class="st3"
        d="M450.6,32.9c0,0.1,0,0.1,0,0.2c0,0,0.1,0,0.1-0.1C450.7,33,450.7,33,450.6,32.9z"
      />
      <path
        class="st3"
        d="M555.1,71c-0.2,0-0.4,0.1-0.6,0.1v0.1C554.7,71.2,554.9,71.1,555.1,71L555.1,71z"
      />
      <path
        class="st3"
        d="M333.9,58.1c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C333.8,57.9,333.8,58,333.9,58.1z"
      />
      <path
        class="st3"
        d="M333.6,57.6C333.6,57.7,333.7,57.7,333.6,57.6c0.1,0.1,0.1,0.1,0.1,0.1C333.7,57.8,333.7,57.7,333.6,57.6
		C333.7,57.7,333.7,57.7,333.6,57.6z"
      />
      <path
        class="st3"
        d="M450.4,31.8l-0.1-0.1l-0.1,0.1l0.1,0.1C450.4,31.9,450.4,31.8,450.4,31.8z"
      />
      <path
        class="st3"
        d="M317.5,121.2c0,0,0.1,0,0.1-0.1V121c-0.1,0-0.1,0.1-0.2,0.1C317.4,121.1,317.4,121.2,317.5,121.2z"
      />
      <path
        class="st3"
        d="M402.8,40.6c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C402.7,40.6,402.7,40.6,402.8,40.6z"
      />
      <path
        class="st3"
        d="M402.5,40.4L402.5,40.4l-0.1-0.1C402.4,40.3,402.4,40.3,402.5,40.4C402.5,40.3,402.5,40.4,402.5,40.4z"
      />
      <path
        class="st3"
        d="M479.1,22.8c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C479,22.9,479,22.9,479.1,22.8z"
      />
      <path
        class="st3"
        d="M375.1,107.2L375.1,107.2c0,0.1,0,0.2,0.1,0.2v-0.1C375.2,107.3,375.2,107.3,375.1,107.2z"
      />
      <path
        class="st3"
        d="M576,62.8C576,62.8,576,62.7,576,62.8C576,62.7,575.9,62.7,576,62.8C575.9,62.7,575.9,62.7,576,62.8L576,62.8z
		"
      />
      <path
        class="st3"
        d="M426,33.8c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3L426,33.8z"
      />
      <path
        class="st3"
        d="M534.5,61.5c0.1,0,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2C534.3,61.5,534.4,61.5,534.5,61.5
		z"
      />
      <path
        class="st3"
        d="M550.5,68c0-0.1,0.1-0.1,0.1-0.2c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2-0.1,0.3C550.4,67.9,550.4,68,550.5,68z"
      />
      <path
        class="st3"
        d="M463.7,77.4C463.7,77.3,463.7,77.4,463.7,77.4c-0.1,0.1,0,0.2,0,0.2l0.1-0.1C463.8,77.4,463.7,77.4,463.7,77.4
		z"
      />
      <path
        class="st3"
        d="M574.5,53.4C574.5,53.4,574.4,53.4,574.5,53.4c0,0.2,0,0.2,0.1,0.2v-0.1C574.6,53.4,574.5,53.4,574.5,53.4z"
      />
      <path
        class="st3"
        d="M545.9,60.5c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C545.9,60.2,545.8,60.3,545.9,60.5
		C545.7,60.5,545.8,60.5,545.9,60.5z"
      />
      <path
        class="st3"
        d="M592.1,57.6C592.1,57.6,592.2,57.7,592.1,57.6C592.2,57.7,592.2,57.6,592.1,57.6
		C592.2,57.6,592.1,57.6,592.1,57.6z"
      />
      <path
        class="st3"
        d="M413.3,30.1l-0.1-0.1c0,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C413.1,30.1,413.2,30.1,413.3,30.1z"
      />
      <path
        class="st3"
        d="M386.1,101.7l-0.1-0.1c-0.1,0-0.2,0.1-0.2,0.1l0.1,0.1C385.9,101.8,386,101.8,386.1,101.7z"
      />
      <path
        class="st3"
        d="M489.7,6.9C489.6,6.9,489.6,6.9,489.7,6.9c-0.1,0.1-0.1,0.2-0.1,0.2C489.7,7.1,489.7,7.1,489.7,6.9L489.7,6.9z
		"
      />
      <path
        class="st3"
        d="M332.5,107.6C332.5,107.5,332.6,107.5,332.5,107.6C332.6,107.5,332.5,107.5,332.5,107.6c0-0.2-0.1-0.2-0.1-0.2
		l-0.1,0.1C332.4,107.5,332.4,107.5,332.5,107.6L332.5,107.6z"
      />
      <path
        class="st3"
        d="M461,7.8c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C460.9,8,460.9,7.9,461,7.8z"
      />
      <path
        class="st3"
        d="M371.4,22.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.1,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C371.4,22.4,371.4,22.3,371.4,22.2z"
      />
      <path
        class="st3"
        d="M320.5,110.4c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C320.4,110.4,320.4,110.4,320.5,110.4z"
      />
      <path
        class="st3"
        d="M324.4,109.6c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1C324.5,109.4,324.4,109.4,324.4,109.6L324.4,109.6z"
      />
      <path
        class="st3"
        d="M445.9,83.5c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0-0.2,0-0.3,0.1C445.9,83.4,445.9,83.5,445.9,83.5z"
      />
      <path
        class="st3"
        d="M308.3,140.4c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0C308.2,140.6,308.2,140.5,308.3,140.4z"
      />
      <path
        class="st3"
        d="M583.7,74.2L583.7,74.2h-0.2H583.7C583.6,74.3,583.7,74.3,583.7,74.2z"
      />
      <path
        class="st3"
        d="M306.5,133.2v0.1V133.2C306.6,133.2,306.6,133.1,306.5,133.2C306.6,133.1,306.5,133.1,306.5,133.2z"
      />
      <path
        class="st3"
        d="M306.7,132.9c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C306.8,132.9,306.7,132.9,306.7,132.9z"
      />
      <path
        class="st3"
        d="M589.7,67.8C589.7,67.8,589.6,67.8,589.7,67.8L589.7,67.8L589.7,67.8C589.6,67.8,589.7,67.8,589.7,67.8z"
      />
      <path
        class="st3"
        d="M383.1,112.6c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C383.2,112.7,383.2,112.6,383.1,112.6z"
      />
      <path
        class="st3"
        d="M383.1,112.8C383,112.8,383,112.8,383.1,112.8C383,112.8,383,112.9,383.1,112.8
		C383,112.9,383,112.9,383.1,112.8L383.1,112.8z"
      />
      <path
        class="st3"
        d="M560.9,73.2L560.9,73.2C560.8,73.4,560.8,73.3,560.9,73.2C560.8,73.3,560.8,73.3,560.9,73.2z"
      />
      <path
        class="st3"
        d="M376.5,112C376.6,112,376.6,112,376.5,112c0.1-0.1,0-0.2,0-0.2C376.5,111.9,376.4,111.9,376.5,112
		C376.4,112,376.5,112,376.5,112z"
      />
      <path
        class="st3"
        d="M383.9,109.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C384,109.6,383.9,109.6,383.9,109.7z"
      />
      <path
        class="st3"
        d="M555.6,71.6L555.6,71.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0C555.7,71.6,555.6,71.6,555.6,71.6z"
      />
      <polygon class="st3" points="579.7,63.5 579.8,63.5 579.7,63.4 	" />
      <path
        class="st3"
        d="M576.2,64.2L576.2,64.2c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C576.2,64.1,576.2,64.2,576.2,64.2z"
      />
      <path
        class="st3"
        d="M385.5,104.8c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C385.7,104.8,385.6,104.8,385.5,104.8z"
      />
      <path
        class="st3"
        d="M385.3,104.7c0.1,0,0.1,0,0.2,0.1v-0.1C385.4,104.7,385.3,104.7,385.3,104.7z"
      />
      <path
        class="st3"
        d="M314.4,119.8h0.1l0.1-0.1l-0.1-0.1C314.5,119.7,314.5,119.7,314.4,119.8z"
      />
      <path
        class="st3"
        d="M579.5,61.9L579.5,61.9c0.1-0.2,0.1-0.2,0.1-0.2S579.6,61.8,579.5,61.9C579.5,61.9,579.5,61.9,579.5,61.9z"
      />
      <polygon class="st3" points="576.8,62 576.8,61.9 576.7,62 	" />
      <path
        class="st3"
        d="M389.8,99.6C389.7,99.5,389.7,99.5,389.8,99.6c-0.1-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		C389.7,99.5,389.7,99.5,389.8,99.6z"
      />
      <path
        class="st3"
        d="M389.6,99.5C389.6,99.5,389.6,99.4,389.6,99.5c-0.1,0-0.1-0.1-0.2-0.1l0,0l0,0l0,0
		C389.5,99.5,389.6,99.5,389.6,99.5z"
      />
      <polygon class="st3" points="372.4,103 372.3,103.1 372.4,103.1 	" />
      <polygon class="st3" points="338.7,108.3 338.7,108.2 338.6,108.2 	" />
      <polygon class="st3" points="335,105.3 335.1,105.3 335,105.2 	" />
      <polygon class="st3" points="459.4,77.3 459.5,77.3 459.5,77.2 	" />
      <path
        class="st3"
        d="M580.7,49.8c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C580.6,49.9,580.6,49.9,580.7,49.8z"
      />
      <path
        class="st3"
        d="M392.1,90.6l-0.1,0.1c0.1,0,0.2,0,0.3,0.1C392.2,90.7,392.2,90.6,392.1,90.6z"
      />
      <polygon class="st3" points="462,73.6 462.1,73.7 462.1,73.6 	" />
      <polygon class="st3" points="548.7,54.6 548.8,54.6 548.8,54.5 	" />
      <polygon class="st3" points="552.4,48.2 552.3,48.1 552.2,48.1 	" />
      <path
        class="st3"
        d="M596.5,36.4c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C596.4,36.5,596.4,36.4,596.5,36.4z"
      />
      <path
        class="st3"
        d="M484.5,58.8l0.1-0.1c0,0-0.1,0-0.1-0.1l-0.1,0.1C484.4,58.8,484.4,58.8,484.5,58.8z"
      />
      <polygon class="st3" points="481.4,59.1 481.5,59.2 481.5,59.1 	" />
      <polygon class="st3" points="409.6,74 409.5,74 409.5,74.1 	" />
      <path
        class="st3"
        d="M444.4,65.1L444.4,65.1c0-0.1-0.1-0.1-0.1-0.1S444.4,65,444.4,65.1z"
      />
      <polygon class="st3" points="560.3,39.2 560.3,39.3 560.4,39.2 	" />
      <path
        class="st3"
        d="M514.7,46.3C514.7,46.3,514.6,46.3,514.7,46.3c-0.1,0-0.1,0-0.1,0.1C514.6,46.3,514.6,46.3,514.7,46.3z"
      />
      <path
        class="st3"
        d="M380.5,75.2l0.1-0.1c0,0,0-0.1,0.1-0.1c0,0-0.1,0-0.1,0.1C380.5,75.2,380.5,75.2,380.5,75.2z"
      />
      <path
        class="st3"
        d="M514.1,45.8L514.1,45.8c0.1-0.1,0-0.1,0-0.2V45.8C514,45.8,514,45.8,514.1,45.8z"
      />
      <polygon class="st3" points="549,36 548.9,36 548.9,36.1 	" />
      <polygon class="st3" points="548.5,35.5 548.4,35.4 548.4,35.6 	" />
      <path
        class="st3"
        d="M434.7,49.5h0.1l0.1-0.1l-0.1-0.1C434.7,49.4,434.7,49.5,434.7,49.5z"
      />
      <path
        class="st3"
        d="M575.6,17.7c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C575.6,17.8,575.6,17.7,575.6,17.7z"
      />
      <polygon
        class="st3"
        points="533.2,26.6 533.2,26.5 533.2,26.5 533.1,26.5 533.1,26.5 	"
      />
      <polygon class="st3" points="438.4,47.1 438.4,47 438.3,47.1 	" />
      <path
        class="st3"
        d="M501.4,32.7c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C501.4,32.8,501.4,32.7,501.4,32.7z"
      />
      <path
        class="st3"
        d="M501.2,33L501.2,33c-0.1,0.1-0.1,0.2-0.1,0.3C501.2,33.2,501.2,33.1,501.2,33L501.2,33z"
      />
      <polygon class="st3" points="445.9,44.9 446,44.9 446,44.8 	" />
      <polygon class="st3" points="548.7,22.2 548.6,22.3 548.7,22.3 	" />
      <polygon class="st3" points="532.7,25.7 532.6,25.8 532.7,25.8 	" />
      <path
        class="st3"
        d="M434.3,47.1L434.3,47.1C434.3,46.9,434.3,46.9,434.3,47.1C434.2,47,434.3,47,434.3,47.1z"
      />
      <path
        class="st3"
        d="M421.4,49.6l0.1-0.1l-0.1-0.1l-0.1,0.1C421.3,49.6,421.4,49.6,421.4,49.6z"
      />
      <polygon
        class="st3"
        points="308.7,74 308.8,74 308.8,74 308.8,73.9 308.8,73.9 	"
      />
      <path
        class="st3"
        d="M575.8,13c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C575.7,13,575.7,13,575.8,13z"
      />
      <polygon class="st3" points="418.5,45.1 418.5,45.2 418.6,45.1 	" />
      <path
        class="st3"
        d="M412.6,43c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C412.7,42.8,412.7,42.9,412.6,43z"
      />
      <path class="st3" d="M465.4,30.3l-0.1-0.1l-0.1,0.1l0.1,0.1L465.4,30.3z" />
      <polygon class="st3" points="427.4,38.2 427.3,38.3 427.4,38.3 	" />
      <polygon class="st3" points="445.3,33.7 445.5,33.7 445.4,33.6 	" />
      <path
        class="st3"
        d="M463.2,29.2l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C463.2,29.2,463.2,29.2,463.2,29.2z"
      />
      <path
        class="st3"
        d="M402.2,40.2L402.2,40.2c0.1,0.1,0.1,0.1,0.2,0.1C402.3,40.2,402.3,40.2,402.2,40.2z"
      />
      <path
        class="st3"
        d="M462,25.3l0.1-0.1v-0.1l-0.1,0.1C462.1,25.2,462,25.3,462,25.3z"
      />
      <polygon class="st3" points="440.8,29.9 440.8,30 440.9,30 	" />
      <path
        class="st3"
        d="M524.3,179.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C524.5,179.7,524.4,179.7,524.3,179.8z"
      />
      <path
        class="st3"
        d="M546.1,163.8c0,0-0.1,0-0.1-0.1l0,0l0,0C546,163.8,546,163.8,546.1,163.8z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "FastpitchCover_c2",
  props: ["fill"],
};
</script>
